import React__default, { createElement, useState, useRef, useEffect, useCallback, createContext, memo, isValidElement, cloneElement, useLayoutEffect, useMemo, useContext } from 'react';
import { createPortal } from 'react-dom';
import { jsx } from 'react/jsx-runtime';
import ReactDOMServer from 'react-dom/server';
import { useHistory, useLocation, Link, NavLink, Switch, useRouteMatch } from 'react-router-dom';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "/* vietnamese */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Muli Regular'), local('Muli-Regular'), url(https://fonts.gstatic.com/s/muli/v16/7Auwp_0qiz-afT3GLQjUwkQ1OQ.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Muli Regular'), local('Muli-Regular'), url(https://fonts.gstatic.com/s/muli/v16/7Auwp_0qiz-afTzGLQjUwkQ1OQ.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Muli Regular'), local('Muli-Regular'), url(https://fonts.gstatic.com/s/muli/v16/7Auwp_0qiz-afTLGLQjUwkQ.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Muli Bold'), local('Muli-Bold'), url(https://fonts.gstatic.com/s/muli/v16/7Au_p_0qiz-adYnjOCr2z24PMFk-0g.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Muli Bold'), local('Muli-Bold'), url(https://fonts.gstatic.com/s/muli/v16/7Au_p_0qiz-adYnjOCv2z24PMFk-0g.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Muli Bold'), local('Muli-Bold'), url(https://fonts.gstatic.com/s/muli/v16/7Au_p_0qiz-adYnjOCX2z24PMFk.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 800;\n  src: local('Muli ExtraBold'), local('Muli-ExtraBold'), url(https://fonts.gstatic.com/s/muli/v16/7Au_p_0qiz-adZXgOCr2z24PMFk-0g.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 800;\n  src: local('Muli ExtraBold'), local('Muli-ExtraBold'), url(https://fonts.gstatic.com/s/muli/v16/7Au_p_0qiz-adZXgOCv2z24PMFk-0g.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Muli';\n  font-style: normal;\n  font-weight: 800;\n  src: local('Muli ExtraBold'), local('Muli-ExtraBold'), url(https://fonts.gstatic.com/s/muli/v16/7Au_p_0qiz-adZXgOCX2z24PMFk.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n";
styleInject(css_248z);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var css_248z$1 = ".flight-font, .flight-avatar {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-avatar {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large, .flight-avatar--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-avatar {\n  width: 32px;\n  height: 32px;\n  font-weight: 700;\n  background-color: #82899B;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #FFFFFF;\n}\n.flight-avatar--large {\n  width: 48px;\n  height: 48px;\n}\n.flight-avatar--a, .flight-avatar--b {\n  background-color: #9B342B;\n}\n.flight-avatar--c, .flight-avatar--d {\n  background-color: #E8673E;\n}\n.flight-avatar--e, .flight-avatar--f {\n  background-color: #D38E07;\n}\n.flight-avatar--g, .flight-avatar--h {\n  background-color: #8F3B6E;\n}\n.flight-avatar--i, .flight-avatar--j {\n  background-color: #cf00a2;\n}\n.flight-avatar--k, .flight-avatar--l {\n  background-color: #9483D6;\n}\n.flight-avatar--m, .flight-avatar--n {\n  background-color: #7658C0;\n}\n.flight-avatar--o, .flight-avatar--p {\n  background-color: #2F4694;\n}\n.flight-avatar--q, .flight-avatar--r {\n  background-color: #4076CE;\n}\n.flight-avatar--s, .flight-avatar--t {\n  background-color: #4796C0;\n}\n.flight-avatar--u, .flight-avatar--v {\n  background-color: #65C4EB;\n}\n.flight-avatar--w, .flight-avatar--x {\n  background-color: #3dab7b;\n}\n.flight-avatar--y, .flight-avatar--z {\n  background-color: #307A4A;\n}";
styleInject(css_248z$1);

const DEFAULT_CLASS = 'flight-avatar';
const FlightAvatar = props => {
  const {
    firstName,
    lastName,
    email,
    className,
    size
  } = props;
  let fixedInitial = firstName && firstName.length ? firstName[0].toLocaleUpperCase() : '';
  if (!fixedInitial) {
    fixedInitial = email && email.length ? email[0].toLocaleUpperCase() : '';
  }
  let mainClass = DEFAULT_CLASS;
  mainClass += fixedInitial && fixedInitial.length ? ` ${DEFAULT_CLASS}--${fixedInitial.toLocaleLowerCase()}` : '';
  mainClass += className ? ` ${className}` : '';
  mainClass += size ? ` ${DEFAULT_CLASS}--${size}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: mainClass
  }, fixedInitial, lastName && lastName.length ? lastName[0].toLocaleUpperCase() : '');
};
FlightAvatar.propTypes = {
  firstName: propTypes.string,
  lastName: propTypes.string,
  email: propTypes.string,
  className: propTypes.string,
  size: propTypes.string
};
FlightAvatar.defaultProps = {
  firstName: '',
  lastName: '',
  email: '',
  className: '',
  size: ''
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

const SvgAddCondition = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M0 2.77a1.98 1.98 0 0 0 1.98 1.98h13.457a1.98 1.98 0 0 0 1.98-1.98v-.79A1.98 1.98 0 0 0 15.437 0H1.98A1.98 1.98 0 0 0 0 1.98v.79Zm2.882-.395a.879.879 0 1 1 .54.814.87.87 0 0 1-.54-.814Zm3.055 0a.887.887 0 1 1 .88.879.879.879 0 0 1-.88-.879ZM13.854 7.52a6.262 6.262 0 0 1 2.993.753.388.388 0 0 0 .57-.356V7.52a1.98 1.98 0 0 0-1.98-1.98H1.98A1.98 1.98 0 0 0 0 7.522v.791a1.98 1.98 0 0 0 1.98 1.98h6.443a.395.395 0 0 0 .317-.167 6.333 6.333 0 0 1 5.114-2.604Zm-6.151.397a.887.887 0 1 1-.548-.815.879.879 0 0 1 .548.815Zm-3.064 0a.879.879 0 1 1-.541-.814.87.87 0 0 1 .541.814ZM7.568 11.083H1.98A1.979 1.979 0 0 0 0 13.063v.791a1.98 1.98 0 0 0 1.98 1.98h5.335a.404.404 0 0 0 .38-.507 6.333 6.333 0 0 1 .237-3.713.388.388 0 0 0-.364-.53Zm-4.686 2.375a.879.879 0 1 1 .878.88.87.87 0 0 1-.878-.88Z"
}), /*#__PURE__*/createElement("path", {
  d: "M8.707 13.854a5.146 5.146 0 1 0 5.146-5.146 5.154 5.154 0 0 0-5.146 5.146Zm4.552.792a.197.197 0 0 0-.198-.198h-1.187a.594.594 0 0 1 0-1.188h1.187a.198.198 0 0 0 .198-.198v-1.187a.594.594 0 0 1 1.188 0v1.187a.198.198 0 0 0 .198.198h1.187a.594.594 0 1 1 0 1.188h-1.188a.197.197 0 0 0-.197.197v1.188a.594.594 0 1 1-1.188 0v-1.188Z"
}));

const SvgAddTag = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 26 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  clipRule: "evenodd",
  d: "M4.334 3.118a.751.751 0 0 0-.75.749v5.119c0 .199.08.39.22.53l7.146 7.146a.75.75 0 0 0 1.061 0l5.118-5.117a.75.75 0 0 0 0-1.061L9.983 3.337a.75.75 0 0 0-.53-.22H4.334Zm-2.867.749A2.869 2.869 0 0 1 4.334 1h5.119c.76 0 1.49.302 2.027.84l7.146 7.146a2.867 2.867 0 0 1 0 4.056L13.51 18.16a2.867 2.867 0 0 1-4.056 0l-7.146-7.146a2.868 2.868 0 0 1-.84-2.028v-5.12Zm3.235.369a1.059 1.059 0 0 1 1.498 0l.418.418A1.059 1.059 0 0 1 5.12 6.15l-.418-.418a1.059 1.059 0 0 1 0-1.497Z"
}), /*#__PURE__*/createElement("path", {
  d: "M3.584 8.986v-5.12c0-.411.337-.748.75-.748h5.119a.75.75 0 0 1 .53.22l7.146 7.146a.75.75 0 0 1 0 1.061l-5.118 5.118a.75.75 0 0 1-1.06 0L3.803 9.515a.75.75 0 0 1-.22-.53Zm0 0s0 0 0 0Zm-1.277 2.028 7.146 7.146a2.866 2.866 0 0 0 4.056 0l5.117-5.117a2.866 2.866 0 0 0 0-4.057L11.48 1.84A2.869 2.869 0 0 0 9.453 1H4.334a2.869 2.869 0 0 0-2.867 2.867v5.12c0 .76.302 1.489.84 2.027Zm0 0s0 0 0 0ZM6.2 4.236a1.059 1.059 0 1 0-1.498 1.497l.418.418a1.059 1.059 0 0 0 1.498-1.497L6.2 4.236Z",
  stroke: "#F2F3F5",
  strokeWidth: 0.6,
  strokeLinecap: "round"
}), /*#__PURE__*/createElement("rect", {
  x: 16.467,
  y: 5,
  width: 9,
  height: 9,
  rx: 4.5,
  fill: "#fff"
}), /*#__PURE__*/createElement("path", {
  d: "M20.477 12.902V9.85h-3.01v-.868h3.01V6h.896v2.982h3.01v.868h-3.01v3.052h-.896Z"
}));

const SvgAdd = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"
}));

const SvgAddCircleOutline = props => /*#__PURE__*/createElement("svg", _extends({
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("g", {
  id: "Add-Circle--Streamline-Ultimate.svg"
}, /*#__PURE__*/createElement("g", {
  id: "Group 427319089"
}, /*#__PURE__*/createElement("path", {
  id: "Vector",
  d: "M10 6.7998V13.1998",
  stroke: "#0851DF",
  strokeWidth: "1.06",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  id: "Vector_2",
  d: "M6.8 10H13.2",
  stroke: "#0851DF",
  strokeWidth: "1.06",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  id: "Vector_3",
  d: "M2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10Z",
  stroke: "#0851DF",
  strokeWidth: "1.06",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

const SvgAnalytics = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M18 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-3Zm-7 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-3Zm-7 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4Z"
}));

const SvgArtificialIntelligence = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M17 2a2 2 0 0 0-1.731 2.998 2 2 0 0 0 .731.73V7h-3V5l.002-1.445a1 1 0 0 0-.498-.866 5.016 5.016 0 0 0-3.125-.64 4.94 4.94 0 0 0-2.914 1.416c-.32.32-.57.676-.766 1.05L5.67 4.5c-.606 1.05-.762 2.233-.567 3.348C3.275 8.873 2 10.763 2 13c0 1.82.886 3.388 2.166 4.484C4.641 20.032 6.817 22 9.5 22a5.488 5.488 0 0 0 3.057-.93 1 1 0 0 0 .443-.83V17h3v1.27a2.001 2.001 0 0 0-.414 3.144 2 2 0 0 0 3.145-2.412 2 2 0 0 0-.731-.73V16a1 1 0 0 0-1-1h-4v-2h6.271a2 2 0 0 0 3.143.414A2 2 0 1 0 19.27 11H13V9h4a1 1 0 0 0 1-1V5.73a2 2 0 0 0 .414-3.144A2 2 0 0 0 17 2ZM9.977 4.025c.346.034.686.165 1.023.29v3.517a1.003 1.003 0 0 0 0 .326v1.844h-.006A1.98 1.98 0 0 1 9.002 12l.002 2c.729 0 1.406-.216 1.996-.563v2.395a1.003 1.003 0 0 0 0 .326v3.387c-.466.23-.942.455-1.5.455-1.804 0-3.25-1.348-3.455-3.096a1.001 1.001 0 0 0-.4-.69C4.648 15.483 4 14.328 4 13c0-1.401.725-2.607 1.81-3.318A4.922 4.922 0 0 0 7.5 11.33l1-1.732a2.979 2.979 0 0 1-1.291-1.516A1.002 1.002 0 0 0 7.186 8a3.063 3.063 0 0 1-.17-1.23c.007-.109.027-.216.046-.323.015-.073.03-.147.05-.22.02-.076.038-.152.064-.227a3.055 3.055 0 0 1 .703-1.121 2.947 2.947 0 0 1 1.748-.852c.117-.013.234-.013.35-.002Z"
}));

const SvgBaselineArrowDown = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8Z"
}));

const SvgBaselineArrowLeft = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2Z"
}));

const SvgBaselineArrowRight = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8Z"
}));

const SvgBaselineArrowUp = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8Z"
}));

const SvgBaselineCheck = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17Z"
}));

const SvgBaselineKeyboardArrowDown = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41Z"
}));

const SvgBaselineKeyboardArrowLeft = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41Z"
}));

const SvgBaselineKeyboardArrowRight = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41Z"
}));

const SvgBaselineKeyboardArrowUp = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41Z"
}));

const SvgBellAlarm = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2a1.5 1.5 0 0 0-1.5 1.5v.695A5.997 5.997 0 0 0 6 10v6l-2 2v1h16v-1l-2-2v-6a5.997 5.997 0 0 0-4.5-5.805V3.5A1.5 1.5 0 0 0 12 2Zm-6.092.082C3.535 3.91 2 6.772 2 10h2a7.978 7.978 0 0 1 3.127-6.334L5.908 2.082Zm12.184 0-1.219 1.584A7.978 7.978 0 0 1 20 10h2c0-3.228-1.535-6.09-3.908-7.918ZM10 20c0 1.1.9 2 2 2s2-.9 2-2h-4Z"
}));

const SvgBell = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2a1.5 1.5 0 0 0-1.5 1.5v.695A5.998 5.998 0 0 0 6 10v6l-2 2v1h16v-1l-2-2v-6a5.995 5.995 0 0 0-4.5-5.803V3.5A1.5 1.5 0 0 0 12 2Zm-2 18a2 2 0 0 0 4 0h-4Z"
}));

const SvgBlocked = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("g", {
  clipPath: "url(#blocked_svg__a)"
}, /*#__PURE__*/createElement("path", {
  d: "M4.929 4.929c-3.89 3.889-3.89 10.253 0 14.142 3.889 3.89 10.253 3.89 14.142 0 3.89-3.889 3.89-10.253 0-14.142-3.889-3.89-10.253-3.89-14.142 0Zm12.02 3.535L8.465 16.95 7.05 15.536l8.486-8.486 1.414 1.414Z"
})), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
  id: "blocked_svg__a"
}, /*#__PURE__*/createElement("path", {
  d: "M0 0h24v24H0V0Z"
}))));

const SvgBuild = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4Z"
}));

const SvgCamera = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.576 13.544c.787 0 1.424-.637 1.424-1.424l-.007-8.112c0-.787-.637-1.424-1.424-1.424H12.99a1.59 1.59 0 0 1-1.571-1.349C11.287.4 10.458 0 9.77 0H6.229c-.68 0-1.513.395-1.648 1.235a1.6 1.6 0 0 1-1.58 1.35H1.425C.637 2.584 0 3.22 0 4.007v8.112c0 .787.637 1.424 1.424 1.424h13.152ZM7.992 3.403a4.11 4.11 0 1 0-.001 8.221 4.11 4.11 0 0 0 0-8.221Zm0 6.66a2.55 2.55 0 0 1-2.549-2.549 2.55 2.55 0 0 1 2.549-2.548 2.55 2.55 0 0 1 2.548 2.548 2.55 2.55 0 0 1-2.548 2.549ZM13.74 4.14a.66.66 0 1 0-.008 1.324.662.662 0 0 0 .015-1.324h-.007Z",
  fill: "#051336"
}));

const SvgCategories = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M3.75 3.75h6.5v6.5h-6.5v-6.5ZM3.75 13.75h6.5v6.5h-6.5v-6.5ZM13.75 3.75h6.5v6.5h-6.5v-6.5ZM13.75 13.75h6.5v6.5h-6.5v-6.5Z"
}));

const SvgCheckCircleOutline = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M9 .938C4.554.938.937 4.554.937 9c0 4.445 3.617 8.063 8.063 8.063 4.446 0 8.063-3.618 8.063-8.063S13.445.937 9 .937Zm0 15A6.945 6.945 0 0 1 2.062 9 6.945 6.945 0 0 1 9 2.062 6.945 6.945 0 0 1 15.938 9 6.945 6.945 0 0 1 9 15.938Zm3.023-9.086c.22.22.22.576 0 .796l-3.5 3.5a.561.561 0 0 1-.796 0l-1.75-1.75a.563.563 0 1 1 .796-.796l1.353 1.353 3.101-3.102c.22-.22.576-.22.796-.001Z"
}));

const SvgCheckCircle = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9Z"
}));

const SvgCheckboxCheck = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.722 7.81 9.162 19.372 3.6 13.811l2.12-2.121 3.44 3.439 9.44-9.44 2.12 2.122Z"
}));

const SvgCircleApps = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M5 3a2 2 0 1 0-.001 3.999A2 2 0 0 0 5 3Zm7 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 3Zm7 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 19 3ZM5 10a2 2 0 1 0-.001 3.999A2 2 0 0 0 5 10Zm7 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 10Zm7 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 19 10ZM5 17a2 2 0 1 0-.001 3.999A2 2 0 0 0 5 17Zm7 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 17Zm7 0a2 2 0 1 0-.001 3.999A2 2 0 0 0 19 17Z"
}));

const SvgClear = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
}));

const SvgClipboardCheck = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M14.167 3.542h-.225c-.081-1.045-.758-1.667-1.859-1.667H7.917c-1.101 0-1.778.622-1.859 1.667h-.225c-2.015 0-3.125 1.11-3.125 3.125V15c0 2.015 1.11 3.125 3.125 3.125h8.334c2.015 0 3.125-1.11 3.125-3.125V6.667c0-2.015-1.11-3.125-3.125-3.125Zm-6.875.208c0-.49.134-.625.625-.625h4.166c.491 0 .625.134.625.625v.833c0 .491-.134.625-.625.625H7.917c-.491 0-.625-.134-.625-.625V3.75ZM16.042 15c0 1.314-.561 1.875-1.875 1.875H5.833c-1.314 0-1.875-.56-1.875-1.875V6.667c0-1.314.561-1.875 1.875-1.875h.225c.081 1.045.758 1.666 1.859 1.666h4.166c1.101 0 1.778-.621 1.859-1.666h.225c1.314 0 1.875.56 1.875 1.875V15Zm-3.517-5.72a.625.625 0 0 1 0 .884l-2.778 2.778a.623.623 0 0 1-.883 0l-1.39-1.39a.625.625 0 0 1 .885-.884l.948.947 2.335-2.336a.625.625 0 0 1 .883.001Z"
}));

const SvgClockFill = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.29 15.71L11 12.41V5h2v6.59l4.71 4.7-1.42 1.42Z"
}));

const SvgCloudFailed = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M19.35 10.04A7.49 7.49 0 0 0 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46a5.497 5.497 0 0 1 8.05 4.87v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96ZM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27ZM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73Z"
}));

const SvgCogOutline = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M10 6.875A3.128 3.128 0 0 0 6.875 10 3.128 3.128 0 0 0 10 13.125 3.128 3.128 0 0 0 13.125 10 3.128 3.128 0 0 0 10 6.875Zm0 5A1.877 1.877 0 0 1 8.125 10c0-1.034.84-1.875 1.875-1.875 1.034 0 1.875.841 1.875 1.875s-.84 1.875-1.875 1.875Zm7.673-.247A1.889 1.889 0 0 1 16.734 10c0-.667.357-1.29.943-1.629a.904.904 0 0 0 .327-1.232l-1.393-2.405a.904.904 0 0 0-1.231-.329 1.88 1.88 0 0 1-2.825-1.624c0-.5-.407-.905-.906-.905H8.353c-.5 0-.906.406-.906.905a1.883 1.883 0 0 1-2.824 1.625.903.903 0 0 0-1.23.33L1.996 7.142c-.248.429-.1.98.333 1.232.577.334.937.957.94 1.624a1.885 1.885 0 0 1-.943 1.632.895.895 0 0 0-.42.548.898.898 0 0 0 .091.684l1.393 2.404c.248.43.8.579 1.232.33a1.887 1.887 0 0 1 1.88-.003l.001.001a1.877 1.877 0 0 1 .94 1.627c0 .499.407.905.906.905h3.3c.498 0 .904-.406.904-.904a1.882 1.882 0 0 1 2.825-1.626c.43.248.982.1 1.23-.329l1.396-2.407a.905.905 0 0 0-.332-1.233Zm-1.98 2.728a3.149 3.149 0 0 0-2.831.16c-.861.5-1.43 1.383-1.54 2.36H8.675a3.134 3.134 0 0 0-1.54-2.36 3.144 3.144 0 0 0-2.828-.16L3.244 12.52a3.132 3.132 0 0 0 1.273-2.526 3.145 3.145 0 0 0-1.274-2.512l1.064-1.837a3.15 3.15 0 0 0 2.831-.162 3.138 3.138 0 0 0 1.539-2.357h2.645c.11.977.679 1.86 1.541 2.36a3.148 3.148 0 0 0 2.83.16l1.064 1.836a3.134 3.134 0 0 0-1.273 2.522c0 .995.48 1.93 1.273 2.517l-1.065 1.835Z"
}));

const SvgCog = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M19.14 12.936c.036-.3.06-.612.06-.936 0-.324-.024-.636-.072-.936l2.028-1.584a.496.496 0 0 0 .12-.612l-1.92-3.324a.488.488 0 0 0-.588-.216l-2.388.96a7.03 7.03 0 0 0-1.62-.936l-.36-2.544a.479.479 0 0 0-.48-.408h-3.84a.467.467 0 0 0-.468.408l-.36 2.544a7.219 7.219 0 0 0-1.62.936l-2.388-.96a.475.475 0 0 0-.588.216l-1.92 3.324a.465.465 0 0 0 .12.612l2.028 1.584c-.048.3-.084.624-.084.936 0 .312.024.636.072.936L2.844 14.52a.496.496 0 0 0-.12.612l1.92 3.324c.12.216.372.288.588.216l2.388-.96a7.03 7.03 0 0 0 1.62.936l.36 2.544c.048.24.24.408.48.408h3.84c.24 0 .444-.168.468-.408l.36-2.544a7.219 7.219 0 0 0 1.62-.936l2.388.96c.216.084.468 0 .588-.216l1.92-3.324a.465.465 0 0 0-.12-.612l-2.004-1.584ZM12 15.6A3.61 3.61 0 0 1 8.4 12c0-1.98 1.62-3.6 3.6-3.6s3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6Z"
}));

const SvgCollection = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M5 3c-1.093 0-2 .907-2 2v6h8V3H5Zm8 0v8h8V5c0-1.093-.907-2-2-2h-6ZM5 5h4v4H5V5Zm10 0h4v4h-4V5ZM3 13v6c0 1.093.907 2 2 2h6v-8H3Zm10 0v8h6c1.093 0 2-.907 2-2v-6h-8Zm-8 2h4v4H5v-4Zm10 0h4v4h-4v-4Z"
}));

const SvgContactDetails = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M21 5v14h2V5h-2Zm-4 14h2V5h-2v14ZM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1ZM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75ZM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17Z"
}));

const SvgCounter = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M22 4h-7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm-2 13h-2V9h-2V7h4v10ZM6 8.75H5a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4.5a1 1 0 0 0-1-1Z"
}), /*#__PURE__*/createElement("path", {
  d: "M9 4H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 10.25a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4.5a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v4.5Z"
}));

const SvgCrossCircleOutline = props => /*#__PURE__*/createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 13",
  fill: "currentColor"
}, props), /*#__PURE__*/createElement("path", {
  d: "M5.928.95A5.678 5.678 0 00.256 6.622a5.678 5.678 0 005.672 5.672A5.678 5.678 0 0011.6 6.622 5.678 5.678 0 005.928.95zm0 10.552a4.886 4.886 0 01-4.88-4.88c0-2.691 2.188-4.88 4.88-4.88 2.691 0 4.88 2.189 4.88 4.88a4.886 4.886 0 01-4.88 4.88zM7.79 5.32L6.487 6.622 7.79 7.925a.396.396 0 01-.56.56L5.929 7.182 4.625 8.485a.395.395 0 11-.56-.56l1.303-1.303-1.303-1.303a.396.396 0 01.56-.56l1.303 1.303L7.231 4.76a.396.396 0 11.56.56z"
}));

const SvgCustomerInsight = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M10 2a2 2 0 0 0-.64 3.893l.314 1.576A6.019 6.019 0 0 0 7.52 9.02l-1.523-.95a2 2 0 1 0-1.059 1.695l1.516.947a5.969 5.969 0 0 0 .658 5.76l-1.595 1.595A2.001 2.001 0 0 0 3 20a2 2 0 0 0 4 0 2 2 0 0 0-.07-.516l1.597-1.597a5.964 5.964 0 0 0 6.5.285l1.075 1.205a2 2 0 1 0 1.49-1.336l-1.03-1.152a5.953 5.953 0 0 0 .826-6.51l2.05-1.461a2 2 0 1 0-1.385-1.47L16.228 8.75A5.979 5.979 0 0 0 12 7c-.127 0-.252.012-.377.02L11.32 5.5A2 2 0 0 0 10 2Zm2 7c1.133 0 2 .867 2 2s-.867 2-2 2-2-.867-2-2 .867-2 2-2Zm0 5c1.639 0 3 .68 3 1.662V16H9v-.338C9 14.68 10.361 14 12 14Z"
}));

const SvgDataConfiguration = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h6.648l-.177-.31a2.245 2.245 0 0 1-.229-1.69H6v-4h6.65l.756-1.31c.163-.281.382-.51.631-.69H6v-4h12v2.006c.022 0 .044-.006.064-.006h1.872c.021 0 .041.006.062.006V4a2 2 0 0 0-2-2H6Zm0 2h12v4H6V4Zm12.064 10a.254.254 0 0 0-.252.225l-.117 1.011c-.484.168-.92.423-1.3.752l-.938-.406a.251.251 0 0 0-.318.107l-.938 1.622a.254.254 0 0 0 .069.33l.806.597A4.081 4.081 0 0 0 15 19c0 .26.028.513.076.76l-.805.6a.253.253 0 0 0-.068.33l.936 1.62a.253.253 0 0 0 .32.106l.936-.404c.378.328.816.584 1.3.752l.117 1.011a.252.252 0 0 0 .252.225h1.872a.254.254 0 0 0 .252-.225l.117-1.011c.484-.168.92-.423 1.3-.752l.938.406a.252.252 0 0 0 .318-.107l.938-1.622a.254.254 0 0 0-.069-.33l-.806-.6c.048-.246.076-.499.076-.759s-.028-.513-.076-.76l.805-.6a.253.253 0 0 0 .068-.33l-.936-1.62a.253.253 0 0 0-.32-.106l-.936.404a3.974 3.974 0 0 0-1.3-.752l-.117-1.011a.252.252 0 0 0-.252-.225h-1.872ZM19 17.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z"
}));

const SvgDownCarrot = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 15.6 5.765 9.3h12.47L12 15.6Z"
}));

const SvgDownload = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M10 2v9H6l6 6 6-6h-4V2h-4ZM2 20v2h20v-2H2Z"
}));

const SvgEditFullOutline = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 11",
  fill: "currentColor"
}, props), /*#__PURE__*/createElement("path", {
  d: "M10.018 7.044v1.583c0 1.276-.702 1.979-1.978 1.979H2.764c-1.276 0-1.979-.703-1.979-1.979V3.351c0-1.276.703-1.978 1.979-1.978h1.583a.396.396 0 010 .791H2.764c-.832 0-1.187.355-1.187 1.187v5.276c0 .832.355 1.187 1.187 1.187H8.04c.832 0 1.187-.355 1.187-1.187V7.044a.396.396 0 01.791 0zm1.056-4.719c0 .31-.122.6-.341.82l-4.73 4.707a.396.396 0 01-.278.116H3.819a.396.396 0 01-.396-.396V5.667c0-.105.041-.205.116-.28L8.247.659c.218-.22.509-.34.819-.34h.001c.31 0 .6.12.819.339l.849.849c.218.219.34.51.339.82zM8.893 3.86L7.532 2.498 4.215 5.83v1.347H5.56l3.332-3.318zm1.39-1.535a.365.365 0 00-.108-.26l-.849-.848a.364.364 0 00-.519 0l-.716.72 1.363 1.365.72-.718a.365.365 0 00.108-.259z"
}));

const SvgEditOutline = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m16.41 3.795-1.21-1.21c-.78-.78-2.05-.78-2.83 0l-2.68 2.68L1 13.955v4.04h4.04l8.74-8.74 2.63-2.63c.79-.78.79-2.05 0-2.83Zm-12.2 12.2H3v-1.21l8.66-8.66 1.21 1.21-8.66 8.66Zm4.79 2 4-4h6v4H9Z"
}));

const SvgEducation = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M16.037 7.211a.933.933 0 0 0-.662-.274h-.002c-1.484.003-2.938.045-4.422.51A3.574 3.574 0 0 0 9 8.95a3.571 3.571 0 0 0-1.95-1.502c-1.485-.466-2.94-.508-4.423-.51h-.002a.935.935 0 0 0-.938.938v6c0 .514.418.935.93.937 3.1.014 5.112.463 5.985 1.335.005.005.012.006.017.012a.552.552 0 0 0 .165.11.57.57 0 0 0 .43 0 .553.553 0 0 0 .166-.11c.005-.006.012-.007.017-.012.872-.873 2.886-1.321 5.986-1.335a.937.937 0 0 0 .928-.937v-6a.93.93 0 0 0-.274-.665Zm-13.224.852c1.328.006 2.626.059 3.9.458a2.442 2.442 0 0 1 1.724 2.334v3.81c-1.563-.816-3.85-.96-5.624-.976V8.063Zm12.374 5.626c-1.774.016-4.06.16-5.624.976v-3.81c0-1.072.692-2.01 1.724-2.334 1.274-.4 2.573-.452 3.9-.458v5.626ZM9 6.562a2.44 2.44 0 0 0 2.438-2.437A2.44 2.44 0 0 0 9 1.687a2.44 2.44 0 0 0-2.438 2.438A2.44 2.44 0 0 0 9 6.563Zm0-3.75a1.314 1.314 0 0 1 0 2.625 1.314 1.314 0 0 1-1.313-1.312c0-.724.59-1.313 1.313-1.313Z"
}));

const SvgError = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 15h-2v-2h2v2Zm0-4h-2V7h2v6Z"
}));

const ExclamationCircle = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M7.99998 1.33301C4.31798 1.33301 1.33331 4.31767 1.33331 7.99967C1.33331 11.6817 4.31798 14.6663 7.99998 14.6663C11.682 14.6663 14.6666 11.6817 14.6666 7.99967C14.6666 4.31767 11.682 1.33301 7.99998 1.33301ZM7.49998 4.99967C7.49998 4.72367 7.72398 4.49967 7.99998 4.49967C8.27598 4.49967 8.49998 4.72367 8.49998 4.99967V8.04704C8.49998 8.32304 8.27598 8.54704 7.99998 8.54704C7.72398 8.54704 7.49998 8.32304 7.49998 8.04704V4.99967ZM8.01333 10.9997C7.64533 10.9997 7.34324 10.701 7.34324 10.333C7.34324 9.96501 7.63865 9.66634 8.00665 9.66634H8.01333C8.38199 9.66634 8.67999 9.96501 8.67999 10.333C8.67999 10.701 8.38133 10.9997 8.01333 10.9997Z"
}));

const SvgExport = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  clipRule: "evenodd",
  d: "M2 8.5h5v2H4V16h12v-5.5h-3v-2h5V18H2V8.5Z"
}), /*#__PURE__*/createElement("path", {
  d: "M10 2 6 5.99h3V13h2V5.99h3L10 2Z"
}));

const SvgEyeHide = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M4.207 2.793 2.793 4.207 5.076 6.49C2.2 8.838 1 12 1 12s3 8 11 8c2.076 0 3.806-.545 5.242-1.344l2.551 2.551 1.414-1.414-17-17ZM12 4c-1.212 0-2.294.2-3.283.512l2.56 2.56C11.514 7.037 11.753 7 12 7a5 5 0 0 1 5 5c0 .247-.037.486-.072.723l3.43 3.43C22.203 14.102 23 12 23 12s-3-8-11-8ZM7.834 9.248l1.463 1.463C9.108 11.1 9 11.537 9 12a3 3 0 0 0 3 3c.463 0 .9-.108 1.29-.297l1.462 1.463A4.96 4.96 0 0 1 12 17a5 5 0 0 1-5-5c0-1.02.31-1.962.834-2.752Z"
}));

const SvgEyeOpenOutline = props => /*#__PURE__*/createElement("svg", _extends({
  width: "18",
  height: "13",
  viewBox: "0 0 18 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("g", {
  id: "Group 427319083"
}, /*#__PURE__*/createElement("path", {
  id: "Vector",
  d: "M8.99893 1.50094C6.13241 1.44781 3.16775 3.64894 1.30391 5.9032C1.10827 6.14185 1 6.45167 1 6.77286C1 7.09406 1.10827 7.40388 1.30391 7.64253C3.12722 9.84913 6.08334 12.101 8.99893 12.0471C11.9145 12.101 14.8714 9.84913 16.6961 7.64253C16.8917 7.40388 17 7.09406 17 6.77286C17 6.45167 16.8917 6.14185 16.6961 5.9032C14.8301 3.64894 11.8655 1.44781 8.99893 1.50094Z",
  stroke: "#0851DF",
  strokeWidth: "1.06",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  id: "Vector_2",
  d: "M11.6655 6.77443C11.6654 7.35393 11.5089 7.92037 11.2157 8.40212C10.9226 8.88388 10.5061 9.25932 10.0188 9.48098C9.53154 9.70264 8.99537 9.76055 8.47813 9.6474C7.96089 9.53426 7.4858 9.25512 7.11292 8.8453C6.74005 8.43548 6.48614 7.91338 6.3833 7.34501C6.28047 6.77664 6.33332 6.18752 6.53518 5.65215C6.73703 5.11679 7.07883 4.65921 7.51735 4.33727C7.95587 4.01534 8.47142 3.84351 8.99882 3.84351C9.3491 3.8434 9.69597 3.91915 10.0196 4.06642C10.3432 4.21368 10.6373 4.42958 10.8849 4.70177C11.1326 4.97397 11.329 5.29712 11.4629 5.65275C11.5969 6.00839 11.6657 6.38955 11.6655 6.77443Z",
  stroke: "#0851DF",
  strokeWidth: "1.06",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

const SvgEyeOpen = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 4C4 4 1 12 1 12s3 8 11 8 11-8 11-8-3-8-11-8Zm0 3a5 5 0 1 1-.001 10.001A5 5 0 0 1 12 7Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
}));

const SvgFilter = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M10 18h4v-2h-4v2ZM3 6v2h18V6H3Zm3 7h12v-2H6v2Z"
}));

const SvgGallery = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M18 2v12H6V2h12Zm0-2H6C4.9 0 4 .9 4 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2ZM9.5 9.67l1.69 2.26 2.48-3.1L17 13H7l2.5-3.33ZM0 4v14c0 1.1.9 2 2 2h14v-2H2V4H0Z"
}));

const SvgGantt = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M17.5 17.292H3.75c-1.174 0-1.875-.701-1.875-1.875V3.333a.625.625 0 0 1 1.25 0v12.084c0 .49.134.625.625.625H17.5a.625.625 0 0 1 0 1.25ZM12.292 5.833a.625.625 0 0 0-.625-.625H5.833a.625.625 0 0 0 0 1.25h5.834c.345 0 .625-.28.625-.625Zm-1.667 3.334A.625.625 0 0 0 10 8.542H5.833a.625.625 0 0 0 0 1.25H10c.345 0 .625-.28.625-.625Zm4.167 3.333a.625.625 0 0 0-.625-.625H5.833a.625.625 0 0 0 0 1.25h8.334c.345 0 .625-.28.625-.625Z"
}));

const SvgGenerate = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M8 2 2 8l3.764 3.764 1.414-1.416L4.828 8 8 4.828l2.35 2.35 1.414-1.414L8 2Zm10.414 0a.996.996 0 0 0-.707.293L16 4l4 4 1.707-1.707a.999.999 0 0 0 0-1.414l-2.586-2.586A.996.996 0 0 0 18.414 2ZM14.5 5.5 3 17v4h4L18.5 9.5l-4-4Zm3.736 6.736-1.414 1.414 2.35 2.35L16 19.172l-2.348-2.35-1.416 1.414L16 22l6-6-3.764-3.764Z"
}));

const SvgGlobe = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M6.83 12.75c.15 3.08 1.19 6.22 3 9.01-4.24-.94-7.47-4.57-7.8-9.01h4.8Zm3-10.51c-4.24.94-7.47 4.57-7.8 9.01h4.8c.15-3.08 1.19-6.22 3-9.01ZM12.2 2h-.4l-.3.43c-1.9 2.7-3.01 5.8-3.17 8.82h7.34c-.16-3.02-1.27-6.12-3.17-8.82L12.2 2ZM8.33 12.75c.16 3.02 1.27 6.12 3.17 8.82l.3.43h.4l.3-.43c1.9-2.7 3.01-5.8 3.17-8.82H8.33Zm8.84 0c-.15 3.08-1.19 6.22-3 9.01 4.24-.94 7.47-4.57 7.8-9.01h-4.8Zm4.8-1.5c-.33-4.44-3.56-8.07-7.8-9.01 1.81 2.79 2.85 5.93 3 9.01h4.8Z"
}));

const SvgHelpOutline = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M11 18h2v-2h-2v2Zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4Z"
}));

const SvgHouse = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2.1 1 12h3v9h6v-7h4v7h6v-9h3L12 2.1Z"
}));

const SvgIndeterminateCheckbox = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.25 13.5H4.5v-3h15.75v3Z"
}));

const SvgInfoFilled = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 15h-2v-6h2v6Zm0-8h-2V7h2v2Z"
}));

const SvgInfoStroke = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2C6.489 2 2 6.489 2 12s4.489 10 10 10 10-4.489 10-10S17.511 2 12 2Zm0 2c4.43 0 8 3.57 8 8s-3.57 8-8 8-8-3.57-8-8 3.57-8 8-8Zm-1 3v2h2V7h-2Zm0 4v6h2v-6h-2Z"
}));

const SvgItemsList = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M3 9h14V7H3v2Zm0 4h14v-2H3v2Zm0 4h14v-2H3v2Zm16 0h2v-2h-2v2Zm0-10v2h2V7h-2Zm0 6h2v-2h-2v2Z"
}));

const SvgKey = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M7 5a7 7 0 1 0 6.707 9H18v3h4v-3h2v-4H13.707A7 7 0 0 0 7 5Zm0 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
}));

const SvgLanguage = props => /*#__PURE__*/createElement("svg", _extends({
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/createElement("path", {
  d: "M4.002 3c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h14l4 4-.012-18.002a2.002 2.002 0 0 0-2-1.998H4.002zm0 2h15.99l.006 13.17L18.83 17H4.002V5zM15.41 6.014v1.025H13v1.313h4.715c0 2.53-2.09 4.07-2.09 4.07s-1.42-.794-1.42-2.402H13c0 1.968 1.26 2.933 1.26 2.933s-.557.703-1.26.703V15c1.374 0 2.57-1.11 2.57-1.11S16.43 15 18.01 15v-1.344c-.596 0-.94-.674-.94-.674S19 11.21 19 8.352V7.039h-2.41V6.014h-1.18zM7.79 7 5 15h1.64l.52-1.656h2.682L10.359 15H12L9.21 7H7.79zm.71 2.031.93 3H7.57l.93-3z"
}));

const SvgLeftCarrot = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m7.8 12 6.3-6.235v12.47L7.8 12Z"
}));

const SvgLink = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m14.97 8.599-2.13 2.13a3.938 3.938 0 0 1-5.57 0A.843.843 0 1 1 8.46 9.541a2.264 2.264 0 0 0 3.185 0l2.13-2.13a2.252 2.252 0 1 0-3.185-3.185l-.675.682A.845.845 0 0 1 8.72 3.712L9.4 3.03A3.938 3.938 0 1 1 14.97 8.6Zm-6.884 4.493-.675.682a2.252 2.252 0 1 1-3.185-3.185l2.13-2.13a2.264 2.264 0 0 1 3.185 0A.844.844 0 0 0 10.73 7.27a3.931 3.931 0 0 0-5.57 0L3.03 9.4a3.938 3.938 0 0 0 5.57 5.57l.681-.683a.845.845 0 1 0-1.195-1.195Z"
}));

const SvgLinksConnected = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14",
  fill: "currentColor"
}, props), /*#__PURE__*/createElement("path", {
  d: "M5.029 2.422c0-.246-.2-.445-.445-.445H2.308c-.245 0-.445.199-.445.445v2.275c0 .246.2.445.445.445h2.276c.246 0 .445-.199.445-.445V2.422zM11.994 2.422c0-.246-.2-.445-.445-.445H9.273c-.246 0-.445.199-.445.445v2.275c0 .246.2.445.445.445h2.276c.246 0 .445-.199.445-.445V2.422zM5.029 9.386c0-.245-.2-.445-.445-.445H2.308c-.245 0-.445.2-.445.445v2.276c0 .246.2.445.445.445h2.276c.246 0 .445-.2.445-.445V9.386zM3.762 5.143V8.94M10.094 5.143v6.964M8.828 5.143L5.03 8.94M8.195 10.207l1.9 1.9 1.9-1.9",
  stroke: "currentColor",
  strokeWidth: 0.886,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const SvgLoading = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M6.539 7.858c2.054-2.714 5.865-3.542 8.886-1.797 3.022 1.744 4.21 5.458 2.886 8.594l1.5.866c1.788-3.963.313-8.727-3.529-10.945S7.577 3.462 5.04 6.993l1.499.865ZM5.212 12.93a6.827 6.827 0 0 1 .47-3.587l-1.5-.866a8.497 8.497 0 0 0-.63 4.898l1.66-.445Zm2.265 4.219a6.88 6.88 0 0 1-1.822-2.563l-1.66.444a8.543 8.543 0 0 0 2.512 3.55l.97-1.431Zm3.692 1.648a6.82 6.82 0 0 1-2.27-.688l-.967 1.425a8.512 8.512 0 0 0 3.246.981l-.01-1.718Zm3.372-.45a6.922 6.922 0 0 1-1.657.44l.008 1.72a8.75 8.75 0 0 0 2.488-.647l-.84-1.513Z"
}));

const SvgLocationMap = props => /*#__PURE__*/createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 10.751a2.42 2.42 0 0 0 2.417-2.417A2.42 2.42 0 0 0 12 5.917a2.42 2.42 0 0 0-2.417 2.417A2.42 2.42 0 0 0 12 10.751Zm0-3.334a.918.918 0 0 1 0 1.834.918.918 0 0 1 0-1.834Zm8.964-.041c-.508-.316-1.162-.335-1.75-.046l-1.153.577c-.221-3.155-2.852-5.657-6.062-5.657-3.125 0-5.704 2.369-6.043 5.405L3.655 8.81a2.536 2.536 0 0 0-1.406 2.28v8.41c0 .613.31 1.17.828 1.494a1.749 1.749 0 0 0 1.709.08l3.403-1.712a.568.568 0 0 1 .249-.06.545.545 0 0 1 .249.034l6.091 2.277c.24.093.483.139.684.139.049 0 .095-.002.138-.008.283 0 .561-.066.867-.21l3.879-1.95a2.538 2.538 0 0 0 1.404-2.278V8.89c0-.652-.286-1.204-.786-1.515ZM12 3.75a4.59 4.59 0 0 1 4.583 4.584c0 .199-.018.391-.045.58v.001c-.341 2.387-2.728 3.991-4.538 5.188-1.954-1.291-4.583-3.056-4.583-5.769A4.59 4.59 0 0 1 12 3.75ZM4.119 19.731a.247.247 0 0 1-.249-.011.25.25 0 0 1-.12-.22v-8.41c0-.4.222-.76.579-.94l1.68-.842c.219 1.258.843 2.315 1.641 3.212v5.452c-.039.016-.077.023-.117.042L4.119 19.73Zm5.102-1.797c-.023-.009-.048-.011-.071-.019V13.92c.714.568 1.447 1.053 2.082 1.473l.352.233a.75.75 0 0 0 .832 0l.352-.233c.635-.419 1.368-.905 2.082-1.473v6.118l-5.629-2.104Zm11.029-.628c0 .399-.222.759-.578.938l-3.322 1.67V12.52c.725-.814 1.311-1.76 1.577-2.87l1.954-.977c.128-.063.238-.057.291-.024.07.044.078.184.078.242v8.415Z"
}));

const SvgLock = props => /*#__PURE__*/createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 1C8.676 1 6 3.676 6 7v1H4v14h16V8h-2V7c0-3.324-2.676-6-6-6zm0 2c2.276 0 4 1.724 4 4v1H8V7c0-2.276 1.724-4 4-4zm0 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
}));

const SvgMailStatistics = props => /*#__PURE__*/createElement("svg", _extends({
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/createElement("path", {
  d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10v-2H4V9.002L12 14l8-4.998V13h2V6a2 2 0 0 0-2-2H4zm0 2h16v1.002L12 12 4 7.002V6zm15 9v7h-1v-4h-2v6h8v-7h-2v5h-1v-7h-2z"
}));

const SvgManageTemplates = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  clipRule: "evenodd",
  d: "M3 3v6h18V3H3Zm16 2H5v2h14V5ZM3 11v10h8V11H3Zm6 2H5v6h4v-6Z"
}), /*#__PURE__*/createElement("path", {
  d: "M21 11h-8v2h8v-2Zm-8 4h8v2h-8v-2Zm8 4h-8v2h8v-2Z"
}));

const SvgMapControlMinus = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M15 2H1a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2Z",
  fill: "#25314C"
}));

const SvgMapControlPlus = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M15 6.575H9v-5.55C9 .515 8.552.1 8 .1s-1 .414-1 .925v5.55H1c-.552 0-1 .414-1 .925 0 .51.448.925 1 .925h6v5.55c0 .51.448.925 1 .925s1-.414 1-.925v-5.55h6c.552 0 1-.414 1-.925 0-.51-.448-.925-1-.925Z",
  fill: "#051336"
}));

const SvgMapCreateShape = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M17 2.684V1.79C17 .652 16.348 0 15.21 0h-.894c-1.059 0-1.69.57-1.773 1.566H4.457C4.374.57 3.743 0 2.684 0H1.79C.652 0 0 .652 0 1.79v.894c0 1.059.57 1.69 1.566 1.773v8.086C.57 12.626 0 13.257 0 14.316v.894C0 16.348.652 17 1.79 17h.894c1.059 0 1.69-.57 1.773-1.566h8.086c.083.995.714 1.566 1.773 1.566h.894c1.138 0 1.79-.652 1.79-1.79v-.894c0-1.059-.57-1.69-1.566-1.773V4.457C16.43 4.374 17 3.743 17 2.684Zm-4.457 11.409H4.457c-.077-.92-.628-1.472-1.549-1.549V4.458c.92-.077 1.472-.628 1.549-1.55h8.086c.077.922.628 1.473 1.549 1.55v8.086c-.92.077-1.472.628-1.549 1.549Z",
  fill: "#051336"
}));

const SvgMapCrosshairs = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M18.75 8.757h-2.04l.001.013c-.343-3.19-2.946-5.723-6.224-6.056h.013V.73c0-.4-.34-.73-.75-.73S9 .33 9 .73v1.985l.013-.001C5.735 3.047 3.132 5.58 2.789 8.77l.001-.013H.75c-.41 0-.75.33-.75.73 0 .398.34.73.75.73h2.04l-.001-.014c.343 3.189 2.947 5.722 6.224 6.056H9v1.984c0 .399.34.73.75.73s.75-.331.75-.73v-1.985l-.013.001c3.278-.334 5.881-2.867 6.224-6.056l-.001.013h2.04c.41 0 .75-.33.75-.73 0-.399-.34-.73-.75-.73Zm-9 3.162c-1.381 0-2.5-1.089-2.5-2.433 0-1.343 1.119-2.432 2.5-2.432s2.5 1.089 2.5 2.432c0 1.344-1.119 2.433-2.5 2.433Z",
  fill: "#051336"
}));

const SvgMathDivide = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 11v2h16v-2H4Zm8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
}));

const SvgMathExponent = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m3.5 8 4.6 6-4.6 6h2.8l3.2-4.1 3.2 4.1h2.8l-4.6-6 4.6-6h-2.8l-3.2 4.1L6.3 8H3.5ZM18.5 7.6 19.7 4h1.8L19 11l-.1.3c-.5 1.2-1.6 1.7-3.3 1.6v-1.3c1.8 0 2.1-1.1 2.1-1.3l.1-.2-2.2-6h1.8l1.1 3.5Z"
}));

const SvgMathMinus = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M3 11v2h18v-2H3Z"
}));

const SvgMathModulo = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M7.5 4A3.515 3.515 0 0 0 4 7.5C4 9.421 5.579 11 7.5 11S11 9.421 11 7.5 9.421 4 7.5 4Zm8.686.418-10 14 1.628 1.164 10-14-1.628-1.164ZM7.5 6C8.34 6 9 6.66 9 7.5S8.34 9 7.5 9 6 8.34 6 7.5 6.66 6 7.5 6Zm9 7a3.515 3.515 0 0 0-3.5 3.5c0 1.921 1.579 3.5 3.5 3.5s3.5-1.579 3.5-3.5-1.579-3.5-3.5-3.5Zm0 2c.84 0 1.5.66 1.5 1.5s-.66 1.5-1.5 1.5-1.5-.66-1.5-1.5.66-1.5 1.5-1.5Z"
}));

const SvgMathMultiply = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M5.707 4.293 4.293 5.707 10.586 12l-6.293 6.293 1.414 1.414L12 13.414l6.293 6.293 1.414-1.414L13.414 12l6.293-6.293-1.414-1.414L12 10.586 5.707 4.293Z"
}));

const SvgMathPlus = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M11 3v8H3v2h8v8h2v-8h8v-2h-8V3h-2Z"
}));

const SvgMenu = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M3 18h18v-2H3v2Zm0-5h18v-2H3v2Zm0-7v2h18V6H3Z"
}));

const SvgMerchant = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("g", {
  clipPath: "url(#merchant_svg__a)"
}, /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.179 1.592c-.71 0-1.357.413-1.654 1.058l-1.35 2.926a.605.605 0 0 0-.062.263v.61a3.036 3.036 0 0 0 5.464 1.822 3.031 3.031 0 0 0 2.429 1.214c.993 0 1.875-.477 2.429-1.214a3.036 3.036 0 0 0 5.464-1.822v-.622a.605.605 0 0 0-.061-.25l-1.35-2.927a1.822 1.822 0 0 0-1.654-1.058H4.179Zm-2.459 8.71a4.532 4.532 0 0 0 2.429.701c.893 0 1.726-.258 2.428-.701a4.534 4.534 0 0 0 2.429.701c.893 0 1.726-.258 2.429-.701a4.535 4.535 0 0 0 2.428.701c.893 0 1.726-.257 2.429-.701v5.862a1.215 1.215 0 0 1-1.215 1.214h-3.642v-2.39a2.429 2.429 0 0 0-4.858 0v2.39H2.935a1.214 1.214 0 0 1-1.215-1.214v-5.862Z"
})), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
  id: "merchant_svg__a"
}, /*#__PURE__*/createElement("path", {
  transform: "translate(.506 .985)",
  d: "M0 0h17v17H0z"
}))));

const SvgMoreCircle = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M9 17.063C4.554 17.063.937 13.445.937 9 .938 4.554 4.554.937 9 .937c4.446 0 8.063 3.617 8.063 8.063 0 4.446-3.617 8.063-8.063 8.063Zm0-15A6.945 6.945 0 0 0 2.062 9 6.945 6.945 0 0 0 9 15.938 6.945 6.945 0 0 0 15.938 9 6.945 6.945 0 0 0 9 2.062ZM6.953 9a.938.938 0 0 0-.938-.938h-.007A.935.935 0 0 0 5.074 9a.94.94 0 0 0 1.879 0Zm3 0a.938.938 0 0 0-.938-.938h-.007A.935.935 0 0 0 8.074 9a.94.94 0 0 0 1.879 0Zm3 0a.938.938 0 0 0-.938-.938h-.008a.935.935 0 0 0-.933.938.94.94 0 0 0 1.879 0Z"
}));

const SvgMoreHori = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M16 12c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2Zm-2 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2Zm-6 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2Z"
}));

const SvgMoreVert = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12.02 6a2.005 2.005 0 0 1-2.005-2c0-1.104.89-2 1.995-2h.01a2 2 0 0 1 0 4Zm2 6a2 2 0 0 0-2-2h-.01a1.996 1.996 0 0 0-1.995 2c0 1.104.9 2 2.005 2a2 2 0 0 0 2-2Zm0 8a2 2 0 0 0-2-2h-.01a1.996 1.996 0 0 0-1.995 2c0 1.104.9 2 2.005 2a2 2 0 0 0 2-2Z"
}));

const SvgNodeConnect = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M6 2C4.346 2 3 3.346 3 5c0 1.302.839 2.402 2 2.816V15c0 2.75 2.25 5 5 5h1v2l3-3-3-3v2h-1c-1.668 0-3-1.331-3-3V7.816A2.997 2.997 0 0 0 9 5c0-1.654-1.346-3-3-3Zm7 0-3 3 3 3V6h1c1.668 0 3 1.332 3 3v7.184A2.997 2.997 0 0 0 15 19c0 1.654 1.346 3 3 3s3-1.346 3-3a2.997 2.997 0 0 0-2-2.816V9c0-2.75-2.25-5-5-5h-1V2Z"
}));

const SvgNotesList = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 11",
  fill: "currentColor"
}, props), /*#__PURE__*/createElement("path", {
  d: "M7.567.424H2.291C1.015.424.313 1.127.313 2.402v6.332c0 1.275.702 1.978 1.978 1.978h5.276c1.276 0 1.979-.703 1.979-1.978V2.402c0-1.275-.703-1.978-1.979-1.978zm1.187 8.31c0 .832-.355 1.187-1.187 1.187H2.291c-.832 0-1.187-.355-1.187-1.187V2.402c0-.832.355-1.187 1.187-1.187h5.276c.832 0 1.187.355 1.187 1.187v6.332zm-5.54-5.276a.396.396 0 11-.791 0 .396.396 0 01.791 0zm0 2.11a.396.396 0 11-.791 0 .396.396 0 01.791 0zm0 2.11a.396.396 0 11-.791 0 .396.396 0 01.791 0zm4.221-4.22a.396.396 0 01-.395.395H4.402a.396.396 0 010-.791H7.04c.218 0 .395.177.395.396zm0 2.11a.396.396 0 01-.395.396H4.402a.396.396 0 010-.792H7.04c.218 0 .395.178.395.396zm0 2.11a.396.396 0 01-.395.396H4.402a.396.396 0 010-.791H7.04c.218 0 .395.177.395.396z"
}));

const SvgOpenInNew = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7ZM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7Z"
}));

const SvgPencil = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z"
}));

const SvgPeople = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3Zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3Zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5Zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5Z"
}));

const SvgPersonAdd = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6Zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4Z"
}));

const SvgPersonCog = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M8.34 8.958a3.546 3.546 0 0 0 3.543-3.541A3.546 3.546 0 0 0 8.34 1.875a3.546 3.546 0 0 0-3.542 3.542 3.546 3.546 0 0 0 3.542 3.541Zm0-5.833a2.294 2.294 0 0 1 2.293 2.292A2.294 2.294 0 0 1 8.34 7.708a2.294 2.294 0 0 1-2.292-2.291 2.294 2.294 0 0 1 2.292-2.292Zm2.394 8.383c-.21-.034-.45-.05-.734-.05H6.667c-3.286 0-3.542 2.724-3.542 3.559 0 1.302.56 1.858 1.875 1.858h4.167a.625.625 0 0 1 0 1.25H5c-2.015 0-3.125-1.104-3.125-3.108 0-2.219 1.255-4.809 4.792-4.809H10c.35 0 .656.022.932.067.341.054.574.375.518.716a.63.63 0 0 1-.716.517Zm7.793 3.074.111-.062a.624.624 0 0 0 .232-.865l-.763-1.282a.625.625 0 0 0-.843-.225l-.11.061a.552.552 0 0 1-.537 0 .483.483 0 0 1-.253-.416.752.752 0 0 0-.753-.75h-1.27a.752.752 0 0 0-.753.75c0 .17-.097.329-.253.416a.55.55 0 0 1-.537 0 .759.759 0 0 0-1.015.27l-.636 1.068a.753.753 0 0 0-.083.572c.051.194.18.362.355.461.006.002.011.006.017.01.149.088.24.244.24.41.002.17-.095.332-.256.422a.743.743 0 0 0-.275 1.032l.638 1.069a.75.75 0 0 0 1.016.269.55.55 0 0 1 .536 0 .481.481 0 0 1 .252.417c0 .413.337.75.752.75h1.273a.751.751 0 0 0 .752-.75c0-.17.097-.329.253-.416a.549.549 0 0 1 .536 0 .759.759 0 0 0 1.016-.27l.64-1.074a.743.743 0 0 0-.277-1.028l-.015-.008a.484.484 0 0 1-.241-.411.49.49 0 0 1 .252-.42Zm-1.02 1.609-.197.332a1.812 1.812 0 0 0-1.305.18 1.746 1.746 0 0 0-.813 1.005h-.43a1.745 1.745 0 0 0-.813-1.005 1.804 1.804 0 0 0-1.305-.18l-.197-.331a1.72 1.72 0 0 0 .481-1.196c0-.446-.178-.87-.481-1.187l.197-.332c.437.105.907.046 1.305-.18.397-.223.684-.586.813-1.005h.43c.128.418.416.781.813 1.005.4.226.87.285 1.305.18l.198.332c-.305.32-.482.745-.481 1.193 0 .446.176.87.48 1.189ZM15.85 15c0 .46-.373.833-.833.833a.837.837 0 0 1-.838-.833c0-.46.37-.833.83-.833h.008c.46 0 .833.373.833.833Z"
}));

const SvgPerson = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4Z"
}));

const SvgPhoneSetup = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M7.5 1A2.5 2.5 0 0 0 5 3.5v17A2.5 2.5 0 0 0 7.5 23h9a2.5 2.5 0 0 0 2.5-2.5V18H7V4h12v-.5A2.5 2.5 0 0 0 16.5 1h-9Zm9.732 5a.254.254 0 0 0-.252.225l-.117 1.011c-.484.168-.92.423-1.3.752l-.936-.406a.254.254 0 0 0-.32.107l-.938 1.622a.254.254 0 0 0 .069.33l.806.597a4.081 4.081 0 0 0-.076.762c0 .26.028.513.076.76l-.804.6a.253.253 0 0 0-.069.33l.936 1.62a.253.253 0 0 0 .32.106l.935-.404c.38.328.817.584 1.301.752l.117 1.011a.252.252 0 0 0 .252.225h1.872a.254.254 0 0 0 .252-.225l.117-1.011c.484-.168.92-.423 1.3-.752l.938.406a.252.252 0 0 0 .318-.107l.938-1.621a.254.254 0 0 0-.069-.33l-.806-.6c.048-.247.076-.5.076-.76s-.028-.513-.076-.76l.805-.6a.253.253 0 0 0 .068-.33l-.936-1.62a.253.253 0 0 0-.32-.106l-.936.404a3.974 3.974 0 0 0-1.3-.752l-.117-1.011A.252.252 0 0 0 19.102 6h-1.87Zm.936 3.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5ZM12 18.875a1.124 1.124 0 1 1 .002 2.248A1.124 1.124 0 0 1 12 18.875Z"
}));

const Picture = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 56 56",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M42 7.58301H14C8.358 7.58301 5.25 10.691 5.25 16.333V39.6663C5.25 45.3083 8.358 48.4163 14 48.4163H42C47.642 48.4163 50.75 45.3083 50.75 39.6663V16.333C50.75 10.691 47.642 7.58301 42 7.58301ZM14 11.083H42C45.6797 11.083 47.25 12.6533 47.25 16.333V33.2497L36.6566 22.6563C35.7466 21.7463 34.2534 21.7463 33.3434 22.6563L21.8166 34.1828C21.3733 34.6261 20.6267 34.6261 20.1834 34.1828L17.9899 31.9896C17.0799 31.0796 15.5868 31.0796 14.6768 31.9896L8.75 37.9163V16.333C8.75 12.6533 10.3203 11.083 14 11.083ZM15.75 20.9997C15.75 19.3897 17.0428 18.083 18.6504 18.083H18.6738C20.2815 18.083 21.5856 19.3897 21.5856 20.9997C21.5856 22.6097 20.2838 23.9163 18.6738 23.9163C17.0661 23.9163 15.75 22.6097 15.75 20.9997Z"
}));

const SvgPushNotification = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M7 1a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3h-2v2H7V4h10v2h2V3a2 2 0 0 0-2-2H7Zm8 7c-1.1 0-2 .9-2 2v8l2-2h6c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2h-6Z"
}));

const SvgPuzzle = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M18.5 9H17a2 2 0 1 0 0 4h1.5a.5.5 0 0 1 .5.5V16a2 2 0 0 1-2 2h-3.5a.5.5 0 0 1-.5-.5V16a2 2 0 1 0-4 0v1.5a.5.5 0 0 1-.5.5H6a2 2 0 0 1-2-2v-2.5a.5.5 0 0 0-.5-.5H2a2 2 0 1 1 0-4h1.5a.5.5 0 0 0 .5-.5V6a2 2 0 0 1 2-2h2.5a.5.5 0 0 0 .5-.5V2a2 2 0 1 1 4 0v1.5a.5.5 0 0 0 .5.5H17a2 2 0 0 1 2 2v2.5a.5.5 0 0 1-.5.5Z"
}));

const SvgRemove = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.24 12.83-1.41 1.41L12 13.41l-2.83 2.83-1.41-1.41L10.59 12 7.76 9.17l1.41-1.41L12 10.59l2.83-2.83 1.41 1.41L13.41 12l2.83 2.83Z"
}));

const SvgReplay = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8Z"
}));

const SvgReport = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M22 3H1v2h1v13h9v3h2v-3h9V5h1V3h-1Zm-4.457 8.957L15 9.414l-4 4-2-2-2.543 2.543-1.414-1.414L9 8.586l2 2 4-4 3.957 3.957-1.414 1.414Z"
}));

const SvgReset = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 21 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M11.813 6.625a5.688 5.688 0 0 1 0 11.375H8.75v-1.75h3.063a3.921 3.921 0 0 0 3.937-3.938 3.921 3.921 0 0 0-3.938-3.937h-4.96l2.694 2.704-1.233 1.233L3.5 7.5l4.813-4.813 1.242 1.234-2.704 2.704h4.962ZM5.25 16.25H7V18H5.25v-1.75Z"
}));

const SvgRightCarrot = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m16.2 12-6.3 6.235V5.765L16.2 12Z"
}));

const SvgRocket = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M15.25 5.78a3 3 0 0 0-3 2.99 3 3 0 0 0 6 0 3 3 0 0 0-3-2.99Zm0 4.49c-.83 0-1.5-.67-1.5-1.49s.67-1.49 1.5-1.49 1.5.67 1.5 1.49-.67 1.49-1.5 1.49Zm6.18-7.2a.737.737 0 0 0-.55-.54c-.24-.06-6.02-1.41-9.79 2.36-.51.51-.94 1.01-1.34 1.49l-2.09.45a5.743 5.743 0 0 0-4.4 3.52l-.96 2.39c-.1.26-.06.55.12.76.14.17.35.26.57.26.05 0 .11 0 .16-.02l3.37-.75c-.05.17-.1.34-.16.52-.13.45-.02.93.31 1.25l2.52 2.52c.24.24.56.37.89.37.11 0 .22-.01.32-.04.21-.06.41-.11.61-.17l-.76 3.39c-.06.27.03.55.25.73.14.12.31.18.49.18.09 0 .19-.02.28-.05l2.39-.96c1.86-.74 3.22-2.42 3.53-4.35l.44-2.02c.5-.41 1.01-.85 1.55-1.39 3.77-3.78 2.31-9.66 2.25-9.91v.01Zm-17.2 8.91.43-1.07c.54-1.37 1.79-2.36 3.28-2.6l.55-.12c-.25.42-.46.84-.66 1.28l-.03.06c-.27.58-.51 1.19-.73 1.82l-2.84.63Zm5.93 4.15-2.31-2.31c.3-1.01.59-1.89.91-2.71l4.19 4.18c-.82.3-1.72.56-2.78.85l-.01-.01Zm5.56-.02a4.195 4.195 0 0 1-2.61 3.23l-1.07.43.63-2.81c.67-.21 1.29-.45 1.88-.7.01 0 .03-.01.04-.02.43-.19.84-.4 1.24-.63l-.11.5Zm-1.28-1.45L9.4 9.63c.63-1.23 1.45-2.38 2.75-3.68 2.61-2.61 6.58-2.26 7.92-2.05.24 1.35.67 5.4-1.95 8.02-1.3 1.3-2.42 2.12-3.68 2.74Z"
}));

const SvgSearch = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
}));

const SvgSecurity = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M11.77 7a.75.75 0 0 1-.75.75.755.755 0 0 1-.755-.75c0-.414.331-.75.745-.75h.01a.75.75 0 0 1 .75.75ZM18 3.375v11.25C18 16.875 16.875 18 14.625 18H3.375C1.125 18 0 16.875 0 14.625V3.375C0 1.125 1.125 0 3.375 0h11.25C16.875 0 18 1.125 18 3.375ZM13.5 7.5c0-1.655-1.345-3-3-3a3.002 3.002 0 0 0-2.87 3.87L4.5 11.5v2h2V12H8l1.63-1.63A3.002 3.002 0 0 0 13.5 7.5Z"
}));

const SvgSend = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M14.451 2.049a1.854 1.854 0 0 0-1.774-.492L3.935 3.743A2.515 2.515 0 0 0 2 6.238 2.516 2.516 0 0 0 3.97 8.706l3.097.729.729 3.096a2.516 2.516 0 0 0 2.468 1.97h.018a2.515 2.515 0 0 0 2.476-1.935l2.186-8.742a1.856 1.856 0 0 0-.493-1.775Zm-.478 1.532-2.186 8.742c-.219.876-.926 1.182-1.518 1.177-.563-.004-1.293-.32-1.5-1.197l-.736-3.128 2.82-2.82a.5.5 0 0 0-.707-.708L7.325 8.468l-3.128-.736C3.32 7.525 3.003 6.794 3 6.231c-.004-.564.302-1.3 1.177-1.518l8.742-2.186a.862.862 0 0 1 .825.229.862.862 0 0 1 .23.825Z"
}));

const SvgSmiley = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M10 18.958c-4.942 0-8.958-4.016-8.958-8.958S5.058 1.042 10 1.042 18.958 5.058 18.958 10c0 4.941-4.016 8.958-8.958 8.958Zm0-16.666C5.75 2.291 2.292 5.75 2.292 10S5.75 17.708 10 17.708 17.708 14.25 17.708 10 14.25 2.292 10 2.292Zm3.542 6.041c0-.841-.442-1.458-1.042-1.458-.6 0-1.042.617-1.042 1.458 0 .842.442 1.458 1.042 1.458.6 0 1.042-.616 1.042-1.458Zm-5 0c0-.841-.442-1.458-1.042-1.458-.6 0-1.042.617-1.042 1.458 0 .842.442 1.458 1.042 1.458.6 0 1.042-.616 1.042-1.458Zm5.291 4.542a.624.624 0 1 0-.991-.758 3.536 3.536 0 0 1-2.834 1.416 3.544 3.544 0 0 1-2.825-1.416.625.625 0 0 0-1 .75 4.811 4.811 0 0 0 3.825 1.916c1.492 0 2.909-.7 3.834-1.916l-.009.008Z"
}));

const SvgSpeedo = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m18.53 10.25-6.967 1.802-.059.015.001.003A1.993 1.993 0 0 0 10 14a2 2 0 0 0 2 2c.509 0 .969-.196 1.322-.51l.001.002 5.207-5.242ZM19 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm1-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM8.5 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM12 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3.438 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
}), /*#__PURE__*/createElement("path", {
  d: "M9 19.001h6",
  stroke: "#000",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M12 3C5.935 3 1 7.935 1 14a11 11 0 0 0 1.472 5.502l.29.5L4 20l-.001-1.9-.064-.1A9.006 9.006 0 0 1 3 14c0-4.963 4.038-9 9-9s9 4.037 9 9a8.997 8.997 0 0 1-.936 4l-.064.109V20h1.239l.289-.499A10.996 10.996 0 0 0 23 14c0-6.065-4.935-11-11-11Z"
}), /*#__PURE__*/createElement("path", {
  d: "M3 18h3v2H3v-2Zm15 0h3v2h-3v-2Z"
}));

const SvgSubcategoryTree = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  clipRule: "evenodd",
  d: "M8.286 2h7.428v7.429h-2.857v1.714h5.712v3.428h2.86V22H14v-7.429h2.855v-1.714H7.141v1.714H10V22H2.57v-7.429h2.855v-3.428h5.717V9.429H8.286V2ZM14 7.714v-4h-4v4h4Zm-9.714 8.572v4h4v-4h-4Zm11.428 0v4h4v-4h-4Z"
}));

const SvgSubject = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M14 17H4v2h10v-2Zm6-8H4v2h16V9ZM4 15h16v-2H4v2ZM4 5v2h16V5H4Z"
}));

const SvgSwap = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 10",
  fill: "currentColor"
}, props), /*#__PURE__*/createElement("path", {
  d: "M10.957 6.322L8.32 8.96a.395.395 0 11-.559-.56l1.963-1.962h-6.96a.396.396 0 010-.792h7.915a.396.396 0 01.28.676zM9.491 3.404a.396.396 0 00-.396-.395H2.136L4.1 1.046a.396.396 0 00-.56-.56L.901 3.124a.396.396 0 00.28.675h7.914a.395.395 0 00.396-.395z"
}));

const SvgTag = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m12.636 3-9.081 9.082c-.74.74-.74 1.939 0 2.679l5.684 5.684c.74.74 1.94.74 2.68 0L21 11.364V3h-8.364Zm5.048 1.895a1.422 1.422 0 1 1 0 2.843 1.422 1.422 0 0 1 0-2.843Z"
}));

const SvgTap = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 12h6a4 4 0 0 1 4 4v4h-6v-2H4v2H2V10h2v2h6V7H6V5h4V4h2v1h4v2h-4v5Zm-8 4h14v2h2v-2a2 2 0 0 0-2-2H4v2Z"
}), /*#__PURE__*/createElement("path", {
  d: "M16 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
}));

const SvgTarget = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 12a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0Zm4-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
}), /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
}));

const SvgTemplate = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M8 7h8v2H8V7Z"
}), /*#__PURE__*/createElement("path", {
  d: "M11 17V8h2v9h-2ZM20 2h2v2h-2V2ZM2 2h2v2H2V2ZM20 7h2v2h-2V7ZM2 7h2v2H2V7ZM7 2h2v2H7V2ZM7 20h2v2H7v-2ZM11 2h2v2h-2V2ZM11 20h2v2h-2v-2ZM15 2h2v2h-2V2ZM15 20h2v2h-2v-2ZM20 11h2v2h-2v-2ZM2 11h2v2H2v-2ZM20 15h2v2h-2v-2ZM2 15h2v2H2v-2ZM20 20h2v2h-2v-2ZM2 20h2v2H2v-2Z"
}));

const SvgTextBoxWithCorners = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 13",
  fill: "currentColor"
}, props), /*#__PURE__*/createElement("g", {
  clipPath: "url(#text-box-with-corners_svg__clip0_2668_179593)"
}, /*#__PURE__*/createElement("path", {
  d: "M11.282 4.14h.792s.132 0 .132.133v4.484s0 .132-.132.132h-.792s-.132 0-.132-.132V4.273s0-.132.132-.132zM4.687 1.24H9.17s.132 0 .132.131v.792s0 .131-.132.131H4.687s-.132 0-.132-.131V1.37s0-.132.132-.132zM1.784 4.14h.792s.132 0 .132.133v4.484s0 .132-.132.132h-.792s-.132 0-.132-.132V4.273s0-.132.132-.132zM4.687 10.736H9.17s.132 0 .132.132v.792s0 .132-.132.132H4.687s-.132 0-.132-.132v-.792s0-.132.132-.132zM10.096 1.766a1.583 1.583 0 103.166 0 1.583 1.583 0 00-3.166 0zM.598 1.766a1.583 1.583 0 103.165 0 1.583 1.583 0 00-3.165 0zM10.096 11.264a1.583 1.583 0 103.165 0 1.583 1.583 0 00-3.165 0zM.598 11.264a1.583 1.583 0 103.165 0 1.583 1.583 0 00-3.165 0zM9.303 4.405a.528.528 0 00-.527-.528H5.082a.528.528 0 00-.527.528v.791a.528.528 0 001.055 0v-.132a.132.132 0 01.132-.132h.527a.132.132 0 01.132.132v2.902a.132.132 0 01-.132.132h-.395a.528.528 0 000 1.055h2.11a.528.528 0 100-1.055h-.396a.132.132 0 01-.131-.132V5.064a.132.132 0 01.131-.132h.528a.132.132 0 01.132.132v.132a.528.528 0 001.055 0v-.791z"
})), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
  id: "text-box-with-corners_svg__clip0_2668_179593"
}, /*#__PURE__*/createElement("path", {
  transform: "translate(.598 .184)",
  d: "M0 0h12.663v12.663H0z"
}))));

const SvgTextBox = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M2 4v6H1v4h1v6h20v-6h1v-4h-1V4H2Zm2 2h16v4h-1v4h1v4H4v-4h1v-4H4V6Zm5 2v2h2v6h2v-6h2V8H9Z"
}));

const SvgTextBubble = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M3.214 18.125c-.12 0-.238-.002-.353-.006a1.006 1.006 0 0 1-.924-.68 1.018 1.018 0 0 1 .3-1.122c.776-.626 1.087-1.32 1.212-1.795C2.42 13.289 1.874 11.733 1.874 10c0-4.294 3.342-7.293 8.125-7.293 4.784 0 8.125 3 8.125 7.293S14.783 17.293 10 17.293c-.989 0-1.937-.134-2.828-.399-1.136.99-2.701 1.23-3.957 1.23Zm-.316-1.256h.005-.005ZM10 3.96c-4.047 0-6.875 2.484-6.875 6.042 0 1.53.504 2.885 1.46 3.918.128.14.188.332.158.52-.14.893-.58 1.738-1.257 2.43.967-.035 2.267-.257 3.067-1.11a.624.624 0 0 1 .66-.164c.862.298 1.8.45 2.787.45 4.048 0 6.875-2.486 6.875-6.044 0-3.557-2.827-6.043-6.875-6.043Zm.85 6.04a.833.833 0 0 0-.833-.832h-.009A.83.83 0 0 0 9.18 10c0 .46.378.833.838.833.46 0 .833-.373.833-.833Zm3.333 0a.833.833 0 0 0-.833-.832h-.008a.83.83 0 0 0-.83.833c0 .46.378.833.838.833.46 0 .833-.373.833-.833Zm-6.666 0a.833.833 0 0 0-.834-.832h-.008a.83.83 0 0 0-.83.833c0 .46.378.833.838.833.46 0 .834-.373.834-.833Z"
}));

const SvgTrashCan = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M10 2 9 3H4v2h16V3h-5l-1-1h-4ZM5 7v13c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7H5Z"
}));

const SvgUpCarrot = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "m12 8.4 6.235 6.3H5.765L12 8.4Z"
}));

const SvgUserAttributes = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M8 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm4.594 1c.26.61.406 1.284.406 2h9V7h-9.406Zm-.004 4a4.942 4.942 0 0 1-1.01 1.518c.441.135.845.301 1.235.482H22v-2h-9.41ZM8 14c-3.278 0-6 1.429-6 3v1h12v-1c0-1.571-2.722-3-6-3Zm7.346 1c.417.61.654 1.284.654 2h6v-2h-6.654Z"
}));

const SvgWarning = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M1 21h22L12 2 1 21Zm12-3h-2v-2h2v2Zm0-4h-2v-4h2v4Z"
}));

const SvgWebhook = props => /*#__PURE__*/createElement("svg", _extends({
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/createElement("path", {
  d: "M11.656 2.344a5.038 5.038 0 0 0-4 2.5c-1.207 2.09-.71 4.71 1.032 6.25L7 14a1.986 1.986 0 0 0-1.719 1A1.982 1.982 0 0 0 6 17.719 1.98 1.98 0 0 0 8.719 17a2.008 2.008 0 0 0 0-2l2.656-4.563-.875-.5a2.995 2.995 0 1 1 3-5.187 2.995 2.995 0 0 1 1.094 4.094l1.75 1C17.723 7.457 16.887 4.379 14.5 3a4.986 4.986 0 0 0-2.844-.656Zm.094 3a1.98 1.98 0 0 0-.75.25c-.957.55-1.27 1.793-.719 2.75.367.64 1.031.996 1.719 1l2.625 4.562.875-.5a2.995 2.995 0 1 1 3 5.188 2.995 2.995 0 0 1-4.094-1.094l-1.75 1c1.38 2.387 4.457 3.223 6.844 1.844 2.387-1.38 3.223-4.457 1.844-6.844-1.207-2.09-3.73-2.988-5.938-2.25L13.72 8.344a2.008 2.008 0 0 0 0-2 1.991 1.991 0 0 0-1.969-1ZM7 11c-2.758 0-5 2.242-5 5s2.242 5 5 5a5.019 5.019 0 0 0 4.906-4h3.375A1.99 1.99 0 0 0 19 16a1.99 1.99 0 0 0-3.719-1H10v1c0 1.652-1.348 3-3 3s-3-1.348-3-3 1.348-3 3-3Z"
}));

const SvgWorkflow = props => /*#__PURE__*/createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/createElement("path", {
  d: "M6 3C4.355 3 3 4.355 3 6c0 1.293.843 2.395 2 2.813V13h2V8.812C8.157 8.396 9 7.293 9 6c0-1.645-1.355-3-3-3Zm12 0a3 3 0 0 0-2.824 2H11v2h4.174a3 3 0 0 0 4.947 1.121A3 3 0 0 0 18 3ZM6 5c.564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.564.436-1 1-1Zm11 6v4l-3 3 4 4 4-4-3-3v-4h-2ZM3 15v6h6v-6H3Z"
}));

const IconMap = {
  add: SvgAdd,
  addCircleOutline: SvgAddCircleOutline,
  addCondition: SvgAddCondition,
  addTag: SvgAddTag,
  analytics: SvgAnalytics,
  artificialIntelligence: SvgArtificialIntelligence,
  baselineArrowDown: SvgBaselineArrowDown,
  baselineArrowLeft: SvgBaselineArrowLeft,
  baselineArrowRight: SvgBaselineArrowRight,
  baselineArrowUp: SvgBaselineArrowUp,
  baselineCheck: SvgBaselineCheck,
  baselineKeyboardArrowDown: SvgBaselineKeyboardArrowDown,
  baselineKeyboardArrowLeft: SvgBaselineKeyboardArrowLeft,
  baselineKeyboardArrowRight: SvgBaselineKeyboardArrowRight,
  baselineKeyboardArrowUp: SvgBaselineKeyboardArrowUp,
  bell: SvgBell,
  bellAlarm: SvgBellAlarm,
  blocked: SvgBlocked,
  build: SvgBuild,
  camera: SvgCamera,
  categories: SvgCategories,
  checkCircle: SvgCheckCircle,
  checkCircleOutline: SvgCheckCircleOutline,
  checkboxCheck: SvgCheckboxCheck,
  circleApps: SvgCircleApps,
  clear: SvgClear,
  clipboardCheck: SvgClipboardCheck,
  clockFill: SvgClockFill,
  cloudFailed: SvgCloudFailed,
  cog: SvgCog,
  cogOutline: SvgCogOutline,
  collection: SvgCollection,
  contactDetails: SvgContactDetails,
  counter: SvgCounter,
  crossCircleOutline: SvgCrossCircleOutline,
  customerInsight: SvgCustomerInsight,
  dataConfiguration: SvgDataConfiguration,
  downCarrot: SvgDownCarrot,
  download: SvgDownload,
  editFullOutline: SvgEditFullOutline,
  editOutline: SvgEditOutline,
  education: SvgEducation,
  error: SvgError,
  exclamationCircle: ExclamationCircle,
  eyeHide: SvgEyeHide,
  eyeOpen: SvgEyeOpen,
  eyeOpenOutline: SvgEyeOpenOutline,
  export: SvgExport,
  filter: SvgFilter,
  gallery: SvgGallery,
  gantt: SvgGantt,
  generate: SvgGenerate,
  globe: SvgGlobe,
  helpOutline: SvgHelpOutline,
  house: SvgHouse,
  indeterminateCheckbox: SvgIndeterminateCheckbox,
  infoFilled: SvgInfoFilled,
  infoStroke: SvgInfoStroke,
  itemsList: SvgItemsList,
  key: SvgKey,
  language: SvgLanguage,
  leftCarrot: SvgLeftCarrot,
  link: SvgLink,
  linksConnected: SvgLinksConnected,
  loading: SvgLoading,
  locationMap: SvgLocationMap,
  lock: SvgLock,
  mailStatistics: SvgMailStatistics,
  manageTemplates: SvgManageTemplates,
  mapControlMinus: SvgMapControlMinus,
  mapControlPlus: SvgMapControlPlus,
  mapCreateShape: SvgMapCreateShape,
  mapCrosshairs: SvgMapCrosshairs,
  mathDivide: SvgMathDivide,
  mathExponent: SvgMathExponent,
  mathMinus: SvgMathMinus,
  mathModulo: SvgMathModulo,
  mathMultiply: SvgMathMultiply,
  mathPlus: SvgMathPlus,
  menu: SvgMenu,
  merchant: SvgMerchant,
  moreCircle: SvgMoreCircle,
  // to ensure compatibility with past implementations for now
  moreHori: SvgMoreVert,
  moreVert: SvgMoreHori,
  nodeConnect: SvgNodeConnect,
  notesList: SvgNotesList,
  openInNew: SvgOpenInNew,
  pencil: SvgPencil,
  people: SvgPeople,
  person: SvgPerson,
  personAdd: SvgPersonAdd,
  personCog: SvgPersonCog,
  phoneSetup: SvgPhoneSetup,
  pictureFile: Picture,
  pushNotification: SvgPushNotification,
  puzzle: SvgPuzzle,
  remove: SvgRemove,
  replay: SvgReplay,
  report: SvgReport,
  reset: SvgReset,
  rightCarrot: SvgRightCarrot,
  rocket: SvgRocket,
  search: SvgSearch,
  security: SvgSecurity,
  send: SvgSend,
  smiley: SvgSmiley,
  speedo: SvgSpeedo,
  subcategoryTree: SvgSubcategoryTree,
  subject: SvgSubject,
  swap: SvgSwap,
  tag: SvgTag,
  tap: SvgTap,
  target: SvgTarget,
  template: SvgTemplate,
  textBox: SvgTextBox,
  textBoxWithCorners: SvgTextBoxWithCorners,
  textBubble: SvgTextBubble,
  trashCan: SvgTrashCan,
  upCarrot: SvgUpCarrot,
  userAttributes: SvgUserAttributes,
  warning: SvgWarning,
  webhook: SvgWebhook,
  workflow: SvgWorkflow
};
const getIcon = (iconName, props) => {
  if (typeof iconName !== 'string') {
    throw new Error('parameter 1 iconName needs to be a string');
  } else if (props && typeof props !== 'object') {
    throw new Error('parameter 2 props needs to be an object');
  }
  const IconComponent = IconMap[iconName];
  return IconComponent ? /*#__PURE__*/React__default.createElement(IconComponent, props) : null;
};

var css_248z$2 = ".flight-font, .flight-button {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-button--medium, .flight-button--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium, .flight-button--large {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-button {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon, .flight-button--large svg, .flight-button--medium svg, .flight-button--small svg {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small, .flight-button--small svg {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium, .flight-button--medium svg {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large, .flight-button--large svg {\n  width: 24px;\n  height: 24px;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-button {\n  height: 40px;\n  border-radius: 24px;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n  background-color: #FFFFFF;\n  position: relative;\n  width: max-content;\n  cursor: pointer;\n}\n.flight-button, .flight-button * {\n  outline: none;\n}\n.flight-button__label {\n  padding: 0 4px;\n}\n.flight-button:focus:enabled, .flight-button:focus:enabled * {\n  outline: none;\n}\n.flight-button:disabled {\n  color: #B4B8C3;\n  cursor: no-drop;\n}\n.flight-button:disabled svg {\n  fill: #B4B8C3;\n}\n.flight-button--small {\n  height: 32px;\n}\n.flight-button--small.flight-button--without-text {\n  width: 32px;\n}\n.flight-button--medium {\n  height: 40px;\n}\n.flight-button--medium.flight-button--without-text {\n  width: 40px;\n}\n.flight-button--large {\n  height: 48px;\n}\n.flight-button--large.flight-button--without-text {\n  width: 48px;\n}\n.flight-button--primary {\n  background-color: #0851DF;\n  color: #FFFFFF;\n}\n.flight-button--primary svg {\n  fill: #FFFFFF;\n}\n.flight-button--primary:hover:enabled, .flight-button--primary:focus:enabled {\n  background-color: #1237B5;\n  outline: 2px solid #030830 !important;\n}\n.flight-button--primary:active:enabled {\n  background-color: #182587;\n}\n.flight-button--primary:disabled {\n  background-color: #F2F3F5;\n}\n.flight-button--secondary {\n  -webkit-box-shadow: inset 0 0 0 1px #0851DF;\n  -moz-box-shadow: inset 0 0 0 1px #0851DF;\n  -ms-box-shadow: inset 0 0 0 1px #0851DF;\n  -o-box-shadow: inset 0 0 0 1px #0851DF;\n  box-shadow: inset 0 0 0 1px #0851DF;\n  color: #0851DF;\n}\n.flight-button--secondary:hover:enabled, .flight-button--secondary:focus:enabled {\n  background-color: #DDECFF;\n  color: #1237B5;\n}\n.flight-button--secondary:hover:enabled svg, .flight-button--secondary:focus:enabled svg {\n  fill: #1237B5;\n}\n.flight-button--secondary:active:enabled {\n  background-color: #B9D9FF;\n}\n.flight-button--secondary:disabled {\n  -webkit-box-shadow: inset 0 0 0 1px #CDD0D7;\n  -moz-box-shadow: inset 0 0 0 1px #CDD0D7;\n  -ms-box-shadow: inset 0 0 0 1px #CDD0D7;\n  -o-box-shadow: inset 0 0 0 1px #CDD0D7;\n  box-shadow: inset 0 0 0 1px #CDD0D7;\n}\n.flight-button--minor {\n  color: #697186;\n  border: none;\n}\n.flight-button--minor svg {\n  fill: #697186;\n}\n.flight-button--minor:hover:enabled, .flight-button--minor:focus:enabled {\n  color: #0851DF;\n  background-color: #F2F3F5;\n}\n.flight-button--minor:hover:enabled svg, .flight-button--minor:focus:enabled svg {\n  fill: #0851DF;\n}\n.flight-button--minor:active:enabled {\n  color: #1237B5;\n  background-color: #E6E7EB;\n}\n.flight-button--minor:active:enabled svg {\n  fill: #1237B5;\n}\n.flight-button--link {\n  color: #0851DF;\n  width: auto;\n  height: auto;\n  border-radius: 0;\n  padding: 0;\n  background-color: transparent;\n}\n.flight-button--link--has-underline:hover:enabled, .flight-button--link--has-underline:focus:enabled {\n  text-decoration: underline;\n}\n.flight-button--link:hover:enabled, .flight-button--link:focus:enabled {\n  color: #1237B5;\n}\n.flight-button--link:hover:enabled svg, .flight-button--link:focus:enabled svg {\n  fill: #1237B5;\n}\n.flight-button--loading .flight-button__label, .flight-button--loading svg {\n  visibility: hidden;\n}\n.flight-button--loading svg:last-child {\n  position: absolute;\n  visibility: visible;\n  -webkit-animation-name: spin;\n  -moz-animation-name: spin;\n  -ms-animation-name: spin;\n  -o-animation-name: spin;\n  animation-name: spin;\n  -webkit-animation-delay: 0s;\n  -moz-animation-delay: 0s;\n  -ms-animation-delay: 0s;\n  -o-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-duration: 0.75s;\n  -moz-animation-duration: 0.75s;\n  -ms-animation-duration: 0.75s;\n  -o-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-timing-function: linear;\n  -ms-animation-timing-function: linear;\n  -o-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: infinite;\n  -moz-animation-iteration-count: infinite;\n  -ms-animation-iteration-count: infinite;\n  -o-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-direction: normal;\n  -moz-animation-direction: normal;\n  -ms-animation-direction: normal;\n  -o-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-fill-mode: none;\n  -moz-animation-fill-mode: none;\n  -ms-animation-fill-mode: none;\n  -o-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  -moz-animation-play-state: running;\n  -ms-animation-play-state: running;\n  -o-animation-play-state: running;\n  animation-play-state: running;\n}";
styleInject(css_248z$2);

const DEFAULT_CLASS$1 = 'flight-button';
const BUTTON_THEMES = {
  primary: 'primary',
  secondary: 'secondary',
  minor: 'minor',
  link: 'link'
};
const BUTTON_SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
const FlightButton = props => {
  const {
    className,
    disabled,
    hasUnderline,
    iconLeft,
    iconRight,
    label,
    loading,
    size,
    theme,
    helperkey,
    onClick,
    onBlur,
    onFocus,
    onKeyDown,
    onMouseEnter,
    onMouseLeave,
    buttonRef,
    type,
    isPropagateUpperActions,
    ariaLabel,
    ariaCurrent,
    ariaExpanded,
    isAriaExpandedVisible,
    ariaDescribedBy,
    isAriaDescribedBy,
    tabIndex
  } = props;
  const handleOnClick = event => {
    if (disabled || loading) return;
    if (onClick) onClick(event);
    if (!isPropagateUpperActions) {
      event.stopPropagation();
    }
  };
  const handleOnBlur = event => {
    if (disabled || loading) return;
    if (onBlur) onBlur(event);
  };
  const handleOnFocus = event => {
    if (disabled || loading) return;
    if (onFocus) onFocus(event);
  };
  const handleOnKeyDown = event => {
    if (disabled || loading) return;
    if (onKeyDown) onKeyDown(event);
  };
  const handleOnMouseEnter = event => {
    if (disabled) return;
    if (onMouseEnter) onMouseEnter(event);
  };
  const handleOnMouseLeave = event => {
    if (disabled) return;
    if (onMouseLeave) onMouseLeave(event);
  };
  const labelElement = label ? /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$1}__label`
  }, label) : null;
  const loadingIcon = loading ? getIcon('loading') : null;
  let buttonClass = DEFAULT_CLASS$1;
  buttonClass += ` ${DEFAULT_CLASS$1}--${BUTTON_THEMES[theme] || BUTTON_THEMES.primary}`;
  buttonClass += BUTTON_THEMES[theme] === BUTTON_THEMES.link && hasUnderline ? ` ${DEFAULT_CLASS$1}--link--has-underline` : '';
  buttonClass += ` ${DEFAULT_CLASS$1}--${BUTTON_SIZES[size] || BUTTON_SIZES.medium}`;
  buttonClass += iconLeft || iconRight ? ` ${DEFAULT_CLASS$1}--with-icon` : '';
  buttonClass += !label ? ` ${DEFAULT_CLASS$1}--without-text` : '';
  buttonClass += loading ? ` ${DEFAULT_CLASS$1}--loading` : '';
  buttonClass += className ? ` ${className}` : '';
  const btnProps = {
    className: buttonClass,
    disabled,
    onBlur: handleOnBlur,
    onClick: handleOnClick,
    onFocus: handleOnFocus,
    onKeyDown: handleOnKeyDown,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave,
    type,
    ref: buttonRef,
    tabIndex
  };
  if (helperkey) {
    btnProps.helperkey = helperkey;
  }
  if (ariaLabel) {
    btnProps['aria-label'] = ariaLabel;
  } else if (!label) {
    // throw error for accessibility
    console.error("Flight Design System: 'ariaLabel' needs to be present when 'label' is empty in FlightButton");
  }
  if (ariaCurrent) {
    btnProps['aria-current'] = ariaCurrent;
  }
  if (isAriaExpandedVisible) {
    btnProps['aria-expanded'] = ariaExpanded;
  }
  if (isAriaDescribedBy) {
    btnProps['aria-describedby'] = ariaDescribedBy;
  }
  /* eslint-disable react/button-has-type */
  return /*#__PURE__*/React__default.createElement("button", btnProps, iconLeft ? getIcon(iconLeft) : null, labelElement, iconRight ? getIcon(iconRight) : null, loadingIcon);
};
/* eslint-enable react/button-has-type */
FlightButton.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  hasUnderline: propTypes.bool,
  iconLeft: propTypes.string,
  iconRight: propTypes.string,
  label: propTypes.node,
  loading: propTypes.bool,
  onBlur: propTypes.func,
  onClick: propTypes.func.isRequired,
  onFocus: propTypes.func,
  onKeyDown: propTypes.func,
  onMouseEnter: propTypes.func,
  onMouseLeave: propTypes.func,
  size: propTypes.string,
  theme: propTypes.string,
  type: propTypes.string,
  helperkey: propTypes.oneOfType([propTypes.number, propTypes.string]),
  buttonRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.shape({
      focus: propTypes.func
    })
  })]),
  isPropagateUpperActions: propTypes.bool,
  ariaLabel: propTypes.string,
  ariaCurrent: propTypes.string,
  ariaExpanded: propTypes.bool,
  isAriaExpandedVisible: propTypes.bool,
  ariaDescribedBy: propTypes.string,
  isAriaDescribedBy: propTypes.bool,
  tabIndex: propTypes.number
};
FlightButton.defaultProps = {
  className: '',
  disabled: false,
  hasUnderline: true,
  iconLeft: '',
  iconRight: '',
  label: '',
  loading: false,
  onBlur: () => undefined,
  onFocus: () => undefined,
  onKeyDown: () => undefined,
  onMouseEnter: () => undefined,
  onMouseLeave: () => undefined,
  size: 'medium',
  theme: 'primary',
  type: 'button',
  helperkey: '',
  buttonRef: null,
  isPropagateUpperActions: false,
  ariaLabel: '',
  ariaCurrent: '',
  ariaExpanded: false,
  isAriaExpandedVisible: false,
  ariaDescribedBy: '',
  isAriaDescribedBy: false,
  tabIndex: 0
};

var css_248z$3 = ".flight-font, .flight-card {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-card__header {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-card {\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  min-width: 100px;\n  min-height: 100px;\n  border-radius: 10px;\n}\n.flight-card__actionables {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n}\n.flight-card__overlay {\n  display: none;\n}\n.flight-card:hover .flight-card__overlay, .flight-card:focus .flight-card__overlay {\n  display: block;\n  background-color: rgba(255, 255, 255, 0.5);\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n.flight-card:hover .flight-card__overlay__button, .flight-card:focus .flight-card__overlay__button {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  width: 90px;\n}\n.flight-card__container {\n  display: table;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 2;\n}\n.flight-card__container__mid {\n  display: table-cell;\n  vertical-align: middle;\n}\n.flight-card__container__mid__loading {\n  height: 26px;\n  width: 26px;\n  background-color: rgba(0, 0, 0, 0.3);\n  margin: 0 auto;\n  padding: 10px;\n  border-radius: 0.5rem;\n}\n.flight-card__container__mid__loading svg {\n  fill: white;\n}\n.flight-card__container__mid__loading svg:last-child {\n  position: absolute;\n  visibility: visible;\n  -webkit-animation-name: spin;\n  -moz-animation-name: spin;\n  -ms-animation-name: spin;\n  -o-animation-name: spin;\n  animation-name: spin;\n  -webkit-animation-delay: 0s;\n  -moz-animation-delay: 0s;\n  -ms-animation-delay: 0s;\n  -o-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-duration: 0.75s;\n  -moz-animation-duration: 0.75s;\n  -ms-animation-duration: 0.75s;\n  -o-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-timing-function: linear;\n  -ms-animation-timing-function: linear;\n  -o-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: infinite;\n  -moz-animation-iteration-count: infinite;\n  -ms-animation-iteration-count: infinite;\n  -o-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-direction: normal;\n  -moz-animation-direction: normal;\n  -ms-animation-direction: normal;\n  -o-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-fill-mode: none;\n  -moz-animation-fill-mode: none;\n  -ms-animation-fill-mode: none;\n  -o-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  -moz-animation-play-state: running;\n  -ms-animation-play-state: running;\n  -o-animation-play-state: running;\n  animation-play-state: running;\n}";
styleInject(css_248z$3);

const DEFAULT_CLASS$2 = 'flight-card';
const FlightCard = props => {
  const {
    header,
    body,
    footer,
    actionables,
    loading,
    image,
    className,
    onClick,
    onDblClick,
    onKeyDown,
    accessibilityText,
    tabIndex,
    isImageBgColor,
    defaultText,
    addOverlay,
    onBtnClick
  } = props;
  let mainClass = DEFAULT_CLASS$2;
  mainClass += className ? ` ${className}` : '';
  const loadingIcon = loading ? getIcon('loading') : null;
  const getRandomColor = () => `hsl(${360 * Math.random()},${25 + 70 * Math.random()}%,${85 + 10 * Math.random()}%`;
  return /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    onClick: event => {
      switch (event.detail) {
        case 2:
          {
            onDblClick();
            break;
          }
        default:
          {
            onClick();
          }
      }
    },
    onKeyDown: onKeyDown,
    role: "button",
    tabIndex: tabIndex,
    "aria-label": accessibilityText
  }, loading ? /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__container`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__container__mid`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__container__mid__loading`
  }, loadingIcon))) : null, addOverlay ? /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__overlay`
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    className: `${DEFAULT_CLASS$2}__overlay__button`,
    label: "Use",
    theme: "primary",
    onClick: onBtnClick,
    tabIndex: -1
  })) : null, image ? /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__image`
  }, image) : null, isImageBgColor && !image ? /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__image`,
    style: {
      backgroundColor: getRandomColor()
    }
  }, defaultText) : null, /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__header`
  }, header), body ? /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__body`
  }, body) : null, footer ? /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__footer`
  }, footer) : null, actionables ? /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$2}__actionables`
  }, actionables) : null);
};
FlightCard.propTypes = {
  header: propTypes.oneOfType([propTypes.element, propTypes.string]).isRequired,
  body: propTypes.oneOfType([propTypes.element, propTypes.string]),
  footer: propTypes.oneOfType([propTypes.element, propTypes.string]),
  actionables: propTypes.element,
  loading: propTypes.bool,
  image: propTypes.element,
  className: propTypes.string,
  onClick: propTypes.func,
  onDblClick: propTypes.func,
  onKeyDown: propTypes.func,
  tabIndex: propTypes.number,
  accessibilityText: propTypes.string,
  isImageBgColor: propTypes.bool,
  defaultText: propTypes.string,
  addOverlay: propTypes.bool,
  onBtnClick: propTypes.func
};
FlightCard.defaultProps = {
  body: null,
  footer: null,
  actionables: null,
  loading: false,
  image: null,
  className: '',
  onClick: () => undefined,
  onDblClick: () => undefined,
  onKeyDown: () => undefined,
  tabIndex: -1,
  accessibilityText: '',
  isImageBgColor: false,
  defaultText: '',
  addOverlay: false,
  onBtnClick: () => undefined
};

var css_248z$4 = ".flight-carousel-wrapper {\n  width: 100%;\n  position: relative;\n}\n.flight-carousel-wrapper .flight-carousel {\n  width: 100%;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n.flight-carousel-wrapper .flight-carousel-toggle {\n  position: absolute;\n  height: 100%;\n  width: 100px;\n  display: flex;\n  align-items: center;\n  top: 0;\n}\n.flight-carousel-wrapper .flight-carousel-toggle__button > svg {\n  width: 24px;\n  height: 24px;\n}\n.flight-carousel-wrapper .flight-carousel-toggle--left {\n  left: 0;\n  background-image: linear-gradient(to right, #FFFFFF -40%, transparent);\n  opacity: 0.9;\n}\n.flight-carousel-wrapper .flight-carousel-toggle--left .flight-carousel-toggle__button {\n  margin-left: 4px;\n}\n.flight-carousel-wrapper .flight-carousel-toggle--right {\n  right: 0;\n  background-image: linear-gradient(to left, #FFFFFF -40%, transparent);\n  opacity: 0.9;\n}\n.flight-carousel-wrapper .flight-carousel-toggle--right .flight-carousel-toggle__button {\n  margin: 0 4px 0 auto;\n}";
styleInject(css_248z$4);

const ARROW_DIRECTIONS = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
};
const DEFAULT_CLASS$3 = 'flight-carousel';
const FlightCarousel = props => {
  const {
    className,
    scrollInteval,
    children
  } = props;
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollRight, setScrollRight] = useState(0);
  const carouselRef = useRef(null);
  const handleScroll = e => {
    setScrollLeft(e.currentTarget.scrollLeft);
    setScrollRight(e.currentTarget.scrollWidth - e.currentTarget.getBoundingClientRect().width - e.currentTarget.scrollLeft);
  };
  useEffect(() => {
    if (carouselRef && carouselRef.current) {
      carouselRef.current.addEventListener('scroll', handleScroll);
      setScrollRight(carouselRef.current.scrollWidth - carouselRef.current.getBoundingClientRect().width - carouselRef.current.scrollLeft);
    }
    return () => {
      if (carouselRef && carouselRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        carouselRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, [carouselRef, scrollRight]);
  const handleToggleButtonClick = direction => {
    if (carouselRef && carouselRef.current) {
      const newScrollLeft = direction === ARROW_DIRECTIONS.RIGHT ? Math.min(carouselRef.current.scrollLeft + scrollInteval, carouselRef.current.scrollWidth) : Math.max(carouselRef.current.scrollLeft - scrollInteval, 0);
      carouselRef.current.scrollTo({
        left: newScrollLeft,
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  let wrapperClass = `${DEFAULT_CLASS$3}-wrapper`;
  wrapperClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement("div", {
    className: DEFAULT_CLASS$3,
    ref: carouselRef
  }, children), scrollLeft > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$3}-toggle ${DEFAULT_CLASS$3}-toggle--left`
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    className: `${DEFAULT_CLASS$3}-toggle__button`,
    iconLeft: "baselineKeyboardArrowLeft",
    onClick: () => handleToggleButtonClick(ARROW_DIRECTIONS.LEFT),
    theme: "minor",
    ariaLabel: "carousel-move-left"
  })), scrollRight > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$3}-toggle ${DEFAULT_CLASS$3}-toggle--right`
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    className: `${DEFAULT_CLASS$3}-toggle__button`,
    iconLeft: "baselineKeyboardArrowRight",
    onClick: () => handleToggleButtonClick(ARROW_DIRECTIONS.RIGHT),
    theme: "minor",
    ariaLabel: "carousel-move-right"
  })));
};
FlightCarousel.propTypes = {
  className: propTypes.string,
  scrollInteval: propTypes.number,
  children: propTypes.node
};
FlightCarousel.defaultProps = {
  className: '',
  scrollInteval: 200,
  children: null
};

const CHECKBOX_STATES = {
  UNSELECTED: 'UNSELECTED',
  INDETERMINATE: 'INDETERMINATE',
  SELECTED: 'SELECTED'
};
const EVENT_KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  TAB: 'Tab'
};
const CALENDAR_TABLE_HEADERS = [{
  name: 'S',
  key: 'Sunday',
  isVisible: true,
  isSortable: false,
  hideTooltip: true
}, {
  name: 'M',
  key: 'Monday',
  isVisible: true,
  isSortable: false,
  hideTooltip: true
}, {
  name: 'T',
  key: 'Tuesday',
  isVisible: true,
  isSortable: false,
  hideTooltip: true
}, {
  name: 'W',
  key: 'Wednesday',
  isVisible: true,
  isSortable: false,
  hideTooltip: true
}, {
  name: 'T',
  key: 'Thursday',
  isVisible: true,
  isSortable: false,
  hideTooltip: true
}, {
  name: 'F',
  key: 'Friday',
  isVisible: true,
  isSortable: false,
  hideTooltip: true
}, {
  name: 'S',
  key: 'Saturday',
  isVisible: true,
  isSortable: false,
  hideTooltip: true
}];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

var css_248z$5 = ".flight-font, .flight-carousel-item {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-carousel-item {\n  display: inline-block;\n  margin: 0 20px;\n}\n.flight-carousel-item__background {\n  width: 100%;\n  height: 100%;\n  background: #0851DF;\n  opacity: 0;\n  transition: 0.5s linear;\n}\n.flight-carousel-item__active .flight-carousel-item__background, .flight-carousel-item:hover .flight-carousel-item__background, .flight-carousel-item:focus .flight-carousel-item__background {\n  opacity: 1;\n}";
styleInject(css_248z$5);

const DEFAULT_CLASS$4 = 'flight-carousel-item';
const FlightCarouselItem = props => {
  const {
    className,
    onClick,
    children,
    onFocus
  } = props;
  let mainClass = DEFAULT_CLASS$4;
  mainClass += className ? ` ${className}` : '';
  const handleOnKeyDown = event => {
    if (event.key === EVENT_KEYS.ENTER) {
      if (onClick) onClick();
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: handleOnKeyDown,
    tabIndex: 0,
    role: "button"
  }, children);
};
FlightCarouselItem.propTypes = {
  className: propTypes.string,
  onClick: propTypes.func,
  onFocus: propTypes.func,
  children: propTypes.node
};
FlightCarouselItem.defaultProps = {
  className: '',
  onClick: () => undefined,
  onFocus: () => undefined,
  children: null
};

var css_248z$6 = ".flight-font, .flight-checkbox-wrapper {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-checkbox-wrapper {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon, .flight-checkbox-wrapper .flight-checkbox__icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small, .flight-checkbox-wrapper .flight-checkbox__icon {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.flight-checkbox-wrapper:focus, .flight-checkbox-wrapper:focus-visible {\n  height: 19px;\n  outline: #0851DF auto 1px;\n}\n.flight-checkbox-wrapper:hover:not(.flight-checkbox-wrapper--disabled) .flight-checkbox, .flight-checkbox-wrapper:focus:not(.flight-checkbox-wrapper--disabled) .flight-checkbox {\n  -webkit-box-shadow: inset 0 0 0 1px #37425E;\n  -moz-box-shadow: inset 0 0 0 1px #37425E;\n  -ms-box-shadow: inset 0 0 0 1px #37425E;\n  -o-box-shadow: inset 0 0 0 1px #37425E;\n  box-shadow: inset 0 0 0 1px #37425E;\n}\n.flight-checkbox-wrapper:hover:not(.flight-checkbox-wrapper--disabled) .flight-checkbox--selected, .flight-checkbox-wrapper:hover:not(.flight-checkbox-wrapper--disabled) .flight-checkbox--indeterminate, .flight-checkbox-wrapper:focus:not(.flight-checkbox-wrapper--disabled) .flight-checkbox--selected, .flight-checkbox-wrapper:focus:not(.flight-checkbox-wrapper--disabled) .flight-checkbox--indeterminate {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  -ms-box-shadow: none;\n  -o-box-shadow: none;\n  box-shadow: none;\n  background-color: #1237B5;\n}\n.flight-checkbox-wrapper:hover:not(.flight-checkbox-wrapper--disabled) .flight-checkbox--label, .flight-checkbox-wrapper:focus:not(.flight-checkbox-wrapper--disabled) .flight-checkbox--label {\n  color: #051336;\n}\n.flight-checkbox-wrapper .flight-checkbox {\n  -webkit-box-shadow: inset 0 0 0 1px #697186;\n  -moz-box-shadow: inset 0 0 0 1px #697186;\n  -ms-box-shadow: inset 0 0 0 1px #697186;\n  -o-box-shadow: inset 0 0 0 1px #697186;\n  box-shadow: inset 0 0 0 1px #697186;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  margin-left: 1px;\n}\n.flight-checkbox-wrapper .flight-checkbox__icon {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  fill: #FFFFFF;\n}\n.flight-checkbox-wrapper .flight-checkbox--selected, .flight-checkbox-wrapper .flight-checkbox--indeterminate {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  -ms-box-shadow: none;\n  -o-box-shadow: none;\n  box-shadow: none;\n  background-color: #0851DF;\n}\n.flight-checkbox-wrapper .flight-checkbox:focus, .flight-checkbox-wrapper .flight-checkbox:focus-visible {\n  outline: #0851DF auto 1px;\n}\n.flight-checkbox-wrapper .flight-checkbox--label {\n  color: #37425E;\n  padding-left: 24px;\n}\n.flight-checkbox-wrapper .flight-checkbox--no-label {\n  color: #37425E;\n  padding-left: 19px;\n}\n.flight-checkbox-wrapper--disabled {\n  cursor: no-drop;\n}\n.flight-checkbox-wrapper--disabled .flight-checkbox {\n  -webkit-box-shadow: inset 0 0 0 1px #B4B8C3;\n  -moz-box-shadow: inset 0 0 0 1px #B4B8C3;\n  -ms-box-shadow: inset 0 0 0 1px #B4B8C3;\n  -o-box-shadow: inset 0 0 0 1px #B4B8C3;\n  box-shadow: inset 0 0 0 1px #B4B8C3;\n}\n.flight-checkbox-wrapper--disabled .flight-checkbox__icon {\n  fill: #B4B8C3;\n}\n.flight-checkbox-wrapper--disabled .flight-checkbox--selected, .flight-checkbox-wrapper--disabled .flight-checkbox--indeterminate {\n  background-color: #E6E7EB;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  -ms-box-shadow: none;\n  -o-box-shadow: none;\n  box-shadow: none;\n}\n.flight-checkbox-wrapper--disabled .flight-checkbox, .flight-checkbox-wrapper--disabled .flight-checkbox--label {\n  color: #B4B8C3;\n  pointer-events: none;\n}";
styleInject(css_248z$6);

const DEFAULT_CLASS$5 = 'flight-checkbox';
const ARIA_CHECKED_MAP = {
  [CHECKBOX_STATES.SELECTED]: 'true',
  [CHECKBOX_STATES.UNSELECTED]: 'false',
  [CHECKBOX_STATES.INDETERMINATE]: 'mixed'
};
const FlightCheckbox = props => {
  const {
    className,
    disabled,
    label,
    checkState,
    labelledby
  } = props;
  const checkIconProps = {
    className: `${DEFAULT_CLASS$5}__icon`
  };
  const handleOnSelect = event => {
    const {
      onSelect
    } = props;
    if (disabled) return;
    if (onSelect) onSelect(event);
  };
  const handleOnEnter = event => {
    if (event.key === EVENT_KEYS.ENTER) handleOnSelect();
  };
  let wrapperClass = `${DEFAULT_CLASS$5}-wrapper`;
  wrapperClass += disabled ? ` ${wrapperClass}--disabled` : '';
  wrapperClass += className ? ` ${className}` : '';
  let mainClass = DEFAULT_CLASS$5;
  mainClass += checkState && checkState !== CHECKBOX_STATES.UNSELECTED ? ` ${DEFAULT_CLASS$5}--${checkState.toLocaleLowerCase()}` : '';
  let icon = null;
  if (checkState === CHECKBOX_STATES.INDETERMINATE) {
    icon = getIcon('indeterminateCheckbox', checkIconProps);
  } else if (checkState === CHECKBOX_STATES.SELECTED) {
    icon = getIcon('checkboxCheck', checkIconProps);
  }
  const checkBoxAriaProps = {};
  if (label) {
    checkBoxAriaProps['aria-label'] = `checkbox-${label}`;
  }
  if (labelledby) {
    checkBoxAriaProps['aria-labelledby'] = labelledby;
  }
  const labelClass = label ? `${DEFAULT_CLASS$5}--label` : `${DEFAULT_CLASS$5}--no-label`;
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: wrapperClass,
    onClick: handleOnSelect,
    onKeyDown: handleOnEnter,
    role: "checkbox",
    tabIndex: disabled ? '-1' : '0',
    "aria-disabled": disabled,
    "aria-checked": ARIA_CHECKED_MAP[checkState] || 'false'
  }, checkBoxAriaProps), /*#__PURE__*/React__default.createElement("div", _extends({
    className: mainClass,
    tabIndex: "-1",
    "aria-disabled": disabled,
    "aria-checked": ARIA_CHECKED_MAP[checkState] || 'false'
  }, checkBoxAriaProps), icon), /*#__PURE__*/React__default.createElement("span", {
    className: labelClass,
    id: `checkbox-${label}`
  }, label));
};
FlightCheckbox.propTypes = {
  className: propTypes.string,
  label: propTypes.string,
  labelledby: propTypes.string,
  disabled: propTypes.bool,
  checkState: propTypes.string,
  onSelect: propTypes.func.isRequired
};
FlightCheckbox.defaultProps = {
  className: '',
  label: '',
  labelledby: '',
  disabled: false,
  checkState: CHECKBOX_STATES.UNSELECTED
};

var css_248z$7 = ".flight-font, .flight-collapsible-wrapper {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon, .flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label__icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small, .flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label__icon {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-collapsible-wrapper {\n  height: auto;\n  width: 100%;\n  background-color: #FFFFFF;\n}\n.flight-collapsible-wrapper, .flight-collapsible-wrapper * {\n  outline: none;\n}\n.flight-collapsible-wrapper .flight-collapsible:first-child > .flight-collapsible__label {\n  border-top: 1px solid #E6E7EB;\n}\n.flight-collapsible-wrapper .flight-collapsible--disabled {\n  cursor: no-drop;\n}\n.flight-collapsible-wrapper .flight-collapsible--disabled .flight-collapsible__label {\n  pointer-events: none;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label {\n  height: 20px;\n  padding: 12px;\n  border-bottom: 1px solid #E6E7EB;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label:hover, .flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label:focus {\n  color: #051336;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label:hover--selected, .flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label:focus--selected {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  -ms-box-shadow: none;\n  -o-box-shadow: none;\n  box-shadow: none;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label:hover {\n  background-color: #DAF6FF;\n  cursor: pointer;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label:focus {\n  border: 1px solid #0851DF;\n  padding: 12px 11px;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label__icon {\n  position: relative;\n  top: 3px;\n  fill: #051336;\n  float: right;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label--disabled {\n  color: #B4B8C3;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label--disabled:hover, .flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label--disabled:focus {\n  color: #B4B8C3;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__label--disabled .flight-collapsible__label__icon {\n  fill: #B4B8C3;\n}\n.flight-collapsible-wrapper .flight-collapsible .flight-collapsible__content--selected {\n  padding: 8px 48px 24px 12px;\n  overflow-y: auto;\n  min-height: 50px;\n}";
styleInject(css_248z$7);

const DEFAULT_CLASS$6 = 'flight-collapsible';
const LABEL_CLASS = `${DEFAULT_CLASS$6}__label`;
const CONTENT_CLASS = `${DEFAULT_CLASS$6}__content`;
const FlightCollapsible = props => {
  const {
    className,
    disabled,
    onBlur,
    onClick,
    openMultiple,
    items,
    maxHeight,
    isCollapsible
  } = props;
  const stateObject = {};
  items.forEach(item => {
    Object.assign(stateObject, {
      [item.key]: CHECKBOX_STATES.UNSELECTED
    });
  });
  const [checkBoxState, setCheckBoxState] = useState(stateObject);
  const handleOnBlur = event => {
    if (disabled) return;
    if (onBlur) onBlur(event);
  };
  const handleOnClick = (event, triggeredItem) => {
    if (disabled || triggeredItem && triggeredItem.disabled) return;
    const nextStateObject = {
      ...checkBoxState
    };
    if (openMultiple) {
      if (checkBoxState[triggeredItem.key] === CHECKBOX_STATES.UNSELECTED) {
        nextStateObject[triggeredItem.key] = CHECKBOX_STATES.SELECTED;
      } else if (checkBoxState[triggeredItem.key] === CHECKBOX_STATES.SELECTED) {
        nextStateObject[triggeredItem.key] = CHECKBOX_STATES.UNSELECTED;
      }
    } else if (checkBoxState[triggeredItem.key] === CHECKBOX_STATES.UNSELECTED) {
      items.forEach(item => {
        if (item.key === triggeredItem.key) {
          nextStateObject[item.key] = CHECKBOX_STATES.SELECTED;
        } else {
          nextStateObject[item.key] = CHECKBOX_STATES.UNSELECTED;
        }
      });
    } else if (checkBoxState[triggeredItem.key] === CHECKBOX_STATES.SELECTED) {
      nextStateObject[triggeredItem.key] = CHECKBOX_STATES.UNSELECTED;
    }
    setCheckBoxState(nextStateObject);
    if (onClick) onClick(event);
  };
  const handleOnEnter = (event, item) => {
    if (event.key === EVENT_KEYS.ENTER) handleOnClick(event, item);
  };
  let wrapperClass = `${DEFAULT_CLASS$6}-wrapper`;
  wrapperClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, items.map(item => /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$6}${disabled || item.disabled ? ` ${DEFAULT_CLASS$6}--disabled` : ''}`,
    key: item.key
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${LABEL_CLASS}${disabled || item.disabled ? ` ${LABEL_CLASS}--disabled` : ''}`,
    onBlur: handleOnBlur,
    onClick: event => handleOnClick(event, item),
    onKeyDown: event => handleOnEnter(event, item),
    role: "checkbox",
    tabIndex: item.disabled || disabled ? '-1' : '0',
    disabled: item.disabled || disabled,
    "aria-checked": checkBoxState[item.key]
  }, item.name, getIcon(checkBoxState[item.key] === CHECKBOX_STATES.UNSELECTED ? 'baselineKeyboardArrowDown' : 'baselineKeyboardArrowUp', {
    className: `${LABEL_CLASS}__icon`
  })), isCollapsible && /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxHeight
    },
    className: `${CONTENT_CLASS}${checkBoxState && checkBoxState[item.key] !== CHECKBOX_STATES.UNSELECTED ? ` ${CONTENT_CLASS}--selected` : ''}`
  }, checkBoxState[item.key] === CHECKBOX_STATES.SELECTED ? item.content : null))));
};
FlightCollapsible.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  maxHeight: propTypes.string,
  onBlur: propTypes.func,
  onClick: propTypes.func,
  openMultiple: propTypes.bool,
  items: propTypes.arrayOf(propTypes.shape({
    content: propTypes.oneOfType([propTypes.node, propTypes.string]),
    disabled: propTypes.bool,
    iconLeft: propTypes.string,
    iconRight: propTypes.string,
    key: propTypes.oneOfType([propTypes.string, propTypes.number]),
    name: propTypes.oneOfType([propTypes.string, propTypes.element])
  })),
  isCollapsible: propTypes.bool
};
FlightCollapsible.defaultProps = {
  className: '',
  disabled: false,
  maxHeight: '100px',
  onBlur: () => undefined,
  onClick: () => undefined,
  openMultiple: false,
  items: [],
  isCollapsible: true
};

/**
 * Format a Date object to a local date string to display
 * for FlightDatePicker.
 *
 * @param {Object} date - Date object to be processed
 * @returns {string}
 */
function getDateString(date) {
  let isWithWeekday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!(date && typeof date === 'object')) {
    throw new Error('parameter needs to be a date object');
  }
  if (Number.isNaN(date.getTime())) return 'Invalid Date';
  return `${isWithWeekday ? `${WEEKDAYS[date.getDay()]}, ` : ''}${MONTHS[date.getMonth()].slice(0, 3)} ${date.getDate()}, ${date.getFullYear()}`;
}

/**
 * Returns true if year is a leap year and month is Feburary (1)
 *
 * @param {Number} year - Year number
 * @param {Number} month - Month number starting from 0
 * @returns {boolean}
 */
function isLeapYearFeb(year, month) {
  return month === 1 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
}

/**
 * Generate an array of objects where each object represents a week
 * within the month where the date object param is in. Each object
 * contains day of week mapping to date of the month.
 *
 * @param {Object} date - Date object to be processed
 * @returns {string}
 */
function getMonthDaysOfDate(date) {
  if (typeof date !== 'object') {
    throw new Error('parameter needs to be a date object');
  }

  // format for FlightTable tableData to consume
  const daysOfMonth = [];
  let daysOfWeek = {};

  // max # of days of the selected month, accounting for the
  //  extra day in Feburary of a leap year
  let monthMaxDays = MONTH_DAYS[date.getMonth()];
  if (isLeapYearFeb) monthMaxDays += 1;

  // start from first day of the selected month and fill up
  //  daysOfMonth and daysOfWeek
  const startDate = new Date(date);
  startDate.setDate(1);
  while (startDate.getDate() <= monthMaxDays && startDate.getMonth() === date.getMonth()) {
    daysOfWeek[WEEKDAYS[startDate.getDay()]] = startDate.getDate();
    if (startDate.getDay() === WEEKDAYS.length - 1) {
      daysOfMonth.push(daysOfWeek);
      daysOfWeek = {};
    }
    startDate.setDate(startDate.getDate() + 1);
  }
  if (Object.keys(daysOfWeek).length > 0) {
    daysOfMonth.push(daysOfWeek);
  }
  return daysOfMonth;
}

var css_248z$8 = ".flight-font, .flight-tooltip__tooltip {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-tooltip__tooltip {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-tooltip {\n  position: relative;\n  display: inline-block;\n}\n.flight-tooltip__tooltip {\n  border-radius: 4px;\n  background-color: #051336;\n  color: #FFFFFF;\n  padding: 8px;\n  position: absolute;\n  display: none;\n  z-index: 1;\n  width: max-content;\n}\n.flight-tooltip__tooltip--right {\n  left: calc(100% + 4px);\n  top: 50%;\n  transform: translateY(-50%);\n}\n.flight-tooltip__tooltip--left {\n  right: calc(100% + 4px);\n  top: 50%;\n  transform: translateY(-50%);\n}\n.flight-tooltip__tooltip--top {\n  bottom: calc(100% + 4px);\n  left: 50%;\n  transform: translateX(-50%);\n}\n.flight-tooltip__tooltip--bottom {\n  top: calc(100% + 4px);\n  left: 50%;\n  transform: translateX(-50%);\n}\n.flight-tooltip__tooltip--show {\n  display: block;\n}";
styleInject(css_248z$8);

const DEFAULT_CLASS$7 = 'flight-tooltip';
const TOOLTIP_CLASS = `${DEFAULT_CLASS$7}__tooltip`;
const FlightTooltip = props => {
  const {
    children,
    description,
    isEnabled,
    className,
    direction,
    maxWidth,
    delay,
    ariaLabel,
    tabIndex
  } = props;
  const [isShown, setIsShown] = useState(false);
  let timeOutId = null;
  const tooltipRef = element => {
    if (element) {
      // Resize component width based on props.width
      /* eslint-disable no-param-reassign */
      element.style.maxWidth = maxWidth;
    }
  };
  const handleEnterTooltip = () => {
    timeOutId = setTimeout(() => {
      setIsShown(true);
    }, delay);
  };
  const handleLeaveTooltip = () => {
    setIsShown(false);
    clearTimeout(timeOutId);
  };
  let wrapperClass = DEFAULT_CLASS$7;
  wrapperClass += className ? ` ${className}` : '';
  let mainClass = TOOLTIP_CLASS;
  mainClass += ` ${TOOLTIP_CLASS}--${direction}`;
  mainClass += isEnabled && isShown ? ` ${TOOLTIP_CLASS}--show` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass,
    "aria-live": "polite"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$7}__content`,
    onFocus: handleEnterTooltip,
    onBlur: handleLeaveTooltip,
    onMouseEnter: handleEnterTooltip,
    onMouseLeave: handleLeaveTooltip,
    tabIndex: tabIndex,
    role: "tooltip",
    "aria-label": ariaLabel
  }, children), /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    ref: tooltipRef
  }, description));
};
FlightTooltip.propTypes = {
  children: propTypes.node.isRequired,
  description: propTypes.node.isRequired,
  className: propTypes.string,
  isEnabled: propTypes.bool,
  direction: propTypes.string,
  maxWidth: propTypes.string,
  delay: propTypes.number,
  ariaLabel: propTypes.string,
  tabIndex: propTypes.number
};
FlightTooltip.defaultProps = {
  className: '',
  isEnabled: true,
  direction: 'bottom',
  maxWidth: '260px',
  delay: 400,
  ariaLabel: '',
  tabIndex: 0
};

var css_248z$9 = ".flight-font, .flight-text-input__input, .flight-text-input-wrapper {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-text-input__error-message {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-text-input__input, .flight-text-input-wrapper {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon, .flight-text-input__icon-trailing, .flight-text-input__icon-input__svg {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-text-input-wrapper, .flight-text-input-wrapper * {\n  outline: none;\n}\n\n.flight-text-input {\n  position: relative;\n  display: block;\n  max-width: 100%;\n}\n.flight-text-input__label, .flight-text-input__icon-input, .flight-text-input__icon-trailing {\n  position: absolute;\n  top: 10px;\n}\n.flight-text-input__label, .flight-text-input__border {\n  -webkit-transition-delay: 0s;\n  -moz-transition-delay: 0s;\n  -ms-transition-delay: 0s;\n  -o-transition-delay: 0s;\n  transition-delay: 0s;\n  -webkit-transition-duration: 0.15s;\n  -moz-transition-duration: 0.15s;\n  -ms-transition-duration: 0.15s;\n  -o-transition-duration: 0.15s;\n  transition-duration: 0.15s;\n  -webkit-transition-property: all;\n  -moz-transition-property: all;\n  -ms-transition-property: all;\n  -o-transition-property: all;\n  transition-property: all;\n  -webkit-transition-timing-function: ease;\n  -moz-transition-timing-function: ease;\n  -ms-transition-timing-function: ease;\n  -o-transition-timing-function: ease;\n  transition-timing-function: ease;\n}\n.flight-text-input__label {\n  left: 8px;\n  color: #697186;\n  transform-origin: 0 0;\n  pointer-events: none;\n}\n.flight-text-input__border {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 1px;\n  width: 100%;\n  background-color: #0851DF;\n  transform: scaleX(0);\n}\n.flight-text-input__input {\n  -webkit-appearance: none;\n  background-color: #F2F3F5;\n  width: calc(100% - 8px);\n  padding: 12px 0 0 8px;\n  height: calc(\n    28px);\n  border: none;\n  border-bottom: 1px solid #B4B8C3;\n  border-radius: 5px 5px 0 0;\n  color: #051336;\n}\n.flight-text-input__input::-webkit-placeholder {\n  color: #9BA1AF;\n  opacity: 0;\n}\n.flight-text-input__input::-moz-placeholder {\n  color: #9BA1AF;\n  opacity: 0;\n}\n.flight-text-input__input::-ms-placeholder {\n  color: #9BA1AF;\n  opacity: 0;\n}\n.flight-text-input__input::-o-placeholder {\n  color: #9BA1AF;\n  opacity: 0;\n}\n.flight-text-input__input::placeholder {\n  color: #9BA1AF;\n  opacity: 0;\n}\n.flight-text-input__input--with-clear-icon {\n  padding-right: 36px;\n  width: calc(100% - 44px);\n}\n.flight-text-input__input--without-label {\n  padding-top: 0;\n  height: 40px;\n}\n.flight-text-input__input--without-label::-webkit-placeholder {\n  opacity: 1;\n}\n.flight-text-input__input--without-label::-moz-placeholder {\n  opacity: 1;\n}\n.flight-text-input__input--without-label::-ms-placeholder {\n  opacity: 1;\n}\n.flight-text-input__input--without-label::-o-placeholder {\n  opacity: 1;\n}\n.flight-text-input__input--without-label::placeholder {\n  opacity: 1;\n}\n.flight-text-input__input--lite {\n  border-bottom: none;\n  border-radius: 3px;\n  background: transparent;\n}\n.flight-text-input__input--lite:focus, .flight-text-input__input--lite:hover {\n  box-shadow: 0px 0px 0px 1px #0851DF;\n}\n.flight-text-input__input:hover {\n  border-color: #505A72;\n}\n.flight-text-input__input:focus, .flight-text-input__input--not-empty {\n  outline: none;\n}\n.flight-text-input__input:focus ~ .flight-text-input__label, .flight-text-input__input--not-empty ~ .flight-text-input__label {\n  transform: translateY(-8px) scale(0.85);\n}\n.flight-text-input__input:focus::-webkit-placeholder {\n  opacity: 1;\n}\n.flight-text-input__input:focus::-moz-placeholder {\n  opacity: 1;\n}\n.flight-text-input__input:focus::-ms-placeholder {\n  opacity: 1;\n}\n.flight-text-input__input:focus::-o-placeholder {\n  opacity: 1;\n}\n.flight-text-input__input:focus::placeholder {\n  opacity: 1;\n}\n.flight-text-input__input:focus ~ .flight-text-input__label {\n  color: #0851DF;\n}\n.flight-text-input__input:focus ~ .flight-text-input__border {\n  height: 2px;\n  transform: scaleX(1);\n}\n.flight-text-input__input--focus-hide-label:not(.flight-text-input__input--without-label) {\n  padding-top: 0;\n  height: 40px;\n}\n.flight-text-input__input--focus-hide-label:not(.flight-text-input__input--without-label):focus ~ .flight-text-input__label, .flight-text-input__input--focus-hide-label:not(.flight-text-input__input--without-label).flight-text-input__input--not-empty ~ .flight-text-input__label {\n  display: none;\n}\n.flight-text-input__input--rtl {\n  direction: rtl;\n  padding-right: 8px;\n  width: calc(100% - 16px);\n}\n.flight-text-input__input--with-clear-icon.flight-text-input__input--rtl {\n  padding-right: 36px;\n  width: calc(100% - 44px);\n}\n.flight-text-input--with-icon-input .flight-text-input__icon-trailing ~ .flight-text-input__input--rtl:not(.flight-text-input__input--with-clear-icon) {\n  width: calc(100% - 72px);\n  padding-right: 36px;\n}\n.flight-text-input__icon-input {\n  padding-left: 8px;\n}\n.flight-text-input__icon-input__svg {\n  left: 8px;\n  fill: #697186;\n}\n.flight-text-input__icon-input ~ .flight-text-input__label {\n  left: 36px;\n}\n.flight-text-input__icon-input ~ .flight-text-input__input {\n  padding-left: 36px;\n  width: calc(100% - 36px);\n}\n.flight-text-input__icon-input ~ .flight-text-input__input--with-clear-icon {\n  width: calc(100% - 72px);\n}\n.flight-text-input__icon-input ~ .flight-text-input__input--rtl {\n  width: calc(100% - 44px);\n}\n.flight-text-input__icon-input ~ .flight-text-input__input--with-clear-icon, .flight-text-input__icon-input ~ .flight-text-input__input--rtl ~ .flight-text-input__icon-input ~ .flight-text-input__input--not-empty {\n  width: calc(100% - 72px);\n  padding-right: 36px;\n}\n.flight-text-input__icon-trailing {\n  display: flex;\n  align-items: center;\n  right: 8px;\n  padding: 0;\n  fill: #505A72;\n  border: 1px solid transparent;\n  background: none;\n  line-height: 1;\n}\n.flight-text-input__icon-trailing svg {\n  max-width: 100%;\n  max-height: 100%;\n}\n.flight-text-input__icon-trailing:focus {\n  border: 1px solid #0851DF;\n}\n.flight-text-input__icon-trailing:active {\n  fill: #37425E;\n}\n.flight-text-input__icon-trailing--error {\n  fill: #DC3616;\n}\n.flight-text-input__icon-trailing--error:active {\n  fill: #DC3616;\n}\n.flight-text-input__icon-trailing ~ .flight-text-input__input--rtl:not(.flight-text-input__input--with-clear-icon) {\n  width: calc(100% - 44px);\n  padding-right: 36px;\n}\n.flight-text-input__icon-trailing .flight-tooltip__content:focus {\n  border: 1px solid #0851DF;\n}\n.flight-text-input__error-message {\n  color: #DC3616;\n  padding-left: 8px;\n  display: block;\n}\n.flight-text-input__error-message--disabled {\n  color: #B4B8C3;\n}\n.flight-text-input--rtl ~ .flight-text-input__error-message {\n  text-align: right;\n  padding-right: 8px;\n  direction: rtl;\n}\n.flight-text-input--error {\n  margin-bottom: 4px;\n}\n.flight-text-input--error .flight-text-input__input {\n  border-color: #DC3616;\n}\n.flight-text-input--error .flight-text-input__input:focus ~ .flight-text-input__label {\n  color: #DC3616;\n}\n.flight-text-input--error .flight-text-input__input--rtl {\n  width: calc(100% - 72px);\n  padding-right: 36px;\n}\n.flight-text-input--error .flight-text-input__border {\n  background-color: #DC3616;\n}\n.flight-text-input--disabled {\n  cursor: no-drop;\n}\n.flight-text-input--disabled .flight-text-input__icon-input__svg,\n.flight-text-input--disabled .flight-text-input__icon-trailing {\n  fill: #B4B8C3;\n}\n.flight-text-input--disabled .flight-text-input__input {\n  border-color: #CDD0D7;\n  pointer-events: none;\n}\n.flight-text-input--disabled .flight-text-input__input,\n.flight-text-input--disabled .flight-text-input__label {\n  color: #B4B8C3;\n}";
styleInject(css_248z$9);

const INPUT_TYPES = {
  text: 'text',
  password: 'password'
};
const DEFAULT_MAX_LENGTH = 250;
const DEFAULT_CLASS$8 = 'flight-text-input';
const DEFAULT_THEME = 'primary';
const INPUT_CLASS = `${DEFAULT_CLASS$8}__input`;
const ERROR_CLASS = `${DEFAULT_CLASS$8}__error-message`;
const FlightTextInput = props => {
  const {
    className,
    disabled,
    errorMessage,
    hasClearIcon,
    hasError,
    iconInput,
    inputRef,
    label,
    labelId,
    ariaLabel,
    name,
    placeholderText,
    trailingIcon,
    trailingIconLabel,
    trailingIconTooltipDescription,
    type,
    value,
    width,
    onLoad,
    onChange,
    onBlur,
    onFocus,
    onKeyDown,
    onKeyPress,
    maxLength,
    isLabelAlwaysOn,
    autoFocus,
    direction,
    customClass,
    isAriaRequired,
    isAriaAutocomplete,
    theme
  } = props;
  const [isShowPassword, setIsShowPassword] = useState(false);
  const wrapperRef = element => {
    if (element) {
      // Resize component width based on this.props.width
      /* eslint-disable no-param-reassign */
      element.style.width = width;
    }
  };
  let ref = inputRef;
  if (autoFocus && !inputRef) ref = /*#__PURE__*/React__default.createRef();
  useEffect(() => {
    if (onLoad) onLoad();
    if (autoFocus && ref && ref.current) {
      ref.current.focus({
        preventScroll: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleValueChange = event => {
    if (disabled) return;
    event.target.value = event.target.value.slice(0, maxLength);
    if (onChange) onChange(event);
  };
  const handleOnBlur = event => {
    if (disabled) return;
    if (onBlur) onBlur(event);
  };
  const handleOnFocus = event => {
    if (disabled) return;
    if (onFocus) onFocus(event);
  };
  const handleKeyDown = event => {
    if (disabled) return;
    if (onKeyDown) onKeyDown(event);
  };
  const handleKeyPress = event => {
    if (disabled) return;
    if (onKeyPress) onKeyPress(event);
  };
  const handleTrailingIconClear = () => {
    handleValueChange({
      target: {
        value: ''
      }
    });
  };
  const handleToggleShowPassword = () => {
    setIsShowPassword(!isShowPassword);
  };

  // Theme Information
  const themeName = theme.toLowerCase();
  const isLiteTheme = themeName === 'lite';
  const isLabelOn = isLiteTheme ? false : isLabelAlwaysOn;
  let labelWrapperClass = DEFAULT_CLASS$8;
  labelWrapperClass += iconInput ? ` ${DEFAULT_CLASS$8}--with-icon-input` : '';
  labelWrapperClass += hasError ? ` ${DEFAULT_CLASS$8}--error` : '';
  labelWrapperClass += disabled ? ` ${DEFAULT_CLASS$8}--disabled` : '';
  labelWrapperClass += direction === 'rtl' ? ` ${DEFAULT_CLASS$8}--rtl` : '';
  labelWrapperClass += className ? ` ${className}` : '';
  let inputClass = INPUT_CLASS;
  inputClass += value && hasClearIcon ? ` ${INPUT_CLASS}--with-clear-icon` : '';
  inputClass += !label ? ` ${INPUT_CLASS}--without-label` : '';
  inputClass += !isLabelOn ? ` ${INPUT_CLASS}--focus-hide-label` : '';
  inputClass += value ? ` ${INPUT_CLASS}--not-empty` : '';
  inputClass += direction ? ` ${INPUT_CLASS}--${direction}` : '';
  inputClass += isLiteTheme ? ` ${INPUT_CLASS}--${themeName}` : '';
  let errorMessageClass = ERROR_CLASS;
  errorMessageClass += disabled ? ` ${ERROR_CLASS}--disabled` : '';
  const iconSvgInputTrailingClass = `${DEFAULT_CLASS$8}__icon-trailing__icon`;
  let iconInputTrailingClass = `${DEFAULT_CLASS$8}__icon-trailing`;
  iconInputTrailingClass += type !== INPUT_TYPES.password && hasError && (!value || !hasClearIcon) ? ` ${DEFAULT_CLASS$8}__icon-trailing--error` : '';
  let iconInputTrailing = null;
  let iconInputTrailingAriaLabel = '';
  let iconInputTrailingOnClickHandler = () => null;
  if (type === INPUT_TYPES.password) {
    const passwordIconProps = {
      className: iconSvgInputTrailingClass
    };
    iconInputTrailingOnClickHandler = handleToggleShowPassword;
    iconInputTrailing = isShowPassword ? getIcon('eyeHide', passwordIconProps) : getIcon('eyeOpen', passwordIconProps);
    iconInputTrailingAriaLabel = isShowPassword ? 'Show password' : 'Hide password';
  } else if (trailingIcon) {
    iconInputTrailing = getIcon(trailingIcon, {
      className: iconSvgInputTrailingClass
    });
    iconInputTrailingAriaLabel = trailingIconLabel;
  } else if (hasClearIcon && value.length > 0 && !disabled) {
    iconInputTrailing = getIcon('clear', {
      className: iconSvgInputTrailingClass
    });
    iconInputTrailingOnClickHandler = handleTrailingIconClear;
    iconInputTrailingAriaLabel = 'clear field';
  } else if (hasError) {
    iconInputTrailing = getIcon('error', {
      className: iconSvgInputTrailingClass
    });
    iconInputTrailingAriaLabel = 'error';
  }
  const TrailingIcon = _ref => {
    let {
      children
    } = _ref;
    return type === INPUT_TYPES.password || iconInputTrailingAriaLabel === 'clear field' ? /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: iconInputTrailingClass,
      "aria-label": iconInputTrailingAriaLabel,
      onClick: iconInputTrailingOnClickHandler
    }, children) : /*#__PURE__*/React__default.createElement("div", {
      className: iconInputTrailingClass,
      tabIndex: "-1",
      role: "alert",
      "aria-label": iconInputTrailingAriaLabel
    }, children);
  };
  TrailingIcon.propTypes = {
    children: propTypes.node.isRequired
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: `flight-text-input-wrapper ${customClass}`,
    ref: wrapperRef
  }, /*#__PURE__*/React__default.createElement("label", {
    className: labelWrapperClass,
    htmlFor: labelId
  }, iconInput && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$8}__icon-input`
  }, getIcon(iconInput, {
    className: `${DEFAULT_CLASS$8}__icon-input__svg`
  })), /*#__PURE__*/React__default.createElement("input", {
    className: inputClass,
    disabled: disabled,
    "aria-disabled": disabled,
    name: name,
    "aria-autocomplete": isAriaAutocomplete ? 'list' : 'none',
    "aria-required": isAriaRequired,
    "aria-label": ariaLabel || label,
    onChange: handleValueChange,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    onKeyDown: handleKeyDown,
    onKeyPress: handleKeyPress,
    placeholder: placeholderText,
    autoComplete: type === INPUT_TYPES.password ? 'current-password' : '',
    ref: ref,
    type: type === INPUT_TYPES.password && !isShowPassword ? INPUT_TYPES.password : INPUT_TYPES.text,
    value: value,
    id: labelId
  }), iconInputTrailing && /*#__PURE__*/React__default.createElement(TrailingIcon, null, hasError && iconInputTrailingAriaLabel === 'error' ? /*#__PURE__*/React__default.createElement(FlightTooltip, {
    direction: "top",
    isEnabled: true,
    description: trailingIconTooltipDescription,
    tabIndex: -1
  }, iconInputTrailing) : iconInputTrailing), label && (!value || isLabelOn) && /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$8}__label`
  }, label), themeName === DEFAULT_THEME && /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$8}__border`
  })), hasError && errorMessage && /*#__PURE__*/React__default.createElement("span", {
    role: "alert",
    "aria-atomic": true,
    className: errorMessageClass
  }, errorMessage));
};
FlightTextInput.propTypes = {
  autoFocus: propTypes.bool,
  className: propTypes.string,
  direction: propTypes.string,
  disabled: propTypes.bool,
  errorMessage: propTypes.oneOfType([propTypes.string, propTypes.element]),
  hasClearIcon: propTypes.bool,
  hasError: propTypes.bool,
  iconInput: propTypes.string,
  inputRef: propTypes.shape({
    current: propTypes.shape({
      focus: propTypes.func
    })
  }),
  isLabelAlwaysOn: propTypes.bool,
  label: propTypes.string,
  labelId: propTypes.string,
  ariaLabel: propTypes.string,
  onBlur: propTypes.func,
  onFocus: propTypes.func,
  onChange: propTypes.func,
  onKeyDown: propTypes.func,
  onKeyPress: propTypes.func,
  onLoad: propTypes.func,
  name: propTypes.string,
  maxLength: propTypes.number,
  placeholderText: propTypes.string,
  trailingIcon: propTypes.string,
  trailingIconLabel: propTypes.string,
  trailingIconTooltipDescription: propTypes.string,
  type: propTypes.string,
  value: propTypes.string,
  width: propTypes.string,
  customClass: propTypes.string,
  isAriaRequired: propTypes.bool,
  isAriaAutocomplete: propTypes.bool,
  theme: propTypes.oneOf([DEFAULT_THEME, 'lite'])
};
FlightTextInput.defaultProps = {
  autoFocus: false,
  className: '',
  disabled: false,
  errorMessage: null,
  hasClearIcon: false,
  hasError: false,
  iconInput: '',
  inputRef: null,
  isLabelAlwaysOn: true,
  label: '',
  labelId: undefined,
  ariaLabel: '',
  name: null,
  maxLength: DEFAULT_MAX_LENGTH,
  onBlur: () => undefined,
  onFocus: () => undefined,
  onChange: () => undefined,
  onKeyDown: () => undefined,
  onKeyPress: () => undefined,
  onLoad: () => undefined,
  placeholderText: '',
  trailingIcon: '',
  trailingIconLabel: 'Icon',
  trailingIconTooltipDescription: 'Icon',
  type: 'text',
  value: '',
  width: '232px',
  direction: 'ltr',
  customClass: '',
  isAriaRequired: false,
  isAriaAutocomplete: false,
  theme: DEFAULT_THEME
};

function Portal$1(_ref) {
  let {
    children,
    className = 'root-portal',
    el = 'div'
  } = _ref;
  // This useState will be executed only on the initial render
  // https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
  const [container] = useState(() => document.createElement(el));
  React__default.useEffect(() => {
    container.classList.value = className;
    document.body.appendChild(container);
    return () => document.body.removeChild(container);
  }, [className, container]);
  return /*#__PURE__*/createPortal(children, container);
}

const OFFSET = 2; // Distance between trigger and popover
const VIEWPORT_OFFSET = 16; // Minimum distance from viewport edges

function useFixedPosition(direction) {
  const [triggerNode, setTriggerNode] = useState(null);
  const [popoverNode, setPopoverNode] = useState(null);
  const setTriggerElement = useCallback(node => {
    if (node !== null) setTriggerNode(node);
  }, []);
  const setPopoverElement = useCallback(node => {
    if (node !== null) setPopoverNode(node);
  }, []);
  const setFixedPosition = useCallback(() => {
    if (!triggerNode || !popoverNode) return;
    const triggerRect = triggerNode.getBoundingClientRect();
    const popoverRect = popoverNode.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
    const viewportHeight = document.documentElement.clientHeight || window.innerHeight;
    let styles;

    // Initial position based on direction
    switch (direction) {
      case 'top':
        styles = {
          top: `${triggerRect.top - popoverRect.height - OFFSET}px`,
          left: `${triggerRect.left}px`,
          visibility: 'visible'
        };
        break;
      case 'right':
        styles = {
          top: `${triggerRect.top}px`,
          left: `${triggerRect.right + OFFSET}px`,
          visibility: 'visible'
        };
        break;
      case 'left':
        styles = {
          top: `${triggerRect.top}px`,
          left: `${triggerRect.left - popoverRect.width - OFFSET}px`,
          visibility: 'visible'
        };
        break;
      case 'bottom':
      default:
        styles = {
          top: `${triggerRect.bottom + OFFSET}px`,
          left: `${triggerRect.left}px`,
          visibility: 'visible'
        };
    }

    // Apply initial styles
    Object.assign(popoverNode.style, styles);

    // Recalculate positioning if the popover overflows the viewport
    const dropdownRect = popoverNode.getBoundingClientRect();
    let adjustedTop = parseFloat(styles.top);
    let adjustedLeft = parseFloat(styles.left);
    const canFitAbove = triggerRect.top - popoverRect.height > VIEWPORT_OFFSET;
    const canFitBelow = viewportHeight - triggerRect.bottom > popoverRect.height + VIEWPORT_OFFSET;
    const canFitLeft = triggerRect.left - popoverRect.width > VIEWPORT_OFFSET;
    const canFitRight = viewportWidth - triggerRect.right > popoverRect.width + VIEWPORT_OFFSET;
    if (dropdownRect.top < 0 && canFitBelow) {
      // Move to bottom if top overflows and there's space below
      adjustedTop = triggerRect.bottom + OFFSET;
    } else if (dropdownRect.bottom > viewportHeight && canFitAbove) {
      // Move to top if bottom overflows and there's space above
      adjustedTop = triggerRect.top - popoverRect.height - OFFSET;
    }
    if (dropdownRect.left < 0 && canFitRight) {
      // Move to right if left overflows and there's space on the right
      adjustedLeft = triggerRect.right + OFFSET;
    } else if (dropdownRect.right > viewportWidth && canFitLeft) {
      // Move to left if right overflows and there's space on the left
      adjustedLeft = triggerRect.left - popoverRect.width - OFFSET;
    }

    // Apply adjusted styles if necessary
    Object.assign(popoverNode.style, {
      top: `${adjustedTop}px`,
      left: `${adjustedLeft}px`
    });
  }, [direction, popoverNode, triggerNode]);

  // Recalculate position when triggerNode or popoverNode changes
  useEffect(() => {
    if (!triggerNode || !popoverNode) return;
    setFixedPosition();
  }, [triggerNode, popoverNode, setFixedPosition]);

  // Observe size changes in the trigger element
  useEffect(() => {
    if (!triggerNode) return;
    const observer = new ResizeObserver(() => {
      setFixedPosition();
    });
    observer.observe(triggerNode);
    return () => observer.disconnect();
  }, [triggerNode, setFixedPosition]);
  return {
    setTriggerElement,
    setPopoverElement,
    setFixedPosition
  };
}

const handleKeyDownHelper = function (activateFunc, cancelFunc) {
  let preventDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return e => {
    switch (e.key) {
      case 'Esc':
      case 'Escape':
        if (typeof cancelFunc === 'function') {
          if (preventDefault) e.preventDefault();
          cancelFunc();
        }
        break;
      case ' ':
      case 'Spacebar':
      case 'Enter':
        if (typeof activateFunc === 'function') {
          if (preventDefault) e.preventDefault();
          activateFunc();
        }
        break;
    }
  };
};

var css_248z$a = ".flight-font, .flight-dropdown__dropdown {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-dropdown {\n  display: inline-block;\n  max-width: 100%;\n  position: relative;\n}\n.flight-dropdown, .flight-dropdown * {\n  outline: none;\n}\n.flight-dropdown__outside {\n  position: fixed;\n  padding: 0;\n  margin: 0;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  z-index: 999;\n}\n.flight-dropdown__trigger {\n  cursor: pointer;\n}\n.flight-dropdown__trigger, .flight-dropdown__trigger * {\n  outline: none;\n}\n.flight-dropdown__dropdown {\n  -webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -ms-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -o-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  width: min-content;\n  background-color: white;\n  border-radius: 4px;\n  display: block;\n  padding: 8px 0;\n  position: fixed;\n  z-index: 1000;\n  overflow: auto;\n  overflow-wrap: break-word;\n  visibility: hidden;\n  box-sizing: border-box;\n}\n.flight-dropdown__dropdown, .flight-dropdown__dropdown * {\n  outline: none;\n}";
styleInject(css_248z$a);

const DEFAULT_CLASS$9 = 'flight-dropdown';
const OUTSIDE_CLASS = `${DEFAULT_CLASS$9}__outside`;
const DROPDOWN_CLASS = `${DEFAULT_CLASS$9}__dropdown`;
const FlightDropdown = props => {
  const {
    children,
    className,
    direction,
    trigger,
    maxHeight,
    maxWidth,
    ariaControlsId,
    isActive,
    autoFocus,
    isControlledByIsActive,
    handleTriggerClick,
    handleClickOutside,
    hasOutsideTrigger
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const parentRef = useRef({});
  const focusRef = useRef(null);
  const {
    setTriggerElement,
    setPopoverElement,
    setFixedPosition
  } = useFixedPosition(direction);
  const handleOnTriggerClick = event => {
    setIsOpen(true);
    handleTriggerClick(event);
  };
  const handleOnClickOutside = event => {
    setIsOpen(false);
    handleClickOutside(event);
    if (autoFocus) {
      parentRef.current.children[0].focus();
    }
  };
  useEffect(() => {
    if (isOpen && !isControlledByIsActive || isActive && isControlledByIsActive) {
      setFixedPosition();
      window.addEventListener('resize', setFixedPosition);
      document.addEventListener('scroll', setFixedPosition, true);
      if (autoFocus) {
        const correctFocusElIndex = focusRef.current.children.length > 1 ? 1 : 0;
        focusRef.current.children[correctFocusElIndex].focus();
      }
    }
    return () => {
      window.removeEventListener('resize', setFixedPosition);
      document.removeEventListener('scroll', setFixedPosition, true);
    };
  }, [isOpen, direction, isControlledByIsActive, isActive, autoFocus, setFixedPosition]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$9}${className ? ` ${className}` : ''}`,
    ref: parentRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$9}__trigger`,
    onClick: handleOnTriggerClick,
    onKeyDown: handleKeyDownHelper(handleOnTriggerClick, false, true),
    ref: setTriggerElement,
    "aria-haspopup": "true",
    "aria-controls": `dropdown-${ariaControlsId}`,
    "aria-expanded": isActive && (isOpen || isControlledByIsActive),
    role: "button",
    tabIndex: "-1"
  }, trigger), isActive && (isOpen || isControlledByIsActive) && /*#__PURE__*/React__default.createElement(Portal$1, {
    className: className ? `${className.split(' ').shift()}__portal` : undefined
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: focusRef,
    role: "button",
    tabIndex: "-1",
    onKeyDown: handleKeyDownHelper(handleOnTriggerClick, false, true)
  }, hasOutsideTrigger && /*#__PURE__*/React__default.createElement("div", {
    className: `${OUTSIDE_CLASS}`,
    onClick: handleOnClickOutside,
    onKeyDown: () => undefined,
    role: "button",
    tabIndex: "-1",
    "aria-label": "dropdown-outside"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${DROPDOWN_CLASS}`,
    ref: setPopoverElement,
    "aria-hidden": "false",
    role: "dialog",
    id: `dropdown-${ariaControlsId}`,
    tabIndex: "0",
    style: {
      width: isControlledByIsActive && !hasOutsideTrigger && parentRef.current ? parentRef.current.offsetWidth : undefined,
      maxWidth: maxWidth || (isControlledByIsActive && parentRef.current ? parentRef.current.offsetWidth : null),
      maxHeight
    }
  }, children))));
};
FlightDropdown.propTypes = {
  children: propTypes.element.isRequired,
  className: propTypes.string,
  direction: propTypes.string,
  trigger: propTypes.element.isRequired,
  maxHeight: propTypes.string,
  maxWidth: propTypes.string,
  ariaControlsId: propTypes.string,
  isActive: propTypes.bool,
  autoFocus: propTypes.bool,
  hasOutsideTrigger: propTypes.bool,
  isControlledByIsActive: propTypes.bool,
  handleTriggerClick: propTypes.func,
  handleClickOutside: propTypes.func
};
FlightDropdown.defaultProps = {
  className: '',
  direction: '',
  maxHeight: null,
  maxWidth: null,
  ariaControlsId: '',
  isActive: true,
  autoFocus: false,
  isControlledByIsActive: false,
  hasOutsideTrigger: true,
  handleTriggerClick: () => undefined,
  handleClickOutside: () => undefined
};

/**
 * Create the React Context
 */

var DndContext = createContext({
  dragDropManager: undefined
});

var HandlerRole;

(function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
}

var INIT_COORDS = 'dnd-core/INIT_COORDS';
var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = 'dnd-core/HOVER';
var DROP = 'dnd-core/DROP';
var END_DRAG = 'dnd-core/END_DRAG';

function setClientOffset(clientOffset, sourceClientOffset) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: sourceClientOffset || null,
      clientOffset: clientOffset || null
    }
  };
}

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// cheap lodash replacements

/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */
function get(obj, path, defaultValue) {
  return path.split('.').reduce(function (a, c) {
    return a && a[c] ? a[c] : defaultValue || null;
  }, obj);
}
/**
 * drop-in replacement for _.without
 */

function without(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
/**
 * drop-in replacement for _.isString
 * @param input
 */

function isObject(input) {
  return _typeof(input) === 'object';
}
/**
 * repalcement for _.xor
 * @param itemsA
 * @param itemsB
 */

function xor(itemsA, itemsB) {
  var map = new Map();

  var insertItem = function insertItem(item) {
    map.set(item, map.has(item) ? map.get(item) + 1 : 1);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  map.forEach(function (count, key) {
    if (count === 1) {
      result.push(key);
    }
  });
  return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */

function intersection(itemsA, itemsB) {
  return itemsA.filter(function (t) {
    return itemsB.indexOf(t) > -1;
  });
}

var ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(manager) {
  return function beginDrag() {
    var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      publishSource: true
    };
    var _options$publishSourc = options.publishSource,
        publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc,
        clientOffset = options.clientOffset,
        getSourceClientOffset = options.getSourceClientOffset;
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry(); // Initialize the coordinates using the client offset

    manager.dispatch(setClientOffset(clientOffset));
    verifyInvariants(sourceIds, monitor, registry); // Get the draggable source

    var sourceId = getDraggableSource(sourceIds, monitor);

    if (sourceId === null) {
      manager.dispatch(ResetCoordinatesAction);
      return;
    } // Get the source client offset


    var sourceClientOffset = null;

    if (clientOffset) {
      if (!getSourceClientOffset) {
        throw new Error('getSourceClientOffset must be defined');
      }

      verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
      sourceClientOffset = getSourceClientOffset(sourceId);
    } // Initialize the full coordinates


    manager.dispatch(setClientOffset(clientOffset, sourceClientOffset));
    var source = registry.getSource(sourceId);
    var item = source.beginDrag(monitor, sourceId); // If source.beginDrag returns null, this is an indicator to cancel the drag

    if (item == null) {
      return undefined;
    }

    verifyItemIsObject(item);
    registry.pinSource(sourceId);
    var itemType = registry.getSourceType(sourceId);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType: itemType,
        item: item,
        sourceId: sourceId,
        clientOffset: clientOffset || null,
        sourceClientOffset: sourceClientOffset || null,
        isSourcePublic: !!publishSource
      }
    };
  };
}

function verifyInvariants(sourceIds, monitor, registry) {
  invariant(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
  sourceIds.forEach(function (sourceId) {
    invariant(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
  });
}

function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
  invariant(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}

function verifyItemIsObject(item) {
  invariant(isObject(item), 'Item must be an object.');
}

function getDraggableSource(sourceIds, monitor) {
  var sourceId = null;

  for (var i = sourceIds.length - 1; i >= 0; i--) {
    if (monitor.canDragSource(sourceIds[i])) {
      sourceId = sourceIds[i];
      break;
    }
  }

  return sourceId;
}

function createPublishDragSource(manager) {
  return function publishDragSource() {
    var monitor = manager.getMonitor();

    if (monitor.isDragging()) {
      return {
        type: PUBLISH_DRAG_SOURCE
      };
    }
  };
}

function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }

  return Array.isArray(targetType) ? targetType.some(function (t) {
    return t === draggedItemType;
  }) : targetType === draggedItemType;
}

function createHover(manager) {
  return function hover(targetIdsArg) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        clientOffset = _ref.clientOffset;

    verifyTargetIdsIsArray(targetIdsArg);
    var targetIds = targetIdsArg.slice(0);
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    checkInvariants(targetIds, monitor, registry);
    var draggedItemType = monitor.getItemType();
    removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
    hoverAllTargets(targetIds, monitor, registry);
    return {
      type: HOVER,
      payload: {
        targetIds: targetIds,
        clientOffset: clientOffset || null
      }
    };
  };
}

function verifyTargetIdsIsArray(targetIdsArg) {
  invariant(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}

function checkInvariants(targetIds, monitor, registry) {
  invariant(monitor.isDragging(), 'Cannot call hover while not dragging.');
  invariant(!monitor.didDrop(), 'Cannot call hover after drop.');

  for (var i = 0; i < targetIds.length; i++) {
    var targetId = targetIds[i];
    invariant(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
    var target = registry.getTarget(targetId);
    invariant(target, 'Expected targetIds to be registered.');
  }
}

function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
  // Remove those targetIds that don't match the targetType.  This
  // fixes shallow isOver which would only be non-shallow because of
  // non-matching targets.
  for (var i = targetIds.length - 1; i >= 0; i--) {
    var targetId = targetIds[i];
    var targetType = registry.getTargetType(targetId);

    if (!matchesType(targetType, draggedItemType)) {
      targetIds.splice(i, 1);
    }
  }
}

function hoverAllTargets(targetIds, monitor, registry) {
  // Finally call hover on all matching targets.
  targetIds.forEach(function (targetId) {
    var target = registry.getTarget(targetId);
    target.hover(monitor, targetId);
  });
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function createDrop(manager) {
  return function drop() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyInvariants$1(monitor);
    var targetIds = getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action

    targetIds.forEach(function (targetId, index) {
      var dropResult = determineDropResult(targetId, index, registry, monitor);
      var action = {
        type: DROP,
        payload: {
          dropResult: _objectSpread(_objectSpread({}, options), dropResult)
        }
      };
      manager.dispatch(action);
    });
  };
}

function verifyInvariants$1(monitor) {
  invariant(monitor.isDragging(), 'Cannot call drop while not dragging.');
  invariant(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}

function determineDropResult(targetId, index, registry, monitor) {
  var target = registry.getTarget(targetId);
  var dropResult = target ? target.drop(monitor, targetId) : undefined;
  verifyDropResultType(dropResult);

  if (typeof dropResult === 'undefined') {
    dropResult = index === 0 ? {} : monitor.getDropResult();
  }

  return dropResult;
}

function verifyDropResultType(dropResult) {
  invariant(typeof dropResult === 'undefined' || isObject(dropResult), 'Drop result must either be an object or undefined.');
}

function getDroppableTargets(monitor) {
  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
  targetIds.reverse();
  return targetIds;
}

function createEndDrag(manager) {
  return function endDrag() {
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyIsDragging(monitor);
    var sourceId = monitor.getSourceId();

    if (sourceId != null) {
      var source = registry.getSource(sourceId, true);
      source.endDrag(monitor, sourceId);
      registry.unpinSource();
    }

    return {
      type: END_DRAG
    };
  };
}

function verifyIsDragging(monitor) {
  invariant(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

function createDragDropActions(manager) {
  return {
    beginDrag: createBeginDrag(manager),
    publishDragSource: createPublishDragSource(manager),
    hover: createHover(manager),
    drop: createDrop(manager),
    endDrag: createEndDrag(manager)
  };
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
var DragDropManagerImpl = /*#__PURE__*/function () {
  function DragDropManagerImpl(store, monitor) {
    var _this = this;

    _classCallCheck(this, DragDropManagerImpl);

    this.isSetUp = false;

    this.handleRefCountChange = function () {
      var shouldSetUp = _this.store.getState().refCount > 0;

      if (_this.backend) {
        if (shouldSetUp && !_this.isSetUp) {
          _this.backend.setup();

          _this.isSetUp = true;
        } else if (!shouldSetUp && _this.isSetUp) {
          _this.backend.teardown();

          _this.isSetUp = false;
        }
      }
    };

    this.store = store;
    this.monitor = monitor;
    store.subscribe(this.handleRefCountChange);
  }

  _createClass(DragDropManagerImpl, [{
    key: "receiveBackend",
    value: function receiveBackend(backend) {
      this.backend = backend;
    }
  }, {
    key: "getMonitor",
    value: function getMonitor() {
      return this.monitor;
    }
  }, {
    key: "getBackend",
    value: function getBackend() {
      return this.backend;
    }
  }, {
    key: "getRegistry",
    value: function getRegistry() {
      return this.monitor.registry;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      /* eslint-disable-next-line @typescript-eslint/no-this-alias */
      var manager = this;
      var dispatch = this.store.dispatch;

      function bindActionCreator(actionCreator) {
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var action = actionCreator.apply(manager, args);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      var actions = createDragDropActions(this);
      return Object.keys(actions).reduce(function (boundActions, key) {
        var action = actions[key];
        boundActions[key] = bindActionCreator(action);
        return boundActions;
      }, {});
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.store.dispatch(action);
    }
  }]);

  return DragDropManagerImpl;
}();

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (process.env.NODE_ENV !== 'production') {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

var strictEquality = function strictEquality(a, b) {
  return a === b;
};
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */

function areCoordsEqual(offsetA, offsetB) {
  if (!offsetA && !offsetB) {
    return true;
  } else if (!offsetA || !offsetB) {
    return false;
  } else {
    return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
  }
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */

function areArraysEqual(a, b) {
  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : strictEquality;

  if (a.length !== b.length) {
    return false;
  }

  for (var i = 0; i < a.length; ++i) {
    if (!isEqual(a[i], b[i])) {
      return false;
    }
  }

  return true;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var initialState = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: payload.sourceClientOffset,
        initialClientOffset: payload.clientOffset,
        clientOffset: payload.clientOffset
      };

    case HOVER:
      if (areCoordsEqual(state.clientOffset, payload.clientOffset)) {
        return state;
      }

      return _objectSpread$1(_objectSpread$1({}, state), {}, {
        clientOffset: payload.clientOffset
      });

    case END_DRAG:
    case DROP:
      return initialState;

    default:
      return state;
  }
}

var ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}
function addTarget(targetId) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: targetId
    }
  };
}
function removeSource(sourceId) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}
function removeTarget(targetId) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: targetId
    }
  };
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var initialState$1 = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: false,
  isSourcePublic: null
};
function reduce$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case BEGIN_DRAG:
      return _objectSpread$2(_objectSpread$2({}, state), {}, {
        itemType: payload.itemType,
        item: payload.item,
        sourceId: payload.sourceId,
        isSourcePublic: payload.isSourcePublic,
        dropResult: null,
        didDrop: false
      });

    case PUBLISH_DRAG_SOURCE:
      return _objectSpread$2(_objectSpread$2({}, state), {}, {
        isSourcePublic: true
      });

    case HOVER:
      return _objectSpread$2(_objectSpread$2({}, state), {}, {
        targetIds: payload.targetIds
      });

    case REMOVE_TARGET:
      if (state.targetIds.indexOf(payload.targetId) === -1) {
        return state;
      }

      return _objectSpread$2(_objectSpread$2({}, state), {}, {
        targetIds: without(state.targetIds, payload.targetId)
      });

    case DROP:
      return _objectSpread$2(_objectSpread$2({}, state), {}, {
        dropResult: payload.dropResult,
        didDrop: true,
        targetIds: []
      });

    case END_DRAG:
      return _objectSpread$2(_objectSpread$2({}, state), {}, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: false,
        isSourcePublic: null,
        targetIds: []
      });

    default:
      return state;
  }
}

function reduce$2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return state + 1;

    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return state - 1;

    default:
      return state;
  }
}

var NONE = [];
var ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */

function areDirty(dirtyIds, handlerIds) {
  if (dirtyIds === NONE) {
    return false;
  }

  if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
    return true;
  }

  var commonIds = intersection(handlerIds, dirtyIds);
  return commonIds.length > 0;
}

function reduce$3() {

  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case HOVER:
      break;

    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;

    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }

  var _action$payload = action.payload,
      _action$payload$targe = _action$payload.targetIds,
      targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe,
      _action$payload$prevT = _action$payload.prevTargetIds,
      prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
  var result = xor(targetIds, prevTargetIds);
  var didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);

  if (!didChange) {
    return NONE;
  } // Check the target ids at the innermost position. If they are valid, add them
  // to the result


  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
  var innermostTargetId = targetIds[targetIds.length - 1];

  if (prevInnermostTargetId !== innermostTargetId) {
    if (prevInnermostTargetId) {
      result.push(prevInnermostTargetId);
    }

    if (innermostTargetId) {
      result.push(innermostTargetId);
    }
  }

  return result;
}

function reduce$4() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function reduce$5() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    dirtyHandlerIds: reduce$3(state.dirtyHandlerIds, {
      type: action.type,
      payload: _objectSpread$3(_objectSpread$3({}, action.payload), {}, {
        prevTargetIds: get(state, 'dragOperation.targetIds', [])
      })
    }),
    dragOffset: reduce(state.dragOffset, action),
    refCount: reduce$2(state.refCount, action),
    dragOperation: reduce$1(state.dragOperation, action),
    stateId: reduce$4(state.stateId)
  };
}

/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */
function add(a, b) {
  return {
    x: a.x + b.x,
    y: a.y + b.y
  };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */

function subtract(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */

function getSourceClientOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset,
      initialSourceClientOffset = state.initialSourceClientOffset;

  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
    return null;
  }

  return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */

function getDifferenceFromInitialOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset;

  if (!clientOffset || !initialClientOffset) {
    return null;
  }

  return subtract(clientOffset, initialClientOffset);
}

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }
var DragDropMonitorImpl = /*#__PURE__*/function () {
  function DragDropMonitorImpl(store, registry) {
    _classCallCheck$1(this, DragDropMonitorImpl);

    this.store = store;
    this.registry = registry;
  }

  _createClass$1(DragDropMonitorImpl, [{
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        handlerIds: undefined
      };
      var handlerIds = options.handlerIds;
      invariant(typeof listener === 'function', 'listener must be a function.');
      invariant(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
      var prevStateId = this.store.getState().stateId;

      var handleChange = function handleChange() {
        var state = _this.store.getState();

        var currentStateId = state.stateId;

        try {
          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !areDirty(state.dirtyHandlerIds, handlerIds);

          if (!canSkipListener) {
            listener();
          }
        } finally {
          prevStateId = currentStateId;
        }
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      var _this2 = this;

      invariant(typeof listener === 'function', 'listener must be a function.');
      var previousState = this.store.getState().dragOffset;

      var handleChange = function handleChange() {
        var nextState = _this2.store.getState().dragOffset;

        if (nextState === previousState) {
          return;
        }

        previousState = nextState;
        listener();
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId);
      invariant(source, "Expected to find a valid source. sourceId=".concat(sourceId));

      if (this.isDragging()) {
        return false;
      }

      return source.canDrag(this, sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var target = this.registry.getTarget(targetId);
      invariant(target, "Expected to find a valid target. targetId=".concat(targetId));

      if (!this.isDragging() || this.didDrop()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();
      return matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return Boolean(this.getItemType());
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      // undefined on initial render
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId, true);
      invariant(source, "Expected to find a valid source. sourceId=".concat(sourceId));

      if (!this.isDragging() || !this.isSourcePublic()) {
        return false;
      }

      var sourceType = this.registry.getSourceType(sourceId);
      var draggedItemType = this.getItemType();

      if (sourceType !== draggedItemType) {
        return false;
      }

      return source.isDragging(this, sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shallow: false
      };

      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var shallow = options.shallow;

      if (!this.isDragging()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();

      if (draggedItemType && !matchesType(targetType, draggedItemType)) {
        return false;
      }

      var targetIds = this.getTargetIds();

      if (!targetIds.length) {
        return false;
      }

      var index = targetIds.indexOf(targetId);

      if (shallow) {
        return index === targetIds.length - 1;
      } else {
        return index > -1;
      }
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.store.getState().dragOperation.itemType;
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.store.getState().dragOperation.item;
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.store.getState().dragOperation.sourceId;
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.store.getState().dragOperation.targetIds;
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.store.getState().dragOperation.dropResult;
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.store.getState().dragOperation.didDrop;
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.store.getState().dragOffset.initialClientOffset;
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.store.getState().dragOffset.initialSourceClientOffset;
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.store.getState().dragOffset.clientOffset;
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset$1() {
      return getSourceClientOffset(this.store.getState().dragOffset);
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset$1() {
      return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
  }]);

  return DragDropMonitorImpl;
}();

var nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }
function validateSourceContract(source) {
  invariant(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
  invariant(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
  invariant(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
  invariant(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
  invariant(typeof target.hover === 'function', 'Expected hover to be a function.');
  invariant(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
  if (allowArray && Array.isArray(type)) {
    type.forEach(function (t) {
      return validateType(t, false);
    });
    return;
  }

  invariant(typeof type === 'string' || _typeof$1(type) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
function rawAsap(task) {
  if (!queue.length) {
    requestFlush();
  } // Equivalent to push, but avoids a function call.


  queue[queue.length] = task;
}
var queue = []; // Once a flush has been requested, no further calls to `requestFlush` are
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.

var requestFlush; // The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.

var index = 0; // If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.

var capacity = 1024; // The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.

function flush() {
  while (index < queue.length) {
    var currentIndex = index; // Advance the index before calling the task. This ensures that we will
    // begin flushing on the next task the task throws an error.

    index = index + 1;
    queue[currentIndex].call(); // Prevent leaking memory for long chains of recursive calls to `asap`.
    // If we call `asap` within tasks scheduled by `asap`, the queue will
    // grow, but to avoid an O(n) walk for every task we execute, we don't
    // shift tasks off the queue after they have been executed.
    // Instead, we periodically shift 1024 tasks off the queue.

    if (index > capacity) {
      // Manually shift all values starting at the index back to the
      // beginning of the queue.
      for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
        queue[scan] = queue[scan + index];
      }

      queue.length -= index;
      index = 0;
    }
  }

  queue.length = 0;
  index = 0;
} // `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */


var scope = typeof global !== 'undefined' ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver; // MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7

if (typeof BrowserMutationObserver === 'function') {
  requestFlush = makeRequestCallFromMutationObserver(flush); // MessageChannels are desirable because they give direct access to the HTML
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
} else {
  requestFlush = makeRequestCallFromTimer(flush);
} // `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.


rawAsap.requestFlush = requestFlush; // To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".

function makeRequestCallFromMutationObserver(callback) {
  var toggle = 1;
  var observer = new BrowserMutationObserver(callback);
  var node = document.createTextNode('');
  observer.observe(node, {
    characterData: true
  });
  return function requestCall() {
    toggle = -toggle;
    node.data = toggle;
  };
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.


function makeRequestCallFromTimer(callback) {
  return function requestCall() {
    // We dispatch a timeout with a specified delay of 0 for engines that
    // can reliably accommodate that request. This will usually be snapped
    // to a 4 milisecond delay, but once we're flushing, there's no delay
    // between events.
    var timeoutHandle = setTimeout(handleTimer, 0); // However, since this timer gets frequently dropped in Firefox
    // workers, we enlist an interval handle that will try to fire
    // an event 20 times per second until it succeeds.

    var intervalHandle = setInterval(handleTimer, 50);

    function handleTimer() {
      // Whichever timer succeeds will cancel both timers and
      // execute the callback.
      clearTimeout(timeoutHandle);
      clearInterval(intervalHandle);
      callback();
    }
  };
} // This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.


rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer; // ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

// RawTasks are recycled to reduce GC churn.

var freeTasks = []; // We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.

var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
  if (pendingErrors.length) {
    throw pendingErrors.shift();
  }
}
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */


function asap(task) {
  var rawTask;

  if (freeTasks.length) {
    rawTask = freeTasks.pop();
  } else {
    rawTask = new RawTask();
  }

  rawTask.task = task;
  rawAsap(rawTask);
} // We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.

var RawTask =
/** @class */
function () {
  function RawTask() {}

  RawTask.prototype.call = function () {
    try {
      this.task.call();
    } catch (error) {
      if (asap.onerror) {
        // This hook exists purely for testing purposes.
        // Its name will be periodically randomized to break any code that
        // depends on its existence.
        asap.onerror(error);
      } else {
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        pendingErrors.push(error);
        requestErrorThrow();
      }
    } finally {
      this.task = null;
      freeTasks[freeTasks.length] = this;
    }
  };

  return RawTask;
}();

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getNextHandlerId(role) {
  var id = getNextUniqueId().toString();

  switch (role) {
    case HandlerRole.SOURCE:
      return "S".concat(id);

    case HandlerRole.TARGET:
      return "T".concat(id);

    default:
      throw new Error("Unknown Handler Role: ".concat(role));
  }
}

function parseRoleFromHandlerId(handlerId) {
  switch (handlerId[0]) {
    case 'S':
      return HandlerRole.SOURCE;

    case 'T':
      return HandlerRole.TARGET;

    default:
      invariant(false, "Cannot parse handler ID: ".concat(handlerId));
  }
}

function mapContainsValue(map, searchValue) {
  var entries = map.entries();
  var isDone = false;

  do {
    var _entries$next = entries.next(),
        done = _entries$next.done,
        _entries$next$value = _slicedToArray(_entries$next.value, 2),
        value = _entries$next$value[1];

    if (value === searchValue) {
      return true;
    }

    isDone = !!done;
  } while (!isDone);

  return false;
}

var HandlerRegistryImpl = /*#__PURE__*/function () {
  function HandlerRegistryImpl(store) {
    _classCallCheck$2(this, HandlerRegistryImpl);

    this.types = new Map();
    this.dragSources = new Map();
    this.dropTargets = new Map();
    this.pinnedSourceId = null;
    this.pinnedSource = null;
    this.store = store;
  }

  _createClass$2(HandlerRegistryImpl, [{
    key: "addSource",
    value: function addSource$1(type, source) {
      validateType(type);
      validateSourceContract(source);
      var sourceId = this.addHandler(HandlerRole.SOURCE, type, source);
      this.store.dispatch(addSource(sourceId));
      return sourceId;
    }
  }, {
    key: "addTarget",
    value: function addTarget$1(type, target) {
      validateType(type, true);
      validateTargetContract(target);
      var targetId = this.addHandler(HandlerRole.TARGET, type, target);
      this.store.dispatch(addTarget(targetId));
      return targetId;
    }
  }, {
    key: "containsHandler",
    value: function containsHandler(handler) {
      return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
  }, {
    key: "getSource",
    value: function getSource(sourceId) {
      var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
      var isPinned = includePinned && sourceId === this.pinnedSourceId;
      var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
      return source;
    }
  }, {
    key: "getTarget",
    value: function getTarget(targetId) {
      invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.dropTargets.get(targetId);
    }
  }, {
    key: "getSourceType",
    value: function getSourceType(sourceId) {
      invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
      return this.types.get(sourceId);
    }
  }, {
    key: "getTargetType",
    value: function getTargetType(targetId) {
      invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.types.get(targetId);
    }
  }, {
    key: "isSourceId",
    value: function isSourceId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.SOURCE;
    }
  }, {
    key: "isTargetId",
    value: function isTargetId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.TARGET;
    }
  }, {
    key: "removeSource",
    value: function removeSource$1(sourceId) {
      var _this = this;

      invariant(this.getSource(sourceId), 'Expected an existing source.');
      this.store.dispatch(removeSource(sourceId));
      asap(function () {
        _this.dragSources.delete(sourceId);

        _this.types.delete(sourceId);
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget$1(targetId) {
      invariant(this.getTarget(targetId), 'Expected an existing target.');
      this.store.dispatch(removeTarget(targetId));
      this.dropTargets.delete(targetId);
      this.types.delete(targetId);
    }
  }, {
    key: "pinSource",
    value: function pinSource(sourceId) {
      var source = this.getSource(sourceId);
      invariant(source, 'Expected an existing source.');
      this.pinnedSourceId = sourceId;
      this.pinnedSource = source;
    }
  }, {
    key: "unpinSource",
    value: function unpinSource() {
      invariant(this.pinnedSource, 'No source is pinned at the time.');
      this.pinnedSourceId = null;
      this.pinnedSource = null;
    }
  }, {
    key: "addHandler",
    value: function addHandler(role, type, handler) {
      var id = getNextHandlerId(role);
      this.types.set(id, type);

      if (role === HandlerRole.SOURCE) {
        this.dragSources.set(id, handler);
      } else if (role === HandlerRole.TARGET) {
        this.dropTargets.set(id, handler);
      }

      return id;
    }
  }]);

  return HandlerRegistryImpl;
}();

function createDragDropManager(backendFactory) {
  var globalContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var backendOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var debugMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var store = makeStoreInstance(debugMode);
  var monitor = new DragDropMonitorImpl(store, new HandlerRegistryImpl(store));
  var manager = new DragDropManagerImpl(store, monitor);
  var backend = backendFactory(manager, globalContext, backendOptions);
  manager.receiveBackend(backend);
  return manager;
}

function makeStoreInstance(debugMode) {
  // TODO: if we ever make a react-native version of this,
  // we'll need to consider how to pull off dev-tooling
  var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce$5, debugMode && reduxDevTools && reduxDevTools({
    name: 'dnd-core',
    instanceId: 'dnd-core'
  }));
}

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var refCount = 0;
var INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
/**
 * A React component that provides the React-DnD context
 */

var DndProvider = memo(function DndProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _getDndContextValue = getDndContextValue(props),
      _getDndContextValue2 = _slicedToArray$1(_getDndContextValue, 2),
      manager = _getDndContextValue2[0],
      isGlobalInstance = _getDndContextValue2[1]; // memoized from props

  /**
   * If the global context was used to store the DND context
   * then where theres no more references to it we should
   * clean it up to avoid memory leaks
   */


  useEffect(function () {
    if (isGlobalInstance) {
      var context = getGlobalContext();
      ++refCount;
      return function () {
        if (--refCount === 0) {
          context[INSTANCE_SYM] = null;
        }
      };
    }
  }, []);
  return jsx(DndContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }), void 0);
});

function getDndContextValue(props) {
  if ('manager' in props) {
    var _manager = {
      dragDropManager: props.manager
    };
    return [_manager, false];
  }

  var manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
  var isGlobalInstance = !props.context;
  return [manager, isGlobalInstance];
}

function createSingletonDndContext(backend) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var debugMode = arguments.length > 3 ? arguments[3] : undefined;
  var ctx = context;

  if (!ctx[INSTANCE_SYM]) {
    ctx[INSTANCE_SYM] = {
      dragDropManager: createDragDropManager(backend, context, options, debugMode)
    };
  }

  return ctx[INSTANCE_SYM];
}

function getGlobalContext() {
  return typeof global !== 'undefined' ? global : window;
}

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }
var isCallingCanDrag = false;
var isCallingIsDragging = false;
var DragSourceMonitorImpl = /*#__PURE__*/function () {
  function DragSourceMonitorImpl(manager) {
    _classCallCheck$3(this, DragSourceMonitorImpl);

    this.sourceId = null;
    this.internalMonitor = manager.getMonitor();
  }

  _createClass$3(DragSourceMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(sourceId) {
      this.sourceId = sourceId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.sourceId;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      invariant(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingCanDrag = true;
        return this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = false;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      if (!this.sourceId) {
        return false;
      }

      invariant(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingIsDragging = true;
        return this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = false;
      }
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      return this.internalMonitor.isDraggingSource(sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId, options) {
      return this.internalMonitor.isOverTarget(targetId, options);
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.internalMonitor.getTargetIds();
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return this.internalMonitor.isSourcePublic();
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.internalMonitor.getSourceId();
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      return this.internalMonitor.subscribeToOffsetChange(listener);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      return this.internalMonitor.canDragSource(sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      return this.internalMonitor.canDropOnTarget(targetId);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DragSourceMonitorImpl;
}();

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }
var isCallingCanDrop = false;
var DropTargetMonitorImpl = /*#__PURE__*/function () {
  function DropTargetMonitorImpl(manager) {
    _classCallCheck$4(this, DropTargetMonitorImpl);

    this.targetId = null;
    this.internalMonitor = manager.getMonitor();
  }

  _createClass$4(DropTargetMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(targetId) {
      this.targetId = targetId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.targetId;
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      // Cut out early if the target id has not been set. This should prevent errors
      // where the user has an older version of dnd-core like in
      // https://github.com/react-dnd/react-dnd/issues/1310
      if (!this.targetId) {
        return false;
      }

      invariant(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');

      try {
        isCallingCanDrop = true;
        return this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = false;
      }
    }
  }, {
    key: "isOver",
    value: function isOver(options) {
      if (!this.targetId) {
        return false;
      }

      return this.internalMonitor.isOverTarget(this.targetId, options);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DropTargetMonitorImpl;
}();

function throwIfCompositeComponentElement(element) {
  // Custom components can no longer be wrapped directly in React DnD 2.0
  // so that we don't need to depend on findDOMNode() from react-dom.
  if (typeof element.type === 'string') {
    return;
  }

  var displayName = element.type.displayName || element.type.name || 'the component';
  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
  return function () {
    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // When passed a node, call the hook straight away.
    if (!isValidElement(elementOrNode)) {
      var node = elementOrNode;
      hook(node, options); // return the node so it can be chained (e.g. when within callback refs
      // <div ref={node => connectDragSource(connectDropTarget(node))}/>

      return node;
    } // If passed a ReactElement, clone it and attach this function as a ref.
    // This helps us achieve a neat API where user doesn't even know that refs
    // are being used under the hood.


    var element = elementOrNode;
    throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly

    var ref = options ? function (node) {
      return hook(node, options);
    } : hook;
    return cloneWithRef(element, ref);
  };
}

function wrapConnectorHooks(hooks) {
  var wrappedHooks = {};
  Object.keys(hooks).forEach(function (key) {
    var hook = hooks[key]; // ref objects should be passed straight through without wrapping

    if (key.endsWith('Ref')) {
      wrappedHooks[key] = hooks[key];
    } else {
      var wrappedHook = wrapHookToRecognizeElement(hook);

      wrappedHooks[key] = function () {
        return wrappedHook;
      };
    }
  });
  return wrappedHooks;
}

function setRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else {
    ref.current = node;
  }
}

function cloneWithRef(element, newRef) {
  var previousRef = element.ref;
  invariant(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs');

  if (!previousRef) {
    // When there is no ref on the element, use the new ref directly
    return cloneElement(element, {
      ref: newRef
    });
  } else {
    return cloneElement(element, {
      ref: function ref(node) {
        setRef(previousRef, node);
        setRef(newRef, node);
      }
    });
  }
}

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function isRef(obj) {
  return (// eslint-disable-next-line no-prototype-builtins
    obj !== null && _typeof$2(obj) === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current')
  );
}

function shallowEqual(objA, objB, compare, compareContext) {
  var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (compareResult !== void 0) {
    return !!compareResult;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
}

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }
var SourceConnector = /*#__PURE__*/function () {
  function SourceConnector(backend) {
    var _this = this;

    _classCallCheck$5(this, SourceConnector);

    this.hooks = wrapConnectorHooks({
      dragSource: function dragSource(node, options) {
        _this.clearDragSource();

        _this.dragSourceOptions = options || null;

        if (isRef(node)) {
          _this.dragSourceRef = node;
        } else {
          _this.dragSourceNode = node;
        }

        _this.reconnectDragSource();
      },
      dragPreview: function dragPreview(node, options) {
        _this.clearDragPreview();

        _this.dragPreviewOptions = options || null;

        if (isRef(node)) {
          _this.dragPreviewRef = node;
        } else {
          _this.dragPreviewNode = node;
        }

        _this.reconnectDragPreview();
      }
    });
    this.handlerId = null; // The drop target may either be attached via ref or connect function

    this.dragSourceRef = null;
    this.dragSourceOptionsInternal = null; // The drag preview may either be attached via ref or connect function

    this.dragPreviewRef = null;
    this.dragPreviewOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDragSource = null;
    this.lastConnectedDragSourceOptions = null;
    this.lastConnectedDragPreview = null;
    this.lastConnectedDragPreviewOptions = null;
    this.backend = backend;
  }

  _createClass$5(SourceConnector, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (this.handlerId === newHandlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "connectTarget",
    get: function get() {
      return this.dragSource;
    }
  }, {
    key: "dragSourceOptions",
    get: function get() {
      return this.dragSourceOptionsInternal;
    },
    set: function set(options) {
      this.dragSourceOptionsInternal = options;
    }
  }, {
    key: "dragPreviewOptions",
    get: function get() {
      return this.dragPreviewOptionsInternal;
    },
    set: function set(options) {
      this.dragPreviewOptionsInternal = options;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      this.reconnectDragSource();
      this.reconnectDragPreview();
    }
  }, {
    key: "reconnectDragSource",
    value: function reconnectDragSource() {
      var dragSource = this.dragSource; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();

      if (didChange) {
        this.disconnectDragSource();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragSource) {
        this.lastConnectedDragSource = dragSource;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragSource = dragSource;
        this.lastConnectedDragSourceOptions = this.dragSourceOptions;
        this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
      }
    }
  }, {
    key: "reconnectDragPreview",
    value: function reconnectDragPreview() {
      var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();

      if (didChange) {
        this.disconnectDragPreview();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragPreview) {
        this.lastConnectedDragPreview = dragPreview;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragPreview = dragPreview;
        this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
        this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
      }
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didConnectedDragSourceChange",
    value: function didConnectedDragSourceChange() {
      return this.lastConnectedDragSource !== this.dragSource;
    }
  }, {
    key: "didConnectedDragPreviewChange",
    value: function didConnectedDragPreviewChange() {
      return this.lastConnectedDragPreview !== this.dragPreview;
    }
  }, {
    key: "didDragSourceOptionsChange",
    value: function didDragSourceOptionsChange() {
      return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
  }, {
    key: "didDragPreviewOptionsChange",
    value: function didDragPreviewOptionsChange() {
      return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
  }, {
    key: "disconnectDragSource",
    value: function disconnectDragSource() {
      if (this.dragSourceUnsubscribe) {
        this.dragSourceUnsubscribe();
        this.dragSourceUnsubscribe = undefined;
      }
    }
  }, {
    key: "disconnectDragPreview",
    value: function disconnectDragPreview() {
      if (this.dragPreviewUnsubscribe) {
        this.dragPreviewUnsubscribe();
        this.dragPreviewUnsubscribe = undefined;
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
      }
    }
  }, {
    key: "dragSource",
    get: function get() {
      return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
  }, {
    key: "dragPreview",
    get: function get() {
      return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
  }, {
    key: "clearDragSource",
    value: function clearDragSource() {
      this.dragSourceNode = null;
      this.dragSourceRef = null;
    }
  }, {
    key: "clearDragPreview",
    value: function clearDragPreview() {
      this.dragPreviewNode = null;
      this.dragPreviewRef = null;
    }
  }]);

  return SourceConnector;
}();

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }
var TargetConnector = /*#__PURE__*/function () {
  function TargetConnector(backend) {
    var _this = this;

    _classCallCheck$6(this, TargetConnector);

    this.hooks = wrapConnectorHooks({
      dropTarget: function dropTarget(node, options) {
        _this.clearDropTarget();

        _this.dropTargetOptions = options;

        if (isRef(node)) {
          _this.dropTargetRef = node;
        } else {
          _this.dropTargetNode = node;
        }

        _this.reconnect();
      }
    });
    this.handlerId = null; // The drop target may either be attached via ref or connect function

    this.dropTargetRef = null;
    this.dropTargetOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDropTarget = null;
    this.lastConnectedDropTargetOptions = null;
    this.backend = backend;
  }

  _createClass$6(TargetConnector, [{
    key: "connectTarget",
    get: function get() {
      return this.dropTarget;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      // if nothing has changed then don't resubscribe
      var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();

      if (didChange) {
        this.disconnectDropTarget();
      }

      var dropTarget = this.dropTarget;

      if (!this.handlerId) {
        return;
      }

      if (!dropTarget) {
        this.lastConnectedDropTarget = dropTarget;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDropTarget = dropTarget;
        this.lastConnectedDropTargetOptions = this.dropTargetOptions;
        this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
      }
    }
  }, {
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (newHandlerId === this.handlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "dropTargetOptions",
    get: function get() {
      return this.dropTargetOptionsInternal;
    },
    set: function set(options) {
      this.dropTargetOptionsInternal = options;
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didDropTargetChange",
    value: function didDropTargetChange() {
      return this.lastConnectedDropTarget !== this.dropTarget;
    }
  }, {
    key: "didOptionsChange",
    value: function didOptionsChange() {
      return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
  }, {
    key: "disconnectDropTarget",
    value: function disconnectDropTarget() {
      if (this.unsubscribeDropTarget) {
        this.unsubscribeDropTarget();
        this.unsubscribeDropTarget = undefined;
      }
    }
  }, {
    key: "dropTarget",
    get: function get() {
      return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
  }, {
    key: "clearDropTarget",
    value: function clearDropTarget() {
      this.dropTargetRef = null;
      this.dropTargetNode = null;
    }
  }]);

  return TargetConnector;
}();

function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);
  return [targetId, function () {
    return registry.removeTarget(targetId);
  }];
}
function registerSource(type, source, manager) {
  var registry = manager.getRegistry();
  var sourceId = registry.addSource(type, source);
  return [sourceId, function () {
    return registry.removeSource(sourceId);
  }];
}

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }

var DragSourceImpl = /*#__PURE__*/function () {
  function DragSourceImpl(spec, monitor, connector) {
    _classCallCheck$7(this, DragSourceImpl);

    this.spec = spec;
    this.monitor = monitor;
    this.connector = connector;
  }

  _createClass$7(DragSourceImpl, [{
    key: "beginDrag",
    value: function beginDrag() {
      var _result;

      var spec = this.spec;
      var monitor = this.monitor;
      var result = null;

      if (_typeof$3(spec.item) === 'object') {
        result = spec.item;
      } else if (typeof spec.item === 'function') {
        result = spec.item(monitor);
      } else {
        result = {};
      }

      return (_result = result) !== null && _result !== void 0 ? _result : null;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (typeof spec.canDrag === 'boolean') {
        return spec.canDrag;
      } else if (typeof spec.canDrag === 'function') {
        return spec.canDrag(monitor);
      } else {
        return true;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging(globalMonitor, target) {
      var spec = this.spec;
      var monitor = this.monitor;
      var isDragging = spec.isDragging;
      return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      var spec = this.spec;
      var monitor = this.monitor;
      var connector = this.connector;
      var end = spec.end;

      if (end) {
        end(monitor.getItem(), monitor);
      }

      connector.reconnect();
    }
  }]);

  return DragSourceImpl;
}();

function useDragSource(spec, monitor, connector) {
  var handler = useMemo(function () {
    return new DragSourceImpl(spec, monitor, connector);
  }, [monitor, connector]);
  useEffect(function () {
    handler.spec = spec;
  }, [spec]);
  return handler;
}

/**
 * A hook to retrieve the DragDropManager from Context
 */

function useDragDropManager() {
  var _useContext = useContext(DndContext),
      dragDropManager = _useContext.dragDropManager;

  invariant(dragDropManager != null, 'Expected drag drop context');
  return dragDropManager;
}

function useDragType(spec) {
  return useMemo(function () {
    var result = spec.type;
    invariant(result != null, 'spec.type must be defined');
    return result;
  }, [spec]);
}

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$2(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }
function useRegisteredDragSource(spec, monitor, connector) {
  var manager = useDragDropManager();
  var handler = useDragSource(spec, monitor, connector);
  var itemType = useDragType(spec);
  useIsomorphicLayoutEffect(function registerDragSource() {
    if (itemType != null) {
      var _registerSource = registerSource(itemType, handler, manager),
          _registerSource2 = _slicedToArray$2(_registerSource, 2),
          handlerId = _registerSource2[0],
          unregister = _registerSource2[1];

      monitor.receiveHandlerId(handlerId);
      connector.receiveHandlerId(handlerId);
      return unregister;
    }
  }, [manager, monitor, connector, handler, itemType]);
}

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$3(arr); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function useOptionalFactory(arg, deps) {
  var memoDeps = _toConsumableArray(deps || []);

  if (deps == null && typeof arg !== 'function') {
    memoDeps.push(arg);
  }

  return useMemo(function () {
    return typeof arg === 'function' ? arg() : arg;
  }, memoDeps);
}

function useDragSourceMonitor() {
  var manager = useDragDropManager();
  return useMemo(function () {
    return new DragSourceMonitorImpl(manager);
  }, [manager]);
}

function useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
  var manager = useDragDropManager();
  var connector = useMemo(function () {
    return new SourceConnector(manager.getBackend());
  }, [manager]);
  useIsomorphicLayoutEffect(function () {
    connector.dragSourceOptions = dragSourceOptions || null;
    connector.reconnect();
  }, [connector, dragSourceOptions]);
  useIsomorphicLayoutEffect(function () {
    connector.dragPreviewOptions = dragPreviewOptions || null;
    connector.reconnect();
  }, [connector, dragPreviewOptions]);
  return connector;
}

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$3(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */

function useCollector(monitor, collect, onUpdate) {
  var _useState = useState(function () {
    return collect(monitor);
  }),
      _useState2 = _slicedToArray$3(_useState, 2),
      collected = _useState2[0],
      setCollected = _useState2[1];

  var updateCollected = useCallback(function () {
    var nextValue = collect(monitor); // This needs to be a deep-equality check because some monitor-collected values
    // include XYCoord objects that may be equivalent, but do not have instance equality.

    if (!fastDeepEqual(collected, nextValue)) {
      setCollected(nextValue);

      if (onUpdate) {
        onUpdate();
      }
    }
  }, [collected, monitor, onUpdate]); // update the collected properties after react renders.
  // Note that the "Dustbin Stress Test" fails if this is not
  // done when the component updates

  useIsomorphicLayoutEffect(updateCollected);
  return [collected, updateCollected];
}

function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$4(); }

function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$4(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
function useMonitorOutput(monitor, collect, onCollect) {
  var _useCollector = useCollector(monitor, collect, onCollect),
      _useCollector2 = _slicedToArray$4(_useCollector, 2),
      collected = _useCollector2[0],
      updateCollected = _useCollector2[1];

  useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
    var handlerId = monitor.getHandlerId();

    if (handlerId == null) {
      return;
    }

    return monitor.subscribeToStateChange(updateCollected, {
      handlerIds: [handlerId]
    });
  }, [monitor, updateCollected]);
  return collected;
}

function useCollectedProps(collector, monitor, connector) {
  return useMonitorOutput(monitor, collector || function () {
    return {};
  }, function () {
    return connector.reconnect();
  });
}

function useConnectDragSource(connector) {
  return useMemo(function () {
    return connector.hooks.dragSource();
  }, [connector]);
}
function useConnectDragPreview(connector) {
  return useMemo(function () {
    return connector.hooks.dragPreview();
  }, [connector]);
}

/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */

function useDrag(specArg, deps) {
  var spec = useOptionalFactory(specArg, deps);
  invariant(!spec.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  var monitor = useDragSourceMonitor();
  var connector = useDragSourceConnector(spec.options, spec.previewOptions);
  useRegisteredDragSource(spec, monitor, connector);
  return [useCollectedProps(spec.collect, monitor, connector), useConnectDragSource(connector), useConnectDragPreview(connector)];
}

/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */

function useAccept(spec) {
  var accept = spec.accept;
  return useMemo(function () {
    invariant(spec.accept != null, 'accept must be defined');
    return Array.isArray(accept) ? accept : [accept];
  }, [accept]);
}

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }

var DropTargetImpl = /*#__PURE__*/function () {
  function DropTargetImpl(spec, monitor) {
    _classCallCheck$8(this, DropTargetImpl);

    this.spec = spec;
    this.monitor = monitor;
  }

  _createClass$8(DropTargetImpl, [{
    key: "canDrop",
    value: function canDrop() {
      var spec = this.spec;
      var monitor = this.monitor;
      return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
  }, {
    key: "hover",
    value: function hover() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.hover) {
        spec.hover(monitor.getItem(), monitor);
      }
    }
  }, {
    key: "drop",
    value: function drop() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.drop) {
        return spec.drop(monitor.getItem(), monitor);
      }
    }
  }]);

  return DropTargetImpl;
}();

function useDropTarget(spec, monitor) {
  var dropTarget = useMemo(function () {
    return new DropTargetImpl(spec, monitor);
  }, [monitor]);
  useEffect(function () {
    dropTarget.spec = spec;
  }, [spec]);
  return dropTarget;
}

function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$5(); }

function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$5(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }
function useRegisteredDropTarget(spec, monitor, connector) {
  var manager = useDragDropManager();
  var dropTarget = useDropTarget(spec, monitor);
  var accept = useAccept(spec);
  useIsomorphicLayoutEffect(function registerDropTarget() {
    var _registerTarget = registerTarget(accept, dropTarget, manager),
        _registerTarget2 = _slicedToArray$5(_registerTarget, 2),
        handlerId = _registerTarget2[0],
        unregister = _registerTarget2[1];

    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, [manager, monitor, dropTarget, connector, accept.map(function (a) {
    return a.toString();
  }).join('|')]);
}

function useDropTargetMonitor() {
  var manager = useDragDropManager();
  return useMemo(function () {
    return new DropTargetMonitorImpl(manager);
  }, [manager]);
}

function useDropTargetConnector(options) {
  var manager = useDragDropManager();
  var connector = useMemo(function () {
    return new TargetConnector(manager.getBackend());
  }, [manager]);
  useIsomorphicLayoutEffect(function () {
    connector.dropTargetOptions = options || null;
    connector.reconnect();
  }, [options]);
  return connector;
}

function useConnectDropTarget(connector) {
  return useMemo(function () {
    return connector.hooks.dropTarget();
  }, [connector]);
}

/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */

function useDrop(specArg, deps) {
  var spec = useOptionalFactory(specArg, deps);
  var monitor = useDropTargetMonitor();
  var connector = useDropTargetConnector(spec.options);
  useRegisteredDropTarget(spec, monitor, connector);
  return [useCollectedProps(spec.collect, monitor, connector), useConnectDropTarget(connector)];
}

// cheap lodash replacements
function memoize(fn) {
  var result = null;

  var memoized = function memoized() {
    if (result == null) {
      result = fn();
    }

    return result;
  };

  return memoized;
}
/**
 * drop-in replacement for _.without
 */

function without$1(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
function union(itemsA, itemsB) {
  var set = new Set();

  var insertItem = function insertItem(item) {
    return set.add(item);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  set.forEach(function (key) {
    return result.push(key);
  });
  return result;
}

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }
var EnterLeaveCounter = /*#__PURE__*/function () {
  function EnterLeaveCounter(isNodeInDocument) {
    _classCallCheck$9(this, EnterLeaveCounter);

    this.entered = [];
    this.isNodeInDocument = isNodeInDocument;
  }

  _createClass$9(EnterLeaveCounter, [{
    key: "enter",
    value: function enter(enteringNode) {
      var _this = this;

      var previousLength = this.entered.length;

      var isNodeEntered = function isNodeEntered(node) {
        return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
      };

      this.entered = union(this.entered.filter(isNodeEntered), [enteringNode]);
      return previousLength === 0 && this.entered.length > 0;
    }
  }, {
    key: "leave",
    value: function leave(leavingNode) {
      var previousLength = this.entered.length;
      this.entered = without$1(this.entered.filter(this.isNodeInDocument), leavingNode);
      return previousLength > 0 && this.entered.length === 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.entered = [];
    }
  }]);

  return EnterLeaveCounter;
}();

var isFirefox = memoize(function () {
  return /firefox/i.test(navigator.userAgent);
});
var isSafari = memoize(function () {
  return Boolean(window.safari);
});

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }

var MonotonicInterpolant = /*#__PURE__*/function () {
  function MonotonicInterpolant(xs, ys) {
    _classCallCheck$a(this, MonotonicInterpolant);

    var length = xs.length; // Rearrange xs and ys so that xs is sorted

    var indexes = [];

    for (var i = 0; i < length; i++) {
      indexes.push(i);
    }

    indexes.sort(function (a, b) {
      return xs[a] < xs[b] ? -1 : 1;
    }); // Get consecutive differences and slopes
    var dxs = [];
    var ms = [];
    var dx;
    var dy;

    for (var _i = 0; _i < length - 1; _i++) {
      dx = xs[_i + 1] - xs[_i];
      dy = ys[_i + 1] - ys[_i];
      dxs.push(dx);
      ms.push(dy / dx);
    } // Get degree-1 coefficients


    var c1s = [ms[0]];

    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
      var m2 = ms[_i2];
      var mNext = ms[_i2 + 1];

      if (m2 * mNext <= 0) {
        c1s.push(0);
      } else {
        dx = dxs[_i2];
        var dxNext = dxs[_i2 + 1];
        var common = dx + dxNext;
        c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
      }
    }

    c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients

    var c2s = [];
    var c3s = [];
    var m;

    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
      m = ms[_i3];
      var c1 = c1s[_i3];
      var invDx = 1 / dxs[_i3];

      var _common = c1 + c1s[_i3 + 1] - m - m;

      c2s.push((m - c1 - _common) * invDx);
      c3s.push(_common * invDx * invDx);
    }

    this.xs = xs;
    this.ys = ys;
    this.c1s = c1s;
    this.c2s = c2s;
    this.c3s = c3s;
  }

  _createClass$a(MonotonicInterpolant, [{
    key: "interpolate",
    value: function interpolate(x) {
      var xs = this.xs,
          ys = this.ys,
          c1s = this.c1s,
          c2s = this.c2s,
          c3s = this.c3s; // The rightmost point in the dataset should give an exact result

      var i = xs.length - 1;

      if (x === xs[i]) {
        return ys[i];
      } // Search for the interval x is in, returning the corresponding y if x is one of the original xs


      var low = 0;
      var high = c3s.length - 1;
      var mid;

      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        var xHere = xs[mid];

        if (xHere < x) {
          low = mid + 1;
        } else if (xHere > x) {
          high = mid - 1;
        } else {
          return ys[mid];
        }
      }

      i = Math.max(0, high); // Interpolate

      var diff = x - xs[i];
      var diffSq = diff * diff;
      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
  }]);

  return MonotonicInterpolant;
}();

var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return null;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return {
    x: left,
    y: top
  };
}
function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}

function isImageNode(node) {
  var _document$documentEle;

  return node.nodeName === 'IMG' && (isFirefox() || !((_document$documentEle = document.documentElement) !== null && _document$documentEle !== void 0 && _document$documentEle.contains(node)));
}

function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers

  if (isSafari() && isImage) {
    dragPreviewHeight /= window.devicePixelRatio;
    dragPreviewWidth /= window.devicePixelRatio;
  }

  return {
    dragPreviewWidth: dragPreviewWidth,
    dragPreviewHeight: dragPreviewHeight
  };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
  // The browsers will use the image intrinsic size under different conditions.
  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
  var isImage = isImageNode(dragPreview);
  var dragPreviewNode = isImage ? sourceNode : dragPreview;
  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
  var offsetFromDragPreview = {
    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
  };
  var sourceWidth = sourceNode.offsetWidth,
      sourceHeight = sourceNode.offsetHeight;
  var anchorX = anchorPoint.anchorX,
      anchorY = anchorPoint.anchorY;

  var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
      dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
      dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;

  var calculateYOffset = function calculateYOffset() {
    var interpolantY = new MonotonicInterpolant([0, 0.5, 1], [// Dock to the top
    offsetFromDragPreview.y, // Align at the center
    offsetFromDragPreview.y / sourceHeight * dragPreviewHeight, // Dock to the bottom
    offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
    var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug

    if (isSafari() && isImage) {
      // We'll have to wait for @3x to see if this is entirely correct
      y += (window.devicePixelRatio - 1) * dragPreviewHeight;
    }

    return y;
  };

  var calculateXOffset = function calculateXOffset() {
    // Interpolate coordinates depending on anchor point
    // If you know a simpler way to do this, let me know
    var interpolantX = new MonotonicInterpolant([0, 0.5, 1], [// Dock to the left
    offsetFromDragPreview.x, // Align at the center
    offsetFromDragPreview.x / sourceWidth * dragPreviewWidth, // Dock to the right
    offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
    return interpolantX.interpolate(anchorX);
  }; // Force offsets if specified in the options.


  var offsetX = offsetPoint.offsetX,
      offsetY = offsetPoint.offsetY;
  var isManualOffsetX = offsetX === 0 || offsetX;
  var isManualOffsetY = offsetY === 0 || offsetY;
  return {
    x: isManualOffsetX ? offsetX : calculateXOffset(),
    y: isManualOffsetY ? offsetY : calculateYOffset()
  };
}

var FILE = '__NATIVE_FILE__';
var URL$1 = '__NATIVE_URL__';
var TEXT = '__NATIVE_TEXT__';
var HTML = '__NATIVE_HTML__';

var NativeTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FILE: FILE,
  URL: URL$1,
  TEXT: TEXT,
  HTML: HTML
});

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
    return resultSoFar || dataTransfer.getData(typeToTry);
  }, '');
  return result != null ? result : defaultValue;
}

var _nativeTypesConfig;

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty$4(_nativeTypesConfig, FILE, {
  exposeProperties: {
    files: function files(dataTransfer) {
      return Array.prototype.slice.call(dataTransfer.files);
    },
    items: function items(dataTransfer) {
      return dataTransfer.items;
    }
  },
  matchesTypes: ['Files']
}), _defineProperty$4(_nativeTypesConfig, HTML, {
  exposeProperties: {
    html: function html(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    }
  },
  matchesTypes: ['Html', 'text/html']
}), _defineProperty$4(_nativeTypesConfig, URL$1, {
  exposeProperties: {
    urls: function urls(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
    }
  },
  matchesTypes: ['Url', 'text/uri-list']
}), _defineProperty$4(_nativeTypesConfig, TEXT, {
  exposeProperties: {
    text: function text(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    }
  },
  matchesTypes: ['Text', 'text/plain']
}), _nativeTypesConfig);

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }

var NativeDragSource = /*#__PURE__*/function () {
  function NativeDragSource(config) {
    _classCallCheck$b(this, NativeDragSource);

    this.config = config;
    this.item = {};
    this.initializeExposedProperties();
  }

  _createClass$b(NativeDragSource, [{
    key: "initializeExposedProperties",
    value: function initializeExposedProperties() {
      var _this = this;

      Object.keys(this.config.exposeProperties).forEach(function (property) {
        Object.defineProperty(_this.item, property, {
          configurable: true,
          enumerable: true,
          get: function get() {
            // eslint-disable-next-line no-console
            console.warn("Browser doesn't allow reading \"".concat(property, "\" until the drop event."));
            return null;
          }
        });
      });
    }
  }, {
    key: "loadDataTransfer",
    value: function loadDataTransfer(dataTransfer) {
      var _this2 = this;

      if (dataTransfer) {
        var newProperties = {};
        Object.keys(this.config.exposeProperties).forEach(function (property) {
          newProperties[property] = {
            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
            configurable: true,
            enumerable: true
          };
        });
        Object.defineProperties(this.item, newProperties);
      }
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      return true;
    }
  }, {
    key: "beginDrag",
    value: function beginDrag() {
      return this.item;
    }
  }, {
    key: "isDragging",
    value: function isDragging(monitor, handle) {
      return handle === monitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {// empty
    }
  }]);

  return NativeDragSource;
}();

function createNativeDragSource(type, dataTransfer) {
  var result = new NativeDragSource(nativeTypesConfig[type]);
  result.loadDataTransfer(dataTransfer);
  return result;
}
function matchNativeItemType(dataTransfer) {
  if (!dataTransfer) {
    return null;
  }

  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
    return matchesTypes.some(function (t) {
      return dataTransferTypes.indexOf(t) > -1;
    });
  })[0] || null;
}

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); return Constructor; }

var OptionsReader = /*#__PURE__*/function () {
  function OptionsReader(globalContext, options) {
    _classCallCheck$c(this, OptionsReader);

    this.ownerDocument = null;
    this.globalContext = globalContext;
    this.optionsArgs = options;
  }

  _createClass$c(OptionsReader, [{
    key: "window",
    get: function get() {
      if (this.globalContext) {
        return this.globalContext;
      } else if (typeof window !== 'undefined') {
        return window;
      }

      return undefined;
    }
  }, {
    key: "document",
    get: function get() {
      var _this$globalContext;

      if ((_this$globalContext = this.globalContext) !== null && _this$globalContext !== void 0 && _this$globalContext.document) {
        return this.globalContext.document;
      } else if (this.window) {
        return this.window.document;
      } else {
        return undefined;
      }
    }
  }, {
    key: "rootElement",
    get: function get() {
      var _this$optionsArgs;

      return ((_this$optionsArgs = this.optionsArgs) === null || _this$optionsArgs === void 0 ? void 0 : _this$optionsArgs.rootElement) || this.window;
    }
  }]);

  return OptionsReader;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$5(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); return Constructor; }
var HTML5BackendImpl = /*#__PURE__*/function () {
  function HTML5BackendImpl(manager, globalContext, options) {
    var _this = this;

    _classCallCheck$d(this, HTML5BackendImpl);

    this.sourcePreviewNodes = new Map();
    this.sourcePreviewNodeOptions = new Map();
    this.sourceNodes = new Map();
    this.sourceNodeOptions = new Map();
    this.dragStartSourceIds = null;
    this.dropTargetIds = [];
    this.dragEnterTargetIds = [];
    this.currentNativeSource = null;
    this.currentNativeHandle = null;
    this.currentDragSourceNode = null;
    this.altKeyPressed = false;
    this.mouseMoveTimeoutTimer = null;
    this.asyncEndDragFrameId = null;
    this.dragOverTargetIds = null;

    this.getSourceClientOffset = function (sourceId) {
      var source = _this.sourceNodes.get(sourceId);

      return source && getNodeClientOffset(source) || null;
    };

    this.endDragNativeItem = function () {
      if (!_this.isDraggingNativeItem()) {
        return;
      }

      _this.actions.endDrag();

      if (_this.currentNativeHandle) {
        _this.registry.removeSource(_this.currentNativeHandle);
      }

      _this.currentNativeHandle = null;
      _this.currentNativeSource = null;
    };

    this.isNodeInDocument = function (node) {
      // Check the node either in the main document or in the current context
      return Boolean(node && _this.document && _this.document.body && document.body.contains(node));
    };

    this.endDragIfSourceWasRemovedFromDOM = function () {
      var node = _this.currentDragSourceNode;

      if (node == null || _this.isNodeInDocument(node)) {
        return;
      }

      if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    };

    this.handleTopDragStartCapture = function () {
      _this.clearCurrentDragSourceNode();

      _this.dragStartSourceIds = [];
    };

    this.handleTopDragStart = function (e) {
      if (e.defaultPrevented) {
        return;
      }

      var dragStartSourceIds = _this.dragStartSourceIds;
      _this.dragStartSourceIds = null;
      var clientOffset = getEventClientOffset(e); // Avoid crashing if we missed a drop event or our previous drag died

      if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      } // Don't publish the source just yet (see why below)


      _this.actions.beginDrag(dragStartSourceIds || [], {
        publishSource: false,
        getSourceClientOffset: _this.getSourceClientOffset,
        clientOffset: clientOffset
      });

      var dataTransfer = e.dataTransfer;
      var nativeType = matchNativeItemType(dataTransfer);

      if (_this.monitor.isDragging()) {
        if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
          // Use custom drag image if user specifies it.
          // If child drag source refuses drag but parent agrees,
          // use parent's node as drag image. Neither works in IE though.
          var sourceId = _this.monitor.getSourceId();

          var sourceNode = _this.sourceNodes.get(sourceId);

          var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;

          if (dragPreview) {
            var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(),
                anchorX = _this$getCurrentSourc.anchorX,
                anchorY = _this$getCurrentSourc.anchorY,
                offsetX = _this$getCurrentSourc.offsetX,
                offsetY = _this$getCurrentSourc.offsetY;

            var anchorPoint = {
              anchorX: anchorX,
              anchorY: anchorY
            };
            var offsetPoint = {
              offsetX: offsetX,
              offsetY: offsetY
            };
            var dragPreviewOffset = getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
            dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
          }
        }

        try {
          // Firefox won't drag without setting data
          dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.setData('application/json', {});
        } catch (err) {// IE doesn't support MIME types in setData
        } // Store drag source node so we can check whether
        // it is removed from DOM and trigger endDrag manually.


        _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?


        var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(),
            captureDraggingState = _this$getCurrentSourc2.captureDraggingState;

        if (!captureDraggingState) {
          // Usually we want to publish it in the next tick so that browser
          // is able to screenshot the current (not yet dragging) state.
          //
          // It also neatly avoids a situation where render() returns null
          // in the same tick for the source element, and browser freaks out.
          setTimeout(function () {
            return _this.actions.publishDragSource();
          }, 0);
        } else {
          // In some cases the user may want to override this behavior, e.g.
          // to work around IE not supporting custom drag previews.
          //
          // When using a custom drag layer, the only way to prevent
          // the default drag preview from drawing in IE is to screenshot
          // the dragging state in which the node itself has zero opacity
          // and height. In this case, though, returning null from render()
          // will abruptly end the dragging, which is not obvious.
          //
          // This is the reason such behavior is strictly opt-in.
          _this.actions.publishDragSource();
        }
      } else if (nativeType) {
        // A native item (such as URL) dragged from inside the document
        _this.beginDragNativeItem(nativeType);
      } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
        // Just let it drag. It's a native type (URL or text) and will be picked up in
        // dragenter handler.
        return;
      } else {
        // If by this time no drag source reacted, tell browser not to drag.
        e.preventDefault();
      }
    };

    this.handleTopDragEndCapture = function () {
      if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) {
        // Firefox can dispatch this event in an infinite loop
        // if dragend handler does something like showing an alert.
        // Only proceed if we have not handled it already.
        _this.actions.endDrag();
      }
    };

    this.handleTopDragEnterCapture = function (e) {
      _this.dragEnterTargetIds = [];

      var isFirstEnter = _this.enterLeaveCounter.enter(e.target);

      if (!isFirstEnter || _this.monitor.isDragging()) {
        return;
      }

      var dataTransfer = e.dataTransfer;
      var nativeType = matchNativeItemType(dataTransfer);

      if (nativeType) {
        // A native item (such as file or URL) dragged from outside the document
        _this.beginDragNativeItem(nativeType, dataTransfer);
      }
    };

    this.handleTopDragEnter = function (e) {
      var dragEnterTargetIds = _this.dragEnterTargetIds;
      _this.dragEnterTargetIds = [];

      if (!_this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        return;
      }

      _this.altKeyPressed = e.altKey; // If the target changes position as the result of `dragenter`, `dragover` might still
      // get dispatched despite target being no longer there. The easy solution is to check
      // whether there actually is a target before firing `hover`.

      if (dragEnterTargetIds.length > 0) {
        _this.actions.hover(dragEnterTargetIds, {
          clientOffset: getEventClientOffset(e)
        });
      }

      var canDrop = dragEnterTargetIds.some(function (targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // IE requires this to fire dragover events
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      }
    };

    this.handleTopDragOverCapture = function () {
      _this.dragOverTargetIds = [];
    };

    this.handleTopDragOver = function (e) {
      var dragOverTargetIds = _this.dragOverTargetIds;
      _this.dragOverTargetIds = [];

      if (!_this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        // Prevent default "drop and blow away the whole document" action.
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
        }

        return;
      }

      _this.altKeyPressed = e.altKey;

      _this.actions.hover(dragOverTargetIds || [], {
        clientOffset: getEventClientOffset(e)
      });

      var canDrop = (dragOverTargetIds || []).some(function (targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // Show user-specified drop effect.
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      } else if (_this.isDraggingNativeItem()) {
        // Don't show a nice cursor but still prevent default
        // "drop and blow away the whole document" action.
        e.preventDefault();
      } else {
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
        }
      }
    };

    this.handleTopDragLeaveCapture = function (e) {
      if (_this.isDraggingNativeItem()) {
        e.preventDefault();
      }

      var isLastLeave = _this.enterLeaveCounter.leave(e.target);

      if (!isLastLeave) {
        return;
      }

      if (_this.isDraggingNativeItem()) {
        setTimeout(function () {
          return _this.endDragNativeItem();
        }, 0);
      }
    };

    this.handleTopDropCapture = function (e) {
      _this.dropTargetIds = [];

      if (_this.isDraggingNativeItem()) {
        var _this$currentNativeSo;

        e.preventDefault();
        (_this$currentNativeSo = _this.currentNativeSource) === null || _this$currentNativeSo === void 0 ? void 0 : _this$currentNativeSo.loadDataTransfer(e.dataTransfer);
      }

      _this.enterLeaveCounter.reset();
    };

    this.handleTopDrop = function (e) {
      var dropTargetIds = _this.dropTargetIds;
      _this.dropTargetIds = [];

      _this.actions.hover(dropTargetIds, {
        clientOffset: getEventClientOffset(e)
      });

      _this.actions.drop({
        dropEffect: _this.getCurrentDropEffect()
      });

      if (_this.isDraggingNativeItem()) {
        _this.endDragNativeItem();
      } else if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    };

    this.handleSelectStart = function (e) {
      var target = e.target; // Only IE requires us to explicitly say
      // we want drag drop operation to start

      if (typeof target.dragDrop !== 'function') {
        return;
      } // Inputs and textareas should be selectable


      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      } // For other targets, ask IE
      // to enable drag and drop


      e.preventDefault();
      target.dragDrop();
    };

    this.options = new OptionsReader(globalContext, options);
    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
  }
  /**
   * Generate profiling statistics for the HTML5Backend.
   */


  _createClass$d(HTML5BackendImpl, [{
    key: "profile",
    value: function profile() {
      var _this$dragStartSource, _this$dragOverTargetI;

      return {
        sourcePreviewNodes: this.sourcePreviewNodes.size,
        sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
        sourceNodeOptions: this.sourceNodeOptions.size,
        sourceNodes: this.sourceNodes.size,
        dragStartSourceIds: ((_this$dragStartSource = this.dragStartSourceIds) === null || _this$dragStartSource === void 0 ? void 0 : _this$dragStartSource.length) || 0,
        dropTargetIds: this.dropTargetIds.length,
        dragEnterTargetIds: this.dragEnterTargetIds.length,
        dragOverTargetIds: ((_this$dragOverTargetI = this.dragOverTargetIds) === null || _this$dragOverTargetI === void 0 ? void 0 : _this$dragOverTargetI.length) || 0
      };
    } // public for test

  }, {
    key: "window",
    get: function get() {
      return this.options.window;
    }
  }, {
    key: "document",
    get: function get() {
      return this.options.document;
    }
    /**
     * Get the root element to use for event subscriptions
     */

  }, {
    key: "rootElement",
    get: function get() {
      return this.options.rootElement;
    }
  }, {
    key: "setup",
    value: function setup() {
      var root = this.rootElement;

      if (root === undefined) {
        return;
      }

      if (root.__isReactDndBackendSetUp) {
        throw new Error('Cannot have two HTML5 backends at the same time.');
      }

      root.__isReactDndBackendSetUp = true;
      this.addEventListeners(root);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      var root = this.rootElement;

      if (root === undefined) {
        return;
      }

      root.__isReactDndBackendSetUp = false;
      this.removeEventListeners(this.rootElement);
      this.clearCurrentDragSourceNode();

      if (this.asyncEndDragFrameId) {
        var _this$window;

        (_this$window = this.window) === null || _this$window === void 0 ? void 0 : _this$window.cancelAnimationFrame(this.asyncEndDragFrameId);
      }
    }
  }, {
    key: "connectDragPreview",
    value: function connectDragPreview(sourceId, node, options) {
      var _this2 = this;

      this.sourcePreviewNodeOptions.set(sourceId, options);
      this.sourcePreviewNodes.set(sourceId, node);
      return function () {
        _this2.sourcePreviewNodes.delete(sourceId);

        _this2.sourcePreviewNodeOptions.delete(sourceId);
      };
    }
  }, {
    key: "connectDragSource",
    value: function connectDragSource(sourceId, node, options) {
      var _this3 = this;

      this.sourceNodes.set(sourceId, node);
      this.sourceNodeOptions.set(sourceId, options);

      var handleDragStart = function handleDragStart(e) {
        return _this3.handleDragStart(e, sourceId);
      };

      var handleSelectStart = function handleSelectStart(e) {
        return _this3.handleSelectStart(e);
      };

      node.setAttribute('draggable', 'true');
      node.addEventListener('dragstart', handleDragStart);
      node.addEventListener('selectstart', handleSelectStart);
      return function () {
        _this3.sourceNodes.delete(sourceId);

        _this3.sourceNodeOptions.delete(sourceId);

        node.removeEventListener('dragstart', handleDragStart);
        node.removeEventListener('selectstart', handleSelectStart);
        node.setAttribute('draggable', 'false');
      };
    }
  }, {
    key: "connectDropTarget",
    value: function connectDropTarget(targetId, node) {
      var _this4 = this;

      var handleDragEnter = function handleDragEnter(e) {
        return _this4.handleDragEnter(e, targetId);
      };

      var handleDragOver = function handleDragOver(e) {
        return _this4.handleDragOver(e, targetId);
      };

      var handleDrop = function handleDrop(e) {
        return _this4.handleDrop(e, targetId);
      };

      node.addEventListener('dragenter', handleDragEnter);
      node.addEventListener('dragover', handleDragOver);
      node.addEventListener('drop', handleDrop);
      return function () {
        node.removeEventListener('dragenter', handleDragEnter);
        node.removeEventListener('dragover', handleDragOver);
        node.removeEventListener('drop', handleDrop);
      };
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners(target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.addEventListener) {
        return;
      }

      target.addEventListener('dragstart', this.handleTopDragStart);
      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
      target.addEventListener('dragenter', this.handleTopDragEnter);
      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.addEventListener('dragover', this.handleTopDragOver);
      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
      target.addEventListener('drop', this.handleTopDrop);
      target.addEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners(target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.removeEventListener) {
        return;
      }

      target.removeEventListener('dragstart', this.handleTopDragStart);
      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
      target.removeEventListener('dragenter', this.handleTopDragEnter);
      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.removeEventListener('dragover', this.handleTopDragOver);
      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
      target.removeEventListener('drop', this.handleTopDrop);
      target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: "getCurrentSourceNodeOptions",
    value: function getCurrentSourceNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
      return _objectSpread$4({
        dropEffect: this.altKeyPressed ? 'copy' : 'move'
      }, sourceNodeOptions || {});
    }
  }, {
    key: "getCurrentDropEffect",
    value: function getCurrentDropEffect() {
      if (this.isDraggingNativeItem()) {
        // It makes more sense to default to 'copy' for native resources
        return 'copy';
      }

      return this.getCurrentSourceNodeOptions().dropEffect;
    }
  }, {
    key: "getCurrentSourcePreviewNodeOptions",
    value: function getCurrentSourcePreviewNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
      return _objectSpread$4({
        anchorX: 0.5,
        anchorY: 0.5,
        captureDraggingState: false
      }, sourcePreviewNodeOptions || {});
    }
  }, {
    key: "isDraggingNativeItem",
    value: function isDraggingNativeItem() {
      var itemType = this.monitor.getItemType();
      return Object.keys(NativeTypes).some(function (key) {
        return NativeTypes[key] === itemType;
      });
    }
  }, {
    key: "beginDragNativeItem",
    value: function beginDragNativeItem(type, dataTransfer) {
      this.clearCurrentDragSourceNode();
      this.currentNativeSource = createNativeDragSource(type, dataTransfer);
      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
      this.actions.beginDrag([this.currentNativeHandle]);
    }
  }, {
    key: "setCurrentDragSourceNode",
    value: function setCurrentDragSourceNode(node) {
      var _this5 = this;

      this.clearCurrentDragSourceNode();
      this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869

      var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
      // means it has ended and the drag source node disappeared from DOM,
      // so the browser didn't dispatch the dragend event.
      //
      // We need to wait before we start listening for mousemove events.
      // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
      // immediately in some browsers.
      //
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869
      //

      this.mouseMoveTimeoutTimer = setTimeout(function () {
        var _this5$rootElement;

        return (_this5$rootElement = _this5.rootElement) === null || _this5$rootElement === void 0 ? void 0 : _this5$rootElement.addEventListener('mousemove', _this5.endDragIfSourceWasRemovedFromDOM, true);
      }, MOUSE_MOVE_TIMEOUT);
    }
  }, {
    key: "clearCurrentDragSourceNode",
    value: function clearCurrentDragSourceNode() {
      if (this.currentDragSourceNode) {
        this.currentDragSourceNode = null;

        if (this.rootElement) {
          var _this$window2;

          (_this$window2 = this.window) === null || _this$window2 === void 0 ? void 0 : _this$window2.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
          this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }

        this.mouseMoveTimeoutTimer = null;
        return true;
      }

      return false;
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e, sourceId) {
      if (e.defaultPrevented) {
        return;
      }

      if (!this.dragStartSourceIds) {
        this.dragStartSourceIds = [];
      }

      this.dragStartSourceIds.unshift(sourceId);
    }
  }, {
    key: "handleDragEnter",
    value: function handleDragEnter(e, targetId) {
      this.dragEnterTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e, targetId) {
      if (this.dragOverTargetIds === null) {
        this.dragOverTargetIds = [];
      }

      this.dragOverTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(e, targetId) {
      this.dropTargetIds.unshift(targetId);
    }
  }]);

  return HTML5BackendImpl;
}();

var HTML5Backend = function createBackend(manager, context, options) {
  return new HTML5BackendImpl(manager, context, options);
};

var css_248z$b = ".flight-table-row--select-effect {\n  cursor: pointer;\n}\n.flight-table-row--select-effect:hover {\n  background-color: #DDECFF;\n}\n.flight-table-row--select-effect:active {\n  background-color: #B9D9FF;\n}\n.flight-table-row--selected {\n  background-color: #DDECFF;\n}\n.flight-table-row__cell {\n  display: table-cell;\n  overflow-wrap: break-word;\n  position: relative;\n  padding: 12px 0;\n  border-top: 0;\n  border-bottom: 1px solid #E6E7EB;\n}\n.flight-table-row__cell * {\n  vertical-align: middle;\n}\n.flight-table-row__cell .menu-icon {\n  fill: #37425E;\n  width: 16px;\n  height: 16px;\n}\n.flight-table-row:not(.flight-table-row--multi-select) .flight-table-row__cell > .flight-checkbox-wrapper {\n  pointer-events: none;\n}";
styleInject(css_248z$b);

const DEFAULT_CLASS$a = 'flight-table-row';
const FlightTableRow = props => {
  const {
    item,
    columns,
    allowRowSelect,
    selected,
    onClick,
    allowMultiSelect,
    className,
    index,
    moveRow,
    isRowDraggable,
    handleDropRow,
    fieldKey
  } = props;
  const dragRef = useRef(null);
  const previewRef = useRef(null);
  const keyValue = index;
  const dragTypes = className.concat('', '-dragRef');
  const [, drag, preview] = useDrag(() => ({
    type: dragTypes,
    item: () => ({
      keyValue,
      item
    }),
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    end() {
      const dropCurrent = previewRef.current;
      const data = {
        dropItem: dropCurrent,
        totalItem: Array.from(dropCurrent.closest('tbody').children)
      };
      if (handleDropRow) {
        handleDropRow(data);
      }
    },
    canDrag: isRowDraggable
  }));
  const [, drop] = useDrop({
    accept: dragTypes,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    hover(hoverItem) {
      const dropCurrent = previewRef.current;
      const currentDroped = dropCurrent;
      const totalItem = Array.from(dropCurrent.closest('tbody').children);
      if (Number(currentDroped.attributes['data-fieldindex'].value) !== hoverItem.keyValue) {
        moveRow(hoverItem, currentDroped, totalItem);
      }
    }
  });
  let mainClass = DEFAULT_CLASS$a;
  mainClass += allowRowSelect ? ` ${DEFAULT_CLASS$a}--select-effect` : '';
  mainClass += allowMultiSelect ? ` ${DEFAULT_CLASS$a}--multi-select` : '';
  mainClass += selected ? ` ${DEFAULT_CLASS$a}--selected` : '';
  drag(dragRef);
  drop(preview(previewRef));
  const handleRowKeyDown = func => e => {
    // only happens when focused on
    if (e.target.className.includes(`${DEFAULT_CLASS$a}`) || e.target.className.includes('flight-checkbox')) {
      switch (e.key) {
        case ' ':
        case 'Enter':
        case 'Spacebar':
          e.preventDefault();
          func();
          break;
      }
    }
  };
  return /*#__PURE__*/React__default.createElement("tr", {
    ref: previewRef,
    className: mainClass,
    tabIndex: 0,
    onClick: onClick || (() => undefined),
    onKeyDown: handleRowKeyDown(onClick || (() => undefined)),
    "data-fieldindex": index,
    "data-fieldkey": fieldKey
  }, isRowDraggable && /*#__PURE__*/React__default.createElement("td", {
    className: `${DEFAULT_CLASS$a}__cell`,
    ref: dragRef
  }, getIcon('menu', {
    className: 'menu-icon'
  })), columns.map(col => /*#__PURE__*/React__default.createElement("td", {
    className: `${DEFAULT_CLASS$a}__cell`,
    key: col
  }, item[col])));
};
FlightTableRow.propTypes = {
  item: propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number])
  }).isRequired,
  columns: propTypes.arrayOf(propTypes.string),
  allowRowSelect: propTypes.bool.isRequired,
  allowMultiSelect: propTypes.bool.isRequired,
  selected: propTypes.bool,
  onClick: propTypes.func.isRequired,
  className: propTypes.string,
  index: propTypes.number,
  fieldKey: propTypes.oneOfType([propTypes.string, propTypes.number]),
  moveRow: propTypes.func,
  isRowDraggable: propTypes.bool,
  handleDropRow: propTypes.func
};
FlightTableRow.defaultProps = {
  columns: [],
  selected: false,
  className: propTypes.string,
  index: propTypes.number,
  fieldKey: propTypes.oneOfType([propTypes.string, propTypes.number]),
  moveRow: () => undefined,
  isRowDraggable: false,
  handleDropRow: () => undefined
};

var css_248z$c = ".flight-icon, .flight-table-header__sort-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-table-header {\n  text-align: left;\n  border-top: 0;\n  padding: 12px 0;\n  border-bottom: 1px solid #E6E7EB;\n  color: #82899B;\n  position: relative;\n}\n.flight-table-header__sort-icon {\n  position: absolute;\n  margin-left: 12px;\n  fill: #82899B;\n  display: inline;\n}\n.flight-table-header--sortable {\n  cursor: pointer;\n}\n.flight-table-header--selected, .flight-table-header--sortable:hover {\n  color: #051336;\n}\n.flight-table-header--selected > .flight-table-header__sort-icon, .flight-table-header--sortable:hover .flight-table-header__sort-icon {\n  fill: #051336;\n}";
styleInject(css_248z$c);

const DEFAULT_CLASS$b = 'flight-table-header';
const FlightTableHeader = props => {
  const {
    selected,
    onClick,
    name,
    isVisible,
    icon,
    tooltip,
    isSortable,
    hideTooltip,
    tooltipDelay,
    iconValue
  } = props;
  let mainClass = DEFAULT_CLASS$b;
  mainClass += isSortable ? ` ${DEFAULT_CLASS$b}--sortable` : '';
  mainClass += onClick && selected ? ` ${DEFAULT_CLASS$b}--selected` : '';
  const ariaSort = iconValue === 'desc' ? 'descending' : 'ascending';
  return isVisible && /*#__PURE__*/React__default.createElement("th", {
    className: mainClass,
    onClick: isSortable ? onClick : () => undefined,
    onKeyDown: isSortable ? event => {
      if (event.key === 'Enter') {
        onClick();
      }
    } : () => undefined,
    scope: "col",
    tabIndex: isSortable ? 0 : -1,
    "aria-sort": isSortable ? ariaSort : 'none'
  }, hideTooltip ? name : /*#__PURE__*/React__default.createElement(FlightTooltip, {
    isEnabled: true,
    description: tooltip || name,
    delay: tooltipDelay
  }, name), isSortable && icon);
};
FlightTableHeader.propTypes = {
  selected: propTypes.bool,
  onClick: propTypes.func,
  name: propTypes.oneOfType([propTypes.string, propTypes.element]),
  isVisible: propTypes.bool,
  icon: propTypes.element,
  isSortable: propTypes.bool,
  tooltip: propTypes.string,
  hideTooltip: propTypes.bool,
  tooltipDelay: propTypes.number,
  iconValue: propTypes.string
};
FlightTableHeader.defaultProps = {
  selected: false,
  onClick: () => undefined,
  name: '',
  isVisible: false,
  icon: null,
  isSortable: false,
  tooltip: '',
  hideTooltip: false,
  tooltipDelay: 400,
  iconValue: 'none'
};

var css_248z$d = ".flight-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-table-loading__cell__bar {\n  -webkit-animation-name: color-grey-change;\n  -moz-animation-name: color-grey-change;\n  -ms-animation-name: color-grey-change;\n  -o-animation-name: color-grey-change;\n  animation-name: color-grey-change;\n  -webkit-animation-delay: 0s;\n  -moz-animation-delay: 0s;\n  -ms-animation-delay: 0s;\n  -o-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  -ms-animation-duration: 1s;\n  -o-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-timing-function: linear;\n  -ms-animation-timing-function: linear;\n  -o-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: infinite;\n  -moz-animation-iteration-count: infinite;\n  -ms-animation-iteration-count: infinite;\n  -o-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-direction: normal;\n  -moz-animation-direction: normal;\n  -ms-animation-direction: normal;\n  -o-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-fill-mode: none;\n  -moz-animation-fill-mode: none;\n  -ms-animation-fill-mode: none;\n  -o-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  -moz-animation-play-state: running;\n  -ms-animation-play-state: running;\n  -o-animation-play-state: running;\n  animation-play-state: running;\n  height: 20px;\n  width: 80%;\n  border-radius: 10px;\n  margin: 8px 0;\n}";
styleInject(css_248z$d);

class Grid {
  constructor(row, col) {
    this.row = row;
    this.col = col;
    this.content = Array(row).fill(0).map(() => Array(col).fill(0));
  }
  getCell(row, col) {
    return this.content[row][col];
  }
  setCell(row, col, value) {
    this.content[row][col] = value;
  }
}

const FlightTableLoading = _ref => {
  let {
    rowNumber,
    colNumber
  } = _ref;
  const grid = new Grid(parseInt(rowNumber, 10), colNumber);
  const mainClass = 'flight-table-loading';
  let rowKey = 0;
  let cellKey = 0;
  return grid.content.map(row => {
    rowKey += 1;
    return /*#__PURE__*/React__default.createElement("tr", {
      className: mainClass,
      key: `flight-table-loading${rowKey}`
    }, row.map(() => {
      cellKey += 1;
      return /*#__PURE__*/React__default.createElement("td", {
        className: `${mainClass}__cell`,
        key: `loading-cell${cellKey}`
      }, /*#__PURE__*/React__default.createElement("div", {
        className: `${mainClass}__cell__bar`
      }));
    }));
  });
};
FlightTableLoading.propTypes = {
  rowNumber: propTypes.number,
  colNumber: propTypes.number.isRequired
};
FlightTableLoading.defaultProps = {
  rowNumber: 3
};

var css_248z$e = ".flight-font, .flight-number-input__input, .flight-number-input-wrapper {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-number-input__error-message {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-number-input__input, .flight-number-input-wrapper {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-number-input-wrapper, .flight-number-input-wrapper * {\n  outline: none;\n}\n\n.flight-number-input {\n  position: relative;\n  display: block;\n  max-width: 100%;\n}\n.flight-number-input__label {\n  position: absolute;\n  top: 10px;\n}\n.flight-number-input__label, .flight-number-input__border {\n  -webkit-transition-delay: 0s;\n  -moz-transition-delay: 0s;\n  -ms-transition-delay: 0s;\n  -o-transition-delay: 0s;\n  transition-delay: 0s;\n  -webkit-transition-duration: 0.15s;\n  -moz-transition-duration: 0.15s;\n  -ms-transition-duration: 0.15s;\n  -o-transition-duration: 0.15s;\n  transition-duration: 0.15s;\n  -webkit-transition-property: all;\n  -moz-transition-property: all;\n  -ms-transition-property: all;\n  -o-transition-property: all;\n  transition-property: all;\n  -webkit-transition-timing-function: ease;\n  -moz-transition-timing-function: ease;\n  -ms-transition-timing-function: ease;\n  -o-transition-timing-function: ease;\n  transition-timing-function: ease;\n}\n.flight-number-input__label {\n  left: 8px;\n  color: #697186;\n  transform-origin: 0 0;\n  pointer-events: none;\n}\n.flight-number-input__border {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 1px;\n  width: 100%;\n  background-color: #0851DF;\n  transform: scaleX(0);\n}\n.flight-number-input__input {\n  -webkit-appearance: none;\n  background-color: #F2F3F5;\n  width: calc(100% - 8px);\n  padding: 12px 0 0 8px;\n  height: calc(\n    28px);\n  border: none;\n  border-bottom: 1px solid #B4B8C3;\n  color: #051336;\n}\n.flight-number-input__input--without-label {\n  padding-top: 0;\n  height: 40px;\n}\n.flight-number-input__input::-webkit-placeholder {\n  color: #CDD0D7;\n  opacity: 0;\n}\n.flight-number-input__input::-moz-placeholder {\n  color: #CDD0D7;\n  opacity: 0;\n}\n.flight-number-input__input::-ms-placeholder {\n  color: #CDD0D7;\n  opacity: 0;\n}\n.flight-number-input__input::-o-placeholder {\n  color: #CDD0D7;\n  opacity: 0;\n}\n.flight-number-input__input::placeholder {\n  color: #CDD0D7;\n  opacity: 0;\n}\n.flight-number-input__input:hover {\n  border-color: #505A72;\n}\n.flight-number-input__input:focus, .flight-number-input__input--not-empty {\n  outline: none;\n}\n.flight-number-input__input:focus ~ .flight-number-input__label, .flight-number-input__input--not-empty ~ .flight-number-input__label {\n  transform: translateY(-8px) scale(0.85);\n}\n.flight-number-input__input:focus::-webkit-placeholder {\n  opacity: 1;\n}\n.flight-number-input__input:focus::-moz-placeholder {\n  opacity: 1;\n}\n.flight-number-input__input:focus::-ms-placeholder {\n  opacity: 1;\n}\n.flight-number-input__input:focus::-o-placeholder {\n  opacity: 1;\n}\n.flight-number-input__input:focus::placeholder {\n  opacity: 1;\n}\n.flight-number-input__input:focus ~ .flight-number-input__label {\n  color: #0851DF;\n}\n.flight-number-input__input:focus ~ .flight-number-input__border {\n  height: 2px;\n  transform: scaleX(1);\n}\n.flight-number-input__error-message {\n  color: #DC3616;\n  padding-left: 8px;\n  display: block;\n}\n.flight-number-input__error-message--disabled {\n  color: #B4B8C3;\n}\n.flight-number-input--error {\n  margin-bottom: 4px;\n}\n.flight-number-input--error .flight-number-input__input {\n  border-color: #DC3616;\n}\n.flight-number-input--error .flight-number-input__input:focus ~ .flight-number-input__label {\n  color: #DC3616;\n}\n.flight-number-input--error .flight-number-input__border {\n  background-color: #DC3616;\n}\n.flight-number-input--disabled {\n  cursor: no-drop;\n}\n.flight-number-input--disabled .flight-number-input__input {\n  border-color: #CDD0D7;\n  pointer-events: none;\n}\n.flight-number-input--disabled .flight-number-input__input,\n.flight-number-input--disabled .flight-number-input__label {\n  color: #B4B8C3;\n}";
styleInject(css_248z$e);

const DEFAULT_CLASS$c = 'flight-number-input';
const INPUT_CLASS$1 = `${DEFAULT_CLASS$c}__input`;
const ERROR_CLASS$1 = `${DEFAULT_CLASS$c}__error-message`;
const regexGen = (allowDecimal, allowNegative, maxDecimalPlace) => {
  let regex = /^[0-9\b]*$/;
  if (allowNegative && allowDecimal) {
    regex = '^-?\\d*\\.?\\d';
  } else if (allowNegative) {
    regex = /^-?[0-9\b]*$/;
  } else if (allowDecimal) {
    regex = '^\\d*\\.?\\d';
  }
  return allowDecimal && maxDecimalPlace ? new RegExp(`${regex}{0,${parseInt(maxDecimalPlace, 10)}}$`) : regex;
};
const FlightNumberInput = props => {
  const {
    className,
    disabled,
    errorMessage,
    hasError,
    inputRef,
    label,
    ariaLabel,
    placeholderText,
    onLoad,
    onBlur,
    allowDecimal,
    allowNegative,
    maxValue,
    name,
    minValue,
    onChange,
    value,
    maxDecimalPlace,
    width,
    onKeyDown,
    onKeyPress,
    onFocus,
    autoFocus
  } = props;
  const wrapperRef = element => {
    if (element) {
      // Resize component width based on this.props.width
      /* eslint-disable no-param-reassign */
      element.style.width = width;
    }
  };
  let ref = inputRef;
  if (autoFocus && !inputRef) ref = /*#__PURE__*/React__default.createRef();
  useEffect(() => {
    if (onLoad) onLoad();
    if (autoFocus && ref && ref.current) ref.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleValueChange = event => {
    const re = regexGen(allowDecimal, allowNegative, maxDecimalPlace);
    const parseFunction = allowDecimal ? parseFloat : parseInt;
    if (disabled || !re.test(event.target.value) || event.target.value === '.' || parseFunction(event.target.value) > parseFunction(maxValue) || parseFunction(event.target.value) < parseFunction(minValue)) return false;
    if (onChange) onChange(event);
    return null;
  };
  const handleKeyDown = event => {
    if (disabled) return;
    const target = {
      ...event.target
    };
    if (event.key === EVENT_KEYS.ARROW_UP || event.key === EVENT_KEYS.ARROW_DOWN) {
      target.value = ((parseFloat(event.target.value) || 0) + (event.key === EVENT_KEYS.ARROW_UP ? 1 : -1)).toString();
      if (allowDecimal && target.value.toString().indexOf('.') !== -1) {
        target.value = parseFloat(parseFloat(target.value).toFixed(maxDecimalPlace)).toString();
      }
      handleValueChange({
        ...event,
        target
      });
      event.preventDefault();
    }
    if (onKeyDown) onKeyDown(event);
  };
  const handleKeyPress = event => {
    if (disabled) return;
    if (onKeyPress) onKeyPress(event);
  };
  const handleOnBlur = event => {
    if (disabled) return;
    const normalizedValue = event.target.value.length ? parseFloat(event.target.value).toString() : '';
    const target = {
      ...event.target,
      value: normalizedValue
    };
    const newEvent = {
      ...event,
      target
    };
    if (event.target.value !== normalizedValue) {
      handleValueChange(newEvent);
    }
    if (onBlur) onBlur(newEvent);
  };
  const handleOnFocus = event => {
    if (disabled) return;
    if (onFocus) onFocus(event);
  };
  let labelWrapperClass = DEFAULT_CLASS$c;
  labelWrapperClass += hasError ? ` ${DEFAULT_CLASS$c}--error` : '';
  labelWrapperClass += disabled ? ` ${DEFAULT_CLASS$c}--disabled` : '';
  labelWrapperClass += className ? ` ${className}` : '';
  let inputClass = INPUT_CLASS$1;
  inputClass += !label ? ` ${INPUT_CLASS$1}--without-label` : '';
  inputClass += value ? ` ${INPUT_CLASS$1}--not-empty` : '';
  let errorMessageClass = ERROR_CLASS$1;
  errorMessageClass += disabled ? ` ${ERROR_CLASS$1}--disabled` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flight-number-input-wrapper",
    ref: wrapperRef
  }, /*#__PURE__*/React__default.createElement("label", {
    className: labelWrapperClass,
    htmlFor: "number-input"
  }, /*#__PURE__*/React__default.createElement("input", {
    name: name,
    type: "text",
    className: inputClass,
    disabled: disabled,
    onChange: handleValueChange,
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    onKeyDown: handleKeyDown,
    onKeyPress: handleKeyPress,
    placeholder: placeholderText,
    "aria-label": ariaLabel || label,
    ref: ref,
    value: value
  }), /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$c}__label`
  }, label), /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$c}__border`
  })), hasError && errorMessage && /*#__PURE__*/React__default.createElement("span", {
    className: errorMessageClass
  }, errorMessage));
};
FlightNumberInput.propTypes = {
  allowDecimal: propTypes.bool,
  allowNegative: propTypes.bool,
  autoFocus: propTypes.bool,
  className: propTypes.string,
  disabled: propTypes.bool,
  errorMessage: propTypes.string,
  hasError: propTypes.bool,
  label: propTypes.string,
  ariaLabel: propTypes.string,
  maxDecimalPlace: propTypes.number,
  maxValue: propTypes.oneOfType([propTypes.string, propTypes.number]),
  minValue: propTypes.oneOfType([propTypes.string, propTypes.number]),
  onBlur: propTypes.func,
  onChange: propTypes.func,
  onFocus: propTypes.func,
  onKeyDown: propTypes.func,
  onKeyPress: propTypes.func,
  onLoad: propTypes.func,
  name: propTypes.string,
  placeholderText: propTypes.string,
  value: propTypes.string,
  width: propTypes.string,
  inputRef: propTypes.shape({
    current: propTypes.shape({
      focus: propTypes.func
    })
  })
};
FlightNumberInput.defaultProps = {
  allowDecimal: false,
  allowNegative: false,
  autoFocus: false,
  className: '',
  disabled: false,
  errorMessage: '',
  hasError: false,
  inputRef: null,
  label: '',
  ariaLabel: '',
  name: null,
  maxDecimalPlace: 2,
  maxValue: '',
  minValue: '',
  onBlur: () => undefined,
  onChange: () => undefined,
  onFocus: () => undefined,
  onKeyDown: () => undefined,
  onKeyPress: () => undefined,
  onLoad: () => undefined,
  placeholderText: '',
  value: '',
  width: '232px'
};

var css_248z$f = ".flight-font, .flight-select {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-select__error-message {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-select__label, .flight-select__dropdown__empty-message {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-select__dropdown__trigger__button {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-select {\n  min-width: 65px;\n  position: relative;\n  display: inline-block;\n}\n.flight-select, .flight-select * {\n  outline: none;\n}\n.flight-select .flight-button {\n  padding: 12px 8px;\n}\n.flight-select .flight-dropdown {\n  width: 100%;\n}\n.flight-select__dropdown {\n  background-color: #F2F3F5;\n  border-bottom: 1px solid #B4B8C3;\n  border-radius: 5px 5px 0 0;\n}\n.flight-select__dropdown__trigger__button {\n  width: 100%;\n  padding: 0 8px 0 4px;\n  border-radius: 5px 5px 0 0;\n  background-color: transparent;\n  color: #1E2B4A;\n}\n.flight-select__dropdown__trigger__button svg:first-child {\n  margin-right: 4px;\n}\n.flight-select__dropdown__trigger__button span + svg {\n  margin-left: auto;\n}\n.flight-select__dropdown__trigger__button:hover:enabled, .flight-select__dropdown__trigger__button:focus:enabled, .flight-select__dropdown__trigger__button:active:enabled {\n  color: #1E2B4A;\n  background-color: transparent;\n}\n.flight-select__dropdown__trigger__button:hover:enabled svg, .flight-select__dropdown__trigger__button:focus:enabled svg, .flight-select__dropdown__trigger__button:active:enabled svg {\n  fill: #697186;\n}\n.flight-select__dropdown__option {\n  width: 100%;\n  border-radius: 0;\n  justify-content: left;\n  text-align: left;\n}\n.flight-select__dropdown__option:hover:enabled, .flight-select__dropdown__option:focus:enabled, .flight-select__dropdown__option--hovered {\n  background-color: #F2F3F5;\n  color: #697186;\n}\n.flight-select__dropdown__option--selected, .flight-select__dropdown__option--selected:hover:enabled, .flight-select__dropdown__option--selected:focus:enabled {\n  background-color: #E6E7EB;\n}\n.flight-select__dropdown__empty-message {\n  color: #82899B;\n  padding: 0 8px;\n  min-width: 133px;\n}\n.flight-select__dropdown--error {\n  border-color: #DC3616;\n  margin-bottom: 4px;\n}\n.flight-select__dropdown__portal .flight-dropdown__dropdown {\n  width: 100%;\n}\n.flight-select:not(.flight-select--disabled) .flight-select__dropdown:hover, .flight-select:not(.flight-select--disabled) .flight-select__dropdown--focused {\n  border-color: #505A72;\n}\n.flight-select__label, .flight-select__border {\n  -webkit-transition-delay: 0s;\n  -moz-transition-delay: 0s;\n  -ms-transition-delay: 0s;\n  -o-transition-delay: 0s;\n  transition-delay: 0s;\n  -webkit-transition-duration: 0.15s;\n  -moz-transition-duration: 0.15s;\n  -ms-transition-duration: 0.15s;\n  -o-transition-duration: 0.15s;\n  transition-duration: 0.15s;\n  -webkit-transition-property: all;\n  -moz-transition-property: all;\n  -ms-transition-property: all;\n  -o-transition-property: all;\n  transition-property: all;\n  -webkit-transition-timing-function: ease;\n  -moz-transition-timing-function: ease;\n  -ms-transition-timing-function: ease;\n  -o-transition-timing-function: ease;\n  transition-timing-function: ease;\n  position: absolute;\n}\n.flight-select__label {\n  color: #697186;\n  left: 8px;\n  top: 10px;\n  transform-origin: 0 0;\n  pointer-events: none;\n}\n.flight-select__label--has-icon {\n  left: 36px;\n}\n.flight-select__label--open {\n  color: #0851DF;\n}\n.flight-select__label--open.flight-select__label--error {\n  color: #DC3616;\n}\n.flight-select__border {\n  top: 39px;\n  left: 0;\n  width: 100%;\n  background-color: #0851DF;\n  transform: scaleX(0);\n}\n.flight-select__border--open {\n  height: 2px;\n  transform: scaleX(1);\n}\n.flight-select__border--error {\n  background-color: #DC3616;\n}\n.flight-select__error-message {\n  color: #DC3616;\n  padding-left: 8px;\n  display: block;\n}\n.flight-select__error-message--disabled {\n  color: #B4B8C3;\n}\n.flight-select--label-animation .flight-select__label--up {\n  transform: translateY(-8px) scale(0.85);\n}\n.flight-select--label-animation .flight-select__dropdown__trigger__button svg + .flight-button__label {\n  padding-left: 4px;\n}\n.flight-select--label-animation .flight-select__dropdown__trigger__button .flight-button__label {\n  padding-left: 0;\n  padding-top: 12px;\n}\n.flight-select--disabled .flight-select__label {\n  color: #B4B8C3;\n}\n.flight-select--disabled .flight-select__dropdown {\n  border-color: #CDD0D7;\n}";
styleInject(css_248z$f);

/* eslint-disable react-hooks/exhaustive-deps */
const DEFAULT_CLASS$d = 'flight-select';
const LABEL_CLASS$1 = `${DEFAULT_CLASS$d}__label`;
const BORDER_CLASS = `${DEFAULT_CLASS$d}__border`;
const DROPDOWN_CLASS$1 = `${DEFAULT_CLASS$d}__dropdown`;
const DROPDOWN_OPTION_CLASS = `${DROPDOWN_CLASS$1}__option`;
const ERROR_CLASS$2 = `${DEFAULT_CLASS$d}__error-message`;
const FlightSelect = props => {
  const {
    className,
    label,
    options,
    selected,
    dropdownMaxHeight,
    dropdownDirection,
    hasLabelAnimation,
    handleOptionClick,
    disabled,
    hasError,
    errorMessage,
    onClick,
    hasIcon,
    searchRegex,
    width,
    iconLeft,
    ariaControlsId
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  // isFocused for handling styles changes when user
  //  is trying to do keyboard focus.
  const [isFocused, setIsFocused] = useState(false);
  const [focusedOptIdx, setFocusedOptIdx] = useState(null);
  const triggerRef = useRef(null);
  // for focusing on a dropdown option.
  const dropdownRef = useRef(null);
  const closeDropdown = isFocusTrigger => {
    setIsOpen(false);
    if (isFocusTrigger) triggerRef.current.focus();
  };
  const onOptionClick = (option, isCloseDropdown) => {
    handleOptionClick(option);
    if (isCloseDropdown) closeDropdown(true);
  };

  // focus on a matched option in the DOM dropdown by index.
  const focusOnOption = function () {
    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    if (dropdownRef && dropdownRef.current && dropdownRef.current.children && index >= 0 && options[index] && options[index].name && index < dropdownRef.current.children.length) {
      setFocusedOptIdx(index);
      dropdownRef.current.children[index].focus();
    }
  };

  // to focus on selected option or first option by default
  useEffect(() => {
    if (isOpen && options && options.length > 0) {
      const selectedIdx = selected && selected.key ? options.findIndex(opt => opt.key === selected.key) : 0;
      // auto focus on selected option when dropdown opens.
      //  if props.selected is not defined or that the selected
      //  option is not found from options list, try to select
      //  the first option in the options list.
      focusOnOption(Math.max(selectedIdx, 0));
    }
  }, [isOpen]);
  const handleOnClick = event => {
    if (disabled) return;
    setIsOpen(true);
    if (onClick) onClick(event);
  };
  const handleFindOptionOnKeyDown = event => {
    const reg = new RegExp('^[a-zA-Z0-9]$');
    if (isOpen) {
      if (reg.test(event.key)) {
        // finds the idx of first option in the list that matches
        //  the letter or number the user just typed.
        let matchedIdx = options.findIndex(opt => {
          const optionWrapper = document.createElement('span');
          optionWrapper.innerHTML = ReactDOMServer.renderToStaticMarkup(opt.name);
          return optionWrapper.textContent.toLocaleLowerCase()[0] === event.key.toLocaleLowerCase();
        });
        if (searchRegex) {
          const regex = new RegExp(searchRegex + event.key, 'i');
          matchedIdx = options.findIndex(opt => {
            const optionWrapper = document.createElement('span');
            optionWrapper.innerHTML = ReactDOMServer.renderToStaticMarkup(opt.name);
            return regex.test(optionWrapper.textContent);
          });
        }
        if (matchedIdx > -1) focusOnOption(matchedIdx);
      } else if (options && options.length > 0 && [EVENT_KEYS.ARROW_UP, EVENT_KEYS.ARROW_DOWN].includes(event.key)) {
        // focuses on the previous/next option when users
        //  input arrow up/down actions using keyboard.
        const newFocusedOptIdx = event.key === EVENT_KEYS.ARROW_UP ? Math.max(focusedOptIdx - 1, 0) : Math.min(focusedOptIdx + 1, options.length - 1);
        focusOnOption(newFocusedOptIdx);
        event.preventDefault();
      } else if (event.key === EVENT_KEYS.ENTER) {
        // select current focused item
        onOptionClick(options[focusedOptIdx], true);
      } else if (event.key === EVENT_KEYS.TAB) {
        // when users enter tab key they exit the component.
        closeDropdown(false);
      } else if (event.key === EVENT_KEYS.ESCAPE) {
        // when users enter escape key, close the dropdown but
        //  focus back to trigger button.
        closeDropdown(true);
      }
    }
  };
  const handleTriggerKeydown = event => {
    if (!isOpen && [EVENT_KEYS.ARROW_UP, EVENT_KEYS.ARROW_DOWN].includes(event.key)) {
      setIsOpen(true);
      event.stopPropagation();
      event.preventDefault();
    }
  };
  let wrapperClass = DEFAULT_CLASS$d;
  wrapperClass += label && label.length && hasLabelAnimation ? ` ${DEFAULT_CLASS$d}--label-animation` : '';
  wrapperClass += disabled ? ` ${DEFAULT_CLASS$d}--disabled` : '';
  wrapperClass += className ? ` ${className}` : '';
  let dropdownClass = DROPDOWN_CLASS$1;
  dropdownClass += isFocused ? ` ${DROPDOWN_CLASS$1}--focused` : '';
  dropdownClass += hasError ? ` ${DROPDOWN_CLASS$1}--error` : '';
  let borderClass = BORDER_CLASS;
  borderClass += isOpen ? ` ${BORDER_CLASS}--open` : '';
  borderClass += hasError ? ` ${BORDER_CLASS}--error` : '';
  let labelClass = LABEL_CLASS$1;
  labelClass += iconLeft ? ` ${LABEL_CLASS$1}--has-icon` : '';
  labelClass += isOpen ? ` ${LABEL_CLASS$1}--open` : '';
  labelClass += hasLabelAnimation && (isOpen || selected && selected.key) ? ` ${LABEL_CLASS$1}--up` : '';
  labelClass += hasError ? ` ${LABEL_CLASS$1}--error` : '';
  let errorMessageClass = ERROR_CLASS$2;
  errorMessageClass += disabled ? ` ${ERROR_CLASS$2}--disabled` : '';
  let icon = '';
  if (hasIcon && isOpen) {
    icon = 'upCarrot';
  } else if (hasIcon) {
    icon = 'downCarrot';
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass,
    style: {
      width
    },
    onKeyDown: handleFindOptionOnKeyDown,
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    className: className ? `${className}__dropdown ${dropdownClass}` : dropdownClass,
    trigger: /*#__PURE__*/React__default.createElement(FlightButton, {
      className: `${DROPDOWN_CLASS$1}__trigger__button`,
      label: selected && selected.name ? selected.name : ' ',
      theme: "minor",
      onBlur: () => setIsFocused(false),
      onClick: handleOnClick,
      onFocus: () => setIsFocused(true),
      onKeyDown: handleTriggerKeydown,
      iconRight: icon,
      iconLeft: iconLeft,
      disabled: disabled,
      buttonRef: triggerRef,
      isPropagateUpperActions: true,
      ariaLabel: label || 'select-dropdown-trigger'
    }),
    ariaControlsId: `select-${ariaControlsId}`,
    direction: dropdownDirection,
    maxHeight: dropdownMaxHeight,
    isActive: isOpen,
    ariaLabel: selected && selected.name ? selected.name : label || 'Nothing selected',
    isControlledByIsActive: true,
    handleClickOutside: () => closeDropdown(true)
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: dropdownRef,
    role: "listbox"
  }, options && options.length ? options.map(option => /*#__PURE__*/React__default.createElement(FlightButton, {
    key: option.key,
    helperkey: option.key.toString(),
    className: `${DROPDOWN_OPTION_CLASS}${selected && selected.key === option.key ? ` ${DROPDOWN_OPTION_CLASS}--selected` : ''}`,
    label: option.name,
    theme: "minor",
    onClick: () => onOptionClick(option, true),
    ariaLabel: `${ReactDOMServer.renderToStaticMarkup(option.name).textContent || option.key || 'option'}`
  })) : /*#__PURE__*/React__default.createElement("div", {
    className: `${DROPDOWN_CLASS$1}__empty-message`
  }, "No options available"))), label && label.length && (!selected || hasLabelAnimation) && /*#__PURE__*/React__default.createElement("div", {
    className: labelClass
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: borderClass
  }), hasError && errorMessage && /*#__PURE__*/React__default.createElement("span", {
    role: "alert",
    className: errorMessageClass
  }, errorMessage));
};
FlightSelect.propTypes = {
  label: propTypes.string,
  className: propTypes.string,
  options: propTypes.arrayOf(propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    name: propTypes.node.isRequired
  })),
  selected: propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    name: propTypes.node.isRequired
  }),
  onClick: propTypes.func,
  hasLabelAnimation: propTypes.bool,
  handleOptionClick: propTypes.func,
  dropdownMaxHeight: propTypes.string,
  dropdownDirection: propTypes.string,
  hasError: propTypes.bool,
  errorMessage: propTypes.string,
  width: propTypes.string,
  disabled: propTypes.bool,
  hasIcon: propTypes.bool,
  searchRegex: propTypes.string,
  iconLeft: propTypes.string,
  ariaControlsId: propTypes.string
};
FlightSelect.defaultProps = {
  label: 'Select an option',
  className: '',
  options: [],
  selected: null,
  onClick: () => undefined,
  hasLabelAnimation: false,
  handleOptionClick: () => undefined,
  dropdownMaxHeight: '200px',
  dropdownDirection: '',
  hasError: false,
  errorMessage: '',
  width: '232px',
  disabled: false,
  hasIcon: true,
  searchRegex: '',
  iconLeft: undefined,
  ariaControlsId: ''
};

var css_248z$g = ".flight-font {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-table-pagination {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-table-pagination {\n  width: 340px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  color: #697186;\n}\n.flight-table-pagination, .flight-table-pagination * {\n  box-sizing: border-box;\n}\n.flight-table-pagination__selected-row-count {\n  padding: 12px;\n}\n.flight-table-pagination__row-select {\n  margin-left: auto;\n}\n.flight-table-pagination__row-select__label {\n  padding-left: 12px;\n}\n.flight-table-pagination__row-select .flight-select {\n  border-radius: 5px 5px 0 0;\n}\n.flight-table-pagination__page-control {\n  display: flex;\n  align-items: center;\n}\n.flight-table-pagination__page-control .flight-number-input-wrapper {\n  margin-right: 8px;\n}\n.flight-table-pagination__page-control .flight-number-input-wrapper .flight-number-input {\n  margin: 0;\n}\n.flight-table-pagination__page-control .flight-number-input-wrapper .flight-number-input__input {\n  width: 100%;\n  padding: 2px 0 0;\n  text-align: center;\n  border-radius: 5px 5px 0 0;\n}";
styleInject(css_248z$g);

const DEFAULT_CLASS$e = 'flight-table-pagination';
const ROW_SELECT_CLASS = `${DEFAULT_CLASS$e}__row-select`;
const PAGE_CONTROL_CLASS = `${DEFAULT_CLASS$e}__page-control`;
const SELECTED_ROWS_COUNT_CLASS = `${DEFAULT_CLASS$e}__selected-row-count`;
const FlightTablePagination = props => {
  const {
    className,
    totalPageNumber,
    currentPageNumber,
    rowsPerPageOptions,
    handlePageChange,
    handleRowsPerPageChange,
    currentRowsPerPage,
    selectedCount
  } = props;
  const [inputValue, setInputValue] = useState(currentPageNumber.toString());
  useEffect(() => {
    setInputValue(currentPageNumber.toString());
  }, [currentPageNumber]);
  const handleOptionClick = option => {
    if (option && option.key) {
      handleRowsPerPageChange(option.key);
    }
  };
  const handleInputKeyDown = event => {
    if (event.key === EVENT_KEYS.ENTER) {
      handlePageChange(Number(event.target.value));
    }
  };
  const handleInputChange = event => {
    setInputValue(event.target.value);
  };
  const handleInputBlur = () => {
    setInputValue(currentPageNumber.toString());
  };
  let mainClass = DEFAULT_CLASS$e;
  mainClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: mainClass
  }, selectedCount !== null && /*#__PURE__*/React__default.createElement("div", {
    className: SELECTED_ROWS_COUNT_CLASS
  }, selectedCount === 0 && 'None', selectedCount === 1 && `${selectedCount} row`, selectedCount > 1 && `${selectedCount} rows`, ' selected'), /*#__PURE__*/React__default.createElement("div", {
    className: ROW_SELECT_CLASS
  }, /*#__PURE__*/React__default.createElement(FlightSelect, {
    options: rowsPerPageOptions.map(option => ({
      key: option,
      name: option.toString()
    })),
    selected: {
      key: currentRowsPerPage,
      name: currentRowsPerPage.toString()
    },
    handleOptionClick: handleOptionClick,
    width: "65px"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: `${ROW_SELECT_CLASS}__label`
  }, "per page")), /*#__PURE__*/React__default.createElement("div", {
    className: PAGE_CONTROL_CLASS
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    theme: "minor",
    iconLeft: "baselineKeyboardArrowLeft",
    disabled: currentPageNumber === 1,
    onClick: () => handlePageChange(currentPageNumber - 1),
    ariaLabel: "table-pagination-go-to-previous-page"
  }), /*#__PURE__*/React__default.createElement(FlightButton, {
    theme: "minor",
    iconLeft: "baselineKeyboardArrowRight",
    disabled: currentPageNumber === totalPageNumber,
    onClick: () => handlePageChange(currentPageNumber + 1),
    ariaLabel: "table-pagination-go-to-next-page"
  }), /*#__PURE__*/React__default.createElement(FlightNumberInput, {
    className: `${PAGE_CONTROL_CLASS}__page-input`,
    maxValue: totalPageNumber,
    minValue: 1,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    onKeyDown: handleInputKeyDown,
    value: inputValue,
    width: "38px"
  }), /*#__PURE__*/React__default.createElement(FlightButton, {
    label: `/ ${totalPageNumber}`,
    theme: "link",
    hasUnderline: true,
    onClick: () => handlePageChange(totalPageNumber)
  })));
};
FlightTablePagination.propTypes = {
  className: propTypes.string,
  totalPageNumber: propTypes.number,
  currentPageNumber: propTypes.number,
  rowsPerPageOptions: propTypes.arrayOf(propTypes.number),
  currentRowsPerPage: propTypes.number,
  selectedCount: propTypes.number,
  handlePageChange: propTypes.func,
  handleRowsPerPageChange: propTypes.func
};
FlightTablePagination.defaultProps = {
  className: '',
  totalPageNumber: 1,
  currentPageNumber: 1,
  rowsPerPageOptions: [10, 20, 40, 60],
  currentRowsPerPage: 20,
  selectedCount: null,
  handlePageChange: () => undefined,
  handleRowsPerPageChange: () => undefined
};

var css_248z$h = ".flight-font, .flight-table-wrapper {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-table-wrapper .flight-table {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-table-wrapper .flight-table thead {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-table-wrapper .flight-table {\n  display: table;\n  background-color: #FFFFFF;\n  border-collapse: collapse;\n  border-spacing: 2px;\n  width: 100%;\n}\n.flight-table-wrapper .flight-table thead > tr, .flight-table-wrapper .flight-table tbody > tr {\n  display: table-row;\n}\n.flight-table-wrapper .flight-table thead > tr .flight-checkbox-wrapper, .flight-table-wrapper .flight-table tbody > tr .flight-checkbox-wrapper {\n  justify-content: center;\n}\n.flight-table-wrapper .flight-table thead th, .flight-table-wrapper .flight-table tbody td {\n  vertical-align: middle;\n}\n.flight-table-wrapper .flight-table thead th:first-child, .flight-table-wrapper .flight-table tbody td:first-child {\n  padding-left: 12px;\n}\n.flight-table-wrapper .flight-table thead th:last-child, .flight-table-wrapper .flight-table tbody td:last-child {\n  padding-right: 12px;\n}\n.flight-table-wrapper .flight-table thead {\n  display: table-header-group;\n}\n.flight-table-wrapper .flight-table tbody {\n  display: table-row-group;\n}\n.flight-table-wrapper .flight-table--multi-select .flight-table-header:first-child {\n  width: 55px;\n}\n.flight-table-wrapper .flight-table-pagination {\n  width: 100%;\n}\n.flight-table-wrapper .top-pagination {\n  margin-bottom: 24px;\n}\n.flight-table-wrapper .bottom-pagination {\n  margin-top: 24px;\n}";
styleInject(css_248z$h);

const DEFAULT_CLASS$f = 'flight-table';
const SORT_ICON_PROPS = {
  className: 'flight-table-header__sort-icon'
};
const SORT_ICON_TOGGLE_MAP = {
  desc: getIcon('baselineArrowDown', SORT_ICON_PROPS),
  asc: getIcon('baselineArrowUp', SORT_ICON_PROPS)
};
const FlightTable = props => {
  const {
    tableHeaders,
    tableData,
    isLoading,
    loadingRowNumber,
    className,
    emptyState,
    hasError,
    errorState,
    selectedDataKey,
    allowRowSelect,
    allowMultiSelect,
    isShowHeader,
    headerTooltipDelay,
    hasPaginationAfterTable,
    hasPaginationBeforeTable,
    paginationProps,
    handleHeaderSort,
    sortByKey,
    sortOrder,
    handleDataSelect,
    handleCheckboxMultiSelect,
    handleSelectAll,
    isRowDraggable,
    handleDropRow,
    showSelectedQuantity,
    ariaLabel,
    role
  } = props;
  const tableAttributes = {};
  if (role) {
    tableAttributes.role = role;
  }
  if (ariaLabel) {
    tableAttributes['aria-label'] = ariaLabel;
  }
  const handleOnDataSelect = item => {
    if (allowRowSelect) handleDataSelect(item);
  };
  const handleOnCheckboxMultiSelect = (event, item) => {
    if (allowMultiSelect) {
      handleCheckboxMultiSelect(item);
      if (event) {
        event.stopPropagation();
      }
    }
  };
  const isRowSelected = key => {
    switch (typeof selectedDataKey) {
      case 'object':
        return selectedDataKey && selectedDataKey.has(key);
      case 'number':
        return selectedDataKey.toString() === key;
      case 'string':
        return selectedDataKey === key;
      default:
        return false;
    }
  };
  const enabledTableData = tableData.filter(item => !(item.metadata && item.metadata.isMultiSelectDisabled));
  const handleToggleHeaderCheckbox = () => {
    // whether the action is to select all or unselect all
    let newSelectedDataKey = new Set();
    if (allowMultiSelect && selectedDataKey.size !== enabledTableData.length) {
      newSelectedDataKey = new Set(enabledTableData.map(item => item.key));
    }
    if (handleSelectAll) handleSelectAll(newSelectedDataKey);
  };

  // handle changes in headerCheckboxState from single row select/deselect
  let headerCheckboxState = CHECKBOX_STATES.INDETERMINATE;
  if (allowMultiSelect && selectedDataKey) {
    if (selectedDataKey.size === enabledTableData.length) {
      headerCheckboxState = CHECKBOX_STATES.SELECTED;
    } else if (selectedDataKey.size === 0) {
      headerCheckboxState = CHECKBOX_STATES.UNSELECTED;
    }
  }
  let ariaLabelHeaderText = 'All rows are unselected.';
  if (headerCheckboxState === 'SELECTED') {
    ariaLabelHeaderText = 'All rows are selected.';
  } else if (headerCheckboxState === 'INDETERMINATE') {
    ariaLabelHeaderText = 'All rows are not selected.';
  }
  const tableHeadersComputed = allowMultiSelect ? [{
    name: /*#__PURE__*/React__default.createElement(FlightCheckbox, {
      checkState: headerCheckboxState,
      onSelect: handleToggleHeaderCheckbox,
      labelledby: ariaLabelHeaderText
    }),
    key: 'checkbox',
    isVisible: true,
    hideTooltip: true
  }].concat(tableHeaders) : tableHeaders;
  const moveRow = (item, currentDroped, totalItem) => {
    let dragRow = null;
    for (let count = 0; count < totalItem.length; count++) {
      if (Number(totalItem[count].attributes['data-fieldindex'].value) === item.keyValue) {
        dragRow = totalItem[count];
      }
    }
    if (totalItem.indexOf(currentDroped) > totalItem.indexOf(dragRow)) {
      currentDroped.after(dragRow);
    } else {
      currentDroped.before(dragRow);
    }
  };
  let tableStateElement = null;
  if (hasError && !tableData.length) {
    tableStateElement = errorState;
  } else if (!tableData.length && !isLoading) {
    tableStateElement = emptyState;
  }
  let tableRows = null;
  if (isLoading) {
    tableRows = /*#__PURE__*/React__default.createElement(FlightTableLoading, {
      rowNumber: loadingRowNumber,
      colNumber: tableHeadersComputed.filter(header => header.isVisible).length
    });
  } else if (tableData.length > 0) {
    const tableDataComputed = allowMultiSelect ? tableData.map(item => ({
      checkbox: /*#__PURE__*/React__default.createElement(FlightCheckbox, {
        checkState: isRowSelected(item.key) ? CHECKBOX_STATES.SELECTED : CHECKBOX_STATES.UNSELECTED,
        onSelect: event => handleOnCheckboxMultiSelect(event, item),
        disabled: item.metadata && item.metadata.isMultiSelectDisabled || false,
        labelledby: isRowSelected(item.key) ? 'selected check box' : 'unselected check box'
      }),
      ...item
    })) : tableData;
    tableRows = tableDataComputed.map((item, index) => {
      const {
        metadata,
        ...itemData
      } = item;
      return /*#__PURE__*/React__default.createElement(FlightTableRow, {
        item: itemData,
        index: index,
        columns: tableHeadersComputed.filter(header => header.isVisible).map(col => col.key),
        key: itemData.key,
        fieldKey: itemData.key,
        moveRow: moveRow,
        allowRowSelect: allowRowSelect && !(metadata && metadata.isMultiSelectDisabled),
        allowMultiSelect: allowMultiSelect,
        onClick: () => !(metadata && metadata.isMultiSelectDisabled) && handleOnDataSelect(item),
        selected: allowMultiSelect && isRowSelected(itemData.key),
        className: className,
        isRowDraggable: isRowDraggable,
        handleDropRow: handleDropRow
      });
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$f}-wrapper ${className}`
  }, hasPaginationBeforeTable && /*#__PURE__*/React__default.createElement(FlightTablePagination, _extends({
    className: "top-pagination"
  }, paginationProps)), /*#__PURE__*/React__default.createElement(DndProvider, {
    backend: HTML5Backend,
    context: window
  }, /*#__PURE__*/React__default.createElement("table", _extends({
    className: `${DEFAULT_CLASS$f}${allowMultiSelect ? ` ${DEFAULT_CLASS$f}--multi-select` : ''}`
  }, tableAttributes), isShowHeader && /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, isRowDraggable && /*#__PURE__*/React__default.createElement("th", {
    className: "flight-table-header",
    "aria-label": "draggable row handler"
  }), tableHeadersComputed.map(header => /*#__PURE__*/React__default.createElement(FlightTableHeader, {
    name: header.name,
    icon: sortByKey === header.key && SORT_ICON_TOGGLE_MAP[sortOrder] || (header.isSortable ? SORT_ICON_TOGGLE_MAP.asc : null),
    iconValue: sortByKey === header.key && sortOrder || (header.isSortable ? 'asc' : 'none'),
    isSortable: header.isSortable,
    onClick: () => handleHeaderSort(header),
    isVisible: header.isVisible,
    key: header.key,
    tooltip: header.tooltip,
    hideTooltip: header.hideTooltip,
    selected: sortByKey === header.key,
    tooltipDelay: headerTooltipDelay
  })))), /*#__PURE__*/React__default.createElement("tbody", null, tableRows))), tableStateElement, hasPaginationAfterTable && /*#__PURE__*/React__default.createElement(FlightTablePagination, _extends({
    className: "bottom-pagination",
    selectedCount: showSelectedQuantity && allowRowSelect && allowMultiSelect && selectedDataKey ? selectedDataKey.size : null
  }, paginationProps)));
};
FlightTable.propTypes = {
  className: propTypes.string,
  tableHeaders: propTypes.arrayOf(propTypes.shape({
    name: propTypes.string,
    key: propTypes.string,
    isVisible: propTypes.bool,
    isSortable: propTypes.bool,
    hideTooltip: propTypes.bool,
    tooltipDelay: propTypes.number
  })).isRequired,
  tableData: propTypes.arrayOf(propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number])
  })),
  selectedDataKey: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.instanceOf(Set)]),
  isLoading: propTypes.bool,
  loadingRowNumber: propTypes.number,
  hasError: propTypes.bool,
  errorState: propTypes.element,
  emptyState: propTypes.element,
  allowRowSelect: propTypes.bool,
  handleHeaderSort: propTypes.func,
  sortByKey: propTypes.string,
  sortOrder: propTypes.string,
  allowMultiSelect: propTypes.bool,
  handleDataSelect: propTypes.func,
  handleCheckboxMultiSelect: propTypes.func,
  handleSelectAll: propTypes.func,
  isShowHeader: propTypes.bool,
  headerTooltipDelay: propTypes.number,
  hasPaginationAfterTable: propTypes.bool,
  hasPaginationBeforeTable: propTypes.bool,
  paginationProps: propTypes.shape({
    totalPageNumber: propTypes.number,
    currentPageNumber: propTypes.number,
    rowsPerPageOptions: propTypes.arrayOf(propTypes.number),
    currentRowsPerPage: propTypes.number,
    handlePageChange: propTypes.func,
    handleRowsPerPageChange: propTypes.func
  }),
  isRowDraggable: propTypes.bool,
  handleDropRow: propTypes.func,
  showSelectedQuantity: propTypes.bool,
  ariaLabel: propTypes.string,
  role: propTypes.string
};
FlightTable.defaultProps = {
  className: '',
  tableData: [],
  selectedDataKey: null,
  isLoading: false,
  loadingRowNumber: 3,
  hasError: false,
  errorState: null,
  emptyState: null,
  allowRowSelect: false,
  handleHeaderSort: () => undefined,
  sortByKey: null,
  sortOrder: null,
  allowMultiSelect: false,
  handleDataSelect: () => undefined,
  handleCheckboxMultiSelect: () => undefined,
  handleSelectAll: () => undefined,
  isShowHeader: true,
  headerTooltipDelay: 400,
  hasPaginationAfterTable: false,
  hasPaginationBeforeTable: true,
  paginationProps: {
    totalPageNumber: 1,
    currentPageNumber: 1,
    rowsPerPageOptions: [10, 20, 40, 60],
    currentRowsPerPage: 20,
    handlePageChange: () => undefined,
    handleRowsPerPageChange: () => undefined
  },
  isRowDraggable: false,
  handleDropRow: () => undefined,
  showSelectedQuantity: false,
  ariaLabel: '',
  role: ''
};

var css_248z$i = ".flight-font {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-date-picker__date-table .flight-table-header, .flight-date-picker__date-table__date {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-date-picker__month-control {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-date-picker__date-table .flight-table-header, .flight-date-picker__date-table__date {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-date-picker {\n  display: inline-block;\n}\n.flight-date-picker__month-control {\n  display: flex;\n  align-items: center;\n  padding: 0 12px 0 20px;\n  margin-bottom: 8px;\n}\n.flight-date-picker__month-control .flight-button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n}\n.flight-date-picker__month-control .flight-button:first-child {\n  margin-left: auto;\n}\n.flight-date-picker__date-table .flight-table-header, .flight-date-picker__date-table .flight-table-row__cell {\n  padding: 4px;\n  border: none;\n  text-align: center;\n}\n.flight-date-picker__date-table .flight-table-header {\n  height: 28px;\n  color: #697186;\n}\n.flight-date-picker__date-table__today {\n  position: relative;\n}\n.flight-date-picker__date-table__today__indicator {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 2px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #051336;\n}\n.flight-date-picker__date-table__date {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  color: #051336;\n}\n.flight-date-picker__date-table__date:hover:enabled, .flight-date-picker__date-table__date:focus:enabled {\n  -webkit-box-shadow: inset 0 0 0 1px #0851DF;\n  -moz-box-shadow: inset 0 0 0 1px #0851DF;\n  -ms-box-shadow: inset 0 0 0 1px #0851DF;\n  -o-box-shadow: inset 0 0 0 1px #0851DF;\n  box-shadow: inset 0 0 0 1px #0851DF;\n  color: #051336;\n  background-color: transparent;\n}\n.flight-date-picker__date-table__date--selected {\n  background-color: #0851DF;\n  color: #FFFFFF;\n}\n.flight-date-picker__date-table__date--selected ~ .flight-date-picker__date-table__today__indicator {\n  background-color: #FFFFFF;\n}\n.flight-date-picker__date-table__date--selected:hover:enabled, .flight-date-picker__date-table__date--selected:focus:enabled {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  -ms-box-shadow: none;\n  -o-box-shadow: none;\n  box-shadow: none;\n  color: #FFFFFF;\n  background-color: #0851DF;\n}\n.flight-date-picker__dropdown__portal .flight-dropdown__dropdown {\n  max-width: none !important;\n  width: min-content;\n}";
styleInject(css_248z$i);

/* eslint-disable react-hooks/exhaustive-deps */
const INVALID_DATE_MESSAGE = 'Invalid date entered';
const MIN_DATE_ERROR = 'Selected date is before minimum date';
const MAX_DATE_ERROR = 'Selected date is after maximum date';
const DEFAULT_CLASS$g = 'flight-date-picker';
const DROPDOWN_CLASS$2 = `${DEFAULT_CLASS$g}__dropdown`;
const FlightDatePicker = props => {
  const {
    className,
    selected,
    dropdownDirection,
    onChange,
    onFocus,
    onSelect,
    disabled,
    hasError,
    errorMessage,
    label,
    maxDate,
    minDate,
    autoFocus,
    ariaControlsId
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [isValidDate, setIsValidDate] = useState(true);
  const [currentDate, setCurrentDate] = useState(new Date());
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const today = new Date();
  if (maxDate) maxDate.setHours(0, 0, 0, 0);
  if (minDate) minDate.setHours(0, 0, 0, 0);
  const firstDayOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const validateDate = date => {
    if (!date || Number.isNaN(new Date(date).getTime())) {
      setIsValidDate(false);
      return false;
    }
    setIsValidDate(true);
    return true;
  };
  useEffect(() => {
    if (selected && validateDate(selected)) {
      setInputValue(getDateString(selected));
    } else if (selected) {
      setInputValue('Invalid Date');
    }
  }, [selected]);
  useEffect(() => {
    if (isOpen) {
      setCurrentDate(selected && validateDate(selected) ? new Date(selected) : new Date());
    }
  }, [selected, isOpen]);
  const handleClose = isResetInputToSelect => {
    setIsOpen(false);
    if (isResetInputToSelect && validateDate(selected)) {
      setInputValue(getDateString(selected));
    }
  };
  const handleTextOnChange = event => {
    setInputValue(event.target.value);
    validateDate(event.target.value);
    if (!isOpen) setIsOpen(true);
    if (onChange) onChange(event);
  };
  const handleInputOnFocus = event => {
    if (disabled) return;
    setIsOpen(true);
    if (event.target.value.length) {
      event.target.select();
    }
    if (onFocus) onFocus(event);
  };
  const handleInputOnKeyDown = event => {
    if (disabled) return;
    const inputDateValue = new Date(event.target.value);
    if (event.key === EVENT_KEYS.ENTER) {
      if (!Number.isNaN(inputDateValue.getTime())) {
        inputDateValue.setHours(0, 0, 0, 0);
        if (minDate && minDate.getTime() > inputDateValue.getTime() || maxDate && maxDate.getTime() < inputDateValue.getTime()) {
          setIsValidDate(false);
          return;
        }
      }
      onSelect(inputDateValue);
      setIsValidDate(true);
      setIsOpen(!isOpen);
    } else if (event.key === EVENT_KEYS.ESCAPE) {
      handleClose(true);
    }
  };
  const handleCalenderPickDate = dateNumber => {
    if (disabled) return;
    const selectDate = new Date(currentDate);
    selectDate.setDate(dateNumber);
    selectDate.setHours(0, 0, 0, 0);
    onSelect(selectDate);
    handleClose(false);
    setIsValidDate(true);
  };
  const toggleMonth = isPrevious => {
    const nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setMonth(currentDate.getMonth() + (isPrevious ? -1 : 1));
    setCurrentDate(nextCurrentDate);
  };
  let wrapperClass = DEFAULT_CLASS$g;
  wrapperClass += disabled ? ` ${DEFAULT_CLASS$g}--disabled` : '';
  wrapperClass += className ? ` ${className}` : '';
  let isSelectedOutsideMinMax = false;
  let inputErrorMessage = '';
  if (minDate && selected && minDate.getTime() > selected.getTime()) {
    isSelectedOutsideMinMax = true;
    inputErrorMessage = MIN_DATE_ERROR;
  } else if (maxDate && selected && maxDate.getTime() < selected.getTime()) {
    isSelectedOutsideMinMax = true;
    inputErrorMessage = MAX_DATE_ERROR;
  }
  if (hasError) {
    inputErrorMessage = errorMessage;
  } else if (!isValidDate) {
    inputErrorMessage = INVALID_DATE_MESSAGE;
  }
  return /*#__PURE__*/React__default.createElement("span", {
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    className: DROPDOWN_CLASS$2,
    trigger: /*#__PURE__*/React__default.createElement(FlightTextInput, {
      className: `${DROPDOWN_CLASS$2}__input`,
      value: inputValue,
      label: label,
      isLabelAlwaysOn: false,
      onChange: handleTextOnChange,
      onFocus: handleInputOnFocus,
      onKeyDown: handleInputOnKeyDown,
      inputRef: inputRef,
      disabled: disabled,
      hasError: hasError || !isValidDate || isSelectedOutsideMinMax,
      errorMessage: inputErrorMessage,
      autoFocus: autoFocus
    }),
    direction: dropdownDirection,
    isActive: isOpen && !disabled,
    isControlledByIsActive: true,
    ariaControlsId: `date-picker-${ariaControlsId}`,
    handleClickOutside: () => handleClose(true)
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: dropdownRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$g}__month-control`
  }, `${MONTHS[currentDate.getMonth()]} ${currentDate.getFullYear()}`, /*#__PURE__*/React__default.createElement(FlightButton, {
    iconLeft: "baselineKeyboardArrowLeft",
    theme: "minor",
    size: "large",
    disabled: minDate && minDate.getTime() >= firstDayOfCurrentMonth.getTime(),
    onClick: () => toggleMonth(true),
    ariaLabel: "datepicker-go-to-previous-month"
  }), /*#__PURE__*/React__default.createElement(FlightButton, {
    iconRight: "baselineKeyboardArrowRight",
    theme: "minor",
    size: "large",
    disabled: maxDate && maxDate.getTime() <= lastDayOfCurrentMonth.getTime(),
    onClick: () => toggleMonth(false),
    ariaLabel: "datepicker-go-to-next-month"
  })), /*#__PURE__*/React__default.createElement(FlightTable, {
    className: `${DEFAULT_CLASS$g}__date-table`,
    tableHeaders: CALENDAR_TABLE_HEADERS,
    tableData: getMonthDaysOfDate(currentDate).map((wk, idx) => {
      const week = {
        ...wk
      };
      Object.keys(week).forEach(day => {
        const dateNumber = week[day];
        const dateObj = new Date(currentDate.getFullYear(), currentDate.getMonth(), dateNumber);
        const isToday = dateNumber === today.getDate() && currentDate.getMonth() === today.getMonth() && currentDate.getFullYear() === today.getFullYear();
        const isSelected = selected && dateNumber === selected.getDate() && currentDate.getMonth() === selected.getMonth() && currentDate.getFullYear() === selected.getFullYear();
        let dateButtonClass = `${DEFAULT_CLASS$g}__date-table__date`;
        dateButtonClass += isSelected ? ` ${dateButtonClass}--selected` : '';
        const dateButton = /*#__PURE__*/React__default.createElement(FlightButton, {
          className: dateButtonClass,
          label: dateNumber,
          theme: "minor",
          size: "small",
          disabled: minDate && minDate.getTime() > dateObj.getTime() || maxDate && maxDate.getTime() < dateObj.getTime(),
          onClick: () => handleCalenderPickDate(dateNumber)
        });
        if (isToday) {
          week[day] = /*#__PURE__*/React__default.createElement("div", {
            className: `${DEFAULT_CLASS$g}__date-table__today`
          }, dateButton, /*#__PURE__*/React__default.createElement("div", {
            className: `${DEFAULT_CLASS$g}__date-table__today__indicator`
          }));
        } else {
          week[day] = dateButton;
        }
      });
      week.key = idx;
      return week;
    }),
    hasPaginationBeforeTable: false
  }))));
};
FlightDatePicker.propTypes = {
  className: propTypes.string,
  selected: propTypes.instanceOf(Date),
  label: propTypes.string,
  onChange: propTypes.func,
  onFocus: propTypes.func,
  onSelect: propTypes.func.isRequired,
  dropdownDirection: propTypes.string,
  hasError: propTypes.bool,
  errorMessage: propTypes.string,
  disabled: propTypes.bool,
  maxDate: propTypes.instanceOf(Date),
  minDate: propTypes.instanceOf(Date),
  autoFocus: propTypes.bool,
  ariaControlsId: propTypes.string
};
FlightDatePicker.defaultProps = {
  className: '',
  selected: null,
  label: 'Pick a date',
  onChange: () => undefined,
  onFocus: () => undefined,
  dropdownDirection: '',
  hasError: false,
  errorMessage: '',
  disabled: false,
  maxDate: null,
  minDate: null,
  autoFocus: false,
  ariaControlsId: ''
};

var css_248z$j = ".flight-font {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-calendar .flight-table-header, .flight-calendar__date__button {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-calendar .flight-table-header, .flight-calendar__date__button {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-calendar .flight-table-header, .flight-calendar .flight-table-row__cell {\n  padding: 4px 0;\n  border: none;\n  text-align: center;\n}\n.flight-calendar .flight-table-header {\n  height: 28px;\n  color: #697186;\n}\n.flight-calendar__today {\n  position: relative;\n}\n.flight-calendar__today__indicator {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 2px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #051336;\n}\n.flight-calendar__date {\n  width: fit-content;\n  padding: 0 4px;\n  margin: 2px 0;\n}\n.flight-calendar__date__button {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  color: #051336;\n}\n.flight-calendar__date__button:hover:enabled, .flight-calendar__date__button:focus:enabled {\n  -webkit-box-shadow: inset 0 0 0 1px #0851DF;\n  -moz-box-shadow: inset 0 0 0 1px #0851DF;\n  -ms-box-shadow: inset 0 0 0 1px #0851DF;\n  -o-box-shadow: inset 0 0 0 1px #0851DF;\n  box-shadow: inset 0 0 0 1px #0851DF;\n  color: #051336;\n  background-color: transparent;\n}\n.flight-calendar__date--start-range, .flight-calendar__date--end-range, .flight-calendar__date--within-range {\n  background-color: #DDECFF;\n}\n.flight-calendar__date--start .flight-calendar__date__button, .flight-calendar__date--start-range .flight-calendar__date__button, .flight-calendar__date--end-range .flight-calendar__date__button, .flight-calendar__date--start-end .flight-calendar__date__button {\n  background-color: #0851DF;\n  color: #FFFFFF;\n}\n.flight-calendar__date--start .flight-calendar__date__button:hover:enabled, .flight-calendar__date--start .flight-calendar__date__button:focus:enabled, .flight-calendar__date--start-range .flight-calendar__date__button:hover:enabled, .flight-calendar__date--start-range .flight-calendar__date__button:focus:enabled, .flight-calendar__date--end-range .flight-calendar__date__button:hover:enabled, .flight-calendar__date--end-range .flight-calendar__date__button:focus:enabled, .flight-calendar__date--start-end .flight-calendar__date__button:hover:enabled, .flight-calendar__date--start-end .flight-calendar__date__button:focus:enabled {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  -ms-box-shadow: none;\n  -o-box-shadow: none;\n  box-shadow: none;\n  color: #FFFFFF;\n  background-color: #0851DF;\n}\n.flight-calendar__date--start ~ .flight-calendar__today__indicator, .flight-calendar__date--start-range ~ .flight-calendar__today__indicator, .flight-calendar__date--end-range ~ .flight-calendar__today__indicator, .flight-calendar__date--start-end ~ .flight-calendar__today__indicator {\n  background-color: #FFFFFF;\n}\n.flight-calendar__date--start-range {\n  border-radius: 50% 0 0 50%;\n  padding-left: 0;\n  margin-left: auto;\n}\n.flight-calendar__date--end-range {\n  border-radius: 0 50% 50% 0;\n  padding-right: 0;\n}\n.flight-calendar__date--within-range > .flight-calendar__date__button {\n  background-color: #DDECFF;\n}";
styleInject(css_248z$j);

const DEFAULT_CLASS$h = 'flight-calendar';
function FlightCalendar(props) {
  const {
    className,
    currentDate,
    startDate,
    endDate,
    minDate,
    maxDate,
    onSelect
  } = props;
  const today = new Date();
  let calendarClass = DEFAULT_CLASS$h;
  calendarClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement(FlightTable, {
    className: calendarClass,
    tableHeaders: CALENDAR_TABLE_HEADERS,
    tableData: getMonthDaysOfDate(currentDate).map((wk, idx) => {
      const week = {
        ...wk
      };
      Object.keys(week).forEach(day => {
        const dateNumber = week[day];
        const dateObj = new Date(currentDate.getFullYear(), currentDate.getMonth(), dateNumber);
        const isToday = dateNumber === today.getDate() && currentDate.getMonth() === today.getMonth() && currentDate.getFullYear() === today.getFullYear();
        let dateClass = `${DEFAULT_CLASS$h}__date`;
        if (startDate && endDate && startDate.getTime() < dateObj.getTime() && endDate.getTime() > dateObj.getTime()) {
          dateClass += ` ${DEFAULT_CLASS$h}__date--within-range`;
        } else if (startDate && endDate && startDate.getTime() === dateObj.getTime() && endDate.getTime() === dateObj.getTime()) {
          dateClass += ` ${DEFAULT_CLASS$h}__date--start-end`;
        } else if (startDate && endDate && endDate.getTime() === dateObj.getTime() && startDate.getTime() !== dateObj.getTime()) {
          dateClass += ` ${DEFAULT_CLASS$h}__date--end-range`;
        } else if (startDate && endDate && startDate.getTime() === dateObj.getTime() && endDate.getTime() !== dateObj.getTime()) {
          dateClass += ` ${DEFAULT_CLASS$h}__date--start-range`;
        } else if (startDate && startDate.getTime() === dateObj.getTime()) {
          dateClass += ` ${DEFAULT_CLASS$h}__date--start`;
        }
        const dateButton = /*#__PURE__*/React__default.createElement("div", {
          className: dateClass
        }, /*#__PURE__*/React__default.createElement(FlightButton, {
          className: `${DEFAULT_CLASS$h}__date__button`,
          label: dateNumber,
          theme: "minor",
          size: "small",
          disabled: minDate && minDate.getTime() > dateObj.getTime() || maxDate && maxDate.getTime() < dateObj.getTime(),
          onClick: () => onSelect(dateObj)
        }));
        if (isToday) {
          week[day] = /*#__PURE__*/React__default.createElement("div", {
            className: `${DEFAULT_CLASS$h}__today`
          }, dateButton, /*#__PURE__*/React__default.createElement("div", {
            className: `${DEFAULT_CLASS$h}__today__indicator`
          }));
        } else {
          week[day] = dateButton;
        }
      });
      week.key = idx;
      return week;
    }),
    hasPaginationBeforeTable: false
  });
}
FlightCalendar.propTypes = {
  className: propTypes.string,
  currentDate: propTypes.instanceOf(Date).isRequired,
  onSelect: propTypes.func,
  startDate: propTypes.instanceOf(Date),
  endDate: propTypes.instanceOf(Date),
  maxDate: propTypes.instanceOf(Date),
  minDate: propTypes.instanceOf(Date)
};
FlightCalendar.defaultProps = {
  className: '',
  onSelect: () => undefined,
  startDate: null,
  endDate: null,
  maxDate: null,
  minDate: null
};

var css_248z$k = ".flight-font {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-date-range-picker__error-message {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-date-range-picker__dropdown__custom__calendar__control {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-date-range-picker__dropdown__option, .flight-date-range-picker__dropdown__trigger__button {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-date-range-picker {\n  display: inline-block;\n}\n.flight-date-range-picker, .flight-date-range-picker * {\n  outline: none;\n}\n.flight-date-range-picker__dropdown {\n  border-radius: 4px;\n  background-color: #F2F3F5;\n  position: relative;\n}\n.flight-date-range-picker__dropdown__trigger__button {\n  min-width: 232px;\n  padding: 0 8px 0 4px;\n  background-color: transparent;\n  color: #051336;\n  border-bottom: 1px solid #B4B8C3;\n  border-radius: 5px 5px 0 0;\n}\n.flight-date-range-picker__dropdown__trigger__button > svg {\n  margin-left: auto;\n  fill: #051336;\n}\n.flight-date-range-picker__dropdown__trigger__button:hover:enabled, .flight-date-range-picker__dropdown__trigger__button:focus:enabled, .flight-date-range-picker__dropdown__trigger__button:active:enabled {\n  color: #051336;\n  background-color: transparent;\n  border-color: #505A72;\n}\n.flight-date-range-picker__dropdown__trigger__button:hover:enabled > svg, .flight-date-range-picker__dropdown__trigger__button:focus:enabled > svg, .flight-date-range-picker__dropdown__trigger__button:active:enabled > svg {\n  fill: #051336;\n}\n.flight-date-range-picker__dropdown__trigger__button--empty {\n  color: #697186;\n}\n.flight-date-range-picker__dropdown__trigger__button--empty > svg {\n  fill: #697186;\n}\n.flight-date-range-picker__dropdown__trigger__button--empty:hover:enabled, .flight-date-range-picker__dropdown__trigger__button--empty:focus:enabled, .flight-date-range-picker__dropdown__trigger__button--empty:active:enabled {\n  color: #697186;\n}\n.flight-date-range-picker__dropdown__trigger__button--empty:hover:enabled > svg, .flight-date-range-picker__dropdown__trigger__button--empty:focus:enabled > svg, .flight-date-range-picker__dropdown__trigger__button--empty:active:enabled > svg {\n  fill: #697186;\n}\n.flight-date-range-picker__dropdown__trigger__button--open ~ .flight-date-range-picker__dropdown__border {\n  transform: scaleX(1);\n}\n.flight-date-range-picker__dropdown__trigger__button--error {\n  border-color: #DC3616;\n}\n.flight-date-range-picker__dropdown__trigger__button--error ~ .flight-date-range-picker__dropdown__border {\n  background-color: #DC3616;\n}\n.flight-date-range-picker__dropdown__trigger__button--error > svg {\n  fill: #DC3616;\n}\n.flight-date-range-picker__dropdown__trigger__button--error:hover:enabled, .flight-date-range-picker__dropdown__trigger__button--error:focus:enabled, .flight-date-range-picker__dropdown__trigger__button--error:active:enabled {\n  border-color: #DC3616;\n}\n.flight-date-range-picker__dropdown__trigger__button--error:hover:enabled > svg, .flight-date-range-picker__dropdown__trigger__button--error:focus:enabled > svg, .flight-date-range-picker__dropdown__trigger__button--error:active:enabled > svg {\n  fill: #DC3616;\n}\n.flight-date-range-picker__dropdown__trigger__button:disabled {\n  border-color: #CDD0D7;\n}\n.flight-date-range-picker__dropdown__portal > .flight-dropdown__dropdown {\n  overflow: visible;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.flight-date-range-picker__dropdown__option {\n  width: 100%;\n  border-radius: 0;\n  justify-content: left;\n  color: #051336;\n  white-space: nowrap;\n}\n.flight-date-range-picker__dropdown__option:hover:enabled, .flight-date-range-picker__dropdown__option:focus:enabled, .flight-date-range-picker__dropdown__option:active:enabled {\n  background-color: #F2F3F5;\n  color: #051336;\n}\n.flight-date-range-picker__dropdown__custom {\n  position: unset;\n  width: 100%;\n}\n.flight-date-range-picker__dropdown__custom__portal > .flight-dropdown__dropdown {\n  display: flex;\n  width: min-content;\n}\n.flight-date-range-picker__dropdown__custom__portal > .flight-dropdown__dropdown--right {\n  left: 50%;\n}\n.flight-date-range-picker__dropdown__custom__portal > .flight-dropdown__dropdown--top {\n  top: auto;\n  bottom: 0;\n}\n.flight-date-range-picker__dropdown__custom__calendar__control {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.flight-date-range-picker__dropdown__custom__calendar__control > .flight-button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  position: absolute;\n  left: 12px;\n}\n.flight-date-range-picker__dropdown__custom__calendar:last-child > .flight-date-range-picker__dropdown__custom__calendar__control > .flight-button {\n  left: unset;\n  right: 12px;\n}\n.flight-date-range-picker__dropdown__border {\n  -webkit-transition-delay: 0s;\n  -moz-transition-delay: 0s;\n  -ms-transition-delay: 0s;\n  -o-transition-delay: 0s;\n  transition-delay: 0s;\n  -webkit-transition-duration: 0.15s;\n  -moz-transition-duration: 0.15s;\n  -ms-transition-duration: 0.15s;\n  -o-transition-duration: 0.15s;\n  transition-duration: 0.15s;\n  -webkit-transition-property: all;\n  -moz-transition-property: all;\n  -ms-transition-property: all;\n  -o-transition-property: all;\n  transition-property: all;\n  -webkit-transition-timing-function: ease;\n  -moz-transition-timing-function: ease;\n  -ms-transition-timing-function: ease;\n  -o-transition-timing-function: ease;\n  transition-timing-function: ease;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: #0851DF;\n  transform: scaleX(0);\n}\n.flight-date-range-picker__dropdown--disabled ~ .flight-date-range-picker__error-message {\n  color: #B4B8C3;\n}\n.flight-date-range-picker__error-message {\n  color: #DC3616;\n  padding-left: 8px;\n  display: block;\n}";
styleInject(css_248z$k);

/* eslint-disable react-hooks/exhaustive-deps */
const DEFAULT_CLASS$i = 'flight-date-range-picker';
const DROPDOWN_CLASS$3 = `${DEFAULT_CLASS$i}__dropdown`;
const TRIGGER_CLASS = `${DROPDOWN_CLASS$3}__trigger__button`;
const CUSTOM_DROPDOWN_CLASS = `${DROPDOWN_CLASS$3}__custom`;

// in the interest of faster integration of PET-1747, we'll add list item + flag
// but this comp should really instead allow users to pass their own option list
// as an override.
const DROPDOWN_OPTIONS = {
  TODAY: 'Today',
  SEVEN_DAYS: 'Last 7 days',
  THIRTY_DAYS: 'Last 30 days',
  SIXTY_DAYS: 'Last 60 days',
  NINETY_DAYS: 'Last 90 days',
  ALL: 'All time'
};
const DROPDOWN_OPTIONS_VALUE = {
  TODAY: 0,
  SEVEN_DAYS: 7,
  THIRTY_DAYS: 30,
  SIXTY_DAYS: 60,
  NINETY_DAYS: 90
};
const isValidDate = date => {
  if (!date || Number.isNaN(new Date(date).getTime())) {
    return false;
  }
  return true;
};
const getAvailableOptions = (includeAllTime, includeToday) => Object.keys(DROPDOWN_OPTIONS).filter(item => {
  if (item === 'TODAY' && !includeToday) return false;
  if (item === 'ALL' && !includeAllTime) return false;
  return true;
});
const getLabelByDateRange = function (startDate, endDate, relativeOffset, relativeUnit) {
  let replaceCustomRangeLabel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let label = DROPDOWN_OPTIONS.ALL;
  if (relativeUnit === 'day') {
    // for some reason for ... of is too heavyweight, was throwing lint error
    const entries = Object.entries(DROPDOWN_OPTIONS_VALUE);
    for (let i = 0; i < entries.length; i++) {
      if (entries[i][1] === relativeOffset) return DROPDOWN_OPTIONS[entries[i][0]];
    }
  } else if (relativeUnit) {
    return `Last ${relativeOffset} ${relativeUnit}(s)`;
  }
  if (replaceCustomRangeLabel && isValidDate(startDate) && isValidDate(endDate) && endDate.getTime() >= today.getTime() && endDate.getTime() < today.getTime() + 86400000) {
    const sevenDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - DROPDOWN_OPTIONS_VALUE.SEVEN_DAYS);
    const thirtyDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - DROPDOWN_OPTIONS_VALUE.THIRTY_DAYS);
    const sixtyDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - DROPDOWN_OPTIONS_VALUE.SIXTY_DAYS);
    const ninetyDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - DROPDOWN_OPTIONS_VALUE.NINETY_DAYS);
    switch (startDate.getTime()) {
      case today.getTime():
        return DROPDOWN_OPTIONS.TODAY;
      case sevenDaysAgo.getTime():
        return DROPDOWN_OPTIONS.SEVEN_DAYS;
      case thirtyDaysAgo.getTime():
        return DROPDOWN_OPTIONS.THIRTY_DAYS;
      case sixtyDaysAgo.getTime():
        return DROPDOWN_OPTIONS.SIXTY_DAYS;
      case ninetyDaysAgo.getTime():
        return DROPDOWN_OPTIONS.NINETY_DAYS;
    }
  }
  if (startDate && !isValidDate(startDate) || endDate && !isValidDate(endDate)) {
    return 'Invalid date';
  }
  if (isValidDate(startDate)) {
    label = `${getDateString(startDate, false)} -`;
    if (isValidDate(endDate)) {
      label += ` ${getDateString(endDate, false)}`;
    }
  }
  return label;
};
const FlightDateRangePicker = props => {
  const {
    className,
    value,
    dropdownDirection,
    onChange,
    onClick,
    disabled,
    hasError,
    errorMessage,
    maxDate,
    minDate,
    isIncludeCustom,
    includeAllTime,
    includeToday,
    ariaControlsId,
    replaceCustomRangeLabel
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [label, setLabel] = useState(DROPDOWN_OPTIONS.ALL);
  const [isCustom, setIsCustom] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  if (maxDate) maxDate.setHours(0, 0, 0, 0);
  if (minDate) minDate.setHours(0, 0, 0, 0);
  const firstDayOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const firstDayOfNextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDayOfNextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0);
  const triggerRef = useRef();
  useEffect(() => {
    if (value) {
      setLabel(getLabelByDateRange(value[0], value[1], value[2], value[3], replaceCustomRangeLabel));
      if (isValidDate(value[0])) {
        setStartDate(value[0]);
        if (isValidDate(value[1])) setEndDate(value[1]);else setEndDate(null);
      }
    }
  }, [value]);
  useEffect(() => {
    if (isOpen && isCustom) {
      setCurrentDate(value && value[0] && isValidDate(value[0]) ? value[0] : new Date());
    }
  }, [value, isOpen, isCustom]);
  const handleClose = () => {
    if (triggerRef && triggerRef.current) {
      triggerRef.current.focus();
    }
    setIsOpen(false);
  };
  const handleSelectPresetRange = option => {
    const end = new Date();
    end.setHours(0, 0, 0, 0);
    const start = new Date(end);
    if (DROPDOWN_OPTIONS_VALUE[option] === 0) {
      onChange([start, new Date(), DROPDOWN_OPTIONS_VALUE[option], 'day']);
    } else if (DROPDOWN_OPTIONS_VALUE[option]) {
      start.setDate(start.getDate() - DROPDOWN_OPTIONS_VALUE[option]);
      onChange([start, end, DROPDOWN_OPTIONS_VALUE[option], 'day']);
    } else {
      onChange([null, null]);
    }

    // handleClose();
  };

  const handleCalendarPickDate = selectDate => {
    if (disabled) return;
    if (!startDate || startDate.getTime() > selectDate.getTime() || startDate && endDate) {
      onChange([selectDate, null]);
    } else {
      onChange([startDate, selectDate]);
      // handleClose();
    }
  };

  const toggleMonth = isPrevious => {
    const nextCurrentDate = new Date(currentDate);
    nextCurrentDate.setMonth(currentDate.getMonth() + (isPrevious ? -1 : 1));
    setCurrentDate(nextCurrentDate);
  };
  let wrapperClass = DEFAULT_CLASS$i;
  wrapperClass += className ? ` ${className}` : '';
  let dropdownClass = DROPDOWN_CLASS$3;
  dropdownClass += disabled ? ` ${DROPDOWN_CLASS$3}--disabled` : '';
  let triggerClass = TRIGGER_CLASS;
  triggerClass += isOpen ? ` ${TRIGGER_CLASS}--open` : '';
  triggerClass += hasError ? ` ${TRIGGER_CLASS}--error` : '';
  let triggerIcon = 'downCarrot';
  if (hasError) triggerIcon = 'error';else if (isOpen) triggerIcon = 'upCarrot';
  return /*#__PURE__*/React__default.createElement("span", {
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    className: dropdownClass,
    trigger: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FlightButton, {
      className: triggerClass,
      label: label,
      theme: "minor",
      iconRight: triggerIcon,
      onClick: e => {
        onClick(e);
        setIsOpen(!isOpen);
      },
      disabled: disabled,
      buttonRef: triggerRef
    }), /*#__PURE__*/React__default.createElement("span", {
      className: `${DROPDOWN_CLASS$3}__border`
    })),
    ariaControlsId: `date-range-picker-${ariaControlsId}`,
    direction: dropdownDirection,
    isActive: isOpen && !disabled,
    isControlledByIsActive: true,
    handleClickOutside: handleClose
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getAvailableOptions(includeAllTime, includeToday).map(option => /*#__PURE__*/React__default.createElement(FlightButton, {
    key: option,
    className: `${DROPDOWN_CLASS$3}__option`,
    label: DROPDOWN_OPTIONS[option],
    theme: "minor",
    size: "small",
    onClick: () => handleSelectPresetRange(option),
    onFocus: () => setIsCustom(false)
  })), isIncludeCustom && /*#__PURE__*/React__default.createElement(FlightDropdown, {
    className: CUSTOM_DROPDOWN_CLASS,
    trigger: /*#__PURE__*/React__default.createElement(FlightButton, {
      className: `${DROPDOWN_CLASS$3}__option`,
      label: "Custom",
      theme: "minor",
      size: "small",
      onClick: () => !isCustom && setIsCustom(true),
      onFocus: () => setIsCustom(true)
    }),
    ariaControlsId: `date-range-custom-picker-${ariaControlsId}`,
    direction: "right",
    isActive: isCustom,
    isControlledByIsActive: true,
    handleClickOutside: () => setIsCustom(false),
    maxWidth: "100%"
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: `${CUSTOM_DROPDOWN_CLASS}__calendar`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${CUSTOM_DROPDOWN_CLASS}__calendar__control`
  }, `${MONTHS[currentDate.getMonth()]}
                    ${currentDate.getFullYear()}`, /*#__PURE__*/React__default.createElement(FlightButton, {
    iconLeft: "baselineKeyboardArrowLeft",
    theme: "minor",
    size: "large",
    disabled: minDate && minDate.getTime() >= firstDayOfCurrentMonth.getTime(),
    onClick: () => toggleMonth(true),
    ariaLabel: "datepicker-go-to-previous-month"
  })), /*#__PURE__*/React__default.createElement(FlightCalendar, {
    currentDate: currentDate,
    onSelect: handleCalendarPickDate,
    startDate: startDate,
    endDate: endDate,
    minDate: minDate,
    maxDate: maxDate
  })), /*#__PURE__*/React__default.createElement("div", {
    className: `${CUSTOM_DROPDOWN_CLASS}__calendar`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${CUSTOM_DROPDOWN_CLASS}__calendar__control`
  }, `${MONTHS[firstDayOfNextMonth.getMonth()]}
                    ${firstDayOfNextMonth.getFullYear()}`, /*#__PURE__*/React__default.createElement(FlightButton, {
    iconRight: "baselineKeyboardArrowRight",
    theme: "minor",
    size: "large",
    disabled: maxDate && maxDate.getTime() <= lastDayOfNextMonth.getTime(),
    onClick: () => toggleMonth(false),
    ariaLabel: "datepicker-go-to-next-month"
  })), /*#__PURE__*/React__default.createElement(FlightCalendar, {
    currentDate: firstDayOfNextMonth,
    onSelect: handleCalendarPickDate,
    startDate: startDate,
    endDate: endDate,
    maxDate: maxDate,
    minDate: minDate
  })))))), hasError && errorMessage && /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$i}__error-message`
  }, errorMessage));
};
FlightDateRangePicker.propTypes = {
  className: propTypes.string,
  value(props, propName, componentName) {
    const error = new Error(`Invalid prop \`${propName}\` supplied to` + ` \`${componentName}\`. Validation failed.`);
    const val = props[propName];
    if (!Array.isArray(val)) return error;
    if (val.length !== 2 && val.length !== 4) return error;
    if (!(val[0] instanceof Date) && val[0] !== null) return error;
    if (!(val[1] instanceof Date) && val[1] !== null) return error;
    if (val[2] !== undefined && typeof val[2] !== 'number') return error;
    if (val[3] !== undefined && typeof val[3] !== 'string') return error;
    return undefined;
  },
  onChange: propTypes.func.isRequired,
  onClick: propTypes.func,
  dropdownDirection: propTypes.string,
  hasError: propTypes.bool,
  errorMessage: propTypes.string,
  disabled: propTypes.bool,
  isIncludeCustom: propTypes.bool,
  includeAllTime: propTypes.bool,
  includeToday: propTypes.bool,
  replaceCustomRangeLabel: propTypes.bool,
  maxDate: propTypes.instanceOf(Date),
  minDate: propTypes.instanceOf(Date),
  ariaControlsId: propTypes.string
};
FlightDateRangePicker.defaultProps = {
  className: '',
  value: [null, null],
  onClick: () => undefined,
  dropdownDirection: '',
  hasError: false,
  errorMessage: '',
  disabled: false,
  isIncludeCustom: false,
  includeAllTime: true,
  includeToday: false,
  replaceCustomRangeLabel: true,
  maxDate: null,
  minDate: null,
  ariaControlsId: ''
};

var css_248z$l = ".flight-font, .flight-filter {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-filter {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-filter, .flight-filter * {\n  outline: none;\n}\n\n.toggle-btn, .clear-all {\n  padding: 12px;\n}\n.toggle-btn:active:focus:hover, .clear-all:active:focus:hover {\n  background-color: #DDECFF;\n}\n\n.filters-badge {\n  color: #FFFFFF;\n  background-color: #0851DF;\n  border-radius: 24px;\n  margin-left: 8px;\n  padding: 0 8px;\n}";
styleInject(css_248z$l);

/* eslint-disable react-hooks/exhaustive-deps */
const DEFAULT_CLASS$j = 'flight-filter';
const FlightFilter = props => {
  const [isOpened, setIsOpened] = useState(false);
  const {
    className,
    children,
    isExpanded,
    clearAll,
    numFilters
  } = props;
  let wrapperClass = DEFAULT_CLASS$j;
  wrapperClass += className ? ` ${className}` : '';
  useEffect(() => {
    setIsOpened(isExpanded);
  }, [isExpanded]);
  const toggleFilters = () => {
    setIsOpened(!isOpened);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    className: "toggle-btn",
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Filters", numFilters > 0 && /*#__PURE__*/React__default.createElement("span", {
      className: "filters-badge"
    }, numFilters)),
    theme: "link",
    onClick: toggleFilters,
    iconRight: isOpened ? 'baselineKeyboardArrowUp' : 'baselineKeyboardArrowDown',
    hasUnderline: false
  }), numFilters > 0 && /*#__PURE__*/React__default.createElement(FlightButton, {
    className: "clear-all",
    label: "Clear all",
    theme: "link",
    size: "small",
    onClick: clearAll,
    hasUnderline: false
  }), isOpened && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$j}__items`
  }, children));
};
FlightFilter.propTypes = {
  className: propTypes.string,
  children: propTypes.node.isRequired,
  isExpanded: propTypes.bool,
  clearAll: propTypes.func,
  numFilters: propTypes.number
};
FlightFilter.defaultProps = {
  className: '',
  isExpanded: false,
  clearAll: () => undefined,
  numFilters: 0
};

// a ghetto, cryoptographically insecure version of the uuid implementation

function genPseudoUUID() {
  const octects = Array.from({
    length: 8
  }, () => Math.floor(Math.random() * 65536));
  let pseudoUUID = '';
  octects.forEach((octect, i) => {
    const hexString = octect.toString(16);
    for (let j = 0; j < 4 - hexString.length; j++) {
      pseudoUUID += '0';
    }
    pseudoUUID += hexString;
    if (i > 0 && i < 4) pseudoUUID += '-';
  });
  return pseudoUUID;
}

var css_248z$m = ".flight-image-uploader {\n  color: #37425E;\n}\n.flight-image-uploader--small__file-wrapper, .flight-image-uploader--small .flight-image-uploader__file-wrapper {\n  max-width: 400px;\n}\n.flight-image-uploader--small__image, .flight-image-uploader--small .flight-image-uploader__image {\n  width: 60px;\n  height: 60px;\n}\n.flight-image-uploader--small__image__empty, .flight-image-uploader--small__image__loading, .flight-image-uploader--small .flight-image-uploader__image__empty, .flight-image-uploader--small .flight-image-uploader__image__loading {\n  width: 24px;\n  height: 24px;\n}\n.flight-image-uploader--small__image .flight-button, .flight-image-uploader--small .flight-image-uploader__image .flight-button {\n  height: 20px;\n  width: 54px;\n}\n.flight-image-uploader--small__content .flight-button--secondary, .flight-image-uploader--small .flight-image-uploader__content .flight-button--secondary {\n  height: 20px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.flight-image-uploader--small__text p, .flight-image-uploader--small .flight-image-uploader__text p {\n  margin-left: 0px;\n}\n.flight-image-uploader--small__text .flight-tooltip, .flight-image-uploader--small .flight-image-uploader__text .flight-tooltip {\n  margin-left: 0px;\n}\n.flight-image-uploader--medium__file-wrapper, .flight-image-uploader--medium .flight-image-uploader__file-wrapper {\n  max-width: 600px;\n}\n.flight-image-uploader--medium__image, .flight-image-uploader--medium .flight-image-uploader__image {\n  width: 84px;\n  height: 84px;\n}\n.flight-image-uploader--medium__image .flight-button, .flight-image-uploader--medium .flight-image-uploader__image .flight-button {\n  height: 28px;\n}\n.flight-image-uploader--large__file-wrapper, .flight-image-uploader--large .flight-image-uploader__file-wrapper {\n  max-width: 907px;\n}\n.flight-image-uploader--large__file-label, .flight-image-uploader--large .flight-image-uploader__file-label {\n  padding: 41px;\n  gap: 41px;\n}\n.flight-image-uploader--large__image, .flight-image-uploader--large .flight-image-uploader__image {\n  width: 146px;\n  height: 146px;\n}\n.flight-image-uploader--large__image__empty, .flight-image-uploader--large__image__loading, .flight-image-uploader--large .flight-image-uploader__image__empty, .flight-image-uploader--large .flight-image-uploader__image__loading {\n  width: 56px;\n  height: 56px;\n}\n.flight-image-uploader--large__content, .flight-image-uploader--large .flight-image-uploader__content {\n  justify-content: start;\n}\n.flight-image-uploader--large__text__primary, .flight-image-uploader--large .flight-image-uploader__text__primary {\n  font-size: 22px;\n}\n.flight-image-uploader--large__text p, .flight-image-uploader--large .flight-image-uploader__text p {\n  margin-right: 34px;\n}\n.flight-image-uploader--large__text .flight-tooltip, .flight-image-uploader--large .flight-image-uploader__text .flight-tooltip {\n  margin-right: 34px;\n}\n.flight-image-uploader__file-wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 600px;\n}\n.flight-image-uploader__image {\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 92px;\n  height: 92px;\n  border-radius: 5px;\n  border: 1px solid #E6E7EB;\n  background-color: #F2F3F5;\n  overflow: hidden;\n}\n.flight-image-uploader__image--loading img {\n  display: none;\n}\n.flight-image-uploader__image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.flight-image-uploader__image__dimensions {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.75);\n  text-align: center;\n  font-size: 10px;\n  line-height: 10px;\n  box-sizing: border-box;\n  padding: 2px;\n}\n.flight-image-uploader__image__actions {\n  position: absolute;\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.75);\n  box-sizing: border-box;\n}\n.flight-image-uploader__image__actions .flight-button {\n  width: 80px;\n  height: 28px;\n  font-size: 12px;\n}\n.flight-image-uploader__image__actions .flight-button--secondary {\n  border: none;\n}\n.flight-image-uploader__image__empty, .flight-image-uploader__image__loading {\n  width: 30px;\n  height: 30px;\n  fill: #82899B;\n}\n.flight-image-uploader__image__loading {\n  animation: spinner 1.5s linear infinite;\n}\n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.flight-image-uploader__content {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px;\n  min-width: 0;\n}\n.flight-image-uploader__content .flight-button--secondary {\n  flex-shrink: 0;\n  background-color: transparent;\n  font-weight: 400;\n  color: #37425E;\n  -webkit-box-shadow: 0 0 0 1px #37425E;\n  box-shadow: 0 0 0 1px #37425E;\n}\n.flight-image-uploader__badge {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  background-color: #0851DF;\n  border-radius: 5px;\n  border: none;\n  padding: 4px 6px;\n  color: white;\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 12px;\n  min-width: 0;\n}\n.flight-image-uploader__badge__filename {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.flight-image-uploader__badge__ext {\n  flex-shrink: 0;\n}\n.flight-image-uploader__badge svg {\n  flex-shrink: 0;\n  margin-left: 6px;\n  width: 16px;\n  fill: currentColor;\n}\n.flight-image-uploader__text {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n.flight-image-uploader__text p {\n  margin: 0 8px;\n}\n.flight-image-uploader__text__secondary {\n  font-size: 12px;\n  color: #697186;\n}\n.flight-image-uploader__text .flight-tooltip {\n  margin: 0 8px;\n}\n.flight-image-uploader__text .flight-tooltip .flight-tooltip__content {\n  display: flex;\n}\n.flight-image-uploader__file-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border: 1px dashed #82899B;\n  border-radius: 5px;\n  box-sizing: border-box;\n  background-color: #fff;\n  cursor: pointer;\n}\n.flight-image-uploader__file-label--is-dragging {\n  outline: 3px dashed #2371F1;\n  border-color: transparent;\n}\n.flight-image-uploader__file-label--is-dragging * {\n  pointer-events: none;\n}\n.flight-image-uploader__file-label input[type=file] {\n  display: none;\n  opacity: 0;\n}\n.flight-image-uploader__file-label:focus-within, .flight-image-uploader__file-label:hover {\n  border-color: #4992FD;\n  background-color: #DDECFF;\n}\n.flight-image-uploader__file-label:focus-within .flight-image-uploader__image, .flight-image-uploader__file-label:hover .flight-image-uploader__image {\n  border-color: #4992FD;\n}\n.flight-image-uploader__file-label:focus-within .flight-image-uploader__image__actions, .flight-image-uploader__file-label:hover .flight-image-uploader__image__actions {\n  display: flex;\n}\n.flight-image-uploader__file-label:focus-within .flight-image-uploader__image__dimensions, .flight-image-uploader__file-label:hover .flight-image-uploader__image__dimensions {\n  display: none;\n}\n.flight-image-uploader__error {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 5px;\n  color: #871313;\n}\n.flight-image-uploader__error svg {\n  height: 16px;\n  fill: currentColor;\n}";
styleInject(css_248z$m);

const MAIN_CLASS = 'flight-image-uploader';
const CLASSES = {
  FILE_WRAPPER: `${MAIN_CLASS}__file-wrapper`,
  FILE_LABEL: `${MAIN_CLASS}__file-label`,
  TEXT: `${MAIN_CLASS}__text`,
  TEXT_LARGE: `${MAIN_CLASS}__text__primary`,
  TEXT_SMALL: `${MAIN_CLASS}__text__secondary`,
  IS_DRAGGING: `${MAIN_CLASS}__file-label--is-dragging`,
  IMAGE: `${MAIN_CLASS}__image`,
  IMAGE_DIMENSIONS: `${MAIN_CLASS}__image__dimensions`,
  IMAGE_ACTIONS: `${MAIN_CLASS}__image__actions`,
  LOADING_ICON: `${MAIN_CLASS}__image__loading`,
  EMPTY_ICON: `${MAIN_CLASS}__image__empty`,
  CONTENT: `${MAIN_CLASS}__content`,
  BADGE: `${MAIN_CLASS}__badge`,
  BADGE_FILENAME: `${MAIN_CLASS}__badge__filename`,
  BADGE_EXT: `${MAIN_CLASS}__badge__ext`,
  ERROR: `${MAIN_CLASS}__error`
};
const ALLOWED_EXTENSIONS = ['.png', '.jpeg', '.jpg', '.tiff'];
const UPLOADER_SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
const generateAllowedExtensions = allowedExtensions => {
  const allowedTypes = allowedExtensions.flat().join(',');
  const allowedTypesString = allowedExtensions.map(ext => ext.substring(1));
  return [allowedTypes, `${allowedTypesString.join(' / ')} only`];
};
const isDataURI = uri => uri && uri.substring(0, 5) === 'data:';
const formatBytes = bytes => {
  if (bytes < 1e3) {
    return `${bytes} B`;
  }
  if (bytes >= 1e3 && bytes < 1e6) {
    return `${(bytes / 1e3).toFixed(0)} kB`;
  }
  if (bytes >= 1e6 && bytes < 1e9) {
    return `${(bytes / 1e6).toFixed(0)} MB`;
  }
  return `${(bytes / 1e9).toFixed(0)} GB`;
};
const renderImagePreview = (src, handleRemove, dimensions, onImageLoad, isLoading) => src ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("img", {
  onLoad: onImageLoad,
  src: src,
  alt: "preview"
}), !isLoading && dimensions && /*#__PURE__*/React__default.createElement("div", {
  className: CLASSES.IMAGE_DIMENSIONS
}, dimensions[0], ' ', "X", ' ', dimensions[1]), !isLoading && /*#__PURE__*/React__default.createElement("div", {
  className: CLASSES.IMAGE_ACTIONS
}, /*#__PURE__*/React__default.createElement(FlightButton, {
  theme: "secondary",
  label: "Remove",
  size: "small",
  onClick: handleRemove
}))) : !isLoading && getIcon('pictureFile', {
  className: CLASSES.EMPTY_ICON
});
const renderFileBadge = (file, showSize, onClick) => {
  const delimitedFileName = file.name.split('.');
  const hasExtension = delimitedFileName.length > 1;
  const fileName = hasExtension ? delimitedFileName.slice(0, -1).join('.') : file.name;
  const fileExt = hasExtension ? `.${delimitedFileName.at(-1)}` : '';
  return /*#__PURE__*/React__default.createElement(FlightTooltip, {
    description: file.name
  }, /*#__PURE__*/React__default.createElement("button", {
    className: CLASSES.BADGE,
    type: "button",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: CLASSES.BADGE_FILENAME
  }, fileName), /*#__PURE__*/React__default.createElement("span", {
    className: CLASSES.BADGE_EXT
  }, fileExt, "\xA0", showSize && `(${formatBytes(file.size)})`), getIcon('clear', {})));
};
const getBusyText = (isLoading, isGenerating) => {
  if (isLoading) return 'Uploading';
  if (isGenerating) return 'Loading';
  return '';
};
const FlightImageUploader = props => {
  const {
    className,
    id,
    allowedExtensions,
    maxFileSize,
    imageUrl,
    imageUrlFileName,
    selectedFile,
    onChange,
    isLoading,
    isDisabled,
    size,
    errorMessage,
    hasError
  } = props;
  const labelRef = useRef(null);
  const inputRef = useRef(null);
  const uploaderClass = `${MAIN_CLASS} ${MAIN_CLASS}--${UPLOADER_SIZES[size]} ${className || ''}`;
  const isCompact = size === UPLOADER_SIZES.small;
  // used when only imageUrl is provided
  const [previewFile, setPreviewFile] = useState();
  // used only when selectedFile is provided
  const [previewURL, setPreviewURL] = useState('');
  const [isPreviewImgLoading, setPreviewImgLoading] = useState(false);
  const [isPreviewFileLoading, setPreviewFileLoading] = useState(false);
  const [error, setError] = useState('');
  const [dimensions, setDimensions] = useState();
  const onImageLoad = _ref => {
    let {
      target
    } = _ref;
    setDimensions([target.naturalWidth, target.naturalHeight]);
    setPreviewImgLoading(false);
  };

  // triple loading state
  const isUpdating = isLoading || isPreviewImgLoading || isPreviewFileLoading;
  const [allowedTypes, allowedTypesString] = generateAllowedExtensions(allowedExtensions);
  const resetLabelClasses = () => {
    if (labelRef.current) labelRef.current.classList.remove(CLASSES.IS_DRAGGING);
  };
  const handleFileUpload = async files => {
    try {
      if (!files?.length) throw new Error('');
      if (files.length > 1) throw new Error('Too many files!');
      const file = files[0];
      if (file.size > maxFileSize) throw new Error('Your file is too chonky!');
      if (!file.type.includes('image') || !allowedExtensions.includes(`.${file.name.split('.').at(-1)}`)) {
        throw new Error('Your file is not an accepted type!');
      }
      onChange(file);
    } catch (e) {
      setError(e.message);
    }
  };
  const handleDrop = evt => {
    if (isUpdating || isDisabled) return;
    evt.preventDefault();
    resetLabelClasses();
    const {
      files
    } = evt.dataTransfer;
    handleFileUpload(files);
  };
  const handleDragLeave = evt => {
    evt.preventDefault();
    resetLabelClasses();
  };
  const handleDragOver = evt => {
    evt.preventDefault();
    if (labelRef.current) labelRef.current.classList.add(CLASSES.IS_DRAGGING);
  };
  const handleChange = evt => {
    if (isUpdating || isDisabled) return;
    const {
      files
    } = evt.target;
    handleFileUpload(files);
  };
  const handleRemove = evt => {
    evt.preventDefault();
    inputRef.current.value = '';
    onChange();
    setPreviewURL('');
    setPreviewFile();
  };

  // Refresh the preview file / url when imageUrl or selectedFile changes
  // previews are only ever set here and in the remove function
  // so it has been removed from the dependencies to prevent le infite render loop
  useEffect(() => {
    const fetchImage = async () => {
      try {
        const imageRes = await fetch(imageUrl);
        const imageBlob = await imageRes.blob();
        const fileName = imageUrlFileName || (isDataURI(imageUrl) ? 'image' : imageUrl.split('/').at(-1));
        const file = new File([imageBlob], fileName);
        setPreviewFile(file);
        inputRef.current.value = '';
      } catch {
        // handle error
      } finally {
        setPreviewFileLoading(false);
      }
    };
    if (previewURL) URL.revokeObjectURL(previewURL);
    if (imageUrl && !selectedFile) {
      setPreviewFileLoading(true);
      setPreviewImgLoading(true);
      fetchImage();
    } else if (selectedFile) {
      if (inputRef.current?.files[0]?.name !== selectedFile.name) inputRef.current.value = '';
      setPreviewURL(URL.createObjectURL(selectedFile));
    }
    return () => previewURL && URL.revokeObjectURL(previewURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageUrl, selectedFile, imageUrlFileName]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: uploaderClass
  }, /*#__PURE__*/React__default.createElement("div", {
    className: CLASSES.FILE_WRAPPER
  }, /*#__PURE__*/React__default.createElement("label", {
    className: CLASSES.FILE_LABEL,
    htmlFor: id,
    "aria-label": "select an image file to upload",
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDragEnd: handleDragLeave,
    onDrop: handleDrop,
    ref: labelRef,
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement("input", {
    id: id,
    type: "file",
    accept: allowedTypes,
    disabled: isDisabled || isLoading,
    onChange: handleChange,
    ref: inputRef
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${CLASSES.IMAGE} ${isUpdating ? `${CLASSES.IMAGE}--loading` : ''}`
  }, isUpdating && getIcon('loading', {
    className: CLASSES.LOADING_ICON
  }), renderImagePreview(previewURL || imageUrl, handleRemove, dimensions, onImageLoad, isUpdating)), /*#__PURE__*/React__default.createElement("div", {
    className: CLASSES.CONTENT
  }, isUpdating ? /*#__PURE__*/React__default.createElement("div", {
    className: CLASSES.TEXT
  }, /*#__PURE__*/React__default.createElement("p", null, getBusyText(isLoading, isPreviewFileLoading || isPreviewImgLoading), "...")) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: CLASSES.TEXT
  }, !isCompact && /*#__PURE__*/React__default.createElement("p", {
    className: CLASSES.TEXT_LARGE
  }, "Drag and drop an image here"), selectedFile || previewFile ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderFileBadge(selectedFile ?? previewFile, !isCompact, handleRemove), isCompact && /*#__PURE__*/React__default.createElement("p", {
    className: CLASSES.TEXT_SMALL
  }, "File size:", ' ', formatBytes(selectedFile?.size ?? previewFile.size))) : /*#__PURE__*/React__default.createElement("p", {
    className: CLASSES.TEXT_SMALL
  }, `${allowedTypesString}  `, isCompact ? /*#__PURE__*/React__default.createElement("br", null) : /*#__PURE__*/React__default.createElement("b", null, "\xB7"), `  Max file size: ${formatBytes(maxFileSize)}`)), /*#__PURE__*/React__default.createElement(FlightButton, {
    theme: "secondary",
    label: selectedFile || previewFile ? 'Change file' : 'Choose file',
    size: "small",
    onClick: () => labelRef.current.click()
  })))), (error || hasError) && /*#__PURE__*/React__default.createElement("div", {
    className: CLASSES.ERROR
  }, getIcon('exclamationCircle', {}), ' ', errorMessage || error)));
};
FlightImageUploader.propTypes = {
  allowedExtensions: propTypes.arrayOf(propTypes.string),
  className: propTypes.string,
  errorMessage: propTypes.string,
  hasError: propTypes.bool,
  id: propTypes.string,
  imageUrl: propTypes.string,
  imageUrlFileName: propTypes.string,
  isDisabled: propTypes.bool,
  isLoading: propTypes.bool,
  maxFileSize: propTypes.number,
  onChange: propTypes.func.isRequired,
  size: propTypes.oneOf(['small', 'medium', 'large']),
  selectedFile: propTypes.shape({
    name: propTypes.string,
    size: propTypes.number,
    type: propTypes.string
  })
};
FlightImageUploader.defaultProps = {
  allowedExtensions: ALLOWED_EXTENSIONS,
  className: '',
  errorMessage: '',
  hasError: false,
  id: `fiu-${genPseudoUUID()}`,
  imageUrl: '',
  imageUrlFileName: '',
  isDisabled: false,
  isLoading: false,
  maxFileSize: 100000000,
  size: 'medium',
  selectedFile: undefined
};

var css_248z$n = ".flight-font, .flight-modal-wrapper .flight-modal {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-modal-wrapper .flight-modal .flight-modal__content {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large, .flight-modal-wrapper .flight-modal .flight-modal__header {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-modal-wrapper .flight-modal .flight-modal__header {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-modal-wrapper {\n  -webkit-animation-name: fade-in-top;\n  -moz-animation-name: fade-in-top;\n  -ms-animation-name: fade-in-top;\n  -o-animation-name: fade-in-top;\n  animation-name: fade-in-top;\n  -webkit-animation-delay: 0s;\n  -moz-animation-delay: 0s;\n  -ms-animation-delay: 0s;\n  -o-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-duration: 0.1s;\n  -moz-animation-duration: 0.1s;\n  -ms-animation-duration: 0.1s;\n  -o-animation-duration: 0.1s;\n  animation-duration: 0.1s;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-timing-function: linear;\n  -ms-animation-timing-function: linear;\n  -o-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: 1;\n  -moz-animation-iteration-count: 1;\n  -ms-animation-iteration-count: 1;\n  -o-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n  -webkit-animation-direction: normal;\n  -moz-animation-direction: normal;\n  -ms-animation-direction: normal;\n  -o-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-fill-mode: none;\n  -moz-animation-fill-mode: none;\n  -ms-animation-fill-mode: none;\n  -o-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  -moz-animation-play-state: running;\n  -ms-animation-play-state: running;\n  -o-animation-play-state: running;\n  animation-play-state: running;\n  position: fixed;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n}\n.flight-modal-wrapper--scroll-lock {\n  overflow: hidden;\n}\n.flight-modal-wrapper__overlay-shadow {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: #051336;\n  opacity: 0.7;\n}\n.flight-modal-wrapper .flight-modal {\n  -webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -ms-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -o-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  background-color: #fefefe;\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  margin: auto;\n  z-index: 99;\n  border-radius: 10px;\n  max-height: 680px;\n  width: 80%;\n  min-width: 400px;\n}\n.flight-modal-wrapper .flight-modal .flight-modal__header {\n  padding: 20px 8px 12px 24px;\n  position: relative;\n}\n.flight-modal-wrapper .flight-modal .flight-modal__content {\n  padding: 12px 24px 0 24px;\n  max-height: 450px;\n  overflow: auto;\n}\n.flight-modal-wrapper .flight-modal .flight-modal__footer {\n  padding: 24px;\n}\n.flight-modal-wrapper .flight-modal--scrollable .flight-modal__header {\n  border-bottom: 1px solid #E6E7EB;\n}\n.flight-modal-wrapper .flight-modal--scrollable .flight-modal__content {\n  padding: 12px 24px;\n}\n.flight-modal-wrapper .flight-modal--scrollable .flight-modal__footer {\n  border-top: 1px solid #E6E7EB;\n}\n.flight-modal-wrapper .flight-modal--small {\n  max-width: 400px;\n}\n.flight-modal-wrapper .flight-modal--medium {\n  max-width: 640px;\n}\n.flight-modal-wrapper .flight-modal--large {\n  max-width: 948px;\n}\n.flight-modal-wrapper .flight-modal--warning .flight-modal__header {\n  background-color: #DC3616;\n  color: #FFFFFF;\n  border-radius: 10px 10px 0 0;\n}\n.flight-modal-wrapper .flight-modal__header__close {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n}\n.flight-modal-wrapper .flight-modal__header__close--warning {\n  background-color: #DC3616;\n}\n.flight-modal-wrapper .flight-modal__header__close--warning svg {\n  fill: #FFFFFF;\n}\n.flight-modal-wrapper .flight-modal__header__close--warning:hover:enabled, .flight-modal-wrapper .flight-modal__header__close--warning:focus:enabled {\n  background-color: #B32013;\n}\n.flight-modal-wrapper .flight-modal__header__close--warning:hover:enabled svg, .flight-modal-wrapper .flight-modal__header__close--warning:focus:enabled svg {\n  fill: #FFFFFF;\n}\n.flight-modal-wrapper .flight-modal__header__close--warning:active:enabled {\n  background-color: #871313;\n}";
styleInject(css_248z$n);

/* eslint-disable react-hooks/exhaustive-deps */
const DEFAULT_CLASS$k = 'flight-modal';
const COMPONENT_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
const FlightModal = props => {
  const {
    isVisible,
    toggleModalShown,
    useEscapeKey,
    scrollable,
    size,
    warning,
    className,
    header,
    content,
    footer,
    ariaTitle
  } = props;
  const focusRef = useRef(null);
  const closeRef = useRef(null);
  const endRef = useRef(null);
  const handleTrapFocusForward = event => {
    if (!event.shiftKey && event.key === EVENT_KEYS.TAB) {
      event.preventDefault();
      closeRef.current.focus();
    }
  };
  const handleTrapFocusBackward = event => {
    if (event.shiftKey && event.key === EVENT_KEYS.TAB) {
      event.preventDefault();
      endRef.current.focus();
    }
  };
  const handleEscapeKey = event => {
    if (useEscapeKey) {
      handleKeyDownHelper(false, toggleModalShown, true)(event);
    }
  };
  useEffect(() => {
    if (isVisible) {
      document.body.classList.add(`${DEFAULT_CLASS$k}-wrapper--scroll-lock`);
      if (closeRef && closeRef.current && endRef && endRef.current) {
        closeRef.current.focus();
        closeRef.current.addEventListener('keydown', handleTrapFocusBackward, false);
        endRef.current.addEventListener('keydown', handleTrapFocusForward, false);
      }
      if (focusRef && focusRef.current) {
        focusRef.current.focus();
        if (useEscapeKey) {
          focusRef.current.addEventListener('keydown', handleKeyDownHelper(false, toggleModalShown, true), false);
        }
      }
    }
    return () => {
      document.body.classList.remove(`${DEFAULT_CLASS$k}-wrapper--scroll-lock`);
      if (closeRef && closeRef.current && endRef && endRef.current) {
        closeRef.current.removeEventListener('keydown', handleTrapFocusBackward);
        endRef.current.removeEventListener('keydown', handleTrapFocusForward);
      }
      if (focusRef && focusRef.current) {
        if (useEscapeKey) {
          focusRef.current.removeEventListener('keydown', handleKeyDownHelper(false, toggleModalShown, true));
        }
      }
    };
  }, [isVisible]);
  if (!isVisible) return null;
  const wrapperClass = `${DEFAULT_CLASS$k}-wrapper`;
  let closeModalButtonClass = `${DEFAULT_CLASS$k}__header__close`;
  let mainClass = DEFAULT_CLASS$k;
  let sizeModifier = `${DEFAULT_CLASS$k}--small`;
  if (scrollable) {
    mainClass += ` ${DEFAULT_CLASS$k}--scrollable`;
  }
  switch (size) {
    case COMPONENT_SIZE.LARGE:
      sizeModifier = `${DEFAULT_CLASS$k}--large`;
      break;
    case COMPONENT_SIZE.MEDIUM:
      sizeModifier = `${DEFAULT_CLASS$k}--medium`;
      break;
    case COMPONENT_SIZE.SMALL:
    default:
      sizeModifier = `${DEFAULT_CLASS$k}--small`;
  }
  mainClass += ` ${sizeModifier}`;
  if (warning) {
    closeModalButtonClass += ` ${closeModalButtonClass}--warning`;
    mainClass += ` ${DEFAULT_CLASS$k}--warning`;
  }
  mainClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass,
    "aria-modal": "true",
    "aria-labelledby": "dialog_label",
    "aria-describedby": "dialog_desc",
    role: warning ? 'alertdialog' : 'dialog'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$k}-wrapper__overlay-shadow`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    role: "button",
    ref: focusRef,
    tabIndex: 0,
    onKeyDown: handleEscapeKey,
    "aria-label": ariaTitle || (warning ? 'alert dialog' : 'dialog')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$k}__header`,
    id: "dialog_label"
  }, header, /*#__PURE__*/React__default.createElement(FlightButton, {
    theme: "minor",
    onClick: toggleModalShown,
    onKeyDown: handleKeyDownHelper(toggleModalShown, false, true),
    iconLeft: "clear",
    className: closeModalButtonClass,
    buttonRef: closeRef,
    ariaLabel: "Close"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$k}__content`,
    id: "dialog_desc"
  }, content), /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$k}__footer`
  }, footer)), /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$k}-wrapper__end`,
    ref: endRef,
    tabIndex: 0
  }));
};
FlightModal.propTypes = {
  isVisible: propTypes.bool,
  toggleModalShown: propTypes.func,
  useEscapeKey: propTypes.bool,
  scrollable: propTypes.bool,
  size: propTypes.string,
  warning: propTypes.bool,
  className: propTypes.string,
  header: propTypes.oneOfType([propTypes.element, propTypes.string]),
  content: propTypes.oneOfType([propTypes.element, propTypes.string]),
  footer: propTypes.oneOfType([propTypes.element, propTypes.string]),
  ariaTitle: propTypes.string
};
FlightModal.defaultProps = {
  isVisible: false,
  toggleModalShown: () => undefined,
  scrollable: false,
  useEscapeKey: false,
  size: 'small',
  warning: false,
  className: '',
  header: null,
  content: null,
  footer: null,
  ariaTitle: ''
};

var css_248z$o = ".flight-font, .flight-tag {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-tag {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-tag {\n  border-radius: 4px;\n  padding: 4px;\n  white-space: nowrap;\n}\n.flight-tag--default {\n  background-color: #F2F3F5;\n  color: #505A72;\n}\n.flight-tag--error {\n  background-color: #FFE1DE;\n  color: #DC3616;\n}\n.flight-tag--success {\n  background-color: #CDF8EE;\n  color: #006117;\n}\n.flight-tag--info {\n  background-color: #DDECFF;\n  color: #1237B5;\n}";
styleInject(css_248z$o);

const TAG_TYPES_MAP = {
  default: 'default',
  success: 'success',
  error: 'error',
  info: 'info'
};
const FlightTag = props => {
  const {
    label,
    type,
    className
  } = props;
  let mainClass = 'flight-tag';
  mainClass += TAG_TYPES_MAP[type] ? ` ${mainClass}--${TAG_TYPES_MAP[type]}` : ` ${mainClass}--${TAG_TYPES_MAP.default}`;
  return /*#__PURE__*/React__default.createElement("span", {
    className: `${mainClass}${className ? ` ${className}` : ''}`
  }, label);
};
FlightTag.propTypes = {
  label: propTypes.string,
  type: propTypes.string,
  className: propTypes.string
};
FlightTag.defaultProps = {
  label: '',
  type: 'default',
  className: ''
};

var css_248z$p = ".flight-font, .flight-nav {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-nav__header__user__profile__email, .flight-nav__header__user__profile__role, .flight-nav__header__project__environment {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-nav__header__user__profile__name {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium, .flight-nav__header__user__profile__avatar {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-nav__sidebar__content .flight-button__label {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-nav__sidebar__content .flight-button.selected .flight-button__label, .flight-nav__sidebar__content .flight-button.selected:hover .flight-button__label, .flight-nav__header__user__profile__name, .flight-nav__header__project__name {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-nav {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.flight-nav__header {\n  width: 100%;\n  height: 62px;\n  background-color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  z-index: 1;\n}\n.flight-nav__header__sidebar-toggle {\n  margin-left: 12px;\n}\n.flight-nav__header__logo {\n  margin-left: 12px;\n}\n.flight-nav__header__logo >, .flight-nav__header__logo > * {\n  outline: none;\n}\n.flight-nav__header__project {\n  margin-left: 40px;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n}\n.flight-nav__header__project__image {\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n}\n.flight-nav__header__project__image img {\n  width: 24px;\n  height: 24px;\n}\n.flight-nav__header__project__name {\n  color: #37425E;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.flight-nav__header__project__environment {\n  transform: translateY(2px);\n  text-transform: capitalize;\n  color: #697186;\n  margin-left: 4px;\n}\n.flight-nav__header__user {\n  margin-right: 20px;\n}\n.flight-nav__header__user__avatar {\n  width: 32px;\n  height: 32px;\n}\n.flight-nav__header__user__dropdown {\n  width: 32px;\n  height: 32px;\n}\n.flight-nav__header__user__dropdown__portal .flight-dropdown__dropdown {\n  margin-top: 4px;\n  padding: 16px 0;\n  width: 228px;\n}\n.flight-nav__header__user__profile__avatar, .flight-nav__header__user__profile__name, .flight-nav__header__user__profile__email, .flight-nav__header__user__profile__role, .flight-nav__header__user__profile__signout {\n  text-align: center;\n  width: fit-content;\n  margin: 0 auto 8px auto;\n}\n.flight-nav__header__user__profile__name, .flight-nav__header__user__profile__email, .flight-nav__header__user__profile__role, .flight-nav__header__user__profile__signout {\n  display: block;\n}\n.flight-nav__header__user__profile__avatar {\n  width: 40px;\n  height: 40px;\n}\n.flight-nav__header__user__profile__name {\n  margin-bottom: 4px;\n  width: fit-content;\n}\n.flight-nav__header__user__profile__role {\n  margin-bottom: 12px;\n}\n.flight-nav__header__user__profile__signout {\n  padding: 0 12px;\n}\n.flight-nav__header__actionables {\n  margin-right: 16px;\n}\n.flight-nav__header__right {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n.flight-nav__header--has-border {\n  border-bottom: 1px solid #E6E7EB;\n}\n.flight-nav__sidebar {\n  display: flex;\n  flex-direction: column;\n  width: 256px;\n  height: calc(100% - 62px);\n  position: fixed;\n  top: 62px;\n  background-color: #FFFFFF;\n  z-index: 1;\n  transition: all 0.1s;\n}\n.flight-nav__sidebar__content {\n  padding-top: 24px;\n  overflow: visible;\n}\n.flight-nav__sidebar__content .flight-button {\n  box-shadow: none;\n  width: 236px;\n  height: 44px;\n  justify-content: left;\n  border-radius: 0 24px 24px 0;\n}\n.flight-nav__sidebar__content .flight-button svg {\n  margin-left: 14px;\n}\n.flight-nav__sidebar__content .flight-button__label {\n  padding-left: 12px;\n}\n.flight-nav__sidebar__content .flight-button:focus, .flight-nav__sidebar__content .flight-button:active {\n  box-shadow: none;\n}\n.flight-nav__sidebar__content .flight-button:hover, .flight-nav__sidebar__content .flight-button:focus {\n  background-color: #F2F3F5;\n}\n.flight-nav__sidebar__content .flight-button:hover svg, .flight-nav__sidebar__content .flight-button:focus svg {\n  fill: #0851DF;\n}\n.flight-nav__sidebar__content .flight-button:not(:focus):not(.selected), .flight-nav__sidebar__content .flight-button:not(:active):not(.selected) {\n  color: #37425E;\n}\n.flight-nav__sidebar__content .flight-button:not(:focus):not(.selected) svg, .flight-nav__sidebar__content .flight-button:not(:active):not(.selected) svg {\n  fill: #697186;\n}\n.flight-nav__sidebar__content .flight-button.selected, .flight-nav__sidebar__content .flight-button.selected:hover {\n  color: #37425E;\n  background-color: #F2F3F5;\n}\n.flight-nav__sidebar--has-border {\n  margin-top: 1px;\n}\n.flight-nav__sidebar--collapsed {\n  width: 64px;\n}\n.flight-nav__sidebar--collapsed .flight-nav__sidebar__content {\n  display: flex;\n  flex-direction: column;\n}\n.flight-nav__sidebar--collapsed .flight-nav__sidebar__content .flight-tooltip {\n  border-radius: 24px;\n  margin-bottom: 8px;\n}\n.flight-nav__sidebar--collapsed .flight-nav__sidebar__content .flight-tooltip__content {\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n}\n.flight-nav__sidebar--collapsed .flight-nav__sidebar__content .flight-tooltip .flight-button {\n  width: 40px;\n  height: 40px;\n  border-radius: 24px;\n}\n.flight-nav__sidebar--collapsed .flight-nav__sidebar__content .flight-tooltip .flight-button svg {\n  margin-left: 0;\n}\n.flight-nav .route-content {\n  height: 100vh;\n  width: 100%;\n  box-sizing: border-box;\n  padding-left: 256px;\n  padding-top: 62px;\n  overflow: auto;\n}\n.flight-nav .route-content--without-sidebar {\n  padding-left: 0;\n}\n.flight-nav .route-content--collapsed {\n  padding-left: 64px;\n}";
styleInject(css_248z$p);

const DEFAULT_CLASS$l = 'flight-nav';
const HEADER_CLASS = `${DEFAULT_CLASS$l}__header`;
const SIDEBAR_CLASS = `${DEFAULT_CLASS$l}__sidebar`;
const ROUTE_CONTENT_CLASS = 'route-content';
const COLLAPSE_WIDTH_THRESHOLD = 600;
const FlightNav = props => {
  const {
    children,
    user,
    userDropdown,
    routes,
    logo,
    logoAriaLabel,
    actionables,
    project,
    hasSidebar,
    handleSignOut,
    handleLogoClick,
    hasHeaderBorder,
    isActiveRouteExactMatch,
    ariaControlsId,
    collapsed,
    handleCollapseChange
  } = props;
  const [isCollapsed, setCollapsed] = useState(collapsed);
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    setCollapsed(collapsed);
  }, [collapsed]);
  const commitCollapseState = newState => {
    setCollapsed(newState);
    if (handleCollapseChange) {
      handleCollapseChange(newState);
    }
  };
  const handleWindowResize = () => {
    if (isCollapsed && window.innerWidth >= COLLAPSE_WIDTH_THRESHOLD || !isCollapsed && window.innerWidth < COLLAPSE_WIDTH_THRESHOLD) {
      commitCollapseState(!isCollapsed);
    }
  };
  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });
  const handleSidebarToggleClick = () => {
    commitCollapseState(!isCollapsed);
  };
  const isCurrentRouteSelected = route => {
    if (route.location === '/' || isActiveRouteExactMatch) {
      return location.pathname === route.location;
    }
    return location.pathname.includes(route.location);
  };
  const getRouteButton = route => {
    let routeButton = /*#__PURE__*/React__default.createElement(FlightButton, {
      label: isCollapsed ? '' : route.label,
      iconLeft: route.icon,
      className: isCurrentRouteSelected(route) ? 'selected' : '',
      key: route.location,
      theme: "secondary",
      onClick: () => history.push(route.location),
      onKeyDown: handleKeyDownHelper(() => history.push(route.location), false, true),
      ariaLabel: route.label,
      ariaCurrent: isCurrentRouteSelected(route) ? 'page' : ''
    });
    if (isCollapsed) {
      routeButton = /*#__PURE__*/React__default.createElement(FlightTooltip, {
        direction: "right",
        description: route.label,
        key: route.location,
        isEnabled: true
      }, routeButton);
    }
    return routeButton;
  };
  let headerClass = HEADER_CLASS;
  headerClass += hasHeaderBorder ? ` ${HEADER_CLASS}--has-border` : '';
  let sidebarClass = SIDEBAR_CLASS;
  sidebarClass += isCollapsed ? ` ${SIDEBAR_CLASS}--collapsed` : '';
  sidebarClass += hasHeaderBorder ? ` ${SIDEBAR_CLASS}--has-border` : '';
  let routeContentClass = ROUTE_CONTENT_CLASS;
  routeContentClass += hasSidebar ? '' : ` ${ROUTE_CONTENT_CLASS}--without-sidebar`;
  routeContentClass += hasSidebar && isCollapsed ? ` ${ROUTE_CONTENT_CLASS}--collapsed` : '';
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: DEFAULT_CLASS$l
  }, /*#__PURE__*/React__default.createElement("div", {
    role: "navigation",
    "aria-label": "header",
    className: headerClass
  }, hasSidebar && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__sidebar-toggle`
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    theme: "minor",
    iconRight: "menu",
    onClick: handleSidebarToggleClick,
    onKeyDown: handleKeyDownHelper(handleSidebarToggleClick, false, true),
    ariaLabel: "sidebar-toggle-sidebar",
    ariaExpanded: !isCollapsed,
    isAriaExpandedVisible: true
  })), logo && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__logo`,
    onClick: handleLogoClick,
    onKeyDown: handleKeyDownHelper(handleLogoClick, false, true),
    role: "button",
    tabIndex: "0",
    "aria-label": logoAriaLabel || 'Flybits logo, home'
  }, logo), project && project.id && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__project`
  }, project.image && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__project__image`
  }, project.image), project.name && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__project__name`
  }, project.name), project.environment && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__project__environment`
  }, "(", project.environment, ")")), /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__right`
  }, actionables && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__actionables`
  }, actionables), userDropdown || user && user.id && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__user`
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    direction: "bottom-left",
    autoFocus: true,
    className: `${HEADER_CLASS}__user__dropdown`,
    ariaControlsId: `nav-${ariaControlsId}`,
    trigger: /*#__PURE__*/React__default.createElement(FlightAvatar, {
      className: `${HEADER_CLASS}__user__avatar`,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__user__profile`
  }, /*#__PURE__*/React__default.createElement(FlightAvatar, {
    className: `${HEADER_CLASS}__user__profile__avatar`,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email
  }), user.firstName && user.lastName ? /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__user__profile__name`
  }, `${user.firstName} ${user.lastName}`) : null, user.email ? /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS}__user__profile__email`
  }, user.email) : null, user.role ? /*#__PURE__*/React__default.createElement(FlightTag, {
    className: `${HEADER_CLASS}__user__profile__role`,
    label: user.role,
    type: "info"
  }) : null, /*#__PURE__*/React__default.createElement(FlightButton, {
    className: `${HEADER_CLASS}__user__profile__signout`,
    label: "Sign out",
    theme: "secondary",
    onClick: handleSignOut,
    onKeyDown: handleKeyDownHelper(handleSignOut, false, true)
  })))))), hasSidebar && /*#__PURE__*/React__default.createElement("div", {
    className: sidebarClass
  }, /*#__PURE__*/React__default.createElement("div", {
    role: "navigation",
    className: `${SIDEBAR_CLASS}__content`,
    "aria-label": "Sidebar"
  }, routes.map(route => getRouteButton(route)))), /*#__PURE__*/React__default.createElement("div", {
    className: routeContentClass
  }, children)));
};
FlightNav.propTypes = {
  children: propTypes.element,
  user: propTypes.shape({
    id: propTypes.string,
    firstName: propTypes.string,
    lastName: propTypes.string,
    email: propTypes.string,
    role: propTypes.string
  }),
  userDropdown: propTypes.node,
  routes: propTypes.arrayOf(propTypes.shape({
    label: propTypes.string,
    icon: propTypes.string,
    location: propTypes.string
  })),
  actionables: propTypes.element,
  project: propTypes.shape({
    id: propTypes.string,
    name: propTypes.string,
    image: propTypes.element,
    environment: propTypes.string
  }),
  logo: propTypes.element,
  logoAriaLabel: propTypes.string,
  hasSidebar: propTypes.bool,
  collapsed: propTypes.bool,
  handleCollapseChange: propTypes.func,
  hasHeaderBorder: propTypes.bool,
  handleSignOut: propTypes.func,
  handleLogoClick: propTypes.func,
  isActiveRouteExactMatch: propTypes.bool,
  ariaControlsId: propTypes.string
};
FlightNav.defaultProps = {
  children: null,
  user: null,
  userDropdown: null,
  routes: [],
  actionables: null,
  project: null,
  logo: null,
  logoAriaLabel: '',
  hasSidebar: true,
  collapsed: true,
  handleCollapseChange: () => undefined,
  hasHeaderBorder: true,
  handleSignOut: () => undefined,
  handleLogoClick: () => undefined,
  isActiveRouteExactMatch: false,
  ariaControlsId: ''
};

var css_248z$q = ".flight-font {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-overflow-menu__dropdown-list__group__option, .flight-overflow-menu__dropdown-list__group__nested-trigger {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-overflow-menu {\n  position: relative;\n}\n.flight-overflow-menu__trigger:focus:enabled .flight-button__label, .flight-overflow-menu__trigger:focus:enabled svg {\n  color: #1237B5;\n  fill: #1237B5;\n}\n.flight-overflow-menu__outside {\n  position: fixed;\n  padding: 0;\n  margin: 0;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  z-index: 999;\n}\n.flight-overflow-menu__outside--opened {\n  display: block;\n}\n.flight-overflow-menu__dropdown-list {\n  -webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -ms-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  -o-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.15);\n  position: fixed;\n  list-style-type: none;\n  width: 224px;\n  background-color: #FFFFFF;\n  margin: 0;\n  padding: 0;\n  z-index: 1000;\n  display: none;\n  visibility: hidden;\n}\n.flight-overflow-menu__dropdown-list__group {\n  padding: 8px 0;\n}\n.flight-overflow-menu__dropdown-list__group:not(:last-child) {\n  border-bottom: 1px solid #E6E7EB;\n}\n.flight-overflow-menu__dropdown-list__group__option, .flight-overflow-menu__dropdown-list__group__nested-trigger {\n  width: 100%;\n  border-radius: 0;\n  position: relative;\n  justify-content: left;\n}\n.flight-overflow-menu__dropdown-list__group__option, .flight-overflow-menu__dropdown-list__group__option:hover:enabled, .flight-overflow-menu__dropdown-list__group__option:focus:enabled, .flight-overflow-menu__dropdown-list__group__nested-trigger, .flight-overflow-menu__dropdown-list__group__nested-trigger:hover:enabled, .flight-overflow-menu__dropdown-list__group__nested-trigger:focus:enabled {\n  color: #1E2B4A;\n}\n.flight-overflow-menu__dropdown-list__group__option svg, .flight-overflow-menu__dropdown-list__group__option:hover:enabled svg, .flight-overflow-menu__dropdown-list__group__option:focus:enabled svg, .flight-overflow-menu__dropdown-list__group__nested-trigger svg, .flight-overflow-menu__dropdown-list__group__nested-trigger:hover:enabled svg, .flight-overflow-menu__dropdown-list__group__nested-trigger:focus:enabled svg {\n  fill: #1E2B4A;\n}\n.flight-overflow-menu__dropdown-list__group__option:focus:enabled, .flight-overflow-menu__dropdown-list__group__nested-trigger:focus:enabled {\n  outline: auto;\n}\n.flight-overflow-menu__dropdown-list__group__option--error:hover:enabled, .flight-overflow-menu__dropdown-list__group__option--error:focus:enabled, .flight-overflow-menu__dropdown-list__group__nested-trigger--error:hover:enabled, .flight-overflow-menu__dropdown-list__group__nested-trigger--error:focus:enabled {\n  background-color: #DC3616;\n  color: #FFFFFF;\n  outline: auto;\n}\n.flight-overflow-menu__dropdown-list__group__option--error:hover:enabled svg, .flight-overflow-menu__dropdown-list__group__option--error:focus:enabled svg, .flight-overflow-menu__dropdown-list__group__nested-trigger--error:hover:enabled svg, .flight-overflow-menu__dropdown-list__group__nested-trigger--error:focus:enabled svg {\n  fill: #FFFFFF;\n}\n.flight-overflow-menu__dropdown-list__group__option--error:focus:enabled, .flight-overflow-menu__dropdown-list__group__nested-trigger--error:focus:enabled {\n  outline: auto;\n}\n.flight-overflow-menu__dropdown-list__group__option--error:active:enabled, .flight-overflow-menu__dropdown-list__group__nested-trigger--error:active:enabled {\n  background-color: #B32013;\n}\n.flight-overflow-menu__dropdown-list__group__nested-trigger {\n  position: relative;\n}\n.flight-overflow-menu__dropdown-list__group__nested-trigger svg:last-child {\n  position: absolute;\n  right: 8px;\n}\n.flight-overflow-menu__dropdown-list__group__nested-trigger:hover ~ .flight-overflow-menu--hover-appear > .flight-overflow-menu__dropdown-list {\n  display: block;\n}\n.flight-overflow-menu__dropdown-list__group__nested-trigger--selected {\n  background-color: #F2F3F5;\n}\n.flight-overflow-menu__dropdown-list--opened {\n  display: block;\n}\n.flight-overflow-menu__dropdown-list--opened__trigger {\n  color: #1237B5;\n  background-color: #E6E7EB;\n}\n.flight-overflow-menu__dropdown-list--opened__trigger svg {\n  fill: #1237B5;\n}\n.flight-overflow-menu__dropdown-list--top {\n  transform: translateY(-4px);\n}\n.flight-overflow-menu__dropdown-list--bottom {\n  transform: translateY(4px);\n}\n.flight-overflow-menu__dropdown-list--nested {\n  position: absolute;\n  top: -32px;\n  left: auto;\n  right: -224px;\n  margin-block-start: 0;\n  margin-block-end: 0;\n  visibility: visible;\n}\n.flight-overflow-menu__dropdown-list--nested.flight-overflow-menu__dropdown-list--top {\n  top: auto;\n  bottom: 0;\n}\n.flight-overflow-menu__dropdown-list--nested-left {\n  right: 224px;\n  left: auto;\n}\n.flight-overflow-menu__dropdown-list--nested-right {\n  left: 224px;\n  right: auto;\n}\n.flight-overflow-menu__dropdown-list--open-right {\n  left: 0;\n}";
styleInject(css_248z$q);

const DEFAULT_CLASS$m = 'flight-overflow-menu';
const OUTSIDE_CLASS$1 = `${DEFAULT_CLASS$m}__outside`;
const DROPDOWN_LIST_CLASS = `${DEFAULT_CLASS$m}__dropdown-list`;
const DROPDOWN_GROUP_CLASS = `${DROPDOWN_LIST_CLASS}__group`;
const NESTED_TRIGGER_CLASS = `${DROPDOWN_GROUP_CLASS}__nested-trigger`;
const removeElementsClassName = (dropdownLists, className) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const list of dropdownLists) {
    list.className = list.className.replace(new RegExp(` ${className}`, 'g'), '');
  }
};
const mapOptions = (options, self) => {
  const mappedOptions = [];
  options.forEach(option => {
    if (option.children && option.children.length) {
      let optionClass = NESTED_TRIGGER_CLASS;
      optionClass += option.theme === 'error' ? ` ${NESTED_TRIGGER_CLASS}--error` : '';
      mappedOptions.push( /*#__PURE__*/React__default.createElement("li", {
        key: option.key,
        role: "menuitem"
      }, /*#__PURE__*/React__default.createElement(FlightButton, {
        label: option.name,
        className: optionClass,
        iconLeft: option.iconLeft || '',
        iconRight: "baselineKeyboardArrowRight",
        theme: "minor",
        size: "small",
        disabled: option.disabled || false,
        onClick: self.handleNestedTriggerEnter,
        onMouseEnter: self.handleNestedTriggerEnter,
        onFocus: self.handleNestedTriggerEnter,
        ariaLabel: `${option.name || `Option: ${option.key}` || 'option'}`,
        tabIndex: 0,
        role: "button"
      }), /*#__PURE__*/React__default.createElement(FlightOverflowMenu, {
        optionGroups: option.children,
        isRoot: false,
        direction: self.props.direction,
        outsideRef: self.outsideReference
      })));
    } else {
      const handleOptionClick = event => {
        option.onClick(event);
        self.outsideReference.current.click();
      };
      let optionClass = `${DROPDOWN_GROUP_CLASS}__option`;
      optionClass += option.theme === 'error' ? ` ${DROPDOWN_GROUP_CLASS}__option--error` : '';
      mappedOptions.push( /*#__PURE__*/React__default.createElement("div", {
        key: option.key,
        role: "menuitem"
      }, /*#__PURE__*/React__default.createElement(FlightButton, {
        key: option.key,
        label: option.name,
        className: optionClass,
        onClick: handleOptionClick || (() => undefined),
        iconLeft: option.iconLeft || '',
        theme: "minor",
        size: "small",
        disabled: option.disabled || false,
        onMouseEnter: self.handleNestedTriggerEnter,
        onFocus: self.handleNestedTriggerEnter,
        ariaLabel: `${option.name || `Option: ${option.key}` || 'option'}`,
        role: "menuitem",
        tabIndex: 0
      })));
    }
  });
  return mappedOptions;
};
const FlightOverflowMenu = props => {
  const {
    className,
    optionGroups,
    isRoot,
    isOpenRight,
    direction,
    disabled,
    outsideRef,
    label,
    ariaLabel,
    iconLeft,
    iconRight
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [targetTrigger, setTargetTrigger] = useState('');
  const outsideReference = outsideRef || /*#__PURE__*/React__default.createRef();
  const {
    setTriggerElement,
    setPopoverElement,
    setFixedPosition
  } = useFixedPosition(direction);
  const handleRootTriggerClick = event => {
    if (disabled) return;
    setIsOpen(true);
    setTargetTrigger(event.target);
  };
  const handleClickOutside = event => {
    if (disabled) return;
    const rootDropdownList = event.target.nextElementSibling;
    if (rootDropdownList) {
      removeElementsClassName(rootDropdownList.getElementsByClassName(NESTED_TRIGGER_CLASS), `${NESTED_TRIGGER_CLASS}--selected`);
      removeElementsClassName(rootDropdownList.getElementsByClassName(DROPDOWN_LIST_CLASS), `${DROPDOWN_LIST_CLASS}--opened`);
    }
    if (targetTrigger && targetTrigger.current) targetTrigger.current.focus();
    setIsOpen(false);
    event.stopPropagation();
  };
  const handleNestedTriggerEnter = event => {
    if (disabled) return;
    let parentDropdownList = event.target.parentElement;
    while (parentDropdownList.localName === 'svg' || !(parentDropdownList.className && parentDropdownList.className.split(' ').filter(classNameInList => classNameInList === DROPDOWN_GROUP_CLASS).length)) {
      parentDropdownList = parentDropdownList.parentElement;
    }
    const allDropdownLists = parentDropdownList.getElementsByClassName(DROPDOWN_LIST_CLASS);
    removeElementsClassName(allDropdownLists, `${DROPDOWN_LIST_CLASS}--opened`);
    removeElementsClassName(parentDropdownList.getElementsByClassName(NESTED_TRIGGER_CLASS), `${NESTED_TRIGGER_CLASS}--selected`);
    if (event.target.className.includes && event.target.className.includes(NESTED_TRIGGER_CLASS)) {
      const currentChildrenDropdownList = event.target.nextElementSibling.getElementsByClassName(DROPDOWN_LIST_CLASS)[0];
      /* eslint-disable no-param-reassign */
      event.target.classList.add(`${NESTED_TRIGGER_CLASS}--selected`);
      currentChildrenDropdownList.classList.add(`${DROPDOWN_LIST_CLASS}--opened`);
      if (currentChildrenDropdownList.getBoundingClientRect().right > window.innerWidth && !currentChildrenDropdownList.className.includes(`${DROPDOWN_LIST_CLASS}--nested-right`)) {
        currentChildrenDropdownList.classList.add(`${DROPDOWN_LIST_CLASS}--nested-left`);
      } else if (currentChildrenDropdownList.getBoundingClientRect().left < 0 && !currentChildrenDropdownList.className.includes(`${DROPDOWN_LIST_CLASS}--nested-left`)) {
        currentChildrenDropdownList.classList.add(`${DROPDOWN_LIST_CLASS}--nested-right`);
      }
      if (currentChildrenDropdownList.getBoundingClientRect().top < 0 && currentChildrenDropdownList.className.includes(`${DROPDOWN_LIST_CLASS}--top`)) {
        currentChildrenDropdownList.classList.remove(`${DROPDOWN_LIST_CLASS}--top`);
      } else if (currentChildrenDropdownList.getBoundingClientRect().bottom > window.innerHeight) {
        currentChildrenDropdownList.classList.add(`${DROPDOWN_LIST_CLASS}--top`);
      }
    }
  };

  // Handle keyboard navigation
  const handleTriggerNavigation = event => {
    const currentMenuitem = event.target.parentElement;
    const next = currentMenuitem.nextElementSibling;
    const prev = currentMenuitem.previousElementSibling;
    if (!isOpen && [EVENT_KEYS.ENTER, EVENT_KEYS.ARROW_DOWN].includes(event.key)) {
      if (event.target.classList.contains('flight-overflow-menu__trigger')) {
        handleRootTriggerClick(event);
        event.stopPropagation();
        event.preventDefault();
      }
    } else if (isOpen) {
      if (event.key === EVENT_KEYS.ESCAPE) {
        // when users enter escape key, close the dropdown but
        // focus back to trigger button.
        handleClickOutside(event);
        event.stopPropagation();
        event.preventDefault();
      }
      if (event.key === EVENT_KEYS.ARROW_UP) {
        if (prev) {
          prev.children[0].focus();
        }
        event.stopPropagation();
        event.preventDefault();
      }
      if (event.key === EVENT_KEYS.ARROW_DOWN) {
        if (next) {
          next.children[0].focus();
        }
        event.stopPropagation();
        event.preventDefault();
      }
      if (event.key === EVENT_KEYS.ARROW_LEFT) {
        event.target.parentElement.parentElement.parentElement.parentElement.previousElementSibling.focus();
        event.stopPropagation();
        event.preventDefault();
      }
      if (event.key === EVENT_KEYS.ARROW_RIGHT) {
        const nextSubmenu = event.target.nextElementSibling;
        if (nextSubmenu) {
          nextSubmenu.click();
          nextSubmenu.children[0].children[0].children[0].children[0].focus();
        }
        event.stopPropagation();
        event.preventDefault();
      }
    }
  };
  const mappedGroups = [];
  optionGroups.forEach((options, idx) => {
    mappedGroups.push(
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React__default.createElement("div", {
      className: DROPDOWN_GROUP_CLASS,
      role: "group",
      key: idx
    }, mapOptions(options, {
      handleNestedTriggerEnter,
      handleTriggerNavigation,
      outsideReference,
      props: {
        direction
      }
    })));
  });
  useEffect(() => {
    let rootOverflowMenu = targetTrigger.parentElement;
    while (rootOverflowMenu && rootOverflowMenu.localName === 'svg' || rootOverflowMenu && !(rootOverflowMenu.className && rootOverflowMenu.className.split(' ').filter(RootClassName => RootClassName === DEFAULT_CLASS$m).length)) {
      rootOverflowMenu = rootOverflowMenu.parentElement;
    }
    if (rootOverflowMenu && rootOverflowMenu.lastElementChild.getBoundingClientRect().bottom > window.innerHeight) {
      rootOverflowMenu.lastElementChild.classList.remove(`${DROPDOWN_LIST_CLASS}--bottom`);
      rootOverflowMenu.lastElementChild.classList.add(`${DROPDOWN_LIST_CLASS}--top`);
    } else if (rootOverflowMenu && rootOverflowMenu.lastElementChild.getBoundingClientRect().top < 0) {
      rootOverflowMenu.lastElementChild.classList.remove(`${DROPDOWN_LIST_CLASS}--top`);
      rootOverflowMenu.lastElementChild.classList.add(`${DROPDOWN_LIST_CLASS}--bottom`);
    }
  }, [isOpen, targetTrigger]);
  useEffect(() => {
    if (isOpen) {
      setFixedPosition();
      // Focus on the dropdown's first item
      const rootItemList = outsideReference.current.nextSibling;
      const firstGroup = rootItemList.firstElementChild; // group
      const firstItem = firstGroup.firstElementChild; // menuitem
      const firstItemButton = firstItem.firstElementChild; // item button
      if (firstItemButton) firstItemButton.focus();
      window.addEventListener('resize', setFixedPosition);
      document.addEventListener('scroll', setFixedPosition, true);
    }
    const trigger = targetTrigger.current;
    return () => {
      if (trigger) trigger.focus();
      window.removeEventListener('resize', setFixedPosition);
      document.removeEventListener('scroll', setFixedPosition, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, direction, setFixedPosition]);
  let mainClass = DEFAULT_CLASS$m;
  mainClass += isRoot ? '' : ` ${DEFAULT_CLASS$m}--hover-appear`;
  mainClass += className ? ` ${className}` : '';
  let dropdownListClass = DROPDOWN_LIST_CLASS;
  dropdownListClass += isOpen ? ` ${DROPDOWN_LIST_CLASS}--opened` : '';
  dropdownListClass += ` ${DROPDOWN_LIST_CLASS}--${direction}`;
  dropdownListClass += isRoot && isOpenRight ? ` ${DROPDOWN_LIST_CLASS}--open-right` : '';
  dropdownListClass += isRoot ? '' : ` ${DROPDOWN_LIST_CLASS}--nested`;
  return /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    onKeyDown: handleTriggerNavigation,
    role: "button",
    tabIndex: -1
  }, isRoot && /*#__PURE__*/React__default.createElement(FlightButton, {
    className: `${DEFAULT_CLASS$m}__trigger`,
    iconLeft: iconLeft,
    iconRight: iconRight,
    label: label,
    theme: "minor",
    disabled: disabled,
    onClick: handleRootTriggerClick,
    ariaLabel: ariaLabel || label || 'select an option',
    buttonRef: setTriggerElement,
    role: "button",
    "aria-controls": "overflow-menu-outside",
    tabIndex: 0,
    ariaExpanded: isOpen,
    isAriaExpandedVisible: true
  }), isRoot && isOpen && /*#__PURE__*/React__default.createElement(Portal$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: `${OUTSIDE_CLASS$1}${isOpen ? ` ${OUTSIDE_CLASS$1}--opened` : ''}`,
    ref: outsideReference,
    onClick: handleClickOutside,
    onKeyDown: () => undefined,
    role: "button",
    tabIndex: -1,
    "aria-label": "overflow menu outside",
    "aria-expanded": "true"
  }), /*#__PURE__*/React__default.createElement("ul", {
    className: dropdownListClass,
    id: "overflow-menu-outside",
    role: "menu",
    ref: setPopoverElement
  }, mappedGroups)), !isRoot && /*#__PURE__*/React__default.createElement("ul", {
    className: dropdownListClass,
    ref: setPopoverElement,
    role: "menu"
  }, mappedGroups));
};
FlightOverflowMenu.propTypes = {
  className: propTypes.string,
  direction: propTypes.string,
  disabled: propTypes.bool,
  label: propTypes.string,
  ariaLabel: propTypes.string,
  iconLeft: propTypes.string,
  iconRight: propTypes.string,
  isOpenRight: propTypes.bool,
  optionGroups: propTypes.arrayOf(propTypes.arrayOf(propTypes.shape({
    disabled: propTypes.bool,
    iconLeft: propTypes.string,
    key: propTypes.oneOfType([propTypes.string, propTypes.number]),
    name: propTypes.string.isRequired,
    onClick: propTypes.func,
    theme: propTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    children: propTypes.any
  }))),
  // For nested overflow menus only
  isRoot: propTypes.bool,
  outsideRef: propTypes.shape({
    current: propTypes.shape({
      click: propTypes.func
    })
  })
};
FlightOverflowMenu.defaultProps = {
  className: '',
  direction: 'bottom',
  disabled: false,
  label: '',
  ariaLabel: '',
  iconLeft: '',
  iconRight: 'moreVert',
  isOpenRight: false,
  optionGroups: [],
  // For nested overflow menus only
  isRoot: true,
  outsideRef: null
};

var css_248z$r = ".flight-font, .flight-radio-button-wrapper {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-radio-button-wrapper {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-radio-button-wrapper {\n  cursor: pointer;\n}\n.flight-radio-button-wrapper .flight-radio-button {\n  display: flex;\n  align-items: center;\n  color: #37425E;\n  height: 20px;\n}\n.flight-radio-button-wrapper .flight-radio-button__input {\n  display: none;\n}\n.flight-radio-button-wrapper .flight-radio-button__radio {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  -o-box-sizing: border-box;\n  box-sizing: border-box;\n  width: 16px;\n  height: 16px;\n  background-color: #FFFFFF;\n  border: 1px solid #697186;\n  border-radius: 20px;\n}\n.flight-radio-button-wrapper .flight-radio-button__radio--selected {\n  border: 5px solid #0851DF;\n}\n.flight-radio-button-wrapper .flight-radio-button__radio--selected ~ .flight-radio-button__span {\n  color: #051336;\n}\n.flight-radio-button-wrapper .flight-radio-button__span {\n  padding-left: 8px;\n}\n.flight-radio-button-wrapper .flight-radio-button:hover .flight-radio-button__radio, .flight-radio-button-wrapper .flight-radio-button:focus .flight-radio-button__radio {\n  border-color: #37425E;\n}\n.flight-radio-button-wrapper .flight-radio-button:hover .flight-radio-button__radio--selected, .flight-radio-button-wrapper .flight-radio-button:focus .flight-radio-button__radio--selected {\n  border-color: #1237B5;\n}\n.flight-radio-button-wrapper .flight-radio-button:hover .flight-radio-button__span, .flight-radio-button-wrapper .flight-radio-button:focus .flight-radio-button__span {\n  color: #051336;\n}\n.flight-radio-button-wrapper--disabled {\n  cursor: no-drop;\n}\n.flight-radio-button-wrapper--disabled .flight-radio-button {\n  pointer-events: none;\n}\n.flight-radio-button-wrapper--disabled .flight-radio-button__radio {\n  border-color: #B4B8C3;\n}\n.flight-radio-button-wrapper--disabled .flight-radio-button__radio--selected ~ .flight-radio-button__span {\n  color: #B4B8C3;\n}\n.flight-radio-button-wrapper--disabled .flight-radio-button__span {\n  color: #B4B8C3;\n}";
styleInject(css_248z$r);

const FlightRadioButton = props => {
  const {
    disabled,
    checked,
    label,
    ariaLabel,
    className,
    onSelect,
    value
  } = props;
  const handleSelect = () => {
    if (disabled) return;
    if (onSelect) {
      onSelect(value);
    }
  };
  const handleKeyDown = event => {
    if (event.key === EVENT_KEYS.ENTER) {
      handleSelect();
    }
  };
  const mainClass = 'flight-radio-button';
  const labelClass = `${mainClass}__span`;
  const labelElement = label ? /*#__PURE__*/React__default.createElement("span", {
    className: labelClass
  }, label) : null;
  let wrapperClass = `${mainClass}-wrapper`;
  wrapperClass += disabled ? ` ${wrapperClass}--disabled` : '';
  wrapperClass += className ? ` ${className}` : '';
  let radioClass = `${mainClass}__radio`;
  radioClass += checked ? ` ${radioClass}--selected` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    role: "radio",
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelect,
    onKeyDown: handleKeyDown,
    "aria-checked": checked,
    "aria-label": ariaLabel || label
  }, /*#__PURE__*/React__default.createElement("div", {
    className: radioClass,
    tabIndex: -1
  }), labelElement));
};
FlightRadioButton.propTypes = {
  label: propTypes.string,
  ariaLabel: propTypes.string,
  checked: propTypes.bool,
  className: propTypes.string,
  disabled: propTypes.bool,
  onSelect: propTypes.func,
  /* eslint-disable react/forbid-prop-types */
  value: propTypes.any.isRequired
};
FlightRadioButton.defaultProps = {
  label: '',
  ariaLabel: '',
  checked: false,
  className: '',
  disabled: false,
  onSelect: () => undefined
};

const useDebounce = (value, delay) => {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    // Update debounced value after delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed
    // within the delay period. Timeout gets cleared and restarted.
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay] // Only re-call effect if value or delay changes
  );

  return debouncedValue;
};

const DEFAULT_CLASS$n = 'flight-search';
const FlightSearch = props => {
  const {
    placeholderText,
    width,
    disabled,
    className,
    onSearch,
    autoSearchDelay,
    searchInputRef,
    hasSearchIcon,
    onLoad,
    autoFocus,
    label
  } = props;
  const [textInputValue, setTextInputValue] = useState('');
  const debouncedValue = useDebounce(textInputValue, autoSearchDelay);
  // isDirty = true after component loads
  const isDirty = useRef(false);
  useEffect(() => {
    if (!isDirty.current) {
      isDirty.current = true;
      return;
    }
    onSearch(debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);
  let wrapperClass = DEFAULT_CLASS$n;
  wrapperClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass,
    role: "search"
  }, /*#__PURE__*/React__default.createElement(FlightTextInput, {
    name: "search",
    "aria-label": "Search",
    iconInput: hasSearchIcon ? 'search' : '',
    hasClearIcon: true,
    placeholderText: placeholderText,
    width: width,
    value: textInputValue,
    onChange: event => setTextInputValue(event.target.value),
    onLoad: onLoad,
    disabled: disabled,
    inputRef: searchInputRef,
    autoFocus: autoFocus,
    isAriaAutocomplete: true,
    label: label
  }));
};
FlightSearch.propTypes = {
  placeholderText: propTypes.string,
  width: propTypes.string,
  disabled: propTypes.bool,
  className: propTypes.string,
  onSearch: propTypes.func.isRequired,
  onLoad: propTypes.func,
  autoFocus: propTypes.bool,
  autoSearchDelay: propTypes.number,
  searchInputRef: propTypes.shape({
    current: propTypes.shape({
      focus: propTypes.func
    })
  }),
  hasSearchIcon: propTypes.bool,
  label: propTypes.string
};
FlightSearch.defaultProps = {
  placeholderText: '',
  width: '232px',
  disabled: false,
  className: '',
  onLoad: () => undefined,
  autoFocus: false,
  autoSearchDelay: 500,
  searchInputRef: null,
  hasSearchIcon: true,
  label: ''
};

/**
 * Truncates a string to at most length of n.
 * If n <= 3, it will return the string as is.
 *
 * @param {string} str  The string to be truncated
 * @param {number} n    Max length of the string if it needs to be truncated
 * @returns {string}
 */
function truncateString(str, n) {
  if (typeof str !== 'string') {
    throw new Error('parameter 1 str needs to be a string');
  } else if (typeof n !== 'number') {
    throw new Error('parameter 2 n needs to be a number');
  }
  return str.length > n && n > 3 ? `${str.substr(0, n - 3)}...` : str;
}

var css_248z$s = ".flight-font, .flight-multi-select {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-multi-select__error-message {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-multi-select__dropdown__empty-message {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-multi-select__dropdown__trigger__button {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-multi-select__dropdown__trigger__button__label {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-multi-select {\n  min-width: 65px;\n  width: fit-content;\n  position: relative;\n  display: inline-block;\n}\n.flight-multi-select, .flight-multi-select * {\n  outline: none;\n}\n.flight-multi-select .flight-dropdown {\n  width: 100%;\n}\n.flight-multi-select .flight-dropdown__dropdown {\n  margin: 4px 0;\n}\n.flight-multi-select__dropdown {\n  border-bottom: 1px solid #B4B8C3;\n}\n.flight-multi-select__dropdown__trigger__button {\n  color: #697186;\n  border-radius: 5px 5px 0 0;\n  background-color: #F2F3F5;\n  padding-left: 4px;\n}\n.flight-multi-select__dropdown__trigger__button svg {\n  fill: #697186;\n}\n.flight-multi-select__dropdown__trigger__button:hover:enabled, .flight-multi-select__dropdown__trigger__button:focus:enabled, .flight-multi-select__dropdown__trigger__button:active:enabled {\n  color: #697186;\n  background-color: #F2F3F5;\n}\n.flight-multi-select__dropdown__trigger__button:hover:enabled svg, .flight-multi-select__dropdown__trigger__button:focus:enabled svg, .flight-multi-select__dropdown__trigger__button:active:enabled svg {\n  fill: #697186;\n}\n.flight-multi-select__dropdown__trigger__button--open {\n  color: #051336;\n}\n.flight-multi-select__dropdown__trigger__button--open svg {\n  fill: #37425E;\n}\n.flight-multi-select__dropdown__option {\n  margin: 12px 8px 0 8px;\n}\n.flight-multi-select__dropdown__option:first-child {\n  margin-top: 0;\n}\n.flight-multi-select__dropdown__empty-message {\n  color: #82899B;\n  padding: 0 8px;\n  min-width: 133px;\n}\n.flight-multi-select__dropdown--with-search .flight-dropdown__dropdown {\n  padding-top: 0;\n}\n.flight-multi-select__dropdown--with-search .flight-dropdown__dropdown .flight-search .flight-text-input__input {\n  background-color: white;\n}\n.flight-multi-select__dropdown--with-search .flight-multi-select__dropdown__empty-message {\n  padding-top: 8px;\n}\n.flight-multi-select__dropdown--error {\n  border-color: #DC3616;\n  margin-bottom: 4px;\n}\n.flight-multi-select:not(.flight-multi-select--disabled) .flight-multi-select__dropdown:hover, .flight-multi-select:not(.flight-multi-select--disabled) .flight-multi-select__dropdown--focused {\n  border-color: #0851DF;\n}\n.flight-multi-select__error-message {\n  color: #DC3616;\n  padding-left: 8px;\n  display: block;\n}\n.flight-multi-select__error-message--disabled {\n  color: #B4B8C3;\n}\n.flight-multi-select--disabled .flight-multi-select__dropdown {\n  border-color: #CDD0D7;\n}\n.flight-multi-select__dropdown__portal .flight-search {\n  margin-top: -8px;\n}\n.flight-multi-select__dropdown__portal .flight-dropdown__dropdown {\n  width: min-content;\n  max-width: none !important;\n}\n.flight-multi-select__dropdown__portal .flight-dropdown__dropdown .flight-checkbox-label {\n  white-space: nowrap;\n  width: 100%;\n}";
styleInject(css_248z$s);

/* eslint-disable react-hooks/exhaustive-deps */
const DEFAULT_CLASS$o = 'flight-multi-select';
const DROPDOWN_CLASS$4 = `${DEFAULT_CLASS$o}__dropdown`;
const TRIGGER_CLASS$1 = `${DROPDOWN_CLASS$4}__trigger__button`;
const DROPDOWN_OPTION_CLASS$1 = `${DROPDOWN_CLASS$4}__option`;
const ERROR_CLASS$3 = `${DEFAULT_CLASS$o}__error-message`;
const FlightSelectMulti = props => {
  const {
    className,
    label,
    options,
    dropdownMaxHeight,
    dropdownDirection,
    isLabelAlwaysShown,
    isSearchEnabled,
    handleOptionSelect,
    handleSearch,
    searchPlaceholder,
    disabled,
    hasError,
    errorMessage,
    onClick,
    optionMaxChar,
    autoFocus,
    allowSingleSelectOnly,
    onClickOutsideParent,
    width,
    iconLeft,
    ariaControlsId
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  // isFocused for handling styles changes when user
  //  is trying to do keyboard focus.
  const [isFocused, setIsFocused] = useState(false);
  // isSearchInputFocused decides if search text input needs to be
  //  focused on the next render, should be true for everytime
  //  the dropdown is being opened.
  const [isSearchInputFocused, setIsSearchInputFocused] = useState(false);
  const [focusedOptIdx, setFocusedOptIdx] = useState(0);

  // for focusing on the trigger after dropdown is closed and resizing
  // dropdown width based on trigger width
  const triggerRef = useRef(null);
  // for focusing on a dropdown option.
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const selectedOptions = options.filter(option => option.isSelected);
  const focusDropdownChild = optionIdx => {
    if (!optionIdx && isSearchEnabled && searchInputRef && searchInputRef.current) {
      // Allowing user to re-focus on search input when arrow up
      //  on first option
      searchInputRef.current.focus();
    } else if (optionIdx >= 0 && dropdownRef && dropdownRef.current && dropdownRef.current.children && dropdownRef.current.children[optionIdx]) {
      // Focus on the {optionIdx + 1}th option in the dropdown
      dropdownRef.current.children[optionIdx].focus();
    }
  };

  // For focusing on the option when search is not enabled
  useEffect(() => {
    if (isOpen && dropdownRef && dropdownRef.current && triggerRef && triggerRef.current) {
      // Focus on the (first option) or (the search input)
      //  when opening the dropdown for the first time
      focusDropdownChild(focusedOptIdx);
      dropdownRef.current.style.minWidth = `${triggerRef.current.getBoundingClientRect().width}px`;
    }
  }, [isOpen, focusedOptIdx, dropdownRef, selectedOptions.length]);
  const closeDropdown = isFocusTrigger => {
    setIsOpen(false);
    if (isFocusTrigger) triggerRef.current.focus();
  };
  const handleTriggerClick = event => {
    setIsOpen(true);
    setIsSearchInputFocused(true);
    if (onClick) onClick(event);
  };
  const handleOnKeyDown = event => {
    if (isOpen) {
      if (options && options.length > 0 && [EVENT_KEYS.ARROW_UP, EVENT_KEYS.ARROW_DOWN].includes(event.key)) {
        // focuses on the previous/next option when users
        //  input arrow up/down actions using keybard.
        //  using Math.min/max to handle boundaries. min
        //  depends on isSearchEnabled since FlightSearch
        //  will be the first child of the dropdown.
        const newFocusedOptIdx = event.key === EVENT_KEYS.ARROW_UP ? Math.max(focusedOptIdx - 1, 0) : Math.min(focusedOptIdx + 1, options.length - (isSearchEnabled ? 0 : 1));
        setFocusedOptIdx(newFocusedOptIdx);
        event.preventDefault();
      } else if (event.key === EVENT_KEYS.TAB) {
        // when users enter tab key they exit the component.
        closeDropdown(false);
      } else if (event.key === EVENT_KEYS.ESCAPE) {
        // when users enter escape key, close the dropdown but
        //  focus back to trigger button.
        closeDropdown(true);
      }
    }
  };
  const handleSearchInputOnLoad = () => {
    if (!disabled && isSearchInputFocused && searchInputRef && searchInputRef.current && searchInputRef.current.focus) {
      searchInputRef.current.focus();
      setIsSearchInputFocused(false);
    }
  };
  const handleTriggerKeydown = event => {
    if (!isOpen && [EVENT_KEYS.ARROW_UP, EVENT_KEYS.ARROW_DOWN].includes(event.key)) {
      setIsOpen(true);
      event.stopPropagation();
      event.preventDefault();
    }
  };
  let wrapperClass = DEFAULT_CLASS$o;
  wrapperClass += disabled ? ` ${DEFAULT_CLASS$o}--disabled` : '';
  wrapperClass += className ? ` ${className}` : '';
  let triggerClass = TRIGGER_CLASS$1;
  triggerClass += isOpen ? ` ${TRIGGER_CLASS$1}--open` : '';
  let dropdownClass = DROPDOWN_CLASS$4;
  dropdownClass += isSearchEnabled ? ` ${DROPDOWN_CLASS$4}--with-search` : '';
  dropdownClass += isFocused ? ` ${DROPDOWN_CLASS$4}--focused` : '';
  dropdownClass += hasError ? ` ${DROPDOWN_CLASS$4}--error` : '';
  let errorMessageClass = ERROR_CLASS$3;
  errorMessageClass += disabled ? ` ${ERROR_CLASS$3}--disabled` : '';
  let labelClass = `${DROPDOWN_CLASS$4}__trigger__button__label`;
  labelClass += iconLeft ? ` ${labelClass}--has-icon` : '';
  let triggerText = label;
  if (selectedOptions.length) {
    const labelText = `${label}: `;
    const moreOptionsText = ` + ${selectedOptions.length - 1} more`;
    if (isLabelAlwaysShown && selectedOptions.length > 1) {
      triggerText = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
        className: labelClass
      }, labelText), truncateString(selectedOptions[0].name, optionMaxChar - (labelText.length + moreOptionsText.length)) + moreOptionsText);
    } else if (isLabelAlwaysShown) {
      triggerText = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
        className: labelClass
      }, labelText), truncateString(selectedOptions[0].name, optionMaxChar - labelText.length));
    } else if (selectedOptions.length > 1) {
      triggerText = truncateString(selectedOptions[0].name, optionMaxChar - moreOptionsText.length) + moreOptionsText;
    } else {
      triggerText = truncateString(selectedOptions[0].name, optionMaxChar);
    }
  }
  function handleOnClickOutsideParent() {
    if (onClickOutsideParent) {
      onClickOutsideParent();
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass,
    style: {
      width
    },
    onKeyDown: handleOnKeyDown,
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    className: dropdownClass,
    trigger: /*#__PURE__*/React__default.createElement(FlightButton, {
      className: triggerClass,
      label: triggerText || ' ',
      theme: "minor",
      onBlur: () => setIsFocused(false),
      onClick: handleTriggerClick,
      onFocus: () => setIsFocused(true),
      onKeyDown: handleTriggerKeydown,
      iconRight: isOpen ? 'upCarrot' : 'downCarrot',
      iconLeft: iconLeft,
      disabled: disabled,
      buttonRef: triggerRef,
      isPropagateUpperActions: true,
      ariaLabel: label || 'select-multi-dropdown-button'
    }),
    direction: dropdownDirection,
    maxHeight: dropdownMaxHeight,
    isActive: isOpen,
    isControlledByIsActive: true,
    ariaControlsId: `select-multi-${ariaControlsId}`,
    handleClickOutside: () => {
      closeDropdown(true);
      handleOnClickOutsideParent();
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: dropdownRef
  }, isSearchEnabled && /*#__PURE__*/React__default.createElement(FlightSearch, {
    placeholderText: searchPlaceholder,
    onSearch: handleSearch,
    width: "100%",
    hasSearchIcon: false,
    searchInputRef: searchInputRef,
    onLoad: handleSearchInputOnLoad,
    autoFocus: autoFocus
  }), options && options.length ? options.map(option => /*#__PURE__*/React__default.createElement(FlightCheckbox, {
    key: option.key,
    className: DROPDOWN_OPTION_CLASS$1,
    label: truncateString(option.name, optionMaxChar),
    checkState: option.isSelected ? CHECKBOX_STATES.SELECTED : CHECKBOX_STATES.UNSELECTED,
    disabled: option.isDisabled || !option.isSelected && allowSingleSelectOnly && options.some(value => value.isSelected === true),
    onSelect: () => handleOptionSelect(option)
  })) : /*#__PURE__*/React__default.createElement("div", {
    className: `${DROPDOWN_CLASS$4}__empty-message`
  }, "No options available"))), /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$o}__border`
  }), hasError && errorMessage && /*#__PURE__*/React__default.createElement("span", {
    className: errorMessageClass
  }, errorMessage));
};
FlightSelectMulti.propTypes = {
  label: propTypes.string,
  className: propTypes.string,
  options: propTypes.arrayOf(propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    name: propTypes.string.isRequired,
    isSelected: propTypes.bool
  })),
  onClick: propTypes.func,
  isLabelAlwaysShown: propTypes.bool,
  isSearchEnabled: propTypes.bool,
  handleSearch: propTypes.func,
  handleOptionSelect: propTypes.func,
  dropdownMaxHeight: propTypes.string,
  dropdownDirection: propTypes.string,
  hasError: propTypes.bool,
  errorMessage: propTypes.string,
  width: propTypes.string,
  disabled: propTypes.bool,
  optionMaxChar: propTypes.number,
  searchPlaceholder: propTypes.string,
  autoFocus: propTypes.bool,
  allowSingleSelectOnly: propTypes.bool,
  onClickOutsideParent: propTypes.func,
  iconLeft: propTypes.string,
  ariaControlsId: propTypes.string
};
FlightSelectMulti.defaultProps = {
  label: 'Select options',
  className: '',
  options: [],
  onClick: () => undefined,
  isLabelAlwaysShown: false,
  isSearchEnabled: false,
  handleSearch: () => undefined,
  handleOptionSelect: () => undefined,
  dropdownMaxHeight: '232px',
  dropdownDirection: '',
  hasError: false,
  errorMessage: '',
  width: null,
  disabled: false,
  optionMaxChar: 40,
  searchPlaceholder: 'Search',
  autoFocus: false,
  allowSingleSelectOnly: false,
  onClickOutsideParent: () => null,
  iconLeft: undefined,
  ariaControlsId: ''
};

var css_248z$t = ".flight-font, .flight-select-searchable {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-select-searchable__error-message {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-select-searchable__dropdown__empty-message {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n.flight-select-searchable {\n  min-width: 65px;\n  position: relative;\n  display: inline-block;\n}\n.flight-select-searchable, .flight-select-searchable * {\n  outline: none;\n}\n.flight-select-searchable__dropdown__portal .flight-dropdown__dropdown {\n  width: 100%;\n}\n.flight-select-searchable__dropdown__option {\n  width: 100%;\n  border-radius: 0;\n  justify-content: left;\n  text-align: left;\n  white-space: nowrap;\n}\n.flight-select-searchable__dropdown__option:hover:enabled, .flight-select-searchable__dropdown__option:focus:enabled, .flight-select-searchable__dropdown__option--hovered {\n  background-color: #F2F3F5;\n}\n.flight-select-searchable__dropdown__option--selected, .flight-select-searchable__dropdown__option--selected:hover:enabled, .flight-select-searchable__dropdown__option--selected:focus:enabled {\n  background-color: #E6E7EB;\n}\n.flight-select-searchable__dropdown__input {\n  margin-bottom: 0;\n}\n.flight-select-searchable__dropdown__input .flight-text-input__icon-trailing {\n  pointer-events: none;\n}\n.flight-select-searchable__dropdown .flight-dropdown__dropdown {\n  width: 100%;\n}\n.flight-select-searchable__dropdown__empty-message {\n  color: #82899B;\n  padding: 0 8px;\n  min-width: 133px;\n}\n.flight-select-searchable__dropdown--error {\n  margin-bottom: 4px;\n}\n.flight-select-searchable__error-message {\n  color: #DC3616;\n  padding-left: 8px;\n  display: block;\n}\n.flight-select-searchable__error-message--disabled {\n  color: #B4B8C3;\n}\n.flight-select-searchable--disabled .flight-select-searchable__dropdown .flight-dropdown__trigger {\n  cursor: no-drop;\n}";
styleInject(css_248z$t);

/* eslint-disable react-hooks/exhaustive-deps */
const DEFAULT_CLASS$p = 'flight-select-searchable';
const DROPDOWN_CLASS$5 = `${DEFAULT_CLASS$p}__dropdown`;
const DROPDOWN_OPTION_CLASS$2 = `${DROPDOWN_CLASS$5}__option`;
const ERROR_CLASS$4 = `${DEFAULT_CLASS$p}__error-message`;
const FlightSelectSearchable = props => {
  const {
    className,
    clearOnClickOutside,
    label,
    options,
    selected,
    dropdownMaxHeight,
    dropdownDirection,
    handleOptionClick,
    handleSearch,
    disabled,
    hasError,
    errorMessage,
    onFocus,
    autoFocus,
    width,
    onKeyDown,
    iconLeft,
    ariaControlsId,
    isLabelAlwaysOn
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  // if props.selected is has a value, and user tries to type
  //  in something else in the input, isReselecting helps the
  //  component to reset the input value to selected.name if
  //  the user does not select another option after changing
  //  the input value.
  const [isReselecting, setIsReselecting] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [hoveredOptIdx, setHoveredOptIdx] = useState(-1);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  useEffect(() => {
    if (isOpen) {
      if (selected && selected.key) {
        if (!isReselecting) {
          setIsReselecting(true);
        }
      } else if (options && options.length > 0) {
        setHoveredOptIdx(-1);
      }
    } else {
      let nextInputValue = '';
      if (selected && selected.key) {
        nextInputValue = selected.name;
      }
      setInputValue(nextInputValue);
    }
  }, [isOpen]);
  useEffect(() => {
    // this useEffect is for when the value of props.selected
    //  gets modified outside of the component.
    if (isSearching) return; // inputValue should be left alone when searching
    if (selected && selected.key && options && options.find) {
      const validOption = options.find(opt => opt.key === selected.key);
      const newInputValue = validOption && validOption.name ? validOption.name : '';
      setInputValue(newInputValue);
    } else {
      setInputValue('');
    }
  }, [selected, options]);
  const hoverOnOptionIdx = OptionIdx => {
    if (dropdownRef && dropdownRef.current) {
      // focusing on a dropdown option for the case when
      //  the option is outside of dropdown view.
      dropdownRef.current.children[OptionIdx !== -1 ? OptionIdx : 0].focus();
      // quickly switching back to focus on the input or
      //  else users will lose the ability to keep typing.
      inputRef.current.focus();
    }
  };
  useEffect(() => {
    // show hover state of options[index]
    hoverOnOptionIdx(hoveredOptIdx);
  }, [hoveredOptIdx]);
  const onOptionClick = option => {
    if (isOpen) {
      setIsOpen(false);
      setIsSearching(false);
      setInputValue(option && option.name || '');
      handleOptionClick(option);
      // reset search after and option is selected to show
      //  default options when open again.
      handleSearch('');
      inputRef.current.blur();
    }
  };
  const onWrapperKeyDown = event => {
    if ([EVENT_KEYS.ARROW_UP, EVENT_KEYS.ARROW_DOWN].includes(event.key)) {
      const newHoveredOptIdx = event.key === EVENT_KEYS.ARROW_UP ? Math.max(hoveredOptIdx - 1, 0) : Math.min(hoveredOptIdx + 1, options.length - 1);
      setHoveredOptIdx(newHoveredOptIdx);
      event.preventDefault();
    } else if (event.key === EVENT_KEYS.ENTER) {
      let option = options[hoveredOptIdx];
      if ((option && option.name && typeof option.name !== 'string' || !option) && inputRef.current && inputRef.current.value) {
        option = {
          key: inputRef.current.value,
          name: inputRef.current.value
        };
      }
      onOptionClick(option);
    } else if (event.key === EVENT_KEYS.TAB) {
      // disabling tab key's effect within the component.
      if (clearOnClickOutside) handleSearch('');
      setIsOpen(false);
      inputRef.current.blur();
    }
  };
  const handleTextOnChange = event => {
    // Reset option as hovered when text changes.
    setHoveredOptIdx(-1);
    setIsSearching(true);
    setInputValue(event.target.value);
    handleSearch(event.target.value);
  };
  const handleInputOnFocus = event => {
    if (disabled) return;
    setIsOpen(true);
    if (event.target.value.length) {
      event.target.select();
    }
    if (onFocus) onFocus(event);
  };
  let wrapperClass = DEFAULT_CLASS$p;
  wrapperClass += disabled ? ` ${DEFAULT_CLASS$p}--disabled` : '';
  wrapperClass += className ? ` ${className}` : '';
  let dropdownClass = DROPDOWN_CLASS$5;
  dropdownClass += hasError ? ` ${DROPDOWN_CLASS$5}--error` : '';
  let errorMessageClass = ERROR_CLASS$4;
  errorMessageClass += disabled ? ` ${ERROR_CLASS$4}--disabled` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass,
    style: {
      width
    },
    onKeyDown: onWrapperKeyDown,
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    className: className ? `${className}__dropdown ${dropdownClass}` : dropdownClass,
    trigger: /*#__PURE__*/React__default.createElement(FlightTextInput, {
      className: `${DROPDOWN_CLASS$5}__input`,
      value: inputValue || !isReselecting && selected && selected.name || '',
      label: label,
      onChange: handleTextOnChange,
      onFocus: handleInputOnFocus,
      trailingIcon: isOpen ? 'upCarrot' : 'downCarrot',
      iconInput: iconLeft,
      inputRef: inputRef,
      disabled: disabled,
      hasError: hasError,
      autoFocus: autoFocus,
      onKeyDown: onKeyDown,
      isLabelAlwaysOn: isLabelAlwaysOn
    }),
    ariaControlsId: `select-searchable-${ariaControlsId}`,
    direction: dropdownDirection,
    maxHeight: dropdownMaxHeight,
    isActive: isOpen && !disabled,
    isControlledByIsActive: true,
    handleClickOutside: () => {
      if (clearOnClickOutside) handleSearch('');
      setIsOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: dropdownRef
  }, options && options.length ? options.map((option, idx) => {
    let optionButtonClassName = DROPDOWN_OPTION_CLASS$2;
    if (selected && selected.key === option.key) {
      optionButtonClassName += ` ${DROPDOWN_OPTION_CLASS$2}--selected`;
    } else if (idx === hoveredOptIdx) {
      optionButtonClassName += ` ${DROPDOWN_OPTION_CLASS$2}--hovered`;
    }
    return /*#__PURE__*/React__default.createElement(FlightButton, {
      key: option.key,
      helperkey: option.key,
      className: optionButtonClassName,
      label: option.name,
      theme: "minor",
      onClick: () => onOptionClick(option),
      ariaLabel: option.key
    });
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: `${DROPDOWN_CLASS$5}__empty-message`
  }, "No results found."))), hasError && errorMessage && /*#__PURE__*/React__default.createElement("span", {
    className: errorMessageClass
  }, errorMessage));
};
FlightSelectSearchable.propTypes = {
  label: propTypes.string,
  className: propTypes.string,
  clearOnClickOutside: propTypes.bool,
  options: propTypes.arrayOf(propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    name: propTypes.node.isRequired
  })),
  selected: propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    name: propTypes.node.isRequired
  }),
  onFocus: propTypes.func,
  handleOptionClick: propTypes.func,
  handleSearch: propTypes.func,
  dropdownMaxHeight: propTypes.string,
  dropdownDirection: propTypes.string,
  hasError: propTypes.bool,
  errorMessage: propTypes.string,
  width: propTypes.string,
  disabled: propTypes.bool,
  autoFocus: propTypes.bool,
  onKeyDown: propTypes.func,
  iconLeft: propTypes.string,
  ariaControlsId: propTypes.string,
  isLabelAlwaysOn: propTypes.bool
};
FlightSelectSearchable.defaultProps = {
  label: 'Select an option',
  className: '',
  clearOnClickOutside: false,
  options: [],
  selected: null,
  onFocus: () => undefined,
  handleOptionClick: () => undefined,
  handleSearch: () => undefined,
  dropdownMaxHeight: '200px',
  dropdownDirection: '',
  hasError: false,
  errorMessage: '',
  width: '232px',
  disabled: false,
  autoFocus: false,
  onKeyDown: () => undefined,
  iconLeft: undefined,
  ariaControlsId: '',
  isLabelAlwaysOn: true
};

var css_248z$u = ".flight-font, .flight-snackbar {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-snackbar__content {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold, .flight-snackbar__title {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon, .flight-snackbar svg {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-snackbar {\n  -webkit-box-shadow: 0 4px 15px #E6E7EB;\n  -moz-box-shadow: 0 4px 15px #E6E7EB;\n  -ms-box-shadow: 0 4px 15px #E6E7EB;\n  -o-box-shadow: 0 4px 15px #E6E7EB;\n  box-shadow: 0 4px 15px #E6E7EB;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  padding: 12px;\n  width: 534px;\n  height: 20px;\n  color: #051336;\n}\n.flight-snackbar__icon {\n  height: 100%;\n  margin-right: 8px;\n}\n.flight-snackbar__actions {\n  position: absolute;\n  right: 12px;\n}\n.flight-snackbar__actions__button {\n  color: #1E2B4A;\n}\n.flight-snackbar__actions__button:not(:first-child) {\n  margin-left: 16px;\n}\n.flight-snackbar--floating {\n  position: absolute;\n  margin: auto;\n  left: 0;\n  right: 0;\n  top: 0;\n}\n.flight-snackbar--animation {\n  -webkit-animation-name: fade-in-bottom;\n  -moz-animation-name: fade-in-bottom;\n  -ms-animation-name: fade-in-bottom;\n  -o-animation-name: fade-in-bottom;\n  animation-name: fade-in-bottom;\n  -webkit-animation-delay: 0s;\n  -moz-animation-delay: 0s;\n  -ms-animation-delay: 0s;\n  -o-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-duration: 0.1s;\n  -moz-animation-duration: 0.1s;\n  -ms-animation-duration: 0.1s;\n  -o-animation-duration: 0.1s;\n  animation-duration: 0.1s;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-timing-function: linear;\n  -ms-animation-timing-function: linear;\n  -o-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: 1;\n  -moz-animation-iteration-count: 1;\n  -ms-animation-iteration-count: 1;\n  -o-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n  -webkit-animation-direction: normal;\n  -moz-animation-direction: normal;\n  -ms-animation-direction: normal;\n  -o-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-fill-mode: none;\n  -moz-animation-fill-mode: none;\n  -ms-animation-fill-mode: none;\n  -o-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  -moz-animation-play-state: running;\n  -ms-animation-play-state: running;\n  -o-animation-play-state: running;\n  animation-play-state: running;\n}\n.flight-snackbar--default {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  -ms-box-shadow: none;\n  -o-box-shadow: none;\n  box-shadow: none;\n  background-color: #1E2B4A;\n}\n.flight-snackbar--default .flight-snackbar__title, .flight-snackbar--default .flight-snackbar__content {\n  color: #FFFFFF;\n}\n.flight-snackbar--default .flight-snackbar__actions__button {\n  color: #B9D9FF;\n}\n.flight-snackbar--default .flight-snackbar__actions__button:hover:enabled, .flight-snackbar--default .flight-snackbar__actions__button:focus:enabled {\n  color: #7CB4FF;\n}\n.flight-snackbar--default .flight-snackbar__actions__button:active:enabled {\n  color: #4992FD;\n}\n.flight-snackbar--error {\n  background-color: #FFE1DE;\n}\n.flight-snackbar--error svg {\n  fill: #B32013;\n}\n.flight-snackbar--warning {\n  background-color: #FDF9D4;\n}\n.flight-snackbar--warning svg {\n  fill: #FF9C02;\n}\n.flight-snackbar--success {\n  background-color: #CDF8EE;\n}\n.flight-snackbar--success svg {\n  fill: #00882F;\n}\n.flight-snackbar--info {\n  background-color: #DAF6FF;\n}\n.flight-snackbar--info svg {\n  fill: #1576B2;\n}\n.flight-snackbar--with-title {\n  width: 509px;\n  display: block;\n  height: auto;\n}\n.flight-snackbar--with-title .flight-snackbar__icon {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n}\n.flight-snackbar--with-title .flight-snackbar__title, .flight-snackbar--with-title .flight-snackbar__content {\n  padding: 0 0 4px 32px;\n}\n.flight-snackbar--with-title .flight-snackbar__content {\n  margin-bottom: 36px;\n}\n.flight-snackbar--with-title .flight-snackbar__actions {\n  bottom: 12px;\n}\n.flight-snackbar--without-icon .flight-snackbar__title, .flight-snackbar--without-icon .flight-snackbar__content {\n  padding-left: 0;\n}";
styleInject(css_248z$u);

const DEFAULT_CLASS$q = 'flight-snackbar';
const AUTO_DISMISS_TIMER = 5000;
const SNACKBAR_TYPES_MAP = {
  default: 'default',
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warning'
};
const TYPES_ICON_MAP = {
  default: null,
  success: getIcon('checkCircle'),
  error: getIcon('blocked'),
  info: getIcon('infoFilled'),
  warning: getIcon('error')
};
const FlightSnackbar = props => {
  const {
    isVisible,
    isFloating,
    animation,
    icon,
    title,
    content,
    type,
    isAutoDismiss,
    dismissAfter,
    action,
    actionName,
    handleClose,
    className
  } = props;
  const iconElement = getIcon(icon) || TYPES_ICON_MAP[type];
  const dismissTimer = useRef();
  const handleDismiss = () => {
    clearTimeout(dismissTimer.current);
    handleClose();
  };
  if (isVisible && isAutoDismiss) {
    dismissTimer.current = setTimeout(handleDismiss, dismissAfter);
  }
  useEffect(() => () => {
    clearTimeout(dismissTimer.current);
  }, []);
  let mainClass = DEFAULT_CLASS$q;
  mainClass += isFloating ? ` ${DEFAULT_CLASS$q}--floating` : '';
  mainClass += animation ? ` ${DEFAULT_CLASS$q}--animation` : '';
  mainClass += SNACKBAR_TYPES_MAP[type] ? ` ${DEFAULT_CLASS$q}--${SNACKBAR_TYPES_MAP[type]}` : ` ${DEFAULT_CLASS$q}--${SNACKBAR_TYPES_MAP.default}`;
  mainClass += title ? ` ${DEFAULT_CLASS$q}--with-title` : '';
  mainClass += iconElement ? '' : ` ${DEFAULT_CLASS$q}--without-icon`;
  mainClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isVisible && /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    role: "alert"
  }, iconElement && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$q}__icon`
  }, iconElement), title && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$q}__title`,
    tabIndex: 0
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$q}__content`,
    tabIndex: 0
  }, content), /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$q}__actions`
  }, action && /*#__PURE__*/React__default.createElement(FlightButton, {
    className: `${DEFAULT_CLASS$q}__actions__button`,
    label: actionName,
    theme: "link",
    onClick: action,
    hasUnderline: false,
    ariaLabel: actionName || 'snackbar-action'
  }), !isAutoDismiss && /*#__PURE__*/React__default.createElement(FlightButton, {
    className: `${DEFAULT_CLASS$q}__actions__button`,
    label: "Dismiss",
    theme: "link",
    onClick: handleDismiss,
    hasUnderline: false
  }))));
};
FlightSnackbar.propTypes = {
  className: propTypes.string,
  isVisible: propTypes.bool,
  isFloating: propTypes.bool,
  animation: propTypes.bool,
  icon: propTypes.string,
  title: propTypes.string,
  content: propTypes.node,
  type: propTypes.string,
  isAutoDismiss: propTypes.bool,
  dismissAfter: propTypes.number,
  action: propTypes.func,
  actionName: propTypes.string,
  handleClose: propTypes.func
};
FlightSnackbar.defaultProps = {
  className: '',
  isVisible: false,
  isFloating: true,
  animation: false,
  icon: '',
  title: '',
  content: '',
  type: 'default',
  isAutoDismiss: false,
  dismissAfter: AUTO_DISMISS_TIMER,
  action: () => undefined,
  actionName: 'Action',
  handleClose: () => undefined
};

var css_248z$v = ".flight-font, .flight-tab-panel {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-tab {\n  display: inline-block;\n}\n.flight-tab__button {\n  background: none;\n  color: #505A72;\n  width: fit-content;\n  border-radius: 0;\n}\n.flight-tab__button .flight-button__label {\n  padding: 0;\n}\n.flight-tab__button--active .flight-button__label {\n  line-height: 40px;\n}\n.flight-tab__button:focus:enabled:not(:hover:enabled) {\n  background: none;\n}\n\n.flight-tab-list {\n  z-index: 2;\n  background-color: #FFFFFF;\n  width: 100%;\n  height: fit-content;\n  border-bottom: 1px solid #E6E7EB;\n  box-sizing: border-box;\n  top: -12px;\n  position: relative;\n}\n.flight-tab-list--sticky {\n  position: -webkit-sticky;\n  position: sticky;\n}\n.flight-tab-list--center {\n  text-align: center;\n}\n.flight-tab-list--left {\n  text-align: left;\n}\n.flight-tab-list--left .flight-tab:first-child {\n  margin-left: 40px;\n}\n.flight-tab-list--right {\n  text-align: right;\n}\n.flight-tab-list--right .flight-tab:nth-last-child(2) {\n  margin-right: 40px;\n}\n\n.flight-tab-panel {\n  min-height: 300px;\n  padding: 30px;\n  border-bottom: 1px solid #E6E7EB;\n}\n\n.flight-tabs {\n  position: relative;\n}\n.flight-tabs__border {\n  transition: transform 0.15s ease;\n  position: absolute;\n  height: 4px;\n  background-color: #0851DF;\n  top: 36px;\n  z-index: 3;\n}";
styleInject(css_248z$v);

const DEFAULT_CLASS$r = 'flight-tab-panel';
const FlightTabPanel = props => {
  const {
    className,
    children
  } = props;
  let wrapperClass = DEFAULT_CLASS$r;
  wrapperClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, children);
};
FlightTabPanel.propTypes = {
  className: propTypes.string,
  children: propTypes.node
};
FlightTabPanel.defaultProps = {
  className: '',
  children: null
};

const DEFAULT_CLASS$s = 'flight-tab';
const FlightTab = props => {
  const {
    className,
    title,
    disabled,
    active,
    onClick,
    tabRef
  } = props;
  let wrapperClass = DEFAULT_CLASS$s;
  let BUTTON_CLASS = `${DEFAULT_CLASS$s}__button`;
  const ACTIVE_CLASS = `${BUTTON_CLASS}--active`;
  wrapperClass += className ? ` ${className}` : '';
  BUTTON_CLASS += active ? ` ${ACTIVE_CLASS}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    theme: "minor",
    className: BUTTON_CLASS,
    label: title,
    disabled: disabled,
    onClick: onClick,
    buttonRef: tabRef,
    ariaLabel: title || 'tab-button'
  }));
};
FlightTab.propTypes = {
  className: propTypes.string,
  title: propTypes.string.isRequired,
  disabled: propTypes.bool,
  active: propTypes.bool.isRequired,
  onClick: propTypes.func.isRequired,
  tabRef: propTypes.shape({
    current: propTypes.shape({
      getBoundingClientRect: propTypes.func
    })
  })
};
FlightTab.defaultProps = {
  className: '',
  disabled: false,
  tabRef: null
};

const DEFAULT_CLASS$t = 'flight-tab-list';
const FlightTabList = props => {
  const {
    className,
    children,
    orientation,
    sticky,
    border
  } = props;
  let wrapperClass = DEFAULT_CLASS$t;
  wrapperClass += sticky ? ` ${DEFAULT_CLASS$t}--sticky` : '';
  wrapperClass += orientation === 'center' ? ` ${DEFAULT_CLASS$t}--center` : '';
  wrapperClass += orientation === 'left' ? ` ${DEFAULT_CLASS$t}--left` : '';
  wrapperClass += orientation === 'right' ? ` ${DEFAULT_CLASS$t}--right` : '';
  wrapperClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, children, border);
};
FlightTabList.propTypes = {
  className: propTypes.string,
  children: propTypes.node.isRequired,
  orientation: propTypes.string,
  sticky: propTypes.bool,
  border: propTypes.node.isRequired
};
FlightTabList.defaultProps = {
  className: '',
  orientation: 'center',
  sticky: false
};

/* eslint-disable no-param-reassign */
const DEFAULT_CLASS$u = 'flight-tabs';
const BORDER_CLASS$1 = `${DEFAULT_CLASS$u}__border`;
const FlightTabs = props => {
  const {
    className,
    labels,
    selectedTab,
    onSelect,
    orientation,
    children,
    sticky
  } = props;
  const listOfRefs = new Map();
  const [activeTabRect, setActiveTabRect] = useState(null);
  const UPDATED_BORDER_CLASS = sticky ? `${BORDER_CLASS$1} ${BORDER_CLASS$1}--sticky` : BORDER_CLASS$1;
  let wrapperClass = DEFAULT_CLASS$u;
  wrapperClass += className ? ` ${className}` : '';
  useLayoutEffect(() => {
    if (listOfRefs.get(selectedTab)) {
      const selectedTabRef = listOfRefs.get(selectedTab);
      if (selectedTabRef.current) {
        setActiveTabRect(selectedTabRef.current);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, /*#__PURE__*/React__default.createElement(FlightTabList, {
    orientation: orientation,
    sticky: sticky,
    border: activeTabRect ? /*#__PURE__*/React__default.createElement("div", {
      className: UPDATED_BORDER_CLASS,
      style: {
        top: `${activeTabRect.offsetHeight - 4}px`,
        width: activeTabRect.offsetWidth,
        transform: `translateX(${activeTabRect.offsetLeft}px)`
      }
    }) : /*#__PURE__*/React__default.createElement("span", null)
  }, labels.map(elem => /*#__PURE__*/React__default.createElement(RenderTab, {
    key: elem.key,
    elem: elem,
    listOfRefs: listOfRefs,
    selectedTab: selectedTab,
    onSelect: onSelect
  }))), children);
};
const RenderTab = _ref => {
  let {
    elem,
    listOfRefs,
    selectedTab,
    onSelect
  } = _ref;
  const tabRef = useRef();
  listOfRefs.set(elem.key, tabRef);
  return /*#__PURE__*/React__default.createElement(FlightTab, {
    title: elem.name,
    active: elem.key === selectedTab,
    onClick: () => onSelect(elem),
    tabRef: tabRef
  });
};
RenderTab.propTypes = {
  elem: propTypes.shape({
    key: propTypes.oneOfType([propTypes.number, propTypes.string]),
    name: propTypes.string
  }).isRequired,
  listOfRefs: propTypes.instanceOf(Map).isRequired,
  selectedTab: propTypes.oneOfType([propTypes.number, propTypes.string]).isRequired,
  onSelect: propTypes.func.isRequired
};
FlightTabs.propTypes = {
  className: propTypes.string,
  selectedTab: propTypes.oneOfType([propTypes.number, propTypes.string]).isRequired,
  labels: propTypes.arrayOf(propTypes.shape({
    key: propTypes.oneOfType([propTypes.number, propTypes.string]),
    name: propTypes.string
  })).isRequired,
  onSelect: propTypes.func.isRequired,
  children: propTypes.node,
  orientation: propTypes.string,
  sticky: propTypes.bool
};
FlightTabs.defaultProps = {
  className: '',
  children: null,
  orientation: 'center',
  sticky: false
};

var css_248z$w = ".flight-font, .flight-text-area__textarea, .flight-text-area {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-text-area__footer {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-text-area__textarea, .flight-text-area {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-icon, .flight-text-area__status-icon__container {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  fill: #0851DF;\n}\n.flight-icon--small {\n  width: 16px;\n  height: 16px;\n}\n.flight-icon--medium {\n  width: 20px;\n  height: 20px;\n}\n.flight-icon--large {\n  width: 24px;\n  height: 24px;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-text-area {\n  color: #697186;\n  position: relative;\n  padding: 24px 0;\n}\n.flight-text-area__span {\n  position: absolute;\n  left: 8px;\n  top: 0;\n  display: block;\n}\n.flight-text-area__textarea {\n  display: block;\n  background-color: #F2F3F5;\n  border: 1px solid #B4B8C3;\n  width: calc(100% - 18px);\n  min-height: 113px;\n  padding: 2px 8px;\n  resize: none;\n}\n.flight-text-area__textarea:hover {\n  border-color: #505A72;\n}\n.flight-text-area__textarea:focus {\n  border-color: #0851DF;\n  -webkit-box-shadow: 0 0 0 1px #0851DF;\n  -moz-box-shadow: 0 0 0 1px #0851DF;\n  -ms-box-shadow: 0 0 0 1px #0851DF;\n  -o-box-shadow: 0 0 0 1px #0851DF;\n  box-shadow: 0 0 0 1px #0851DF;\n}\n.flight-text-area__textarea:focus ~ .flight-text-area__span {\n  color: #0851DF;\n}\n.flight-text-area__footer {\n  float: right;\n  margin: 4px 8px 0 0;\n}\n.flight-text-area__status-icon__container {\n  position: absolute;\n  right: 0;\n  top: 0;\n  display: none;\n}\n.flight-text-area--error .flight-text-area__textarea {\n  border-color: #DC3616;\n}\n.flight-text-area--error .flight-text-area__textarea:focus {\n  -webkit-box-shadow: 0 0 0 1px #DC3616;\n  -moz-box-shadow: 0 0 0 1px #DC3616;\n  -ms-box-shadow: 0 0 0 1px #DC3616;\n  -o-box-shadow: 0 0 0 1px #DC3616;\n  box-shadow: 0 0 0 1px #DC3616;\n}\n.flight-text-area--error .flight-text-area__textarea:focus ~ .flight-text-area__span {\n  color: #DC3616;\n}\n.flight-text-area--error .flight-text-area__footer {\n  float: left;\n  margin: 4px 0 0 8px;\n  color: #DC3616;\n}\n.flight-text-area--error .flight-text-area__status-icon {\n  display: block;\n  fill: #DC3616;\n}\n.flight-text-area--error .flight-text-area__status-icon__container {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n}\n.flight-text-area--error .flight-text-area__status-icon__container:focus {\n  border: 1px solid #0851DF;\n}\n.flight-text-area--disabled {\n  cursor: no-drop;\n}\n.flight-text-area--disabled .flight-text-area__textarea {\n  border-color: #CDD0D7;\n  pointer-events: none;\n}\n.flight-text-area--disabled .flight-text-area__status-icon {\n  fill: #B4B8C3;\n}\n.flight-text-area--disabled .flight-text-area__textarea,\n.flight-text-area--disabled .flight-text-area__footer,\n.flight-text-area--disabled .flight-text-area__span {\n  color: #B4B8C3;\n}";
styleInject(css_248z$w);

const DEFAULT_ERROR_MESSAGE = 'Error field';
const DEFAULT_LABEL_TEXT = 'Description';
const DEFAULT_CLASS$v = 'flight-text-area';
const DEFAULT_MAX_LENGTH$1 = 500;
const DEFAULT_WIDTH = '400px';
const FlightTextArea = props => {
  const {
    className,
    disabled,
    errorMessage,
    hasError,
    hideCharCounter,
    label,
    direction,
    maxLength,
    name,
    onChange,
    onFocus,
    onBlur,
    width,
    value,
    placeholderText,
    ariaLabel,
    isAriaRequired
  } = props;
  const wrapperRef = element => {
    if (element) {
      // Resize component width based on this.props.width
      /* eslint-disable no-param-reassign */
      element.style.minWidth = width;
      element.style.width = width;
    }
  };
  const handleValueChange = event => {
    if (disabled || event.target.value.length > maxLength) return;
    if (onChange) onChange(event);
  };
  const handleOnFocus = event => {
    if (disabled) return;
    if (onFocus) onFocus(event);
  };
  const handleOnBlur = event => {
    if (disabled) return;
    if (onBlur) onBlur(event);
  };
  const normalizedValue = value.slice(0, maxLength);
  const iconStatus = hasError ? getIcon('error', {
    className: `${DEFAULT_CLASS$v}__status-icon`
  }) : null;
  let footerText = `${normalizedValue.length} / ${maxLength}`;
  if (hasError) {
    footerText = errorMessage;
  } else if (hideCharCounter) {
    footerText = '';
  }
  let mainClass = DEFAULT_CLASS$v;
  mainClass += hasError ? ` ${DEFAULT_CLASS$v}--error` : '';
  mainClass += disabled ? ` ${DEFAULT_CLASS$v}--disabled` : '';
  mainClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    ref: wrapperRef,
    dir: direction || 'auto'
  }, /*#__PURE__*/React__default.createElement("textarea", {
    className: `${DEFAULT_CLASS$v}__textarea`,
    disabled: disabled,
    maxLength: maxLength,
    name: name,
    onChange: handleValueChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    "aria-label": ariaLabel || label,
    "aria-required": isAriaRequired,
    value: normalizedValue,
    placeholder: placeholderText,
    dir: direction || 'auto'
  }), /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$v}__span`
  }, label), iconStatus && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$v}__status-icon__container`,
    tabIndex: "0",
    role: "alert",
    "aria-label": `error ${errorMessage}`
  }, iconStatus), /*#__PURE__*/React__default.createElement("span", {
    "aria-live": "polite",
    "aria-atomic": true,
    "aria-label": !hideCharCounter ? `Characters remaining: ${normalizedValue.length} of ${maxLength}` : '',
    className: `${DEFAULT_CLASS$v}__footer`
  }, footerText));
};
FlightTextArea.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  errorMessage: propTypes.string,
  hasError: propTypes.bool,
  hideCharCounter: propTypes.bool,
  label: propTypes.string,
  direction: propTypes.string,
  ariaLabel: propTypes.string,
  isAriaRequired: propTypes.bool,
  maxLength: propTypes.number,
  name: propTypes.string,
  onChange: propTypes.func,
  onFocus: propTypes.func,
  onBlur: propTypes.func,
  value: propTypes.string,
  width: propTypes.string,
  placeholderText: propTypes.string
};
FlightTextArea.defaultProps = {
  className: '',
  disabled: false,
  errorMessage: DEFAULT_ERROR_MESSAGE,
  hasError: false,
  hideCharCounter: false,
  label: DEFAULT_LABEL_TEXT,
  direction: 'auto',
  ariaLabel: DEFAULT_LABEL_TEXT,
  isAriaRequired: false,
  maxLength: DEFAULT_MAX_LENGTH$1,
  name: '',
  onChange: () => undefined,
  onFocus: () => undefined,
  onBlur: () => undefined,
  value: '',
  width: DEFAULT_WIDTH,
  placeholderText: ''
};

var css_248z$x = ".flight-font, .flight-time {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-time__select__dropdown__portal .flight-dropdown__dropdown .flight-button {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-time__select__dropdown__portal .flight-dropdown__dropdown {\n  width: 100%;\n}\n.flight-time__select__dropdown__portal .flight-dropdown__dropdown .flight-button {\n  color: #051336;\n  white-space: nowrap;\n}";
styleInject(css_248z$x);

/**
 * Generates an array of timestamps of a day with this schema:
 * [{
 * key: 0,
 * name: "12:00 AM",
 * value: 0
 * }, {
 * ...
 * }]
 * value is the number of seconds from 12:00 AM to current timestamp
 *
 * @param {number} interval  The interval between each timestamp of the day in minutes
 * @returns {Array<Object>}
 */
function timeIntervalGen(interval, min, max) {
  const times = [];
  let startTime = min && min > 0 ? Math.min(min, 24 * 60) : 0;
  const endTime = max !== undefined && max !== null && max < 24 * 60 ? Math.max(max, 0) : 24 * 60;
  const meridian = ['AM', 'PM'];
  const hoursCorrection = {
    '00': '12'
  };
  let epoch = startTime * 60;
  for (let i = 0; startTime < endTime; i++) {
    const hoursOfDay = Math.floor(startTime / 60); // getting hours of day in 0-24 format
    const minutesOfHour = startTime % 60; // getting minutes of the hour in 0-55 format

    // getting curr time
    const currHour = `0${hoursOfDay % 12}`.slice(-2);
    const currMin = `0${minutesOfHour}`.slice(-2);
    const currMeridian = meridian[Math.floor(hoursOfDay / 12)];

    // correcting 00 to 12 when necessary
    const updatedHour = hoursCorrection[currHour] || currHour;

    // adding timestamp to array
    times[i] = {
      key: epoch.toString(),
      name: `${updatedHour}:${currMin} ${currMeridian}`,
      value: epoch
    };

    // incrementing counters
    epoch += interval * 60;
    startTime += interval;
  }
  return times;
}

const DEFAULT_CLASS$w = 'flight-time';
const SELECT_CLASS = `${DEFAULT_CLASS$w}__select`;
const FlightTime = props => {
  const {
    className,
    disabled,
    selectedTime,
    handleTimeChange,
    width,
    interval,
    errorMessage,
    hasError,
    label,
    min,
    max
  } = props;
  const timeStampArray = timeIntervalGen(interval, min, max);
  let matchedTimeStamp;
  const [searchTerm, setSearchTerm] = useState('');
  if (selectedTime !== null) {
    matchedTimeStamp = timeStampArray.find(time => time.key.toString() === selectedTime.key.toString() && time.name === selectedTime.name && time.value === selectedTime.value);
  } else {
    matchedTimeStamp = true;
  }
  let wrapperClass = DEFAULT_CLASS$w;
  wrapperClass += className ? ` ${className}` : '';
  if (matchedTimeStamp) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: wrapperClass
    }, /*#__PURE__*/React__default.createElement(FlightSelectSearchable, {
      className: SELECT_CLASS,
      clearOnClickOutside: true,
      disabled: disabled,
      selected: selectedTime,
      width: width,
      options: searchTerm ? timeStampArray.filter(opt => opt.name.includes(searchTerm)) : timeStampArray,
      label: label,
      handleOptionClick: handleTimeChange,
      handleSearch: setSearchTerm,
      hasError: hasError,
      errorMessage: errorMessage,
      isLabelAlwaysOn: false
    }));
  }
  return null;
};
FlightTime.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  width: propTypes.string,
  selectedTime: propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    name: propTypes.string.isRequired,
    value: propTypes.number.isRequired
  }),
  handleTimeChange: propTypes.func.isRequired,
  interval: propTypes.number,
  hasError: propTypes.bool,
  errorMessage: propTypes.string,
  label: propTypes.string,
  max: propTypes.number,
  min: propTypes.number
};
FlightTime.defaultProps = {
  className: '',
  disabled: false,
  selectedTime: null,
  width: 'unset',
  interval: 15,
  hasError: false,
  errorMessage: '',
  label: 'Pick a time',
  max: undefined,
  min: undefined
};

var css_248z$y = ".flight-font, .flight-time-zone {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-time-zone__select__dropdown__portal .flight-dropdown__dropdown .flight-button {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-time-zone .flight-select__dropdown__option {\n  width: 100%;\n  white-space: nowrap;\n}\n.flight-time-zone .flight-select__dropdown__trigger__button {\n  width: 100%;\n  min-width: 121px;\n}\n.flight-time-zone__select__dropdown__portal .flight-dropdown__dropdown {\n  width: min-content;\n  max-width: none !important;\n}\n.flight-time-zone__select__dropdown__portal .flight-dropdown__dropdown .flight-button {\n  color: #051336;\n}\n.flight-time-zone__select__dropdown__portal .flight-dropdown__dropdown .flight-button__label {\n  text-align: left;\n  white-space: nowrap;\n}";
styleInject(css_248z$y);

const tz = [{
  key: '0',
  name: '(GMT-5:00) Acre Time',
  value: -300
}, {
  key: '1',
  name: '(GMT+4:30) Afghanistan Time',
  value: 270
}, {
  key: '2',
  name: '(GMT-9:00) Alaska Standard Time',
  value: -540
}, {
  key: '3',
  name: '(GMT-8:00) Alaska Daylight Time',
  value: -480
}, {
  key: '4',
  name: '(GMT-4:00) Amazon Time',
  value: -240
}, {
  key: '5',
  name: '(GMT-3:00) Amazon Summer Time',
  value: -180
}, {
  key: '6',
  name: '(GMT+3:00) Arabia Standard Time',
  value: 180
}, {
  key: '7',
  name: '(GMT-3:00) Argentina Time',
  value: -180
}, {
  key: '8',
  name: '(GMT+4:00) Armenia Time',
  value: 240
}, {
  key: '9',
  name: '(GMT-4:00) Atlantic Standard Time',
  value: -240
}, {
  key: '10',
  name: '(GMT-3:00) Atlantic Daylight Time',
  value: -180
}, {
  key: '11',
  name: '(GMT+9:30) Australian Central Standard Time',
  value: 570
}, {
  key: '12',
  name: '(GMT+10:30) Australian Central Daylight Savings Time',
  value: 630
}, {
  key: '13',
  name: '(GMT+8:45) Australian Central Western Standard Time',
  value: 525
}, {
  key: '14',
  name: '(GMT+10:00) Australian Eastern Standard Time',
  value: 600
}, {
  key: '15',
  name: '(GMT+11:00) Australian Eastern Daylight Savings Time',
  value: 660
}, {
  key: '16',
  name: '(GMT+8:00) Australian Western Standard Time',
  value: 480
}, {
  key: '17',
  name: '(GMT+4:00) Azerbaijan Time',
  value: 240
}, {
  key: '18',
  name: '(GMT-1:00) Azores Standard Time',
  value: -60
}, {
  key: '19',
  name: '(GMT+0:00) Azores Summer Time',
  value: 0
}, {
  key: '20',
  name: '(GMT-12:00) Baker Island Time',
  value: -720
}, {
  key: '21',
  name: '(GMT+6:00) Bangladesh Standard Time',
  value: 360
}, {
  key: '22',
  name: '(GMT+6:00) Bhutan Time',
  value: 360
}, {
  key: '23',
  name: '(GMT-4:00) Bolivia Time',
  value: -240
}, {
  key: '24',
  name: '(GMT+11:00) Bougainville Standard Time',
  value: 660
}, {
  key: '25',
  name: '(GMT-3:00) Brasilia Time',
  value: -180
}, {
  key: '26',
  name: '(GMT-2:00) Brasilia Summer Time',
  value: -120
}, {
  key: '27',
  name: '(GMT+8:00) Brunei Darussalam Time',
  value: 480
}, {
  key: '28',
  name: '(GMT+8:00) Brunei Time',
  value: 480
}, {
  key: '29',
  name: '(GMT-1:00) Cape Verde Time',
  value: -60
}, {
  key: '30',
  name: '(GMT+2:00) Central Africa Time',
  value: 120
}, {
  key: '31',
  name: '(GMT+1:00) Central European Time',
  value: 60
}, {
  key: '32',
  name: '(GMT+2:00) Central European Summer Time',
  value: 120
}, {
  key: '33',
  name: '(GMT+8:00) Central Indonesia Time',
  value: 480
}, {
  key: '34',
  name: '(GMT-6:00) Central Standard Time',
  value: -360
}, {
  key: '35',
  name: '(GMT-5:00) Central Daylight Time',
  value: -300
}, {
  key: '36',
  name: '(GMT+8:45) Central Western Standard Time',
  value: 525
}, {
  key: '37',
  name: '(GMT+10:00) Chamorro Standard Time',
  value: 600
}, {
  key: '38',
  name: '(GMT+12:45) Chatham Standard Time',
  value: 765
}, {
  key: '39',
  name: '(GMT+13:45) Chatham Daylight Time',
  value: 825
}, {
  key: '40',
  name: '(GMT-4:00) Chile Standard Time',
  value: -240
}, {
  key: '41',
  name: '(GMT-3:00) Chile Summer Time',
  value: -180
}, {
  key: '42',
  name: '(GMT+8:00) China Standard Time',
  value: 480
}, {
  key: '43',
  name: '(GMT+8:00) Choibalsan Standard Time',
  value: 480
}, {
  key: '44',
  name: '(GMT+9:00) Choibalsan Summer Time',
  value: 540
}, {
  key: '45',
  name: '(GMT+7:00) Christmas Island Time',
  value: 420
}, {
  key: '46',
  name: '(GMT+10:00) Chuuk Time',
  value: 600
}, {
  key: '47',
  name: '(GMT-8:00) Clipperton Island Standard Time',
  value: -480
}, {
  key: '48',
  name: '(GMT+6:30) Cocos Islands Time',
  value: 390
}, {
  key: '49',
  name: '(GMT-5:00) Colombia Time',
  value: -300
}, {
  key: '50',
  name: '(GMT-4:00) Colombia Summer Time',
  value: -240
}, {
  key: '51',
  name: '(GMT-10:00) Cook Island Time',
  value: -600
}, {
  key: '52',
  name: '(GMT+0:00) Coordinated Universal Time',
  value: 0
}, {
  key: '53',
  name: '(GMT-5:00) Cuba Standard Time',
  value: -300
}, {
  key: '54',
  name: '(GMT-4:00) Cuba Daylight Time',
  value: -240
}, {
  key: '55',
  name: '(GMT+7:00) Davis Time',
  value: 420
}, {
  key: '56',
  name: "(GMT+10:00) Dumont d'Urville Time",
  value: 600
}, {
  key: '57',
  name: '(GMT+3:00) East Africa Time',
  value: 180
}, {
  key: '58',
  name: '(GMT-6:00) Easter Island Standard Time',
  value: -360
}, {
  key: '59',
  name: '(GMT-5:00) Easter Island Summer Time',
  value: -300
}, {
  key: '60',
  name: '(GMT+2:00) Eastern European Time',
  value: 120
}, {
  key: '61',
  name: '(GMT+3:00) Eastern European Summer Time',
  value: 180
}, {
  key: '62',
  name: '(GMT-1:00) Eastern Greenland Time',
  value: -60
}, {
  key: '63',
  name: '(GMT+0:00) Eastern Greenland Summer Time',
  value: 0
}, {
  key: '64',
  name: '(GMT+9:00) Eastern Indonesia Time',
  value: 540
}, {
  key: '65',
  name: '(GMT+9:00) Eastern Indonesian Time',
  value: 540
}, {
  key: '66',
  name: '(GMT-5:00) Eastern Standard Time',
  value: -300
}, {
  key: '67',
  name: '(GMT-4:00) Eastern Daylight Time',
  value: -240
}, {
  key: '68',
  name: '(GMT-5:00) Ecuador Time',
  value: -300
}, {
  key: '69',
  name: '(GMT-4:00) Falkland Islands Time',
  value: -240
}, {
  key: '70',
  name: '(GMT-3:00) Falkland Islands Summer Time',
  value: -180
}, {
  key: '71',
  name: '(GMT-2:00) Fernando de Noronha Time',
  value: -120
}, {
  key: '72',
  name: '(GMT+12:00) Fiji Time',
  value: 720
}, {
  key: '73',
  name: '(GMT-3:00) French Guiana Time',
  value: -180
}, {
  key: '74',
  name: '(GMT+5:00) French Southern and Antarctic Time',
  value: 300
}, {
  key: '75',
  name: '(GMT+3:00) Further-eastern European Time',
  value: 180
}, {
  key: '76',
  name: '(GMT-6:00) Galapagos Time',
  value: -360
}, {
  key: '77',
  name: '(GMT-9:00) Gambier Island Time',
  value: -540
}, {
  key: '78',
  name: '(GMT-9:00) Gambier Islands',
  value: -540
}, {
  key: '79',
  name: '(GMT+4:00) Georgia Standard Time',
  value: 240
}, {
  key: '80',
  name: '(GMT+12:00) Gilbert Island Time',
  value: 720
}, {
  key: '81',
  name: '(GMT+0:00) Greenwich Mean Time',
  value: 0
}, {
  key: '82',
  name: '(GMT+1:00) British Summer Time',
  value: 60
}, {
  key: '83',
  name: '(GMT+4:00) Gulf Standard Time',
  value: 240
}, {
  key: '84',
  name: '(GMT-4:00) Guyana Time',
  value: -240
}, {
  key: '85',
  name: '(GMT-10:00) Hawaii-Aleutian Standard Time',
  value: -600
}, {
  key: '86',
  name: '(GMT-9:00) Hawaii-Aleutian Daylight Time',
  value: -540
}, {
  key: '87',
  name: '(GMT+5:00) Heard and McDonald Islands Time',
  value: 300
}, {
  key: '88',
  name: '(GMT+8:00) Hong Kong Time',
  value: 480
}, {
  key: '89',
  name: '(GMT+6:00) Indian Chagos Time',
  value: 360
}, {
  key: '90',
  name: '(GMT+5:30) Indian Standard Time',
  value: 330
}, {
  key: '91',
  name: '(GMT+7:00) Indochina Time',
  value: 420
}, {
  key: '92',
  name: '(GMT+3:30) Iran Standard Time',
  value: 210
}, {
  key: '93',
  name: '(GMT+4:30) Iran Daylight Time',
  value: 270
}, {
  key: '94',
  name: '(GMT+1:00) Irish Standard Time',
  value: 60
}, {
  key: '95',
  name: '(GMT+8:00) Irkutsk Time',
  value: 480
}, {
  key: '96',
  name: '(GMT+2:00) Israel Standard Time',
  value: 120
}, {
  key: '97',
  name: '(GMT+3:00) Israel Daylight Time',
  value: 180
}, {
  key: '98',
  name: '(GMT+9:00) Japan Standard Time',
  value: 540
}, {
  key: '99',
  name: '(GMT+2:00) Kaliningrad Time',
  value: 120
}, {
  key: '100',
  name: '(GMT+12:00) Kamchatka Time',
  value: 720
}, {
  key: '101',
  name: '(GMT+7:00) Khovd Standard Time',
  value: 420
}, {
  key: '102',
  name: '(GMT+8:00) Khovd Summer Time',
  value: 480
}, {
  key: '103',
  name: '(GMT+9:00) Korea Standard Time',
  value: 540
}, {
  key: '104',
  name: '(GMT+11:00) Kosrae Time',
  value: 660
}, {
  key: '105',
  name: '(GMT+7:00) Krasnoyarsk Time',
  value: 420
}, {
  key: '106',
  name: '(GMT+6:00) Kyrgyzstan time',
  value: 360
}, {
  key: '107',
  name: '(GMT+14:00) Line Islands Time',
  value: 840
}, {
  key: '108',
  name: '(GMT+10:30) Lord Howe Standard Time',
  value: 630
}, {
  key: '109',
  name: '(GMT+11:00) Lord Howe Daylight Time',
  value: 660
}, {
  key: '110',
  name: '(GMT+11:00) Macquarie Island Station Time',
  value: 660
}, {
  key: '111',
  name: '(GMT+11:00) Magadan Time',
  value: 660
}, {
  key: '112',
  name: '(GMT+8:00) Malaysia Standard Time',
  value: 480
}, {
  key: '113',
  name: '(GMT+5:00) Maldives Time',
  value: 300
}, {
  key: '114',
  name: '(GMT-9:30) Marquesas Islands Time',
  value: -570
}, {
  key: '115',
  name: '(GMT+12:00) Marshall Islands',
  value: 720
}, {
  key: '116',
  name: '(GMT+4:00) Mauritius Time',
  value: 240
}, {
  key: '117',
  name: '(GMT+5:00) Mawson Station Time',
  value: 300
}, {
  key: '118',
  name: '(GMT+3:00) Moscow Time',
  value: 180
}, {
  key: '119',
  name: '(GMT-7:00) Mountain Standard Time',
  value: -420
}, {
  key: '120',
  name: '(GMT-6:00) Mountain Daylight Time',
  value: -360
}, {
  key: '121',
  name: '(GMT+6:30) Myanmar Standard Time',
  value: 390
}, {
  key: '122',
  name: '(GMT+12:00) Nauru Time',
  value: 720
}, {
  key: '123',
  name: '(GMT+5:45) Nepal Time',
  value: 345
}, {
  key: '124',
  name: '(GMT+11:00) New Caledonia Time',
  value: 660
}, {
  key: '125',
  name: '(GMT+12:00) New Zealand Standard Time',
  value: 720
}, {
  key: '126',
  name: '(GMT+13:00) New Zealand Daylight Time',
  value: 780
}, {
  key: '127',
  name: '(GMT-3:30) Newfoundland Standard Time',
  value: -210
}, {
  key: '128',
  name: '(GMT-2:30) Newfoundland Daylight Time',
  value: -150
}, {
  key: '129',
  name: '(GMT-11:00) Niue Time',
  value: -660
}, {
  key: '130',
  name: '(GMT+11:00) Norfolk Time',
  value: 660
}, {
  key: '131',
  name: '(GMT+6:00) Omsk Time',
  value: 360
}, {
  key: '132',
  name: '(GMT+5:00) Oral Time',
  value: 300
}, {
  key: '133',
  name: '(GMT-8:00) Pacific Standard Time',
  value: -480
}, {
  key: '134',
  name: '(GMT-7:00) Pacific Daylight Time',
  value: -420
}, {
  key: '135',
  name: '(GMT+5:00) Pakistan Standard Time',
  value: 300
}, {
  key: '136',
  name: '(GMT+9:00) Palau Time',
  value: 540
}, {
  key: '137',
  name: '(GMT+10:00) Papua New Guinea Time',
  value: 600
}, {
  key: '138',
  name: '(GMT-4:00) Paraguay Time',
  value: -240
}, {
  key: '139',
  name: '(GMT-3:00) Paraguay Summer Time',
  value: -180
}, {
  key: '140',
  name: '(GMT-5:00) Peru Time',
  value: -300
}, {
  key: '141',
  name: '(GMT+8:00) Philippine Standard Time',
  value: 480
}, {
  key: '142',
  name: '(GMT+13:00) Phoenix Island Time',
  value: 780
}, {
  key: '143',
  name: '(GMT+11:00) Pohnpei Standard Time',
  value: 660
}, {
  key: '144',
  name: '(GMT-3:00) Rothera Research Station Time',
  value: -180
}, {
  key: '145',
  name: '(GMT+4:00) Réunion Time',
  value: 240
}, {
  key: '146',
  name: '(GMT-3:00) Saint Pierre and Miquelon Standard Time',
  value: -180
}, {
  key: '147',
  name: '(GMT-2:00) Saint Pierre and Miquelon Daylight time',
  value: -120
}, {
  key: '148',
  name: '(GMT+11:00) Sakhalin Island time',
  value: 660
}, {
  key: '149',
  name: '(GMT+4:00) Samara Time',
  value: 240
}, {
  key: '150',
  name: '(GMT-11:00) Samoa Standard Time',
  value: -660
}, {
  key: '151',
  name: '(GMT+4:00) Seychelles Time',
  value: 240
}, {
  key: '152',
  name: '(GMT+3:00) Showa Station Time',
  value: 180
}, {
  key: '153',
  name: '(GMT+8:00) Singapore Time',
  value: 480
}, {
  key: '154',
  name: '(GMT+11:00) Solomon Islands Time',
  value: 660
}, {
  key: '155',
  name: '(GMT+2:00) South African Standard Time',
  value: 120
}, {
  key: '156',
  name: '(GMT-2:00) South Georgia Time',
  value: -120
}, {
  key: '157',
  name: '(GMT+11:00) Srednekolymsk Time',
  value: 660
}, {
  key: '158',
  name: '(GMT+5:30) Sri Lanka Standard Time',
  value: 330
}, {
  key: '159',
  name: '(GMT-3:00) Suriname Time',
  value: -180
}, {
  key: '160',
  name: '(GMT-10:00) Tahiti Time',
  value: -600
}, {
  key: '161',
  name: '(GMT+5:00) Tajikistan Time',
  value: 300
}, {
  key: '162',
  name: '(GMT+7:00) Thailand Standard Time',
  value: 420
}, {
  key: '163',
  name: '(GMT+9:00) Timor Leste Time',
  value: 540
}, {
  key: '164',
  name: '(GMT+13:00) Tokelau Time',
  value: 780
}, {
  key: '165',
  name: '(GMT+13:00) Tonga Time',
  value: 780
}, {
  key: '166',
  name: '(GMT+3:00) Turkey Time',
  value: 180
}, {
  key: '167',
  name: '(GMT+5:00) Turkmenistan Time',
  value: 300
}, {
  key: '168',
  name: '(GMT+12:00) Tuvalu Time',
  value: 720
}, {
  key: '169',
  name: '(GMT+8:00) Ulaanbaatar Standard Time',
  value: 480
}, {
  key: '170',
  name: '(GMT+9:00) Ulaanbaatar Summer Time',
  value: 540
}, {
  key: '171',
  name: '(GMT-3:00) Uruguay Standard Time',
  value: -180
}, {
  key: '172',
  name: '(GMT-2:00) Uruguay Summer Time',
  value: -120
}, {
  key: '173',
  name: '(GMT+5:00) Uzbekistan Time',
  value: 300
}, {
  key: '174',
  name: '(GMT+11:00) Vanuatu Time',
  value: 660
}, {
  key: '175',
  name: '(GMT-4:00) Venezuelan Standard Time',
  value: -240
}, {
  key: '176',
  name: '(GMT+10:00) Vladivostok Time',
  value: 600
}, {
  key: '177',
  name: '(GMT+4:00) Volgograd Time',
  value: 240
}, {
  key: '178',
  name: '(GMT+6:00) Vostok Station Time',
  value: 360
}, {
  key: '179',
  name: '(GMT+12:00) Wake Island Time',
  value: 720
}, {
  key: '180',
  name: '(GMT+12:00) Wallis and Futuna Time',
  value: 720
}, {
  key: '181',
  name: '(GMT+1:00) West Africa Time',
  value: 60
}, {
  key: '182',
  name: '(GMT+2:00) West Africa Summer Time',
  value: 120
}, {
  key: '183',
  name: '(GMT-3:00) West Greenland Time',
  value: -180
}, {
  key: '184',
  name: '(GMT-2:00) West Greenland Summer Time',
  value: -120
}, {
  key: '185',
  name: '(GMT+0:00) Western European Time',
  value: 0
}, {
  key: '186',
  name: '(GMT+1:00) Western European Summer Time',
  value: 60
}, {
  key: '187',
  name: '(GMT+7:00) Western Indonesia Time',
  value: 420
}, {
  key: '188',
  name: '(GMT+8:00) Western Standard Time',
  value: 480
}];

const DEFAULT_CLASS$x = 'flight-time-zone';
const SELECT_CLASS$1 = `${DEFAULT_CLASS$x}__select`;
const FlightTimeZone = props => {
  const {
    className,
    disabled,
    selectedTimeZone,
    handleTimeZoneChange,
    width,
    errorMessage,
    hasError,
    timeZoneList,
    label,
    timeZoneRegex
  } = props;
  let wrapperClass = DEFAULT_CLASS$x;
  wrapperClass += className ? ` ${className}` : '';
  let matchedTimeZone;
  if (selectedTimeZone !== null) {
    matchedTimeZone = timeZoneList.find(timeZone => timeZone.key.toString() === selectedTimeZone.key.toString() && timeZone.name === selectedTimeZone.name && timeZone.value === selectedTimeZone.value);
  } else {
    matchedTimeZone = true;
  }
  if (matchedTimeZone) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: wrapperClass
    }, /*#__PURE__*/React__default.createElement(FlightSelect, {
      className: SELECT_CLASS$1,
      disabled: disabled,
      selected: selectedTimeZone,
      width: width,
      options: timeZoneList,
      label: label,
      hasIcon: false,
      handleOptionClick: handleTimeZoneChange,
      hasError: hasError,
      errorMessage: errorMessage,
      searchRegex: timeZoneRegex
    }));
  }
  return null;
};
FlightTimeZone.propTypes = {
  className: propTypes.string,
  disabled: propTypes.bool,
  width: propTypes.string,
  selectedTimeZone: propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    name: propTypes.string.isRequired,
    value: propTypes.number.isRequired
  }),
  handleTimeZoneChange: propTypes.func.isRequired,
  hasError: propTypes.bool,
  errorMessage: propTypes.string,
  timeZoneList: propTypes.arrayOf(propTypes.shape({
    key: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
    name: propTypes.string.isRequired,
    value: propTypes.number.isRequired
  })),
  label: propTypes.string,
  timeZoneRegex: propTypes.string
};
FlightTimeZone.defaultProps = {
  className: '',
  disabled: false,
  selectedTimeZone: null,
  timeZoneList: tz,
  width: 'unset',
  hasError: false,
  errorMessage: '',
  label: 'Pick a time zone',
  timeZoneRegex: '^\\(GMT[+-]([0-9]|1[0-9]|2[0-4]):[0-5][0-9]\\) '
};

var css_248z$z = ".flight-font, .flight-toggle-switch-wrapper {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-toggle-switch-wrapper {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-toggle-switch-wrapper {\n  cursor: pointer;\n}\n.flight-toggle-switch-wrapper, .flight-toggle-switch-wrapper * {\n  outline: none;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch:focus .flight-toggle-switch__switch, .flight-toggle-switch-wrapper .flight-toggle-switch:focus .flight-toggle-switch__switch * {\n  outline: none;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__switch {\n  position: relative;\n  width: 24px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__switch__input {\n  display: none;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__switch__slider {\n  -webkit-transition-delay: 0s;\n  -moz-transition-delay: 0s;\n  -ms-transition-delay: 0s;\n  -o-transition-delay: 0s;\n  transition-delay: 0s;\n  -webkit-transition-duration: 0.4s;\n  -moz-transition-duration: 0.4s;\n  -ms-transition-duration: 0.4s;\n  -o-transition-duration: 0.4s;\n  transition-duration: 0.4s;\n  -webkit-transition-property: all;\n  -moz-transition-property: all;\n  -ms-transition-property: all;\n  -o-transition-property: all;\n  transition-property: all;\n  -webkit-transition-timing-function: ease;\n  -moz-transition-timing-function: ease;\n  -ms-transition-timing-function: ease;\n  -o-transition-timing-function: ease;\n  transition-timing-function: ease;\n  position: absolute;\n  height: 14px;\n  width: 14px;\n  background-color: #FFFFFF;\n  -webkit-box-shadow: 0 1px 3px #CDD0D7, 0 0 1px #CDD0D7;\n  -moz-box-shadow: 0 1px 3px #CDD0D7, 0 0 1px #CDD0D7;\n  -ms-box-shadow: 0 1px 3px #CDD0D7, 0 0 1px #CDD0D7;\n  -o-box-shadow: 0 1px 3px #CDD0D7, 0 0 1px #CDD0D7;\n  box-shadow: 0 1px 3px #CDD0D7, 0 0 1px #CDD0D7;\n  border-radius: 50%;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__switch__slide-bar {\n  -webkit-transition-delay: 0s;\n  -moz-transition-delay: 0s;\n  -ms-transition-delay: 0s;\n  -o-transition-delay: 0s;\n  transition-delay: 0s;\n  -webkit-transition-duration: 0.4s;\n  -moz-transition-duration: 0.4s;\n  -ms-transition-duration: 0.4s;\n  -o-transition-duration: 0.4s;\n  transition-duration: 0.4s;\n  -webkit-transition-property: all;\n  -moz-transition-property: all;\n  -ms-transition-property: all;\n  -o-transition-property: all;\n  transition-property: all;\n  -webkit-transition-timing-function: ease;\n  -moz-transition-timing-function: ease;\n  -ms-transition-timing-function: ease;\n  -o-transition-timing-function: ease;\n  transition-timing-function: ease;\n  position: absolute;\n  left: 0;\n  right: 0;\n  background-color: #B4B8C3;\n  height: 8px;\n  border-radius: 8px;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__switch__input:checked + .flight-toggle-switch__switch__slide-bar {\n  background-color: #7CB4FF;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__switch__input:checked ~ .flight-toggle-switch__switch__slider {\n  -webkit-transform: translate(10px, 0);\n  -moz-transform: translate(10px, 0);\n  -ms-transform: translate(10px, 0);\n  -o-transform: translate(10px, 0);\n  transform: translate(10px, 0);\n  background-color: #0851DF;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__span {\n  margin-left: 8px;\n  color: #37425E;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__title {\n  display: inline-block;\n  font-weight: bold;\n  color: #37425E;\n  margin-bottom: 10px;\n  position: relative;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch__title:focus {\n  outline: 1px solid #0851DF;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch:hover .flight-toggle-switch__switch__slide-bar, .flight-toggle-switch-wrapper .flight-toggle-switch:focus .flight-toggle-switch__switch__slide-bar {\n  background-color: #697186;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch:hover .flight-toggle-switch__switch__input:checked ~ .flight-toggle-switch__switch__slide-bar, .flight-toggle-switch-wrapper .flight-toggle-switch:focus .flight-toggle-switch__switch__input:checked ~ .flight-toggle-switch__switch__slide-bar {\n  background-color: #4992FD;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch:hover .flight-toggle-switch__switch__input:checked ~ .flight-toggle-switch__switch__slider, .flight-toggle-switch-wrapper .flight-toggle-switch:focus .flight-toggle-switch__switch__input:checked ~ .flight-toggle-switch__switch__slider {\n  background-color: #1237B5;\n}\n.flight-toggle-switch-wrapper .flight-toggle-switch:hover .flight-toggle-switch__span, .flight-toggle-switch-wrapper .flight-toggle-switch:focus .flight-toggle-switch__span {\n  color: black;\n}\n.flight-toggle-switch-wrapper--disabled {\n  cursor: no-drop;\n}\n.flight-toggle-switch-wrapper--disabled .flight-toggle-switch {\n  pointer-events: none;\n}\n.flight-toggle-switch-wrapper--disabled .flight-toggle-switch__switch__slide-bar {\n  background-color: #E6E7EB;\n}\n.flight-toggle-switch-wrapper--disabled .flight-toggle-switch__switch__input:checked + .flight-toggle-switch__switch__slide-bar {\n  background-color: #B9D9FF;\n}\n.flight-toggle-switch-wrapper--disabled .flight-toggle-switch__switch__input:checked ~ .flight-toggle-switch__switch__slider {\n  background-color: #7CB4FF;\n}\n.flight-toggle-switch-wrapper--disabled .flight-toggle-switch__span {\n  color: #B4B8C3;\n}";
styleInject(css_248z$z);

const DEFAULT_CLASS$y = 'flight-toggle-switch';
const FlightToggleSwitch = props => {
  const {
    disabled,
    label,
    checked,
    className,
    onChange,
    title
  } = props;
  const handleClick = event => {
    event.preventDefault();
    if (disabled) return;
    if (onChange) {
      onChange(!checked);
    }
  };
  const handleKeyDown = event => {
    if (event.key === EVENT_KEYS.ENTER) {
      handleClick(event);
    }
  };
  let wrapperClass = `${DEFAULT_CLASS$y}-wrapper`;
  wrapperClass += disabled ? ` ${wrapperClass}--disabled` : '';
  wrapperClass += className ? ` ${className}` : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClass
  }, title && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$y}__title`,
    tabIndex: disabled ? -1 : 0,
    "aria-label": title
  }, title), /*#__PURE__*/React__default.createElement("div", {
    role: "switch",
    className: DEFAULT_CLASS$y,
    tabIndex: disabled ? -1 : 0,
    onClick: handleClick,
    "aria-label": label || `toggle ${checked ? ' enable' : ' disable'}`,
    "aria-checked": checked,
    "aria-disabled": disabled,
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/React__default.createElement("label", {
    className: `${DEFAULT_CLASS$y}__switch`,
    htmlFor: "toggle-switch"
  }, /*#__PURE__*/React__default.createElement("input", {
    className: `${DEFAULT_CLASS$y}__switch__input`,
    type: "checkbox",
    checked: checked,
    id: "toggle-switch",
    readOnly: true
  }), /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$y}__switch__slide-bar`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$y}__switch__slider`
  })), label && /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$y}__span`
  }, label)));
};
FlightToggleSwitch.propTypes = {
  label: propTypes.string,
  checked: propTypes.bool,
  className: propTypes.string,
  disabled: propTypes.bool,
  onChange: propTypes.func,
  title: propTypes.string
};
FlightToggleSwitch.defaultProps = {
  label: '',
  checked: false,
  className: '',
  disabled: false,
  onChange: () => undefined,
  title: ''
};

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var css_248z$A = ".flight-font, .flight-label {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-label {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-label {\n  display: flex;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  background-color: #1237B5;\n  border-radius: 5px;\n  color: #FFFFFF;\n  padding: 4px 10px;\n  margin: 2px;\n  width: max-content;\n  height: min-content;\n}\n.flight-label, .flight-label * {\n  outline: none;\n}\n.flight-label, .flight-label * {\n  box-sizing: border-box;\n}\n.flight-label .label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.flight-label .remove {\n  display: flex;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  margin-left: 4px;\n  margin-right: -4px;\n}\n.flight-label.clickable {\n  cursor: pointer;\n}\n\n.flight-label-disable.clickable {\n  cursor: no-drop;\n}";
styleInject(css_248z$A);

const FlightLabel = _ref => {
  let {
    label,
    onClick,
    onRemove,
    disabled,
    maxWidth
  } = _ref;
  const className = classnames({
    'flight-label': true,
    clickable: typeof onClick === 'function'
  });
  function handleOnClick() {
    if (disabled) return;
    if (typeof onClick !== 'function') return;
    onClick(label);
  }
  function handleOnRemove(e) {
    if (disabled) return;
    if (typeof onRemove !== 'function') return;
    onRemove(label);
    e.stopPropagation();
  }
  const mainClass = className + (disabled ? ' flight-label-disable' : '');
  return /*#__PURE__*/React__default.createElement("div", {
    className: mainClass,
    style: {
      maxWidth: `calc(${maxWidth} - 4px)`
    },
    role: "button",
    tabIndex: "-1",
    onClick: handleOnClick,
    onKeyDown: handleOnClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "label",
    title: label
  }, label), !disabled && onRemove && /*#__PURE__*/React__default.createElement("div", {
    className: "remove",
    role: "button",
    tabIndex: "-1",
    onClick: handleOnRemove,
    onKeyDown: handleOnClick
  }, getIcon('remove', {
    style: {
      fill: 'white'
    }
  })));
};
FlightLabel.propTypes = {
  label: propTypes.string.isRequired,
  onClick: propTypes.func,
  onRemove: propTypes.func,
  disabled: propTypes.bool,
  maxWidth: propTypes.string
};
FlightLabel.defaultProps = {
  onClick: null,
  onRemove: null,
  disabled: false,
  maxWidth: '100%'
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

var css_248z$B = ".flight-font, .flight-label-search {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.flight-label-search {\n  width: 100%;\n}\n.flight-label-search__labels {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n.flight-label-search__error-message {\n  font-size: 12px;\n  line-height: 16px;\n  color: #DC3616;\n  display: block;\n}\n.flight-label-search__trigger {\n  display: block;\n  color: #0851DF;\n  fill: #0851DF;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.flight-label-search__trigger svg {\n  margin-right: 4px;\n}\n.flight-label-search__input {\n  width: 100%;\n}\n.flight-label-search__input__wrapper {\n  height: auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  background-color: #F2F3F5;\n  padding: 2px 4px;\n}\n.flight-label-search__input__wrapper, .flight-label-search__input__wrapper * {\n  box-sizing: border-box;\n}\n.flight-label-search__input__wrapper--active {\n  border: 1px solid #0851DF;\n}\n.flight-label-search__input__wrapper .search-input {\n  flex-grow: 1;\n  min-width: 30%;\n}\n.flight-label-search__input__wrapper .search-input .flight-text-input__input {\n  border-radius: 0;\n  border-bottom: unset;\n}\n.flight-label-search__input__wrapper .search-input .flight-text-input__input:focus ~ .flight-text-input__border {\n  background-color: unset;\n  transform: unset;\n}\n.flight-label-search__input__wrapper .search-input .flight-text-input__border {\n  background-color: unset;\n}\n.flight-label-search__input .flight-dropdown {\n  width: 100%;\n}\n.flight-label-search__input .flight-dropdown__dropdown {\n  width: 100%;\n  padding: 0;\n}\n.flight-label-search__input--dropdown {\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: 300px;\n}\n.flight-label-search__input--dropdown__option {\n  width: 100%;\n  border-radius: 0;\n  justify-content: left;\n  text-align: left;\n}\n.flight-label-search__input--dropdown__option:first-child {\n  margin-top: 8px;\n}\n.flight-label-search__input--dropdown__option:last-child {\n  margin-bottom: 8px;\n}\n.flight-label-search__input--dropdown__option:hover:enabled, .flight-label-search__input--dropdown__option:focus:enabled, .flight-label-search__input--dropdown__option--hovered {\n  background-color: #F2F3F5;\n  color: #697186;\n}\n.flight-label-search__input--dropdown__option--selected, .flight-label-search__input--dropdown__option--selected:hover:enabled, .flight-label-search__input--dropdown__option--selected:focus:enabled {\n  background-color: #E6E7EB;\n}\n.flight-label-search__input--dropdown__option.new {\n  color: #0851DF;\n  text-align: left;\n}\n.flight-label-search__input--dropdown__option.error {\n  color: #DC3616;\n}\n.flight-label-search__input--dropdown__spinner {\n  padding: 10px 30px 20px;\n  display: flex;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.flight-label-search__input--dropdown__spinner svg {\n  fill: #0851DF;\n  -webkit-animation-name: spin;\n  -moz-animation-name: spin;\n  -ms-animation-name: spin;\n  -o-animation-name: spin;\n  animation-name: spin;\n  -webkit-animation-delay: 0s;\n  -moz-animation-delay: 0s;\n  -ms-animation-delay: 0s;\n  -o-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-duration: 0.75s;\n  -moz-animation-duration: 0.75s;\n  -ms-animation-duration: 0.75s;\n  -o-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-timing-function: linear;\n  -ms-animation-timing-function: linear;\n  -o-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: infinite;\n  -moz-animation-iteration-count: infinite;\n  -ms-animation-iteration-count: infinite;\n  -o-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-direction: normal;\n  -moz-animation-direction: normal;\n  -ms-animation-direction: normal;\n  -o-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-fill-mode: none;\n  -moz-animation-fill-mode: none;\n  -ms-animation-fill-mode: none;\n  -o-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  -moz-animation-play-state: running;\n  -ms-animation-play-state: running;\n  -o-animation-play-state: running;\n  animation-play-state: running;\n}";
styleInject(css_248z$B);

const DEFAULT_CLASS$z = 'flight-label-search';
const className = classnames({
  [DEFAULT_CLASS$z]: true
});
const FlightLabelSearch = props => {
  const {
    width,
    height,
    labels,
    options,
    isLoading,
    disabled,
    hasError,
    errorMessage,
    onLabelClick,
    onLabelRemove,
    onLabelAdd,
    onLabelChange,
    onLabelSelected,
    direction,
    labelMaxWidth,
    onTriggerClick,
    onOutsideClick,
    onInfiniteScroll,
    ariaControlsId
  } = props;
  const regexLabel = /^[A-Za-z0-9-]+$/g;
  const regexErrorMessage = 'Special characters are not supported';
  const labelSearchRef = useRef();
  const dropdownBodyRef = useRef();
  const [search, setSearch] = useState('');
  const [error, setError] = useState('');
  const [inputHidden, setInputHidden] = useState(true);
  const [isFocus, setFocus] = useState(false);
  const [newLabels, setNewLabels] = useState([]);
  const [totalLabels, setTotalLabels] = useState([...labels]);
  const [isInfiniteScrollLoading, setInfiniteScrollLoading] = useState(false);
  const reset = useCallback(() => {
    setError('');
    setSearch('');
    onLabelChange('');
    onOutsideClick();
  }, [onLabelChange, onOutsideClick]);
  const handleLabelChange = e => {
    if (disabled) return;
    const keyword = e.target.value;
    if (keyword.indexOf(' ') !== -1) return;
    setSearch(keyword);
    if (!regexLabel.test(keyword) && keyword) {
      setError(regexErrorMessage);
      return;
    }
    setError('');
    onLabelChange(keyword);
  };
  const handleLabelSelected = option => {
    if (disabled) return;
    setNewLabels([...newLabels, option]);
    onLabelSelected([...newLabels, option]);
    reset();
  };
  const handleKeyDown = e => {
    if (e.key !== EVENT_KEYS.ENTER) return;
    if (labels.indexOf(search) > -1 || newLabels.indexOf(search) > -1 || error) return;
    if (!search.length) return;
    handleLabelSelected(search);
  };
  const handleLabelRemove = labelName => {
    setTotalLabels(oldState => [...oldState.filter(label => label !== labelName)]);
    onLabelRemove(labelName);
  };
  const handleNewLabelRemove = label => {
    setNewLabels(newLabels.filter(newLabel => newLabel !== label));

    // used to clear parent newLabels[] if the user add some label but
    // delete before adding to totalLabels
    onLabelAdd(totalLabels);
  };
  const handleInfiniteScroll = async () => {
    if (dropdownBodyRef.current) {
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = dropdownBodyRef.current;
      if (scrollHeight - scrollTop < clientHeight + 1) {
        setInfiniteScrollLoading(true);
        await onInfiniteScroll();
        setInfiniteScrollLoading(false);
      }
    }
  };
  const handleTriggerClick = () => {
    setInputHidden(false);
    onTriggerClick();
  };
  const debouncedChangeHandler = debounce_1(handleInfiniteScroll, 300);
  const renderDropdownBody = () => {
    const optionClass = `${DEFAULT_CLASS$z}__input--dropdown__option`;
    const hasSearch = search.length > 0;
    const labelExists = labels.indexOf(search);
    const newLabelExists = newLabels.indexOf(search);
    if (hasSearch && labelExists > -1 || hasSearch && newLabelExists > -1) {
      return /*#__PURE__*/React__default.createElement(FlightButton, {
        onClick: reset,
        theme: "minor",
        ariaLabel: "option",
        label: "Label exists",
        className: optionClass
      });
    }
    if (hasSearch && error) {
      return /*#__PURE__*/React__default.createElement(FlightButton, {
        onClick: reset,
        theme: "minor",
        ariaLabel: "option",
        label: error,
        className: `${optionClass} error`
      });
    }
    const dropdownOptions = [];
    options.map(option => {
      if (newLabels.indexOf(option) > -1 || totalLabels.indexOf(option) > -1) return false;
      return dropdownOptions.push( /*#__PURE__*/React__default.createElement(FlightButton, {
        key: `label_${option}`,
        onClick: () => handleLabelSelected(option),
        theme: "minor",
        ariaLabel: "option",
        label: option,
        className: optionClass
      }));
    });
    if (hasSearch && options.indexOf(search) === -1) {
      dropdownOptions.unshift( /*#__PURE__*/React__default.createElement(FlightButton, {
        key: "new_label",
        onClick: () => handleLabelSelected(search),
        theme: "minor",
        ariaLabel: "option",
        label: `Create new label "${search}"`,
        className: `${optionClass} new`
      }));
    }
    return dropdownOptions;
  };
  useEffect(() => {
    setTotalLabels(labels);
  }, [labels]);
  useEffect(() => {
    const handleClickOutside = e => {
      if (labelSearchRef.current.contains(e.target) || dropdownBodyRef.current && dropdownBodyRef.current.contains(e.target)) {
        return;
      }
      if (newLabels.length) {
        onLabelAdd([...totalLabels, ...newLabels]);
        setTotalLabels([...totalLabels, ...newLabels]);
      }
      setInputHidden(true);
      setNewLabels([]);
      reset();
    };
    document.body.addEventListener('click', handleClickOutside, {
      capture: true
    });
    return () => {
      document.body.removeEventListener('click', handleClickOutside, {
        capture: true
      });
    };
  }, [newLabels, onLabelAdd, reset, totalLabels]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: labelSearchRef,
    role: "button",
    tabIndex: "-1",
    className: className,
    onKeyDown: handleKeyDown,
    style: {
      width
    }
  }, totalLabels.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$z}__labels`
  }, totalLabels.map(label => /*#__PURE__*/React__default.createElement(FlightLabel, {
    key: label,
    label: label,
    onRemove: handleLabelRemove,
    onClick: onLabelClick,
    disabled: disabled,
    maxWidth: labelMaxWidth
  }))), !disabled && inputHidden && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$z}__trigger`,
    onClick: handleTriggerClick,
    onKeyDown: handleTriggerClick,
    role: "button",
    tabIndex: 0
  }, getIcon('tag'), "Add Labels"), !inputHidden && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$z}__input`
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    isControlledByIsActive: true,
    hasOutsideTrigger: false,
    maxWidth: width,
    maxHeight: height,
    handleClickOutside: reset,
    direction: direction,
    ariaControlsId: `label-search-${ariaControlsId}`,
    trigger: /*#__PURE__*/React__default.createElement("div", {
      className: `${DEFAULT_CLASS$z}__input__wrapper ${isFocus ? `${DEFAULT_CLASS$z}__input__wrapper--active` : ''}`
    }, newLabels.length > 0 && newLabels.map(label => /*#__PURE__*/React__default.createElement(FlightLabel, {
      key: label,
      label: label,
      onRemove: handleNewLabelRemove,
      onClick: onLabelClick,
      disabled: disabled,
      maxWidth: labelMaxWidth
    })), /*#__PURE__*/React__default.createElement(FlightTextInput, {
      autoFocus: true,
      value: search,
      width: "auto",
      placeholderText: "Add Labels",
      onChange: handleLabelChange,
      customClass: "search-input",
      onFocus: () => {
        setFocus(true);
      }
    }))
  }, isFocus || search.length ? /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$z}__input--dropdown`,
    onScroll: debouncedChangeHandler,
    ref: dropdownBodyRef
  }, renderDropdownBody(), (isLoading || isInfiniteScrollLoading) && /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$z}__input--dropdown__spinner`
  }, getIcon('loading'))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null))), hasError ? /*#__PURE__*/React__default.createElement("span", {
    className: `${DEFAULT_CLASS$z}__error-message`
  }, errorMessage) : null);
};
FlightLabelSearch.propTypes = {
  direction: propTypes.string,
  height: propTypes.string,
  isLoading: propTypes.bool,
  disabled: propTypes.bool,
  labels: propTypes.arrayOf(propTypes.string),
  onLabelClick: propTypes.func.isRequired,
  onLabelRemove: propTypes.func.isRequired,
  onLabelChange: propTypes.func.isRequired,
  onLabelAdd: propTypes.func.isRequired,
  onLabelSelected: propTypes.func,
  options: propTypes.arrayOf(propTypes.string),
  width: propTypes.string,
  hasError: propTypes.bool,
  errorMessage: propTypes.string,
  labelMaxWidth: propTypes.string,
  onTriggerClick: propTypes.func,
  onOutsideClick: propTypes.func,
  onInfiniteScroll: propTypes.func,
  ariaControlsId: propTypes.string
};
FlightLabelSearch.defaultProps = {
  direction: 'bottom',
  height: '400px',
  isLoading: false,
  disabled: false,
  labels: [],
  options: [],
  width: '100%',
  labelMaxWidth: '100%',
  hasError: false,
  errorMessage: '',
  onLabelSelected: () => undefined,
  onTriggerClick: () => undefined,
  onOutsideClick: () => undefined,
  onInfiniteScroll: () => undefined,
  ariaControlsId: ''
};

var css_248z$C = ".flight-font, .flight-global-nav__header {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall, .flight-global-nav__header__user__name__username__org, .flight-global-nav__header__links__link a {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-global-nav__header__user__profile__organization, .flight-global-nav__header__user__profile__email {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-global-nav__header__user__name__username {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium, .flight-global-nav__header__user__profile__name {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-global-nav__header {\n  width: 100%;\n  height: 52px;\n  padding: 0 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #051049;\n}\n.flight-global-nav__header, .flight-global-nav__header * {\n  box-sizing: border-box;\n}\n.flight-global-nav__header ul {\n  padding-left: 0;\n  list-style: none;\n  padding-inline-start: unset;\n  margin-block-start: unset;\n  margin-block-end: unset;\n}\n.flight-global-nav__header__left {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n.flight-global-nav__header__right {\n  display: flex;\n  align-items: center;\n}\n.flight-global-nav__header__trigger {\n  display: none;\n  margin-right: 12px;\n  background: transparent;\n  transition: all 0.3s;\n}\n.flight-global-nav__header__trigger svg, .flight-global-nav__header__trigger:hover:enabled > svg, .flight-global-nav__header__trigger:active:enabled > svg, .flight-global-nav__header__trigger:focus:enabled > svg {\n  fill: #FFFFFF;\n}\n.flight-global-nav__header__trigger:hover:enabled {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.flight-global-nav__header__trigger:active:enabled {\n  background-color: rgba(255, 255, 255, 0.2) !important;\n}\n.flight-global-nav__header__trigger:focus:enabled {\n  background-color: transparent;\n}\n.flight-global-nav__header__trigger.flight-button {\n  padding: unset !important;\n}\n.flight-global-nav__header__logo {\n  display: flex;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin-right: 32px;\n}\n.flight-global-nav__header__links {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n}\n.flight-global-nav__header__links__link {\n  height: 100%;\n}\n.flight-global-nav__header__links__link a {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  color: #FFFFFF;\n  text-transform: uppercase;\n  padding: 0 16px;\n  text-decoration: none;\n  transition: all 0.3s;\n}\n.flight-global-nav__header__links__link a:hover {\n  background-color: #0851DF;\n}\n.flight-global-nav__header__links__link a.active {\n  box-shadow: inset 0 -6px 0 #0851DF;\n}\n.flight-global-nav__header__actionables {\n  display: flex;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin-right: 16px;\n}\n.flight-global-nav__header__user {\n  padding: 0 8px;\n}\n.flight-global-nav__header__user__name {\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n}\n.flight-global-nav__header__user__name__avatar {\n  margin-right: 8px;\n}\n.flight-global-nav__header__user__name__username__org {\n  display: block;\n  font-weight: 400;\n}\n.flight-global-nav__header__user__dropdown__portal .flight-dropdown__dropdown {\n  max-width: 256px;\n  margin-top: 8px;\n  padding-bottom: 0;\n}\n.flight-global-nav__header__user__profile {\n  width: 256px;\n  padding: 20px 0 0;\n}\n.flight-global-nav__header__user__profile, .flight-global-nav__header__user__profile * {\n  box-sizing: border-box;\n}\n.flight-global-nav__header__user__profile__avatar {\n  margin: 0 auto;\n}\n.flight-global-nav__header__user__profile__name, .flight-global-nav__header__user__profile__email, .flight-global-nav__header__user__profile__organization {\n  text-align: center;\n}\n.flight-global-nav__header__user__profile__name {\n  margin-top: 20px;\n  margin-bottom: 4px;\n  font-weight: 800;\n}\n.flight-global-nav__header__user__profile__email {\n  margin-bottom: 20px;\n}\n.flight-global-nav__header__user__profile__organization {\n  color: #0851DF;\n  margin-bottom: 20px;\n}\n.flight-global-nav__header__user__profile__menu {\n  border-top: 1px solid #CDD0D7;\n}\n.flight-global-nav__header__user__profile__menu__link {\n  width: 100%;\n  font-weight: 400;\n  color: #051336;\n  justify-content: left;\n  transition: all 0.3s;\n}\n.flight-global-nav__header__user__profile__menu__link:hover, .flight-global-nav__header__user__profile__menu__link:focus {\n  background-color: #F2F3F5;\n  text-decoration: none !important;\n}\n.flight-global-nav__header__user__profile .flight-button {\n  padding: 12px !important;\n}\n.flight-global-nav__main {\n  width: 100%;\n  height: calc(100vh - 52px);\n  overflow-y: auto;\n}\n\n@media only screen and (max-width: 800px) {\n  .flight-global-nav__header {\n    padding: 0 20px;\n    position: relative;\n  }\n  .flight-global-nav__header__left {\n    flex-wrap: wrap;\n  }\n  .flight-global-nav__header__trigger {\n    display: flex;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n  .flight-global-nav__header__links {\n    width: 280px;\n    margin-left: -280px;\n    padding: 0;\n    display: block;\n    position: absolute;\n    top: 52px;\n    left: 0;\n    height: calc(100vh - 52px);\n    z-index: 99;\n    background-color: #051049;\n    flex-wrap: wrap;\n    flex-grow: 0;\n    transition: all 0.3s;\n  }\n  .flight-global-nav__header__links__link {\n    height: 50px;\n  }\n  .flight-global-nav__header__links__link a {\n    padding: 0 28px;\n  }\n  .flight-global-nav__header__links__link a.active {\n    background-color: #0851DF;\n  }\n  .flight-global-nav__header__links.open {\n    margin-left: 0;\n  }\n}\n@media only screen and (max-width: 414px) {\n  .flight-global-nav__header {\n    padding: 0 10px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 0;\n  }\n  .flight-global-nav__header__right {\n    justify-self: end;\n  }\n  .flight-global-nav__header__links__link a {\n    padding: 0 20px;\n  }\n  .flight-global-nav__header__user__name__username {\n    max-width: 100px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}";
styleInject(css_248z$C);

const SvgFlybitsLogoWhite = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 86,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "M31.961 4.797c-.608 0-1.169.233-1.169.35V18.65c0 1.145.585 1.472 1.403 1.472h.327c.795 0 1.356-.35 1.356-1.472V7.273c.023-1.986-.982-2.476-1.917-2.476zM53.188 17.669c-1.496 0-2.665-1.051-2.665-2.57v-1.962c.467-1.075 1.403-1.752 2.688-1.752 1.614 0 2.736 1.261 2.736 3.154 0 1.845-1.1 3.13-2.759 3.13zm.795-8.784c-1.52 0-2.712.677-3.46 1.752V7.273c0-1.986-1.005-2.476-1.917-2.476-.608 0-1.169.233-1.169.35v13.48c0 1.145.561 1.472 1.403 1.472h.327c.795 0 1.356-.35 1.356-1.472v-.35c.561 1.027 1.8 1.845 3.413 1.845 2.97 0 5.003-2.313 5.003-5.63 0-3.434-2.057-5.607-4.956-5.607zM29.226 4.797h-8.37-.841c-.795 0-1.38.373-1.38 1.495V18.65c0 1.145.585 1.472 1.403 1.472h.327c.795 0 1.356-.35 1.356-1.472v-4.345H24.316c1.987 0 2.478-.818 2.478-1.729 0-.607-.257-.888-.35-.888h-4.699v-3.76h5.353c1.987 0 2.478-1.005 2.478-1.917 0-.63-.234-1.214-.35-1.214zM78.927 13.347c-1.45-.304-2.29-.444-2.29-1.215 0-.677.654-1.051 1.823-1.051 1.239 0 2.408.584 3.132 1.425.047.07.982-.514.982-1.308 0-1.239-1.426-2.29-4.325-2.29-2.712 0-4.465 1.379-4.465 3.458 0 2.43 2.291 2.92 3.764 3.247 1.45.304 2.29.444 2.29 1.238 0 .678-.677 1.028-1.893 1.028-1.59 0-2.571-.63-3.296-1.425-.07-.07-.935.49-.935 1.262 0 1.238 1.286 2.313 4.418 2.313 2.946 0 4.723-1.309 4.723-3.458.023-2.383-2.408-2.897-3.928-3.224zM61.347 8.908c-.608 0-1.169.234-1.169.35v9.369c0 1.145.585 1.495 1.403 1.495h.327c.795 0 1.356-.35 1.356-1.495V11.43c0-2.032-1.005-2.523-1.917-2.523zM63.311 6.385c0 1.285-1.496 2.243-2.852 1.192-1.029-1.355-.094-2.85 1.192-2.85.912.023 1.66.747 1.66 1.658zM71.844 16.968c-.328.42-.748.724-1.38.724-.841 0-1.192-.537-1.192-1.588V11.29h1.894c.911 0 1.285-.397 1.285-1.145v-.163c0-.724-.374-1.098-1.239-1.098h-1.94v-.327c0-1.986-.842-2.477-1.847-2.477-.608 0-1.122.234-1.122.35v2.454h-.538c-.888 0-1.285.397-1.285 1.145v.186c0 .701.42 1.075 1.285 1.075h.515v5.163c0 2.406 1.098 3.668 3.46 3.668 1.753 0 2.828-.888 2.828-1.962.024-.841-.678-1.262-.724-1.192zM44.632 8.908c-.678 0-1.333.35-1.707 1.565l-2.057 6.098-2.314-6.12c-.398-1.216-1.006-1.543-1.73-1.543-.935 0-1.754.724-1.684.888l3.624 7.873.748 1.612-1.45 3.855c-.093.163.749.864 1.637.864.678 0 1.286-.35 1.754-1.518l4.862-12.733c.047-.14-.795-.84-1.683-.84zM8.16 9.586a1.425 1.425 0 100-2.85 1.425 1.425 0 000 2.85z",
  fill: "#fff"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M13.043 5.988c-1.191-2.71-4.368-3.901-7.055-2.71-2.687 1.191-3.901 4.369-2.71 7.055 1.192 2.687 4.369 3.902 7.055 2.71a5.321 5.321 0 002.71-7.055zM9.61 11.431c-1.799.795-3.901 0-4.696-1.799-.794-1.798 0-3.901 1.8-4.695 1.798-.795 3.9 0 4.695 1.799.818 1.775 0 3.878-1.799 4.695z",
  fill: "#3AC6FF"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M2.414 4.773c-.42.047-2.29.304-2.407.701-.116.374 1.192 1.682 1.519 1.986a6.205 6.205 0 01.888-2.687zM4.773 13.908c.047.42.304 2.29.701 2.406.374.117 1.682-1.191 1.986-1.519a6.204 6.204 0 01-2.687-.887zM14.819 8.862a6.529 6.529 0 01-.888 2.686c.42-.047 2.29-.304 2.406-.7.117-.375-1.214-1.683-1.518-1.986zM11.571 2.414c-.046-.42-.303-2.29-.7-2.407-.374-.116-1.706 1.192-1.986 1.519a6.417 6.417 0 012.686.888z",
  fill: "#fff"
}));

const DEFAULT_CLASS$A = 'flight-global-nav';
const HEADER_CLASS$1 = `${DEFAULT_CLASS$A}__header`;
const USER_CLASS = `${HEADER_CLASS$1}__user`;
const MAIN_CLASS$1 = `${DEFAULT_CLASS$A}__main`;
const ORGANIZATION = 'Organization';
const FlightGlobalNav = props => {
  const {
    logo,
    logoRoute,
    children,
    user,
    actionables,
    profileRoutes,
    headerRoutes,
    handleSignOut,
    ariaControlsId
  } = props;
  const [isHeaderNavOpen, setHeaderNavOpen] = useState(false);
  const [isActiveDropdown, setActiveDropDown] = useState(false);
  return /*#__PURE__*/React__default.createElement("div", {
    className: DEFAULT_CLASS$A
  }, /*#__PURE__*/React__default.createElement("div", {
    className: HEADER_CLASS$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS$1}__left`
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    theme: "minor",
    size: "small",
    iconRight: "menu",
    onClick: () => {
      setHeaderNavOpen(!isHeaderNavOpen);
    },
    ariaLabel: "toggle-header-nav",
    className: `${HEADER_CLASS$1}__trigger`
  }), logo && /*#__PURE__*/React__default.createElement(Link, {
    to: logoRoute,
    className: `${HEADER_CLASS$1}__logo`,
    "aria-label": "logo"
  }, logo), /*#__PURE__*/React__default.createElement("ul", {
    className: `${HEADER_CLASS$1}__links ${isHeaderNavOpen ? 'open' : ''}`,
    role: "menu",
    onClick: () => {
      setHeaderNavOpen(false);
    },
    onKeyDown: () => {
      setHeaderNavOpen(false);
    },
    tabIndex: "0"
  }, headerRoutes.map(route => /*#__PURE__*/React__default.createElement("li", {
    className: `${HEADER_CLASS$1}__links__link`,
    key: route.location,
    role: "menuitem"
  }, /*#__PURE__*/React__default.createElement(NavLink, {
    to: `/${route.location}`,
    activeClassName: "active"
  }, route.label))))), /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS$1}__right`
  }, actionables && /*#__PURE__*/React__default.createElement("div", {
    className: `${HEADER_CLASS$1}__actionables`
  }, actionables), user && user.id && /*#__PURE__*/React__default.createElement("div", {
    className: USER_CLASS
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    direction: "bottom-left",
    isActive: isActiveDropdown,
    handleClickOutside: () => {
      setActiveDropDown(!isActiveDropdown);
    },
    handleTriggerClick: () => {
      setActiveDropDown(!isActiveDropdown);
    },
    className: `${HEADER_CLASS$1}__user__dropdown`,
    ariaControlsId: `global-nav-${ariaControlsId}`,
    trigger: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: `${USER_CLASS}__name`
    }, /*#__PURE__*/React__default.createElement(FlightAvatar, {
      firstName: user.firstName,
      lastName: user.lastName,
      className: `${USER_CLASS}__name__avatar`
    }), /*#__PURE__*/React__default.createElement("div", {
      className: `${USER_CLASS}__name__username`
    }, `${user.firstName} ${user.lastName}`, user.organization && /*#__PURE__*/React__default.createElement("span", {
      className: `${USER_CLASS}__name__username__org`
    }, user.organization))))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${USER_CLASS}__profile`
  }, /*#__PURE__*/React__default.createElement(FlightAvatar, {
    size: "large",
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    className: `${USER_CLASS}__profile__avatar`
  }), user.firstName && user.lastName ? /*#__PURE__*/React__default.createElement("div", {
    className: `${USER_CLASS}__profile__name`
  }, `${user.firstName} ${user.lastName}`) : null, user.email && /*#__PURE__*/React__default.createElement("div", {
    className: `${USER_CLASS}__profile__email`
  }, user.email), user.organization && /*#__PURE__*/React__default.createElement("div", {
    className: `${USER_CLASS}__profile__organization`
  }, `${ORGANIZATION} ${user.organization}`), /*#__PURE__*/React__default.createElement("div", {
    className: `${USER_CLASS}__profile__menu`
  }, profileRoutes.map(route => /*#__PURE__*/React__default.createElement(FlightButton, {
    key: route.label,
    label: route.label,
    theme: "link",
    className: `${USER_CLASS}__profile__menu__link`,
    onClick: () => {
      setActiveDropDown(false);
      route.action();
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: `${USER_CLASS}__profile__menu`
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    label: "Sign out",
    theme: "link",
    className: `${USER_CLASS}__profile__menu__link`,
    onClick: handleSignOut
  }))))))), /*#__PURE__*/React__default.createElement("main", {
    className: MAIN_CLASS$1
  }, /*#__PURE__*/React__default.createElement(Switch, null, children)));
};
FlightGlobalNav.propTypes = {
  children: propTypes.element,
  actionables: propTypes.element,
  logo: propTypes.element,
  logoRoute: propTypes.string,
  user: propTypes.shape({
    id: propTypes.string,
    firstName: propTypes.string,
    lastName: propTypes.string,
    email: propTypes.string,
    organization: propTypes.string
  }),
  profileRoutes: propTypes.arrayOf(propTypes.shape({
    label: propTypes.string,
    action: propTypes.func
  })),
  headerRoutes: propTypes.arrayOf(propTypes.shape({
    label: propTypes.string,
    location: propTypes.string
  })),
  handleSignOut: propTypes.func,
  ariaControlsId: propTypes.string
};
FlightGlobalNav.defaultProps = {
  children: null,
  actionables: null,
  logo: /*#__PURE__*/React__default.createElement(SvgFlybitsLogoWhite, null),
  logoRoute: '',
  user: null,
  profileRoutes: [],
  headerRoutes: [],
  handleSignOut: () => undefined,
  ariaControlsId: ''
};

var css_248z$D = ".flight-font, .flight-global-nav-sidebar__nav, .flight-global-nav-sidebar {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-global-nav-sidebar__nav__project__name__subtitle {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-global-nav-sidebar__nav__router__menu__links__link a, .flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label, .flight-global-nav-sidebar__nav__project__name {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n.flight-global-nav-sidebar {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-gap: 0;\n  position: relative;\n}\n.flight-global-nav-sidebar ul {\n  padding-left: 0;\n  list-style: none;\n  padding-inline-start: unset;\n  margin-block-start: unset;\n  margin-block-end: unset;\n}\n.flight-global-nav-sidebar--closed {\n  width: 100%;\n  height: 100%;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav {\n  width: 70px;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav__project {\n  grid-template-columns: 100%;\n  justify-items: center;\n  padding: 12px 0;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav__router {\n  padding-top: 0;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label__icon {\n  display: none;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper {\n  grid-template-columns: 100%;\n  padding: 0;\n  margin-right: 0;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper.active {\n  box-shadow: inset 4px 0 0 #0851DF;\n  background-color: #E6E7EB;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper.active .icon {\n  fill: #0851DF;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav__footer__button {\n  justify-content: center;\n}\n.flight-global-nav-sidebar--closed .flight-global-nav-sidebar__nav__footer__button svg {\n  transform: rotate(180deg);\n}\n.flight-global-nav-sidebar__nav {\n  width: 270px;\n  background-color: #F2F3F5;\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  height: 100%;\n  overflow-y: hidden;\n  transition: all 0.3s cubic-bezier(0, 0.28, 0, 0.98);\n}\n.flight-global-nav-sidebar__nav, .flight-global-nav-sidebar__nav * {\n  box-sizing: border-box;\n}\n.flight-global-nav-sidebar__nav__project {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-gap: 12px;\n  padding: 16px 35px 12px 16px;\n  border-bottom: 1px solid #E6E7EB;\n  transition: all 0.3s cubic-bezier(0, 0.28, 0, 0.98);\n}\n.flight-global-nav-sidebar__nav__project__image {\n  width: 38px;\n  height: 38px;\n  background-color: #FFFFFF;\n  cursor: pointer;\n}\n.flight-global-nav-sidebar__nav__project__image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.flight-global-nav-sidebar__nav__project__name {\n  font-weight: 700;\n  color: #051336;\n  line-height: 16px;\n  flex-grow: 2;\n}\n.flight-global-nav-sidebar__nav__project__name__subtitle {\n  display: block;\n  font-weight: 400;\n  color: rgba(5, 19, 54, 0.6);\n}\n.flight-global-nav-sidebar__nav__project__info {\n  position: absolute;\n  top: 24px;\n  left: 235px;\n  opacity: 1;\n  transition: all 0.3s cubic-bezier(0, 0.28, 0, 0.98);\n}\n.flight-global-nav-sidebar__nav__project__info .info-icon {\n  width: 20px;\n  height: 20px;\n  fill: rgba(5, 19, 54, 0.45);\n}\n.flight-global-nav-sidebar__nav__project__info.info-hidden {\n  left: 0;\n  opacity: 0;\n}\n.flight-global-nav-sidebar__nav__router {\n  height: 100%;\n  overflow-y: auto;\n  padding-top: 8px;\n}\n.flight-global-nav-sidebar__nav__router__menu {\n  background-color: transparent;\n  padding: 0;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible:first-child .flight-collapsible__label {\n  border-top: unset;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label {\n  position: relative;\n  border: 0;\n  height: unset;\n  padding: unset;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label:hover {\n  background-color: transparent;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label:focus {\n  border: unset;\n  padding: unset;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label__icon {\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  transform: translateY(-50%);\n  float: unset;\n  fill: #0851DF;\n  width: 20px;\n  height: 20px;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper {\n  width: 100%;\n  height: 45px;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-gap: 16px;\n  align-items: center;\n  padding-left: 16px;\n  margin-right: 40px;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper:hover .icon {\n  fill: #0851DF;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper:hover .label {\n  color: #0851DF;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper .icon {\n  width: 100%;\n  height: 100%;\n  fill: #505A72;\n  display: flex;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  transition: all 0.8s;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper .icon svg {\n  width: 20px;\n  height: 20px;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__label .label-wrapper .label {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  color: #505A72;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: all 0.8s;\n}\n.flight-global-nav-sidebar__nav__router__menu .flight-collapsible .flight-collapsible__content {\n  padding: 0;\n}\n.flight-global-nav-sidebar__nav__router__menu__links__link a {\n  width: 100%;\n  display: block;\n  text-decoration: none;\n  padding: 10px 12px 10px 52px;\n  color: #505A72;\n}\n.flight-global-nav-sidebar__nav__router__menu__links__link a:hover, .flight-global-nav-sidebar__nav__router__menu__links__link a.active {\n  color: #0851DF;\n  background-color: #E6E7EB;\n  font-weight: 700;\n}\n.flight-global-nav-sidebar__nav__footer {\n  border-top: 1px solid #E6E7EB;\n  align-self: end;\n}\n.flight-global-nav-sidebar__nav__footer__button {\n  width: 100% !important;\n  justify-content: right;\n}\n.flight-global-nav-sidebar__nav__footer__button:active:enabled {\n  background-color: #E6E7EB !important;\n}\n.flight-global-nav-sidebar__nav__footer__button svg {\n  fill: #505A72;\n}\n.flight-global-nav-sidebar__main {\n  height: 100%;\n  overflow-y: auto;\n}\n\n@media only screen and (max-width: 800px) {\n  .flight-global-nav-sidebar {\n    transform: rotate(0deg);\n  }\n  .flight-global-nav-sidebar__nav {\n    position: absolute;\n    z-index: 1;\n    grid-template-columns: 100%;\n    height: calc(100vh - 52px);\n  }\n  .flight-global-nav-sidebar__nav__project__info {\n    position: fixed;\n  }\n  .flight-global-nav-sidebar__nav__project__info--hidden {\n    display: none;\n  }\n  .flight-global-nav-sidebar__main {\n    padding-left: 70px;\n  }\n}";
styleInject(css_248z$D);

const DEFAULT_CLASS$B = 'flight-global-nav-sidebar';
const NAV_CLASS = `${DEFAULT_CLASS$B}__nav`;
const MAIN_CLASS$2 = `${DEFAULT_CLASS$B}__main`;
const COLLAPSE_WIDTH_THRESHOLD$1 = 800;
const FlightGlobalNavSidebar = props => {
  const {
    project,
    routeGroups,
    children,
    infoContent
  } = props;
  const [isSidebarClose, setIsSidebarClose] = useState(false);
  const [category, setCategory] = useState('');
  const {
    url
  } = useRouteMatch();
  const {
    innerWidth
  } = window;
  useEffect(() => {
    if (innerWidth <= COLLAPSE_WIDTH_THRESHOLD$1) {
      return setIsSidebarClose(true);
    }
    return setIsSidebarClose(false);
  }, [innerWidth]);
  const handleLinkClick = title => {
    const link = document.querySelector(`.${NAV_CLASS}__router__menu__links__link`);
    if (innerWidth <= COLLAPSE_WIDTH_THRESHOLD$1) {
      link.addEventListener('click', setIsSidebarClose(true));
    }
    return setCategory(title);
  };
  const links = routeGroups.map(group => ({
    key: group.title,
    name: /*#__PURE__*/React__default.createElement("div", {
      className: `label-wrapper ${category === group.title ? 'active' : ''}`,
      key: group.title
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "icon",
      onClick: () => {
        setIsSidebarClose(false);
      },
      onKeyDown: () => {
        setIsSidebarClose(false);
      },
      role: "button",
      "aria-label": group.title,
      tabIndex: 0
    }, getIcon(group.icon)), !isSidebarClose && /*#__PURE__*/React__default.createElement("span", {
      className: "label"
    }, group.title)),
    content: /*#__PURE__*/React__default.createElement("ul", {
      className: `${NAV_CLASS}__router__menu__links`,
      role: "menu"
    }, group.routes.map(route => /*#__PURE__*/React__default.createElement("li", {
      className: `${NAV_CLASS}__router__menu__links__link`,
      key: route.location,
      onClick: () => handleLinkClick(group.title),
      onKeyDown: () => handleLinkClick(group.title),
      role: "menuitem",
      tabIndex: 0
    }, /*#__PURE__*/React__default.createElement(NavLink, {
      to: `${url}/${route.location}`,
      activeClassName: "active"
    }, route.label))))
  }));
  return /*#__PURE__*/React__default.createElement("div", {
    className: `${DEFAULT_CLASS$B}${isSidebarClose ? '--closed' : ''}`
  }, /*#__PURE__*/React__default.createElement("nav", {
    className: NAV_CLASS
  }, project && /*#__PURE__*/React__default.createElement("div", {
    className: `${NAV_CLASS}__project`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${NAV_CLASS}__project__image`,
    onClick: () => {
      setIsSidebarClose(!isSidebarClose);
    },
    onKeyDown: () => {
      setIsSidebarClose(!isSidebarClose);
    },
    role: "button",
    tabIndex: 0
  }, project.image), !isSidebarClose && /*#__PURE__*/React__default.createElement("div", {
    className: `${NAV_CLASS}__project__name`
  }, project.name, /*#__PURE__*/React__default.createElement("span", {
    className: `${NAV_CLASS}__project__name__subtitle`
  }, project.environment)), /*#__PURE__*/React__default.createElement(FlightTooltip, {
    className: `${NAV_CLASS}__project__info ${isSidebarClose || !infoContent ? 'info-hidden' : ''}`,
    description: infoContent
  }, getIcon('infoStroke', {
    className: 'info-icon'
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: `${NAV_CLASS}__router`
  }, /*#__PURE__*/React__default.createElement(FlightCollapsible, {
    items: links,
    maxHeight: "auto",
    className: `${NAV_CLASS}__router__menu`,
    isCollapsible: !isSidebarClose
  })), /*#__PURE__*/React__default.createElement("div", {
    className: `${NAV_CLASS}__footer`
  }, /*#__PURE__*/React__default.createElement(FlightButton, {
    theme: "link",
    size: "large",
    iconRight: "baselineKeyboardArrowLeft",
    ariaLabel: "toggle-sidebar",
    className: `${NAV_CLASS}__footer__button`,
    onClick: () => {
      setIsSidebarClose(!isSidebarClose);
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: MAIN_CLASS$2
  }, /*#__PURE__*/React__default.createElement(Switch, null, children)));
};
FlightGlobalNavSidebar.propTypes = {
  children: propTypes.element,
  project: propTypes.shape({
    id: propTypes.string,
    name: propTypes.string,
    image: propTypes.element,
    environment: propTypes.string
  }),
  infoContent: propTypes.string,
  routeGroups: propTypes.arrayOf(propTypes.shape({
    title: propTypes.string.isRequired,
    icon: propTypes.string.isRequired,
    routes: propTypes.arrayOf(propTypes.shape({
      label: propTypes.string.isRequired,
      location: propTypes.string.isRequired
    }))
  }))
};
FlightGlobalNavSidebar.defaultProps = {
  children: null,
  project: null,
  infoContent: '',
  routeGroups: []
};

var css_248z$E = ".flight-font, .flight-suggestion-list {\n  font-family: \"Muli\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--code {\n  font-family: \"Roboto Mono\", \"Courier\", monospace;\n  font-size: 12px;\n  line-height: 20px;\n}\n.flight-font--xxsmall, .flight-suggestion-list__body__listbox div[role=option] span:not(:first-child) {\n  font-size: 11px;\n  line-height: 12px;\n}\n.flight-font--xsmall, .flight-suggestion-list__error-message {\n  font-size: 12px;\n  line-height: 16px;\n}\n.flight-font--small, .flight-suggestion-list__body__listbox div[role=option], .flight-suggestion-list__icon-container p {\n  font-size: 14px;\n  line-height: 20px;\n}\n.flight-font--medium {\n  font-size: 16px;\n  line-height: 20px;\n}\n.flight-font--large {\n  font-size: 20px;\n  line-height: 28px;\n}\n.flight-font--xlarge {\n  font-size: 24px;\n  line-height: 32px;\n}\n.flight-font--2xlarge {\n  font-size: 28px;\n  line-height: 36px;\n}\n.flight-font--3xlarge {\n  font-size: 32px;\n  line-height: 44px;\n}\n.flight-font--normal, .flight-suggestion-list__dropdown__portal .flight-dropdown__dropdown .flight-button {\n  font-weight: 400;\n}\n.flight-font--bold {\n  font-weight: 700;\n}\n.flight-font--xbold {\n  font-weight: 800;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-accel {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  20% {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n  40% {\n    -webkit-transform: rotate(110deg);\n    -moz-transform: rotate(110deg);\n    -ms-transform: rotate(110deg);\n    -o-transform: rotate(110deg);\n    transform: rotate(110deg);\n  }\n  60% {\n    -webkit-transform: rotate(250deg);\n    -moz-transform: rotate(250deg);\n    -ms-transform: rotate(250deg);\n    -o-transform: rotate(250deg);\n    transform: rotate(250deg);\n  }\n  80% {\n    -webkit-transform: rotate(315deg);\n    -moz-transform: rotate(315deg);\n    -ms-transform: rotate(315deg);\n    -o-transform: rotate(315deg);\n    transform: rotate(315deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-moz-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-o-keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@keyframes color-grey-change {\n  0% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n  50% {\n    -webkit-background: #E6E7EB;\n    -moz-background: #E6E7EB;\n    -ms-background: #E6E7EB;\n    -o-background: #E6E7EB;\n    background: #E6E7EB;\n  }\n  100% {\n    -webkit-background: #F2F3F5;\n    -moz-background: #F2F3F5;\n    -ms-background: #F2F3F5;\n    -o-background: #F2F3F5;\n    background: #F2F3F5;\n  }\n}\n@-webkit-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-top {\n  0% {\n    -webkit-transform: translateY(-10px);\n    -moz-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    -o-transform: translateY(-10px);\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@-o-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(10px);\n    -moz-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    -o-transform: translateY(10px);\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n.sr-only {\n  position: absolute !important;\n  clip: rect(1px, 1px, 1px, 1px);\n  padding: 0 !important;\n  border: 0 !important;\n  height: 1px !important;\n  width: 1px !important;\n  overflow: hidden;\n}\n\n.highlight {\n  background-color: #F2F3F5;\n  color: #051336;\n}\n\n.flight-suggestion-list__dropdown__input input {\n  padding-right: 32px;\n  text-overflow: ellipsis;\n}\n.flight-suggestion-list__dropdown__input .flight-text-input__icon-trailing {\n  right: -16px;\n}\n.flight-suggestion-list__error-message {\n  color: #DC3616;\n  padding-left: 8px;\n  display: block;\n}\n.flight-suggestion-list__error-message--disabled {\n  color: #B4B8C3;\n}\n.flight-suggestion-list__icon-container {\n  display: flex;\n  align-items: center;\n  background: #F2F3F5;\n  padding: 5px 16px;\n  gap: 10px;\n}\n.flight-suggestion-list__icon-container svg {\n  width: 15px;\n  height: 15px;\n  fill: #25314C;\n}\n.flight-suggestion-list__icon-container p {\n  margin: 5px 0;\n  font-weight: 700;\n}\n.flight-suggestion-list__body {\n  display: grid;\n  min-height: 200px;\n  padding-top: 5px;\n  height: 230px;\n  overflow: auto;\n  position: relative;\n}\n.flight-suggestion-list__body__loading {\n  display: flex;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  background: #F2F3F5;\n  width: 100%;\n  height: 100%;\n}\n.flight-suggestion-list__body__loading svg:last-child {\n  width: 75px;\n  height: 75px;\n  fill: #B4B8C3;\n  position: absolute;\n  visibility: visible;\n  -webkit-animation-name: spin;\n  -moz-animation-name: spin;\n  -ms-animation-name: spin;\n  -o-animation-name: spin;\n  animation-name: spin;\n  -webkit-animation-delay: 0s;\n  -moz-animation-delay: 0s;\n  -ms-animation-delay: 0s;\n  -o-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation-duration: 0.75s;\n  -moz-animation-duration: 0.75s;\n  -ms-animation-duration: 0.75s;\n  -o-animation-duration: 0.75s;\n  animation-duration: 0.75s;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-timing-function: linear;\n  -ms-animation-timing-function: linear;\n  -o-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: infinite;\n  -moz-animation-iteration-count: infinite;\n  -ms-animation-iteration-count: infinite;\n  -o-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-direction: normal;\n  -moz-animation-direction: normal;\n  -ms-animation-direction: normal;\n  -o-animation-direction: normal;\n  animation-direction: normal;\n  -webkit-animation-fill-mode: none;\n  -moz-animation-fill-mode: none;\n  -ms-animation-fill-mode: none;\n  -o-animation-fill-mode: none;\n  animation-fill-mode: none;\n  -webkit-animation-play-state: running;\n  -moz-animation-play-state: running;\n  -ms-animation-play-state: running;\n  -o-animation-play-state: running;\n  animation-play-state: running;\n}\n.flight-suggestion-list__body__listbox {\n  display: flex;\n  flex-direction: column;\n}\n.flight-suggestion-list__body__listbox div[role=option] {\n  display: flex;\n  align-items: center;\n  padding: 7px 16px;\n  justify-content: space-between;\n  line-height: 18px;\n  cursor: pointer;\n}\n.flight-suggestion-list__body__listbox div[role=option]:hover, .flight-suggestion-list__body__listbox div[role=option]:focus, .flight-suggestion-list__body__listbox div[role=option]:active {\n  background-color: #F2F3F5;\n  color: #051336;\n}\n.flight-suggestion-list__body__listbox div[role=option] span {\n  flex-grow: 2;\n  flex-basis: 60%;\n  max-width: 60%;\n}\n.flight-suggestion-list__body__listbox div[role=option] span:not(:first-child) {\n  color: #ADADAD;\n  flex-grow: 1;\n  flex-basis: 20%;\n  max-width: 20%;\n  text-align: end;\n}\n.flight-suggestion-list__body__message {\n  display: flex;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 10px;\n  color: #B4B8C3;\n}\n.flight-suggestion-list__body__message svg {\n  width: 74px;\n  height: 74px;\n  fill: #B4B8C3;\n}\n.flight-suggestion-list__dropdown__portal .flight-dropdown__dropdown {\n  max-width: fit-content !important;\n}\n.flight-suggestion-list__dropdown__portal .flight-dropdown__dropdown .flight-text-input-wrapper {\n  width: auto !important;\n}\n.flight-suggestion-list__dropdown__portal .flight-dropdown__dropdown .flight-text-input__icon-input {\n  padding-left: 16px;\n}\n.flight-suggestion-list__dropdown__portal .flight-dropdown__dropdown .flight-text-input input {\n  padding-left: 40px;\n  width: calc(100% - 40px);\n  border-top: 1px solid #B4B8C3;\n  background: transparent;\n  border-radius: 0;\n}\n.flight-suggestion-list__dropdown__portal .flight-dropdown__dropdown .flight-button {\n  color: #051336;\n  white-space: nowrap;\n  display: flex;\n  justify-content: space-between;\n}";
styleInject(css_248z$E);

const DEFAULT_CLASS$C = 'flight-suggestion-list';
const ERROR_CLASS$5 = `${DEFAULT_CLASS$C}__error-message`;
const DROPDOWN_CLASS$6 = `${DEFAULT_CLASS$C}__dropdown`;
const DROPDOWN_SVG_ICON_CLASS = `${DEFAULT_CLASS$C}__icon-container`;
const DROPDOWN_BODY_CLASS = `${DEFAULT_CLASS$C}__body`;
const LOADING_CLASS = `${DROPDOWN_BODY_CLASS}__loading`;
const MESSAGE_CLASS = `${DROPDOWN_BODY_CLASS}__message`;
const LISTBOX_CLASS = `${DROPDOWN_BODY_CLASS}__listbox`;
const DEFAULT_CONTENT = {
  errorMessage: '',
  noDataAvailableMsg: {
    icon: 'puzzle',
    text: 'No contents available'
  },
  serverErrorMsg: {
    icon: 'globe',
    text: 'Could not load content'
  },
  noDataFoundMsg: {
    icon: 'search',
    text: 'No content found'
  },
  countOfSuggestionsAriaLabel: 'suggestions found. Use up and down arrows to navigate',
  searchAriaLabel: 'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
  listBoxAriaLabel: 'List of content suggestions'
};
const FlightSuggestionList = props => {
  const {
    options,
    selected,
    content,
    className,
    width,
    disabled,
    hasError,
    ariaControlsId,
    noDataAvailable,
    isServerError,
    autoFocus,
    loading,
    onFocus,
    onBlur,
    onSearchFocus,
    onSearchBlur,
    clearOnClickOutside,
    handleSearch,
    handleOptionClick,
    handleClickOutside,
    fetchNextPage,
    intro,
    searchPlaceholder
  } = props;
  const {
    errorMessage,
    noDataAvailableMsg,
    serverErrorMsg,
    noDataFoundMsg,
    countOfSuggestionsAriaLabel,
    searchAriaLabel,
    listBoxAriaLabel
  } = {
    ...DEFAULT_CONTENT,
    ...content
  };

  // States
  const [currentFocusedIndex, setCurrentFocusIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [listboxNode, setListboxNode] = useState(null);
  const [lastElement, setLastElement] = useState(null);
  useEffect(() => {
    // this useEffect is for when the value of props.selected
    //  gets modified outside of the component (i.e. reset)
    setInputValue('');
  }, [selected]);

  // Observer to support infinite scrolling
  const contentListingObserver = useRef(new IntersectionObserver(_ref => {
    let [entry] = _ref;
    if (entry.isIntersecting) {
      if (fetchNextPage) {
        fetchNextPage();
      }
    }
  }, {
    threshold: 0.25
  }));

  // Support infinite scrolling
  useEffect(() => {
    const observer = contentListingObserver.current;

    /* Observe only if all below conditions are true ->
      1. Content is not loading
      2. Box has enough items to show scrollbar
    */

    if (listboxNode && !loading) {
      const listBoxHeight = listboxNode.scrollHeight;
      const parentBoxHeight = listboxNode.parentNode.clientHeight;
      const shouldObserve = lastElement && listBoxHeight > parentBoxHeight;
      if (shouldObserve) {
        observer.observe(lastElement);
      }
    }
    return () => {
      if (lastElement) {
        observer.unobserve(lastElement);
      }
      observer.disconnect();
    };
  }, [contentListingObserver, listboxNode, loading, lastElement]);

  // Refs
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  let errorMessageClass = ERROR_CLASS$5;
  errorMessageClass += disabled ? ` ${ERROR_CLASS$5}--disabled` : '';
  const handleOptionFocusOnKeyPress = useCallback(() => {
    if (listboxNode) {
      const childrenCount = listboxNode.childNodes.length;
      let focusableChildren = null;
      let newFocusIndex = currentFocusedIndex;

      // Reset aria-selected value and remove highlight class
      listboxNode.childNodes.forEach(optChild => {
        optChild.classList.remove('highlight');
        optChild.setAttribute('aria-selected', false);
      });

      // Figure out next focusable element
      if (currentFocusedIndex >= childrenCount) {
        [focusableChildren] = listboxNode.childNodes;
        newFocusIndex = 0;
      } else if (currentFocusedIndex < 0) {
        focusableChildren = listboxNode.childNodes[childrenCount - 1];
        newFocusIndex = childrenCount - 1;
      } else {
        focusableChildren = listboxNode.childNodes[currentFocusedIndex];
      }
      if (focusableChildren) {
        searchInputRef.current.setAttribute('aria-activedescendant', focusableChildren.id);
        focusableChildren.classList.add('highlight');
        focusableChildren.setAttribute('aria-selected', 'true');
        focusableChildren.focus();
      }
      if (newFocusIndex !== currentFocusedIndex) {
        setCurrentFocusIndex(newFocusIndex);
      }
    }
  }, [currentFocusedIndex, listboxNode]);
  useEffect(() => {
    if (isOpen && searchInputRef && searchInputRef.current) {
      searchInputRef.current.focus();
      // Adding accessibility attribute
      searchInputRef.current.setAttribute('aria-owns', 'contentFinderListbox');
    } else {
      // Reset search
      setSearchValue('');
    }
  }, [isOpen]);
  useEffect(() => {
    handleOptionFocusOnKeyPress();
  }, [currentFocusedIndex, handleOptionFocusOnKeyPress]);
  const handleSearchTextOnChange = event => {
    setSearchValue(event.target.value);
    if (handleSearch) handleSearch(event.target.value);
  };
  const handleTextInputOnFocus = event => {
    setIsOpen(true);
    if (onFocus) {
      onFocus(event);
    }
  };
  const handleTextInputOnBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
  };
  const handleSearchOnFocus = event => {
    if (onSearchFocus) {
      onSearchFocus(event);
    }
  };
  const handleSearchOnBlur = event => {
    if (onSearchBlur) {
      onSearchBlur(event);
    }
  };

  // List box Keypress event
  const handleKeyPress = event => {
    switch (event.key) {
      case EVENT_KEYS.ESCAPE:
        if (searchInputRef.current) {
          searchInputRef.current.removeAttribute('aria-activedescendant');
          searchInputRef.current.focus();
        }
        setCurrentFocusIndex(null);
        break;
      case EVENT_KEYS.ARROW_UP:
        if (currentFocusedIndex !== null) {
          setCurrentFocusIndex(prevCurrentFocusIndex => prevCurrentFocusIndex - 1);
        } else {
          setCurrentFocusIndex(0);
        }
        break;
      case EVENT_KEYS.ARROW_DOWN:
      case EVENT_KEYS.TAB:
        if (currentFocusedIndex !== null) {
          setCurrentFocusIndex(prevCurrentFocusIndex => prevCurrentFocusIndex + 1);
        } else {
          setCurrentFocusIndex(0);
        }
        break;
    }
  };
  const onOptionClick = option => {
    if (isOpen) {
      setIsOpen(false);
      setInputValue(option.name || '');
      if (clearOnClickOutside) handleSearch('');
      handleOptionClick(option);
    }
  };
  const handleClickOutsideListingBox = event => {
    if (clearOnClickOutside) handleSearch('');
    if (handleClickOutside) {
      handleClickOutside(event);
    }
    setIsOpen(false);
  };

  // Render UI inside Listbox
  const renderContentList = () => {
    if (isServerError) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: MESSAGE_CLASS
      }, /*#__PURE__*/React__default.createElement("div", null, getIcon(serverErrorMsg.icon ? serverErrorMsg.icon : DEFAULT_CONTENT.serverErrorMsg.icon)), /*#__PURE__*/React__default.createElement("div", null, serverErrorMsg.text));
    }
    if (options && options.length) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: LISTBOX_CLASS,
        ref: setListboxNode,
        id: "contentFinderListbox",
        role: "listbox",
        "aria-label": listBoxAriaLabel,
        tabIndex: -1
      }, options.map((option, idx) => {
        const elemKey = `suggestionOptionItem-${idx}-${option.payload ? option.payload.id : option.name.replaceAll(' ', '_')}`;
        return /*#__PURE__*/React__default.createElement("div", {
          key: elemKey,
          role: "option",
          ref: idx === options.length - 1 ? setLastElement : null,
          id: `contentSuggestion-${idx}`,
          "aria-selected": "false",
          tabIndex: -1,
          onClick: () => onOptionClick(option),
          onKeyDown: event => {
            if (event.key === EVENT_KEYS.ENTER) {
              onOptionClick(option);
            }
          }
        }, /*#__PURE__*/React__default.createElement("span", null, option.name), option.subText && option.subText.map((subText, subTextIdx) => {
          const subTextElemKey = `suggestionListSubtext-${subTextIdx}`;
          return /*#__PURE__*/React__default.createElement("span", {
            key: subTextElemKey
          }, subText);
        }));
      }));
    }
    return /*#__PURE__*/React__default.createElement("div", {
      className: MESSAGE_CLASS
    }, /*#__PURE__*/React__default.createElement("div", null, getIcon(noDataFoundMsg.icon ? noDataFoundMsg.icon : DEFAULT_CONTENT.noDataFoundMsg.icon)), /*#__PURE__*/React__default.createElement("div", null, noDataFoundMsg.text));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: DEFAULT_CLASS$C
  }, /*#__PURE__*/React__default.createElement(FlightDropdown, {
    className: className ? `${DROPDOWN_CLASS$6} ${className}__dropdown` : DROPDOWN_CLASS$6,
    trigger: /*#__PURE__*/React__default.createElement(FlightTextInput, {
      className: `${DROPDOWN_CLASS$6}__input`,
      value: inputValue || selected && selected.name || '',
      label: "",
      placeholderText: intro.text,
      trailingIcon: isOpen ? 'upCarrot' : 'downCarrot',
      onFocus: handleTextInputOnFocus,
      onBlur: handleTextInputOnBlur,
      disabled: disabled,
      hasError: hasError
    }),
    ariaControlsId: `select-searchable-${ariaControlsId}`,
    isActive: isOpen && !disabled,
    autoFocus: autoFocus,
    isControlledByIsActive: true,
    handleClickOutside: handleClickOutsideListingBox
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: DROPDOWN_SVG_ICON_CLASS
  }, getIcon(intro.icon), /*#__PURE__*/React__default.createElement("p", null, intro.text)), noDataAvailable ? /*#__PURE__*/React__default.createElement("div", {
    className: DROPDOWN_BODY_CLASS
  }, /*#__PURE__*/React__default.createElement("div", {
    className: MESSAGE_CLASS
  }, /*#__PURE__*/React__default.createElement("div", null, getIcon(noDataAvailableMsg.icon ? noDataAvailableMsg.icon : DEFAULT_CONTENT.noDataAvailableMsg.icon)), /*#__PURE__*/React__default.createElement("div", null, noDataAvailableMsg.text))) : /*#__PURE__*/React__default.createElement("div", {
    ref: dropdownRef,
    onKeyDown: handleKeyPress,
    style: {
      width
    },
    role: "button",
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-live": "assertive",
    className: "sr-only"
  }, options && `${options.length} ${countOfSuggestionsAriaLabel}`), /*#__PURE__*/React__default.createElement(FlightTextInput, {
    inputRef: searchInputRef,
    className: `${DROPDOWN_CLASS$6}__search__input`,
    value: searchValue,
    label: "",
    placeholderText: searchPlaceholder,
    onChange: handleSearchTextOnChange,
    onFocus: handleSearchOnFocus,
    onBlur: handleSearchOnBlur,
    iconInput: "search",
    ariaLabel: searchAriaLabel
  }), /*#__PURE__*/React__default.createElement("div", {
    className: DROPDOWN_BODY_CLASS
  }, loading && /*#__PURE__*/React__default.createElement("div", {
    className: LOADING_CLASS
  }, getIcon('loading')), renderContentList())))), hasError && errorMessage && /*#__PURE__*/React__default.createElement("span", {
    className: errorMessageClass
  }, errorMessage));
};
FlightSuggestionList.propTypes = {
  options: propTypes.arrayOf(propTypes.shape({
    name: propTypes.string.isRequired,
    subText: propTypes.arrayOf(propTypes.string)
  })),
  selected: propTypes.shape({
    name: propTypes.string.isRequired,
    subText: propTypes.arrayOf(propTypes.string)
  }),
  content: propTypes.shape({
    errorMessage: propTypes.string,
    intro: propTypes.shape({
      icon: propTypes.string,
      text: propTypes.string
    }),
    searchPlaceholder: propTypes.string,
    noDataAvailableMsg: propTypes.shape({
      icon: propTypes.string,
      text: propTypes.string
    }),
    serverErrorMsg: propTypes.shape({
      icon: propTypes.string,
      text: propTypes.string
    }),
    noDataFoundMsg: propTypes.shape({
      icon: propTypes.string,
      text: propTypes.string
    }),
    countOfSuggestionsAriaLabel: propTypes.string,
    searchAriaLabel: propTypes.string,
    listBoxAriaLabel: propTypes.string
  }),
  className: propTypes.string,
  width: propTypes.string,
  ariaControlsId: propTypes.string.isRequired,
  loading: propTypes.bool,
  disabled: propTypes.bool,
  clearOnClickOutside: propTypes.bool,
  noDataAvailable: propTypes.bool,
  isServerError: propTypes.bool,
  autoFocus: propTypes.bool,
  hasError: propTypes.bool,
  onFocus: propTypes.func,
  onBlur: propTypes.func,
  onSearchFocus: propTypes.func,
  onSearchBlur: propTypes.func,
  handleSearch: propTypes.func.isRequired,
  handleOptionClick: propTypes.func.isRequired,
  handleClickOutside: propTypes.func,
  fetchNextPage: propTypes.func,
  intro: propTypes.shape({
    icon: propTypes.string,
    text: propTypes.string
  }),
  searchPlaceholder: propTypes.string
};
FlightSuggestionList.defaultProps = {
  options: [],
  selected: null,
  content: {},
  className: '',
  width: '400px',
  loading: false,
  disabled: false,
  clearOnClickOutside: false,
  noDataAvailable: false,
  isServerError: false,
  autoFocus: true,
  hasError: false,
  onFocus: () => undefined,
  onBlur: () => undefined,
  onSearchFocus: () => undefined,
  onSearchBlur: () => undefined,
  handleClickOutside: () => undefined,
  fetchNextPage: () => undefined,
  intro: {
    icon: '',
    text: ''
  },
  searchPlaceholder: ''
};

export { FlightAvatar, FlightButton, FlightCard, FlightCarousel, FlightCarouselItem, FlightCheckbox, FlightCollapsible, FlightDatePicker, FlightDateRangePicker, FlightDropdown, FlightFilter, FlightGlobalNav, FlightGlobalNavSidebar, FlightImageUploader, FlightLabel, FlightLabelSearch, FlightModal, FlightNav, FlightNumberInput, FlightOverflowMenu, FlightRadioButton, FlightSearch, FlightSelect, FlightSelectMulti, FlightSelectSearchable, FlightSnackbar, FlightSuggestionList, FlightTabPanel, FlightTable, FlightTabs, FlightTag, FlightTextArea, FlightTextInput, FlightTime, FlightTimeZone, FlightToggleSwitch, FlightTooltip, getIcon };
//# sourceMappingURL=index.es.js.map
